/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		18: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-index","1":"route-sscMarker","2":"route-searchResults","3":"route-profile","4":"route-projects","5":"route-home","6":"route-sdg","7":"route-sdg-target-details","8":"route-aboutUs","9":"route-tmp_home_financial_component","10":"route-themes","11":"route-signature","12":"route-sdgLanding","13":"route-marker","14":"route-donors","15":"route-activity-details","16":"route-ourApproaches","17":"route-404Page"}[chunkId]||chunkId) + ".chunk." + {"0":"2c3c9","1":"4f17a","2":"35e09","3":"45d5b","4":"ce3f4","5":"94492","6":"89bb4","7":"60074","8":"0f4ec","9":"12f75","10":"4f133","11":"958d1","12":"dfe73","13":"7583a","14":"0f475","15":"88250","16":"e1a93","17":"0174e"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/Krw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDG_LIST_AGGREGATE; });
/* unused harmony export sdgAggregateFetchStart */
/* unused harmony export sdgAggregateFetchEnd */
/* unused harmony export sdgAggregateFetchSuccess */
/* unused harmony export sdgAggregateFetchFailed */
/* unused harmony export parseSdgAggregateData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSdgListData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tabSection_actions__ = __webpack_require__("PeVu");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Third party Files *************************/


/************************* Redux Action Files ************************/


var SDG_LIST_AGGREGATE = {
  start: "fetch_start/sdg_list_aggregate",
  end: "fetch_end/sdg_list_aggregate",
  success: "fetch_success/sdg_list_aggregate",
  failed: "fetch_failed/sdg_list_aggregate"
};

var sdgAggregateFetchStart = function sdgAggregateFetchStart() {
  return {
    type: SDG_LIST_AGGREGATE.start
  };
};

var sdgAggregateFetchEnd = function sdgAggregateFetchEnd() {
  return {
    type: SDG_LIST_AGGREGATE.end
  };
};

var sdgAggregateFetchSuccess = function sdgAggregateFetchSuccess(data) {
  return {
    type: SDG_LIST_AGGREGATE.success,
    data: data
  };
};

var sdgAggregateFetchFailed = function sdgAggregateFetchFailed(error) {
  return {
    type: SDG_LIST_AGGREGATE.failed,
    error: error
  };
};

function parseSdgAggregateData(data) {
  var parsedData = {
    project: _extends({}, data.project),
    sdg: []
  };
  var newDataArray = [].concat(data.sdg);
  newDataArray.forEach(function (item, index) {
    item.label = item.sdg_name;
    item.share_percent = item.percentage;
    item.value = item.sdg_code;
    item.budget = item.total_budget;
    item.expense = item.total_expense;
    item.color = "#" + item.color;
    item.point = 100 + index;
  });
  parsedData.sdg = newDataArray;
  return parsedData;
}

var fetchSdgListData = function fetchSdgListData(year, recipentCountry, donor) {
  return function (dispatch, getState) {
    var sdgFilter = getState().tabData.sdgFilter,
        recipentCountry = recipentCountry || (sdgFilter.operatingUnits ? sdgFilter.operatingUnits : ""),
        donor = donor || (sdgFilter.budgetSources ? sdgFilter.budgetSources : ""),
        newYear = year || getState().tabData.currentYear;
    dispatch(sdgAggregateFetchStart());
    if (newYear !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SDG_AGGREGATE(newYear, recipentCountry, donor)).then(function (resp) {
      if (resp.success && resp.data) {
        var newData = parseSdgAggregateData(resp.data);
        dispatch(sdgAggregateFetchEnd());
        dispatch(sdgAggregateFetchSuccess(newData));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__components_tabSection_actions__["i" /* onTabSelection */])(getState().tabData.tabSelected));
      } else {
        dispatch(sdgAggregateFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(sdgAggregateFetchEnd());
      dispatch(sdgAggregateFetchFailed());
    });
    dispatch(sdgAggregateFetchFailed());
  };
};

/***/ }),

/***/ "0+k3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXPORT_PDF; });
/* unused harmony export exportPDFFetchStart */
/* unused harmony export exportPDFFetchEnd */
/* unused harmony export exportPDFFetchSuccess */
/* unused harmony export exportPDFFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetExportUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return exportPDFCall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__ = __webpack_require__("Cdrj");
/************************* Lib Files ************************/


var EXPORT_PDF = {
  start: "fetch_start/export_pdf",
  end: "fetch_end/export_pdf",
  success: "fetch_success/export_pdf",
  failed: "fetch_failed/export_pdf",
  reset: "reset/export_pdf"
};
var exportPDFFetchStart = function exportPDFFetchStart() {
  return {
    type: EXPORT_PDF.start
  };
};

var exportPDFFetchEnd = function exportPDFFetchEnd() {
  return {
    type: EXPORT_PDF.end
  };
};

var exportPDFFetchSuccess = function exportPDFFetchSuccess(downloadUrl, previewUrl) {
  return {
    type: EXPORT_PDF.success,
    downloadUrl: downloadUrl,
    previewUrl: previewUrl
  };
};

var exportPDFFetchFailed = function exportPDFFetchFailed(error) {
  return {
    type: EXPORT_PDF.failed,
    error: error
  };
};

var resetExportUrl = function resetExportUrl() {
  return {
    type: EXPORT_PDF.reset
  };
};
var exportPDFCall = function exportPDFCall(template_name, context_data) {
  return function (dispatch) {
    var params = {
      template_name: template_name,
      context_data: context_data
    };
    dispatch(exportPDFFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].postPDF(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_EXPORTPDF, params).then(function (resp) {
      dispatch(exportPDFFetchEnd());
      dispatch(exportPDFFetchSuccess(Object(__WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__["a" /* DownloadUrlGenerator */])(resp.data.file_name), Object(__WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__["b" /* PreviewUrlGenerator */])(resp.data.file_path)));
    }).catch(function (exception) {
      dispatch(exportPDFFetchEnd());
      dispatch(exportPDFFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "0GGf":
/***/ (function(module, exports) {

/*!
Copyright (C) 2013-2017 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
var
// should be a not so common char
// possibly one JSON does not encode
// possibly one encodeURIComponent does not encode
// right now this char is '~' but this might change in the future
specialChar = '~',
    safeSpecialChar = '\\x' + ('0' + specialChar.charCodeAt(0).toString(16)).slice(-2),
    escapedSafeSpecialChar = '\\' + safeSpecialChar,
    specialCharRG = new RegExp(safeSpecialChar, 'g'),
    safeSpecialCharRG = new RegExp(escapedSafeSpecialChar, 'g'),
    safeStartWithSpecialCharRG = new RegExp('(?:^|([^\\\\]))' + escapedSafeSpecialChar),
    indexOf = [].indexOf || function (v) {
  for (var i = this.length; i-- && this[i] !== v;) {}
  return i;
},
    $String = String // there's no way to drop warnings in JSHint
// about new String ... well, I need that here!
// faked, and happy linter!
;

function generateReplacer(value, replacer, resolve) {
  var doNotIgnore = false,
      inspect = !!replacer,
      path = [],
      all = [value],
      seen = [value],
      mapp = [resolve ? specialChar : '[Circular]'],
      last = value,
      lvl = 1,
      i,
      fn;
  if (inspect) {
    fn = typeof replacer === 'object' ? function (key, value) {
      return key !== '' && replacer.indexOf(key) < 0 ? void 0 : value;
    } : replacer;
  }
  return function (key, value) {
    // the replacer has rights to decide
    // if a new object should be returned
    // or if there's some key to drop
    // let's call it here rather than "too late"
    if (inspect) value = fn.call(this, key, value);

    // first pass should be ignored, since it's just the initial object
    if (doNotIgnore) {
      if (last !== this) {
        i = lvl - indexOf.call(all, this) - 1;
        lvl -= i;
        all.splice(lvl, all.length);
        path.splice(lvl - 1, path.length);
        last = this;
      }
      // console.log(lvl, key, path);
      if (typeof value === 'object' && value) {
        // if object isn't referring to parent object, add to the
        // object path stack. Otherwise it is already there.
        if (indexOf.call(all, value) < 0) {
          all.push(last = value);
        }
        lvl = all.length;
        i = indexOf.call(seen, value);
        if (i < 0) {
          i = seen.push(value) - 1;
          if (resolve) {
            // key cannot contain specialChar but could be not a string
            path.push(('' + key).replace(specialCharRG, safeSpecialChar));
            mapp[i] = specialChar + path.join(specialChar);
          } else {
            mapp[i] = mapp[0];
          }
        } else {
          value = mapp[i];
        }
      } else {
        if (typeof value === 'string' && resolve) {
          // ensure no special char involved on deserialization
          // in this case only first char is important
          // no need to replace all value (better performance)
          value = value.replace(safeSpecialChar, escapedSafeSpecialChar).replace(specialChar, safeSpecialChar);
        }
      }
    } else {
      doNotIgnore = true;
    }
    return value;
  };
}

function retrieveFromPath(current, keys) {
  for (var i = 0, length = keys.length; i < length; current = current[
  // keys should be normalized back here
  keys[i++].replace(safeSpecialCharRG, specialChar)]) {}
  return current;
}

function generateReviver(reviver) {
  return function (key, value) {
    var isString = typeof value === 'string';
    if (isString && value.charAt(0) === specialChar) {
      return new $String(value.slice(1));
    }
    if (key === '') value = regenerate(value, value, {});
    // again, only one needed, do not use the RegExp for this replacement
    // only keys need the RegExp
    if (isString) value = value.replace(safeStartWithSpecialCharRG, '$1' + specialChar).replace(escapedSafeSpecialChar, safeSpecialChar);
    return reviver ? reviver.call(this, key, value) : value;
  };
}

function regenerateArray(root, current, retrieve) {
  for (var i = 0, length = current.length; i < length; i++) {
    current[i] = regenerate(root, current[i], retrieve);
  }
  return current;
}

function regenerateObject(root, current, retrieve) {
  for (var key in current) {
    if (current.hasOwnProperty(key)) {
      current[key] = regenerate(root, current[key], retrieve);
    }
  }
  return current;
}

function regenerate(root, current, retrieve) {
  return current instanceof Array ?
  // fast Array reconstruction
  regenerateArray(root, current, retrieve) : current instanceof $String ?
  // root is an empty string
  current.length ? retrieve.hasOwnProperty(current) ? retrieve[current] : retrieve[current] = retrieveFromPath(root, current.split(specialChar)) : root : current instanceof Object ?
  // dedicated Object parser
  regenerateObject(root, current, retrieve) :
  // value as it is
  current;
}

var CircularJSON = {
  stringify: function stringify(value, replacer, space, doNotResolve) {
    return CircularJSON.parser.stringify(value, generateReplacer(value, replacer, !doNotResolve), space);
  },
  parse: function parse(text, reviver) {
    return CircularJSON.parser.parse(text, generateReviver(reviver));
  },
  // A parser should be an API 1:1 compatible with JSON
  // it should expose stringify and parse methods.
  // The default parser is the native JSON.
  parser: JSON
};

module.exports = CircularJSON;

/***/ }),

/***/ "0Z3F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_TOP_BUDGET_SOURCES; });
/* unused harmony export recipientTopBudgetSourcesFetchStart */
/* unused harmony export recipientTopBudgetSourcesFetchEnd */
/* unused harmony export recipientTopBudgetSourcesFetchSuccess */
/* unused harmony export recipientTopBudgetSourcesFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRecipientTopBudgetSources; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util__ = __webpack_require__("nq70");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_util__);



var RECIPIENT_TOP_BUDGET_SOURCES = {
  start: "fetch_start/recipient_top_budget_sources",
  end: "fetch_end/recipient_top_budget_sources",
  success: "fetch_success/recipient_top_budget_sources",
  failed: "fetch_failed/recipient_top_budget_sources"
};

var recipientTopBudgetSourcesFetchStart = function recipientTopBudgetSourcesFetchStart() {
  return {
    type: RECIPIENT_TOP_BUDGET_SOURCES.start
  };
};

var recipientTopBudgetSourcesFetchEnd = function recipientTopBudgetSourcesFetchEnd() {
  return {
    type: RECIPIENT_TOP_BUDGET_SOURCES.end
  };
};

var recipientTopBudgetSourcesFetchSuccess = function recipientTopBudgetSourcesFetchSuccess(data) {
  return {
    type: RECIPIENT_TOP_BUDGET_SOURCES.success,
    data: data
  };
};

var recipientTopBudgetSourcesFetchFailed = function recipientTopBudgetSourcesFetchFailed(error) {
  return {
    type: RECIPIENT_TOP_BUDGET_SOURCES.failed,
    error: error
  };
};

var fetchRecipientTopBudgetSources = function fetchRecipientTopBudgetSources(code, year) {
  return function (dispatch) {
    dispatch(recipientTopBudgetSourcesFetchStart());
    if (year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_COUNTRTY_TOP_BUDGET_SOURCES(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(recipientTopBudgetSourcesFetchEnd());
          dispatch(recipientTopBudgetSourcesFetchSuccess(resp.data));
        } else {
          dispatch(recipientTopBudgetSourcesFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(recipientTopBudgetSourcesFetchEnd());
        dispatch(recipientTopBudgetSourcesFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "14MA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_DOCUMENTS; });
/* unused harmony export recipientDocumentsFetchStart */
/* unused harmony export recipientDocumentsFetchEnd */
/* unused harmony export recipientDocumentsFetchSuccess */
/* unused harmony export recipientDocumentsFetchFailed */
/* unused harmony export createDocumentCategoryList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRecipientDocuments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var RECIPIENT_DOCUMENTS = {
  start: "fetch_start/recipient_documents",
  end: "fetch_end/recipient_documents",
  success: "fetch_success/recipient_documents",
  failed: "fetch_failed/recipient_documents"
};

var recipientDocumentsFetchStart = function recipientDocumentsFetchStart() {
  return {
    type: RECIPIENT_DOCUMENTS.start
  };
};

var recipientDocumentsFetchEnd = function recipientDocumentsFetchEnd() {
  return {
    type: RECIPIENT_DOCUMENTS.end
  };
};

var recipientDocumentsFetchSuccess = function recipientDocumentsFetchSuccess(data, categoryList) {
  return {
    type: RECIPIENT_DOCUMENTS.success,
    data: data,
    categoryList: categoryList
  };
};

var recipientDocumentsFetchFailed = function recipientDocumentsFetchFailed(error) {
  return {
    type: RECIPIENT_DOCUMENTS.failed,
    error: error
  };
};

var createDocumentCategoryList = function createDocumentCategoryList(dataArray) {
  var array = [];
  dataArray.forEach(function (item) {
    if (array.length !== 0) {
      var flag = true;
      array.forEach(function (data) {
        if (data.label == item.category_name) {
          flag = false;
        }
      });
      if (flag) {
        array.push({
          label: item.category_name,
          value: item.category
        });
      }
    } else {
      array.push({
        label: item.category_name,
        value: item.category
      });
    }
  });
  return array;
};

var fetchRecipientDocuments = function fetchRecipientDocuments(code, year, category) {
  return function (dispatch, getState) {
    var categoryList = [];
    dispatch(recipientDocumentsFetchStart());
    category = !category ? "" : category;
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_COUNTRTY_DOCUMENTS(code, year, category)).then(function (resp) {
        if (resp.success && resp.data) {
          if (category == "") {
            categoryList = createDocumentCategoryList(resp.data.data);
          } else {
            categoryList = getState().recipientProfile.documentList.categoryList;
          }
          dispatch(recipientDocumentsFetchEnd());
          dispatch(recipientDocumentsFetchSuccess(resp.data, categoryList));
        } else {
          dispatch(recipientDocumentsFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(recipientDocumentsFetchEnd());
        dispatch(recipientDocumentsFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "24AF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SELECTED_SDG; });
/* unused harmony export setSDG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateSDG; });
var SET_SELECTED_SDG = "SET_SELECTED_SDG";

function setSDG(sdg_code) {
  return {
    type: SET_SELECTED_SDG,
    sdgSelected: sdg_code
  };
}

var updateSDG = function updateSDG(sdg_code) {
  return function (dispatch) {
    dispatch(setSDG(sdg_code));
  };
};

/***/ }),

/***/ "2AgP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAP_YEAR_TIMELINE; });
/* unused harmony export yearListFetchStart */
/* unused harmony export yearListFetchEnd */
/* unused harmony export yearListFetchSuccess */
/* unused harmony export yearListFetchFailed */
/* unused harmony export updateCurrentYear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateMapYearTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setMapCurrentYear; });
var MAP_YEAR_TIMELINE = {
  start: "fetch_start/map_year_timeline",
  end: "fetch_end/map_year_timeline",
  success: "fetch_success/map_year_timeline",
  failed: "fetch_failed/map_year_timeline",
  setYear: "set_map_current_year"
};

var yearListFetchStart = function yearListFetchStart() {
  return {
    type: MAP_YEAR_TIMELINE.start
  };
};

var yearListFetchEnd = function yearListFetchEnd() {
  return {
    type: MAP_YEAR_TIMELINE.end
  };
};

var yearListFetchSuccess = function yearListFetchSuccess(data) {
  return {
    type: MAP_YEAR_TIMELINE.success,
    data: data
  };
};

var yearListFetchFailed = function yearListFetchFailed(error) {
  return {
    type: MAP_YEAR_TIMELINE.failed,
    error: error
  };
};
var updateCurrentYear = function updateCurrentYear(year) {
  return {
    type: MAP_YEAR_TIMELINE.setYear,
    year: year
  };
};

var updateMapYearTimeline = function updateMapYearTimeline(year) {
  return function (dispatch, getState) {
    dispatch(yearListFetchStart());
    var yearList = [].concat(getState().projectTimeline.year);
    dispatch(yearListFetchEnd());

    var currentYear = year ? year : yearList[0];
    dispatch(yearListFetchSuccess(yearList.reverse()));
    dispatch(updateCurrentYear(currentYear));
  };
};

var setMapCurrentYear = function setMapCurrentYear(year) {
  return function (dispatch) {
    dispatch(updateCurrentYear(year));
  };
};

/***/ }),

/***/ "2Ed7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GENERAL_INFO; });
/* unused harmony export generalInfoFetchStart */
/* unused harmony export generalInfoFetchEnd */
/* unused harmony export generalInfoFetchSuccess */
/* unused harmony export generalInfoFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGeneralInfoData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_lib_api__ = __webpack_require__("TOh2");


var GENERAL_INFO = {
  start: "fetch_start/general_info",
  end: "fetch_end/general_info",
  success: "fetch_success/general_info",
  failed: "fetch_failed/general_info"
};
var generalInfoFetchStart = function generalInfoFetchStart() {
  return {
    type: GENERAL_INFO.start
  };
};
var generalInfoFetchEnd = function generalInfoFetchEnd() {
  return {
    type: GENERAL_INFO.end
  };
};
var generalInfoFetchSuccess = function generalInfoFetchSuccess(data) {
  return {
    type: GENERAL_INFO.success,
    data: data
  };
};
var generalInfoFetchFailed = function generalInfoFetchFailed(error) {
  return {
    type: GENERAL_INFO.failed,
    error: error
  };
};
var fetchGeneralInfoData = function fetchGeneralInfoData() {
  return function (dispatch) {
    dispatch(generalInfoFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_GENERAL_INFO).then(function (resp) {
      dispatch(generalInfoFetchEnd());
      dispatch(generalInfoFetchSuccess(resp));
    }).catch(function (exception) {
      dispatch(generalInfoFetchEnd());
      dispatch(generalInfoFetchFailed());
    });
  };
};

/***/ }),

/***/ "2q2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var getActions = function getActions(resource) {
  return {
    start: "fetch_start/pie_chart_data/" + resource,
    success: "fetch_success/pie_chart_data/" + resource,
    error: "fetch_error/pie_chart_data/" + resource
  };
};

var fetchStart = function fetchStart(resource) {
  return {
    type: getActions(resource).start
  };
};

var fetchSuccess = function fetchSuccess(resource, data) {
  return {
    type: getActions(resource).success,
    data: data
  };
};

var fetchError = function fetchError(resource, error) {
  return {
    type: getActions(resource).error,
    error: error
  };
};

var getResource = function getResource(resource) {
  return function (year, field_of_operation, sector_vocabulary) {
    return function (dispatch) {
      dispatch(fetchStart(resource));
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PIE_CHART_DATA(year, field_of_operation, sector_vocabulary)).then(function (response) {
        return dispatch(fetchSuccess(resource, response.data));
      }).catch(function (error) {
        return dispatch(fetchError(resource, error));
      });
    };
  };
};

var actions = {
  getPortalData: getResource("portal"),
  getSectorsData: getResource("sectors"),
  getSdgData: getResource("sgd"),
  getHomePortalsPieChartData: getResource("homePortals"),
  getHomeSdgsPieChartData: getResource("homeSdgs"),
  getHomeSectorsPieChartData: getResource("homeSectors")
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "3UWZ":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function TempCtor() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}

/***/ }),

/***/ "4SAh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_BASIC; });
/* unused harmony export RecipientBasicFetchStart */
/* unused harmony export RecipientBasicFetchEnd */
/* unused harmony export RecipientBasicClear */
/* unused harmony export RecipientBasicFetchSuccess */
/* unused harmony export RecipientBasicFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadRecipientBasic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var RECIPIENT_BASIC = {
  start: "fetch_start/recipient_basic",
  end: "fetch_end/recipient_basic",
  success: "fetch_success/recipient_basic",
  failed: "fetch_failed/recipient_basic",
  clear: "clear/recipient_basic"
};

var RecipientBasicFetchStart = function RecipientBasicFetchStart() {
  return {
    type: RECIPIENT_BASIC.start
  };
};

var RecipientBasicFetchEnd = function RecipientBasicFetchEnd() {
  return {
    type: RECIPIENT_BASIC.end
  };
};
var RecipientBasicClear = function RecipientBasicClear() {
  return {
    type: RECIPIENT_BASIC.clear
  };
};

var RecipientBasicFetchSuccess = function RecipientBasicFetchSuccess(data) {
  return {
    type: RECIPIENT_BASIC.success,
    data: data
  };
};

var RecipientBasicFetchFailed = function RecipientBasicFetchFailed(error) {
  return {
    type: RECIPIENT_BASIC.failed,
    error: error
  };
};

var loadRecipientBasic = function loadRecipientBasic(code, year) {
  return function (dispatch) {
    dispatch(RecipientBasicFetchStart());
    if (code != "" && year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_COUNTRY_BASIC(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(RecipientBasicFetchEnd());
          dispatch(RecipientBasicFetchSuccess(resp.data));
        } else {
          dispatch(RecipientBasicFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(RecipientBasicFetchEnd());
        dispatch(RecipientBasicFetchFailed(exception));
      });
    } else {
      dispatch(RecipientBasicClear());
      dispatch(RecipientBasicFetchEnd());
    }
  };
};

/***/ }),

/***/ "52Cq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_SUMMARY_DATA; });
/* unused harmony export recipientSummaryDataFetchStart */
/* unused harmony export recipientSummaryDataFetchEnd */
/* unused harmony export recipientSummaryDataFetchSuccess */
/* unused harmony export recipientSummaryDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRecipientSummaryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var RECIPIENT_SUMMARY_DATA = {
  start: "fetch_start/recipient_summary_data",
  end: "fetch_end/recipient_summary_data",
  success: "fetch_success/recipient_summary_data",
  failed: "fetch_failed/recipient_summary_data"
};

var recipientSummaryDataFetchStart = function recipientSummaryDataFetchStart() {
  return {
    type: RECIPIENT_SUMMARY_DATA.start
  };
};

var recipientSummaryDataFetchEnd = function recipientSummaryDataFetchEnd() {
  return {
    type: RECIPIENT_SUMMARY_DATA.end
  };
};

var recipientSummaryDataFetchSuccess = function recipientSummaryDataFetchSuccess(data) {
  return {
    type: RECIPIENT_SUMMARY_DATA.success,
    data: data
  };
};

var recipientSummaryDataFetchFailed = function recipientSummaryDataFetchFailed(error) {
  return {
    type: RECIPIENT_SUMMARY_DATA.failed,
    error: error
  };
};

var getRecipientSummaryData = function getRecipientSummaryData(year, field_of_operation) {
  return function (dispatch) {
    dispatch(recipientSummaryDataFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_SUMMARY_DATA(year, field_of_operation)).then(function (response) {
        dispatch(recipientSummaryDataFetchEnd());
        dispatch(recipientSummaryDataFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(recipientSummaryDataFetchEnd());
        dispatch(recipientSummaryDataFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "6Ifq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COUNTRY_REGIONS_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_SEARCH_TEXT; });
/* unused harmony export countryRegionsFetchStart */
/* unused harmony export countryRegionsFetchEnd */
/* unused harmony export countryRegionsFetchSuccess */
/* unused harmony export updateRegionList */
/* unused harmony export countryRegionsFetchFailed */
/* unused harmony export updateSearchText */
/* unused harmony export getMasterCountryRegionsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return searchCountryRegionsListData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/


var COUNTRY_REGIONS_SEARCH = {
  start: "fetch_start/country_regions_search",
  end: "fetch_end/country_regions_search",
  success: "fetch_success/country_regions_search",
  failed: "fetch_failed/country_regions_search",
  updateList: "update_list/country_regions_search"
};
var UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT";
var countryRegionsFetchStart = function countryRegionsFetchStart() {
  return {
    type: COUNTRY_REGIONS_SEARCH.start
  };
};

var countryRegionsFetchEnd = function countryRegionsFetchEnd() {
  return {
    type: COUNTRY_REGIONS_SEARCH.end
  };
};

var countryRegionsFetchSuccess = function countryRegionsFetchSuccess(countryRegionList) {
  return {
    type: COUNTRY_REGIONS_SEARCH.success,
    countryRegionList: countryRegionList
  };
};

var updateRegionList = function updateRegionList(countryRegionList) {
  return {
    type: COUNTRY_REGIONS_SEARCH.updateList,
    countryRegionList: countryRegionList
  };
};

var countryRegionsFetchFailed = function countryRegionsFetchFailed(error) {
  return {
    type: COUNTRY_REGIONS_SEARCH.failed,
    error: error
  };
};

var updateSearchText = function updateSearchText(text) {
  return {
    type: UPDATE_SEARCH_TEXT,
    text: text
  };
};

var getMasterCountryRegionsList = function getMasterCountryRegionsList() {
  return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_COUNTRYREGION_MASTER).then(function (resp) {
      if (resp && resp.data) {
        dispatch(updateRegionList(resp.data.data));
      }
    });
  };
};

var searchCountryRegionsListData = function searchCountryRegionsListData(searchParam, theme, sdg, donor, year, markerType, markerId, levelTwoMarker) {
  return function (dispatch, getState) {
    dispatch(countryRegionsFetchStart());
    searchParam = searchParam ? searchParam : "";
    donor = donor ? donor : "";
    theme = theme && theme !== -1 ? theme : "";
    sdg = sdg ? sdg : "";
    var currentYear = year ? year : "";
    markerId = markerId ? markerId : "";
    levelTwoMarker = levelTwoMarker ? levelTwoMarker : "";
    markerType = markerType ? markerType : "";

    dispatch(updateSearchText(searchParam));
    var apiCall = __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_COUNTRYREGION_SEARCH(searchParam, theme, sdg, donor, currentYear);
    if (getState().tabData.tabSelected === "signature") apiCall = __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SIGNATURE_COUNTRYREGION_SEARCH(searchParam, theme, sdg, donor, currentYear);

    if (markerType) {
      apiCall = __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SSC_COUNTRY_REGION_SEARCH(searchParam, theme, sdg, donor, currentYear, markerType, markerId, levelTwoMarker);
    }
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(apiCall).then(function (resp) {
      if (resp && resp.data) {
        if (getState().countryRegionSearch.searchText === resp.data.draw) {
          dispatch(countryRegionsFetchEnd());
          dispatch(countryRegionsFetchSuccess(resp.data.data));
        }
      } else {
        dispatch(countryRegionsFetchEnd());
        dispatch(countryRegionsFetchFailed());
      }
    }).catch(function (exception) {
      dispatch(countryRegionsFetchEnd());
      dispatch(countryRegionsFetchFailed());
    });
  };
};

/***/ }),

/***/ "6W2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIGNATURE_SLIDER_DATA; });
/* unused harmony export signatureSliderDataFetchStart */
/* unused harmony export signatureSliderDataFetchEnd */
/* unused harmony export signatureSliderDataClear */
/* unused harmony export signatureSliderDataFetchSuccess */
/* unused harmony export signatureSliderDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSignatureSliderData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var SIGNATURE_SLIDER_DATA = {
  start: "fetch_start/theme_slider_data",
  end: "fetch_end/theme_slider_data",
  success: "fetch_success/theme_slider_data",
  failed: "fetch_failed/theme_slider_data",
  clear: "clear/theme_slider_data"
};

var signatureSliderDataFetchStart = function signatureSliderDataFetchStart() {
  return {
    type: SIGNATURE_SLIDER_DATA.start
  };
};

var signatureSliderDataFetchEnd = function signatureSliderDataFetchEnd() {
  return {
    type: SIGNATURE_SLIDER_DATA.end
  };
};
var signatureSliderDataClear = function signatureSliderDataClear() {
  return {
    type: SIGNATURE_SLIDER_DATA.clear
  };
};

var signatureSliderDataFetchSuccess = function signatureSliderDataFetchSuccess(data) {
  return {
    type: SIGNATURE_SLIDER_DATA.success,
    data: data
  };
};

var signatureSliderDataFetchFailed = function signatureSliderDataFetchFailed(error) {
  return {
    type: SIGNATURE_SLIDER_DATA.failed,
    error: error
  };
};

var fetchSignatureSliderData = function fetchSignatureSliderData(year, sector) {
  return function (dispatch, getState) {
    budgetSources;
    var operatingUnits = "",
        budgetSources = "";
    dispatch(signatureSliderDataFetchStart());
    if (year != "" && sector != "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SIGNATURE_SLIDER_DATA(year, sector, operatingUnits, budgetSources)).then(function (resp) {
        if (resp.success && resp.data) {
          resp.data.aggregate = resp.data.aggregate[0];
          resp.data.aggregate.budget_amount = Number(resp.data.aggregate.budget);
          resp.data.aggregate.percentage = (Number(resp.data.aggregate.expense_amount) * 100 / resp.data.aggregate.budget_amount).toFixed(2);
          resp.data.aggregate.sector_name = resp.data.aggregate.signature_solution;
          resp.data.aggregate.expense_amount = Number(resp.data.aggregate.expense);
          resp.data.aggregate.sector = resp.data.aggregate.ss_id;
          resp.data.aggregate.budget_sources = Number(resp.data.aggregate.donors);
          resp.data.aggregate.countries = resp.data.aggregate.operating_units;
          resp.data.aggregate.outputs = resp.data.aggregate.total_outputs;
          resp.data.aggregate.year = resp.data.aggregate.year.toString();
          dispatch(signatureSliderDataFetchEnd());
          dispatch(signatureSliderDataFetchSuccess(resp.data));
        } else {
          dispatch(signatureSliderDataFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(signatureSliderDataFetchEnd());
        dispatch(signatureSliderDataFetchFailed(exception));
      });
    } else {
      dispatch(signatureSliderDataClear());
      dispatch(signatureSliderDataFetchEnd());
    }
  };
};

/***/ }),

/***/ "6cZ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return YEAR_SUMMARY; });
/* unused harmony export yearSummaryFetchStart */
/* unused harmony export yearSummaryFetchEnd */
/* unused harmony export yearSummaryFetchSuccess */
/* unused harmony export yearSummaryFetchFailed */
/* unused harmony export yearSummaryFetchData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THEME_SUMMARY; });
/* unused harmony export themeSummaryFetchStart */
/* unused harmony export themeSummaryFetchEnd */
/* unused harmony export themeSummaryFetchSuccess */
/* unused harmony export themeSummaryFetchFailed */
/* unused harmony export parseThemeSummaryData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchThemeSummaryData; });
/* unused harmony export SIGNATURE_SUMMARY */
/* unused harmony export signatureSummaryFetchStart */
/* unused harmony export signatureSummaryFetchEnd */
/* unused harmony export signatureSummaryFetchSuccess */
/* unused harmony export signatureSummaryFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchSignatureSummaryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_numberFormatter_js__ = __webpack_require__("Au7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabSection_actions__ = __webpack_require__("PeVu");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var YEAR_SUMMARY = {
  start: "fetch_start/year_summary",
  end: "fetch_end/year_summary",
  success: "fetch_success/year_summary",
  failed: "fetch_failed/year_summary"
};

var yearSummaryFetchStart = function yearSummaryFetchStart() {
  return {
    type: YEAR_SUMMARY.start
  };
};

var yearSummaryFetchEnd = function yearSummaryFetchEnd() {
  return {
    type: YEAR_SUMMARY.end
  };
};

var yearSummaryFetchSuccess = function yearSummaryFetchSuccess(data) {
  return {
    type: YEAR_SUMMARY.success,
    data: data
  };
};

var yearSummaryFetchFailed = function yearSummaryFetchFailed(error) {
  return {
    type: YEAR_SUMMARY.failed,
    error: error
  };
};

var yearSummaryFetchData = function yearSummaryFetchData(year) {
  return function (dispatch) {
    dispatch(yearSummaryFetchStart());
    if (year != null) return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_PROJECT_AGGREGATE + year).then(function (resp) {
      if (resp.success && resp.data) {
        dispatch(yearSummaryFetchEnd());
        dispatch(yearSummaryFetchSuccess(resp.data));
      } else {
        dispatch(yearSummaryFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(yearSummaryFetchEnd());
      dispatch(yearSummaryFetchFailed());
    });
  };
};

////////////// Fetch Theme Summary /////////////////
var THEME_SUMMARY = {
  start: "fetch_start/theme_summary",
  end: "fetch_end/theme_summary",
  success: "fetch_success/theme_summary",
  failed: "fetch_failed/theme_summary"
};

var themeSummaryFetchStart = function themeSummaryFetchStart() {
  return {
    type: THEME_SUMMARY.start
  };
};

var themeSummaryFetchEnd = function themeSummaryFetchEnd() {
  return {
    type: THEME_SUMMARY.end
  };
};

var themeSummaryFetchSuccess = function themeSummaryFetchSuccess(data) {
  return {
    type: THEME_SUMMARY.success,
    data: data
  };
};

var themeSummaryFetchFailed = function themeSummaryFetchFailed(error) {
  return {
    type: THEME_SUMMARY.failed,
    error: error
  };
};

function parseThemeSummaryData(data, selTab) {
  var parsedData = {
    project: _extends({}, data.project),
    sector: []
  };

  var newDataArray = selTab === "signature" ? [].concat(data.signature_solutions) : [].concat(data.sector);
  newDataArray.forEach(function (item, index) {
    item.label = selTab === "signature" ? item.signature_solution : item.sector_name;
    item.share_percent = item.percentage;
    item.value = item.sector;
    item.theme_name = item.sector_name = selTab === "signature" ? item.signature_solution : item.sector_name;
    item.color = "#" + item.color;
    item.total_projects = selTab === "signature" ? item.projects : item.total_projects;
    item.point = 100 + index;
    item.sector = selTab === "signature" ? item.ss_id : item.sector;
  });
  parsedData.sector = newDataArray;
  return parsedData;
}

var fetchThemeSummaryData = function fetchThemeSummaryData(year, source, operatingUnit) {
  return function (dispatch, getState) {
    var themeFilter = getState().tabData.themeFilter,
        budgetSources1 = source || (themeFilter.budgetSources ? themeFilter.budgetSources : ""),
        operatingUnits1 = operatingUnit || (themeFilter.operatingUnits ? themeFilter.operatingUnits : ""),
        newYear = year || getState().tabData.currentYear;
    dispatch(themeSummaryFetchStart());
    if (newYear != null) return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get("" + __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_THEME_AGGREGATE + newYear + "&budget_source=" + budgetSources1 + "&operating_unit=" + operatingUnits1).then(function (resp) {
      if (resp.success && resp.data) {
        if (getState().tabData.tabSelected === "themes") {
          var parsedData = parseThemeSummaryData(resp.data, "themes");
          dispatch(themeSummaryFetchEnd());
          dispatch(themeSummaryFetchSuccess(parsedData));
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__tabSection_actions__["i" /* onTabSelection */])(getState().tabData.tabSelected));
        }
      } else {
        dispatch(themeSummaryFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(themeSummaryFetchEnd());
      dispatch(themeSummaryFetchFailed());
    });
  };
};

////////////// Fetch Signature Summary /////////////////
var SIGNATURE_SUMMARY = {
  start: "fetch_start/theme_summary",
  end: "fetch_end/theme_summary",
  success: "fetch_success/theme_summary",
  failed: "fetch_failed/theme_summary"
};

var signatureSummaryFetchStart = function signatureSummaryFetchStart() {
  return {
    type: SIGNATURE_SUMMARY.start
  };
};

var signatureSummaryFetchEnd = function signatureSummaryFetchEnd() {
  return {
    type: SIGNATURE_SUMMARY.end
  };
};

var signatureSummaryFetchSuccess = function signatureSummaryFetchSuccess(data) {
  return {
    type: SIGNATURE_SUMMARY.success,
    data: data
  };
};

var signatureSummaryFetchFailed = function signatureSummaryFetchFailed(error) {
  return {
    type: SIGNATURE_SUMMARY.failed,
    error: error
  };
};

var fetchSignatureSummaryData = function fetchSignatureSummaryData(year, source, operatingUnit) {
  return function (dispatch, getState) {
    var signatureFilter = getState().tabData.themeFilter,
        budgetSources1 = source || (signatureFilter.budgetSources ? signatureFilter.budgetSources : ""),
        operatingUnits1 = operatingUnit || (signatureFilter.operatingUnits ? signatureFilter.operatingUnits : ""),
        newYear = year || getState().tabData.currentYear;
    dispatch(signatureSummaryFetchStart());
    if (newYear != null) return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get("" + __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_SIGNATURE_AGGREGATE + newYear + "&budget_source=" + budgetSources1 + "&operating_unit=" + operatingUnits1).then(function (resp) {
      if (resp.success && resp.data) {
        if (getState().tabData.tabSelected === "signature") {
          var parsedData = parseThemeSummaryData(resp.data, "signature");
          dispatch(signatureSummaryFetchEnd());
          dispatch(signatureSummaryFetchSuccess(parsedData));
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__tabSection_actions__["i" /* onTabSelection */])(getState().tabData.tabSelected));
        }
      } else {
        dispatch(signatureSummaryFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(signatureSummaryFetchEnd());
      dispatch(signatureSummaryFetchFailed());
    });
  };
};

/***/ }),

/***/ "6dIb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActions; });
/* unused harmony export _actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var getActions = function getActions(resource) {
  return {
    start: "fetch_start/filters_data/" + resource,
    success: "fetch_success/filters_data/" + resource,
    error: "fetch_error/filters_data/" + resource
  };
};

var fetchStart = function fetchStart(resource) {
  return {
    type: getActions(resource).start
  };
};

var fetchSuccess = function fetchSuccess(resource, data) {
  return {
    type: getActions(resource).success,
    data: data
  };
};

var fetchError = function fetchError(resource, error) {
  return {
    type: getActions(resource).error,
    error: error
  };
};

var getResource = function getResource(resource) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return function (filter) {
    return function (dispatch) {
      if (filter) {
        dispatch(fetchStart(resource));
        return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_FILTERS(url || resource, defaultFilter ? "?" + defaultFilter + "&name=" + filter : "?name=" + filter)).then(function (response) {
          return dispatch(fetchSuccess(resource, response.data));
        }).catch(function (error) {
          return dispatch(fetchError(resource, error));
        });
      } else {
        dispatch(fetchSuccess(resource, []));
      }
    };
  };
};

var actions = {
  getDonors: getResource("donors"),
  getFields: getResource("fields"),
  getPortals: getResource("portals"), // getPortals: getResource("portals", "portals", "year=2020"),
  getSdgs: getResource("sdgs", "sectors", "sector_vocabulary__code=7"),
  getOecds: getResource("oecds", "sectors", "sector_vocabulary__code=1"),
  getHomeFields: getResource("homeFields", "fields"),
  getHomeDonors: getResource("homeDonors", "donors"),
  getHomeSdgs: getResource("homeSdgs", "sectors", "sector_vocabulary__code=7"),
  getHomeSectors: getResource("homeSectors", "sectors", "sector_vocabulary__code=2")
};

var _getResource = function _getResource(resource) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return function (filter) {
    return function (dispatch) {
      if (filter) {
        dispatch(fetchStart(resource));
        return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_FILTERS(url || resource, defaultFilter ? "?" + defaultFilter + "&name=" + filter : "?name=" + filter)).then(function (response) {
          return dispatch(fetchSuccess(resource, response.data));
        }).catch(function (error) {
          return dispatch(fetchError(resource, error));
        });
      } else {
        dispatch(fetchSuccess(resource, []));
      }
    };
  };
};

var _actions = function _actions(filters) {
  return {
    getPortals: _getResource("portals", "portals", filters)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "6ofl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_FUND_LIST; });
/* unused harmony export donorFundListFetchStart */
/* unused harmony export donorFundListFetchEnd */
/* unused harmony export donorFundListFetchSuccess */
/* unused harmony export donorFundListFetchFailed */
/* unused harmony export parseDonorFundListData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDonorFundListData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tabSection_actions__ = __webpack_require__("PeVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_numberFormatter__ = __webpack_require__("Au7/");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Lib Files ************************/


/************************* Lib Files ************************/


/************************* Util Files ************************/


var DONOR_FUND_LIST = {
  start: "fetch_start/donor_fund_list",
  end: "fetch_end/donor_fund_list",
  success: "fetch_success/donor_fund_list",
  failed: "fetch_failed/donor_fund_list"
};

var donorFundListFetchStart = function donorFundListFetchStart() {
  return {
    type: DONOR_FUND_LIST.start
  };
};

var donorFundListFetchEnd = function donorFundListFetchEnd() {
  return {
    type: DONOR_FUND_LIST.end
  };
};

var donorFundListFetchSuccess = function donorFundListFetchSuccess(data) {
  return {
    type: DONOR_FUND_LIST.success,
    data: data
  };
};

var donorFundListFetchFailed = function donorFundListFetchFailed(error) {
  return {
    type: DONOR_FUND_LIST.failed,
    error: error
  };
};

function parseDonorFundListData(data) {
  var parsedData = {
    project: _extends({}, data.project),
    data: []
  };
  var newDataArray = [].concat(data.data);
  newDataArray.forEach(function (item, index) {
    item.label = item.level_3_name;
    item.share_percent = Object(__WEBPACK_IMPORTED_MODULE_2__utils_numberFormatter__["e" /* roundTo */])(item.percentage ? item.percentage : 0, 1);
    item.value = item;
    item.donor_name = item.level_3_name ? item.level_3_name : "";
    item.budget = item.total_budget ? item.total_budget : "";
    item.expense = item.total_expense ? item.total_expense : "";
    item.color = "#cccfff";
    item.point = 100 + index;
  });
  parsedData.data = newDataArray;
  return parsedData;
}

var fetchDonorFundListData = function fetchDonorFundListData(year, recipentCountry, donor, themes, sdg) {
  return function (dispatch, getState) {
    var donorFilter = getState().tabData.donorFilter,
        recipentCountry = recipentCountry || (donorFilter.operatingUnits ? donorFilter.operatingUnits : ""),
        newthemes = themes || (donorFilter.themes ? donorFilter.themes : ""),
        donor = donor || (donorFilter.budgetSources ? donorFilter.budgetSources : ""),
        sdg = sdg || (donorFilter.sdg ? donorFilter.sdg : ""),
        newYear = year || getState().tabData.currentYear;

    dispatch(donorFundListFetchStart());
    if (newYear !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONOR_FUND_LIST + "?year=" + newYear + "&recipient_countries=" + recipentCountry + "&sectors=" + newthemes + "&donor=" + donor + "&sdg=" + sdg).then(function (resp) {
      if (resp.success && resp.data) {
        dispatch(donorFundListFetchEnd());
        dispatch(donorFundListFetchSuccess(resp.data));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__components_tabSection_actions__["i" /* onTabSelection */])(getState().tabData.tabSelected));
      } else {
        dispatch(donorFundListFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(donorFundListFetchEnd());
      dispatch(donorFundListFetchFailed());
    });
    dispatch(donorFundListFetchFailed());
  };
};

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "8R5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDG_LIST; });
/* unused harmony export sdgListFetchStart */
/* unused harmony export sdgListFetchEnd */
/* unused harmony export sdgListFetchSuccess */
/* unused harmony export sdgListFetchFailed */
/* unused harmony export updateSdgList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchMasterSdgList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchSdgData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files *************************/

var SDG_LIST = {
  start: "fetch_start/sdg_list",
  end: "fetch_end/sdg_list",
  success: "fetch_success/sdg_list",
  failed: "fetch_failed/sdg_list",
  updateList: "update_list/sdg_list"
};
var sdgListFetchStart = function sdgListFetchStart() {
  return {
    type: SDG_LIST.start
  };
};

var sdgListFetchEnd = function sdgListFetchEnd() {
  return {
    type: SDG_LIST.end
  };
};

var sdgListFetchSuccess = function sdgListFetchSuccess(data) {
  return {
    type: SDG_LIST.success,
    data: data
  };
};

var sdgListFetchFailed = function sdgListFetchFailed(data) {
  return {
    type: SDG_LIST.failed,
    data: data
  };
};

var updateSdgList = function updateSdgList(data) {
  return {
    type: SDG_LIST.updateList,
    data: data
  };
};

var parseSdgData = function parseSdgData(dataArray) {
  dataArray.forEach(function (item) {
    item.value = item.code;
    item.label = item.name;
  });
};

var fetchMasterSdgList = function fetchMasterSdgList(year) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_SDGS + ("?year=" + year)).then(function (resp) {
      if (resp) {
        dispatch(sdgListFetchEnd());
        parseSdgData(resp);
        dispatch(updateSdgList(resp));
      }
    });
  };
};

var fetchSdgData = function fetchSdgData(unit, donor, year) {
  return function (dispatch, getState) {
    dispatch(sdgListFetchStart());
    unit = unit ? unit : "";
    donor = donor ? donor : "";
    var currentYear = year ? year : "";
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_SDGS + ("?operating_unit=" + unit + "&donor=" + donor + "&year=" + currentYear)).then(function (resp) {
      if (resp) {
        dispatch(sdgListFetchEnd());
        parseSdgData(resp);
        dispatch(sdgListFetchSuccess(resp));
      } else {
        dispatch(sdgListFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(sdgListFetchEnd());
      dispatch(sdgListFetchFailed());
    });
  };
};

/***/ }),

/***/ "8YPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_WIND_ROSE; });
/* unused harmony export recipientWindRoseFetchStart */
/* unused harmony export recipientWindRoseFetchEnd */
/* unused harmony export recipientWindRoseFetchSuccess */
/* unused harmony export recipientWindRoseFetchFailed */
/* unused harmony export mapSectorName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRecipientWindRose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var RECIPIENT_WIND_ROSE = {
  start: "fetch_start/recipient_wind_rose",
  end: "fetch_end/recipient_wind_rose",
  success: "fetch_success/recipient_wind_rose",
  failed: "fetch_failed/recipient_wind_rose",
  clear: "clear/recipient_wind_rose"
};

var recipientWindRoseFetchStart = function recipientWindRoseFetchStart() {
  return {
    type: RECIPIENT_WIND_ROSE.start
  };
};

var recipientWindRoseFetchEnd = function recipientWindRoseFetchEnd() {
  return {
    type: RECIPIENT_WIND_ROSE.end
  };
};

var recipientWindRoseFetchSuccess = function recipientWindRoseFetchSuccess(data, initialSector, year, sectorColor) {
  return {
    type: RECIPIENT_WIND_ROSE.success,
    data: data,
    initialSector: initialSector,
    year: year,
    sectorColor: sectorColor
  };
};

var recipientWindRoseFetchFailed = function recipientWindRoseFetchFailed(error) {
  return {
    type: RECIPIENT_WIND_ROSE.failed,
    error: error
  };
};

var mapSectorName = function mapSectorName(themeList, sector) {
  return themeList.filter(function (item) {
    return item.code == sector;
  });
};

var fetchRecipientWindRose = function fetchRecipientWindRose(code, year, sector) {
  return function (dispatch, getState) {
    dispatch(recipientWindRoseFetchStart());
    sector = !sector ? "" : sector;
    if (year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_WIND_ROSE(code, year, sector)).then(function (resp) {
        if (resp.success && resp.data) {
          var sectorName = mapSectorName(getState().themeList.themes, resp.data.sector)[0] ? mapSectorName(getState().themeList.themes, resp.data.sector)[0].label : "";

          dispatch(recipientWindRoseFetchEnd());
          dispatch(recipientWindRoseFetchSuccess(resp.data.consolidate, sectorName, resp.data.year, resp.data.sector_color));
        } else {
          dispatch(recipientWindRoseFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(recipientWindRoseFetchEnd());
        dispatch(recipientWindRoseFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "91gb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var core_namespaceObject = {};
__webpack_require__.d(core_namespaceObject, "initialize", function() { return initialize; });
__webpack_require__.d(core_namespaceObject, "ga", function() { return ga; });
__webpack_require__.d(core_namespaceObject, "set", function() { return set; });
__webpack_require__.d(core_namespaceObject, "send", function() { return send; });
__webpack_require__.d(core_namespaceObject, "pageview", function() { return pageview; });
__webpack_require__.d(core_namespaceObject, "modalview", function() { return modalview; });
__webpack_require__.d(core_namespaceObject, "timing", function() { return timing; });
__webpack_require__.d(core_namespaceObject, "event", function() { return core_event; });
__webpack_require__.d(core_namespaceObject, "exception", function() { return exception; });
__webpack_require__.d(core_namespaceObject, "plugin", function() { return core_plugin; });
__webpack_require__.d(core_namespaceObject, "outboundLink", function() { return outboundLink; });
__webpack_require__.d(core_namespaceObject, "testModeAPI", function() { return core_testModeAPI; });
__webpack_require__.d(core_namespaceObject, "default", function() { return core; });

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/console/warn.js
function warn(s) {
  console.warn('[react-ga]', s);
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/components/OutboundLink.js
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink_OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return preact_compat_es["default"].createElement('a', props);
    }
  }]);

  return OutboundLink;
}(preact_compat_es["Component"]);

_defineProperty(OutboundLink_OutboundLink, "trackLink", function () {
  warn('ga tracking not enabled');
});

_defineProperty(OutboundLink_OutboundLink, "propTypes", {
  eventLabel: prop_types_default.a.string.isRequired,
  target: prop_types_default.a.string,
  to: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  trackerNames: prop_types_default.a.arrayOf(prop_types_default.a.string)
});

_defineProperty(OutboundLink_OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});


// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/mightBeEmail.js
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/trim.js
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/toTitleCase.js
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return trim(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/format.js



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (mightBeEmail(s)) {
    warn('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return toTitleCase(s);
  }

  return s;
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/removeLeadingSlash.js
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/loadGA.js
/* harmony default export */ var loadGA = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */

  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */
});
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/console/log.js
function log(s) {
  console.info('[react-ga]', s);
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/testModeAPI.js
var gaCalls = [];
/* harmony default export */ var testModeAPI = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/core.js
function core__objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = core__objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function core__objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function core_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function core__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      core_ownKeys(source, true).forEach(function (key) {
        core__defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      core_ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function core__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function core__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    core__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    core__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return core__typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  }
}

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var core_internalGa = function internalGa() {
  var _window;

  if (_testMode) return testModeAPI.ga.apply(testModeAPI, arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return warn('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return format(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof core_internalGa === 'function') {
    if (typeof command !== 'string') {
      warn('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) core_internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        core_internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    warn('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    core_internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    core_internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) loadGA(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (core__typeof(config) !== 'object') {
        warn('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    core_internalGa.apply(void 0, args);

    if (_debug) {
      log('called ga(\'arguments\');');
      log("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    warn('`fieldsObject` is required in .set()');
    return;
  }

  if (core__typeof(fieldsObject) !== 'object') {
    warn('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    warn('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    log('called ga(\'set\', fieldsObject);');
    log("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    log('called ga(\'send\', fieldObject);');
    log("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    log("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    warn('path is required in .pageview()');
    return;
  }

  var path = trim(rawPath);

  if (path === '') {
    warn('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', core__objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      log('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      log("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    warn('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = removeLeadingSlash(trim(rawModalName));

  if (modalName === '') {
    warn('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      log('called ga(\'send\', \'pageview\', path);');
      log("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      warn('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function core_event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = core__objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      warn('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        warn('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        warn('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        warn('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          warn('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        warn('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var core_plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        warn('`name` is required in .require()');
        return;
      }

      var name = trim(rawName);

      if (name === '') {
        warn('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (core__typeof(options) !== 'object') {
          warn('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          warn('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          log("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          log("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        warn('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        warn('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            log("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    warn('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      warn('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var core_testModeAPI = testModeAPI;
/* harmony default export */ var core = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: core_event,
  exception: exception,
  plugin: core_plugin,
  outboundLink: outboundLink,
  testModeAPI: testModeAPI
});
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/index.js
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
function esm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function esm__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      esm_ownKeys(source, true).forEach(function (key) {
        esm__defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      esm_ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function esm__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}



var esm_initialize = initialize;
var esm_ga = ga;
var esm_set = set;
var esm_send = send;
var esm_pageview = pageview;
var esm_modalview = modalview;
var esm_timing = timing;
var esm_event = core_event;
var esm_exception = exception;
var esm_plugin = core_plugin;
var esm_outboundLink = outboundLink;
var esm_testModeAPI = core_testModeAPI;
OutboundLink_OutboundLink.origTrackLink = OutboundLink_OutboundLink.trackLink;
OutboundLink_OutboundLink.trackLink = outboundLink;
var esm_OutboundLink = OutboundLink_OutboundLink;
/* harmony default export */ var esm = __webpack_exports__["a"] = (esm__objectSpread({}, core_namespaceObject, {
  OutboundLink: esm_OutboundLink
}));

/***/ }),

/***/ "9KE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GLOBAL_MAP_DATA; });
/* unused harmony export mapDataFetchStart */
/* unused harmony export mapDataFetchEnd */
/* unused harmony export mapDataFetchSuccess */
/* unused harmony export mapDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadGlobalMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/


var GLOBAL_MAP_DATA = {
  start: "fetch_start/global_map_data",
  end: "fetch_end/global_map_data",
  success: "fetch_success/global_map_data",
  failed: "fetch_failed/global_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: GLOBAL_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: GLOBAL_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data) {
  return {
    type: GLOBAL_MAP_DATA.success,
    data: data
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: GLOBAL_MAP_DATA.failed,
    error: error
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var loadGlobalMapData = function loadGlobalMapData(year, unit) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    unit = unit ? unit : "";
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_GLOBAL(year, unit)).then(function (resp) {
      return mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "9TS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("svpX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__("CtKb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("UKR9");




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);

/***/ }),

/***/ "A1ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIGNATURE_OUTCOME_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIGNATURE_OUTCOME_AGGREGATE; });
/* unused harmony export signatureOutcomeFetchStart */
/* unused harmony export signatureOutcomeFetchEnd */
/* unused harmony export signatureOutcomeFetchSuccess */
/* unused harmony export signatureOutcomeClear */
/* unused harmony export signatureOutcomeFetchFailed */
/* unused harmony export updateCountryAggregate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchSignatureOutcome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchSignatureSolutionChartData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__ = __webpack_require__("Cdrj");



var SIGNATURE_OUTCOME_DATA = {
  start: "fetch_start/resources_modality_contribution",
  end: "fetch_end/resources_modality_contribution",
  success: "fetch_success/resources_modality_contribution",
  failed: "fetch_failed/resources_modality_contribution",
  clear: "clear/resources_modality_contribution"
};
var SIGNATURE_OUTCOME_AGGREGATE = "SIGNATURE_OUTCOME_AGGREGATE";

var signatureOutcomeFetchStart = function signatureOutcomeFetchStart() {
  return {
    type: SIGNATURE_OUTCOME_DATA.start
  };
};

var signatureOutcomeFetchEnd = function signatureOutcomeFetchEnd() {
  return {
    type: SIGNATURE_OUTCOME_DATA.end
  };
};

var signatureOutcomeFetchSuccess = function signatureOutcomeFetchSuccess(data) {
  return {
    type: SIGNATURE_OUTCOME_DATA.success,
    data: data
  };
};
var signatureOutcomeClear = function signatureOutcomeClear() {
  return {
    type: SIGNATURE_OUTCOME_DATA.clear
  };
};

var signatureOutcomeFetchFailed = function signatureOutcomeFetchFailed(error) {
  return {
    type: SIGNATURE_OUTCOME_DATA.failed,
    error: error
  };
};

var updateCountryAggregate = function updateCountryAggregate(countryAggregate) {
  return {
    type: SIGNATURE_OUTCOME_AGGREGATE,
    countryAggregate: countryAggregate
  };
};
var fetchSignatureOutcome = function fetchSignatureOutcome(code, year) {
  return function (dispatch, getState) {
    dispatch(signatureOutcomeFetchStart());
    if (year != "" && code != "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SIGNATURE_OUTCOME(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          resp.data.percentage.sort(function (a, b) {
            return Number(b.percent) - Number(a.percent);
          });
          if (resp.data.percentage.length) {
            resp.data.percentage.forEach(function (item, index) {
              item.percentage = item.percent;
              item.fund_stream = item.sector_name;
              item.color = item.sector_color;
            });
            resp.data.total = resp.data.percentage;
            resp.data.country = resp.data.total;
          }
          dispatch(signatureOutcomeFetchEnd());
          dispatch(signatureOutcomeFetchSuccess(resp.data));
        } else {
          dispatch(signatureOutcomeFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(signatureOutcomeFetchEnd());
        dispatch(signatureOutcomeFetchFailed(exception));
      });
    } else {
      dispatch(signatureOutcomeClear());
      dispatch(signatureOutcomeFetchEnd());
    }
  };
};
var fetchSignatureSolutionChartData = function fetchSignatureSolutionChartData(code, year) {
  return function (dispatch, getState) {
    dispatch(signatureOutcomeFetchStart());
    if (year != "" && code != "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_FETCH_SIGNATURE_SOLUTION_CHART_DATA(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          if (resp.data.percentage.length) {
            resp.data.percentage.forEach(function (item, index) {
              item.percentage = item.percent;
              item.fund_stream = item.signature_solution_name;
              item.color = item.color;
            });
            resp.data.percentage.sort(function (a, b) {
              return Number(a.signature_solution_id) - Number(b.signature_solution_id);
            });
            resp.data.country = resp.data.total = resp.data.percentage;
          }
          dispatch(signatureOutcomeFetchEnd());
          dispatch(signatureOutcomeFetchSuccess(resp.data));
        } else {
          dispatch(signatureOutcomeFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(signatureOutcomeFetchEnd());
        dispatch(signatureOutcomeFetchFailed(exception));
      });
    } else {
      dispatch(signatureOutcomeClear());
      dispatch(signatureOutcomeFetchEnd());
    }
  };
};

/***/ }),

/***/ "Ann0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HOME_MAP_DATA; });
/* unused harmony export homeMapDataFetchStart */
/* unused harmony export homeMapDataFetchEnd */
/* unused harmony export homeMapDataFetchSuccess */
/* unused harmony export homeMapDataFetchFailed */
/* unused harmony export homeMapDataReset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHomeMapData; });
/* unused harmony export resetHomeMapData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var HOME_MAP_DATA = {
  start: "fetch_start/home_map_data",
  end: "fetch_end/home_map_data",
  success: "fetch_success/home_map_data",
  failed: "fetch_failed/home_map_data",
  reset: "reset/home_map_data"
};

var homeMapDataFetchStart = function homeMapDataFetchStart() {
  return {
    type: HOME_MAP_DATA.start
  };
};

var homeMapDataFetchEnd = function homeMapDataFetchEnd() {
  return {
    type: HOME_MAP_DATA.end
  };
};

var homeMapDataFetchSuccess = function homeMapDataFetchSuccess(data) {
  return {
    type: HOME_MAP_DATA.success,
    data: data
  };
};

var homeMapDataFetchFailed = function homeMapDataFetchFailed(error) {
  return {
    type: HOME_MAP_DATA.failed,
    error: error
  };
};

var homeMapDataReset = function homeMapDataReset() {
  return {
    type: HOME_MAP_DATA.success
  };
};

var getHomeMapData = function getHomeMapData(year, field, donor, vocabulary) {
  return function (dispatch) {
    dispatch(homeMapDataFetchStart());
    var filterYear = year || "";
    var filterField = field || undefined;
    var filterDonor = donor || undefined;
    var filterVocabulary = vocabulary || undefined;
    if (year !== "") return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_HOME_MAP_DATA(filterYear, filterField, filterDonor, filterVocabulary)).then(function (response) {
      dispatch(homeMapDataFetchEnd());
      dispatch(homeMapDataFetchSuccess(response.data));
    }).catch(function (exception) {
      dispatch(homeMapDataFetchEnd());
      dispatch(homeMapDataFetchFailed(exception));
    });else {
      dispatch(homeMapDataFetchEnd());
      dispatch(homeMapDataFetchFailed());
    }
  };
};

var resetHomeMapData = function resetHomeMapData() {
  return function (dispatch) {
    dispatch(homeMapDataReset());
  };
};

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "Au7/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = numberToCurrencyFormatter;
/* harmony export (immutable) */ __webpack_exports__["b"] = numberToCommaFormatter;
/* harmony export (immutable) */ __webpack_exports__["d"] = numberToDollarFormatter;
/* harmony export (immutable) */ __webpack_exports__["e"] = roundTo;
/* unused harmony export hasNumber */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPercentage;
/******************** Number-abbreviate to currency ***********************/
function numberToCurrencyFormatter(input, decimals, chart) {
  var exp = void 0,
      rounded = void 0,
      suffixes = ["K", "M", "B", "T", "P", "E"],
      prefix = "$";
  if (input < 0) {
    prefix = "-$";
  }

  input = Math.abs(input);
  if (window.isNaN(input)) {
    return null;
  }
  if (input < 1000) {
    return prefix + input;
  }
  exp = Math.floor(Math.log(input) / Math.log(1000));
  if (exp > 2) exp = 2;
  rounded = (input / Math.pow(1000, exp)).toFixed(decimals);
  chart === 1 ? rounded = rounded % 1 === 0 ? parseFloat(rounded).toFixed(0) : rounded : null;
  return prefix + rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + suffixes[exp - 1];
}

/**************** Numbers with thousands separators *************************/
function numberToCommaFormatter(input) {
  return parseInt(input, 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**************** Number To Dollar Formatter ********************************/
function numberToDollarFormatter(input) {
  var prefix = "$";
  if (input < 0) {
    prefix = "-$";
  }
  input = Math.abs(parseInt(input, 10));
  return prefix + input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**************** RoundOff Function *****************************************/
function roundTo(number, digits) {
  var multiplier = Math.pow(10, digits),
      adjustedNum = number * multiplier,
      truncatedNum = Math[adjustedNum < 0 ? "ceil" : "floor"](adjustedNum);
  return truncatedNum / multiplier;
}
function hasNumber(string) {
  return (/\d/.test(string)
  );
}
function formatPercentage(percentage) {
  return Number(percentage).toFixed(1).toString().replace(".0", "");
}

/***/ }),

/***/ "B37S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEARCH_ALL_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_SEARCH_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateSearchText; });
/* unused harmony export searchAllFetchStart */
/* unused harmony export ssearchAllFetchEnd */
/* unused harmony export searchAllFetchSuccess */
/* unused harmony export searchAllFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return searchAllResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/

var SEARCH_ALL_RESULTS = {
  start: "fetch_start/search_all_results",
  end: "fetch_end/search_all_results",
  success: "fetch_success/search_all_results",
  failed: "fetch_failed/search_all_results"
};

var UPDATE_SEARCH_TEXT = "update_search_text/search_all_results";

var updateSearchText = function updateSearchText(text) {
  return {
    type: UPDATE_SEARCH_TEXT,
    text: text
  };
};

var searchAllFetchStart = function searchAllFetchStart() {
  return {
    type: SEARCH_ALL_RESULTS.start
  };
};

var ssearchAllFetchEnd = function ssearchAllFetchEnd() {
  return {
    type: SEARCH_ALL_RESULTS.end
  };
};

var searchAllFetchSuccess = function searchAllFetchSuccess(data, totalCount) {
  return {
    type: SEARCH_ALL_RESULTS.success,
    data: data,
    totalCount: totalCount
  };
};

var searchAllFetchFailed = function searchAllFetchFailed(error) {
  return {
    type: SEARCH_ALL_RESULTS.failed,
    error: error
  };
};

var searchAllResults = function searchAllResults(filterObj) {
  var filterQueryString = {
    country: "",
    themes: "",
    sources: "",
    search: "",
    year: "",
    pageIndex: "",
    pageSize: "",
    sdgs: ""
  };

  var _loop = function _loop(key) {
    filterQueryString[key] = "";
    if (key != "search" && key != "pageIndex" && key != "pageSize") {
      var filterItemlength = filterObj[key].length;
      if (filterItemlength != 0) {
        filterObj[key].forEach(function (item, index) {
          if (filterItemlength - 1 != index) filterQueryString[key] = filterQueryString[key] + item.value + ",";else filterQueryString[key] = filterQueryString[key] + item.value;
        });
      }
    }
  };

  for (var key in filterObj) {
    _loop(key);
  }

  return function (dispatch) {
    dispatch(searchAllFetchStart());
    var queryString = __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SEARCH_RESULT + "year=" + filterQueryString.year + "&keyword=" + filterObj.search + "&budget_sources=" + filterQueryString.sources + "&sectors=" + filterQueryString.themes + "&operating_units=" + filterQueryString.country + "&limit=" + filterObj.pageSize + "&offset=" + (filterObj.pageIndex - 1) * filterObj.pageSize + "&sdgs=" + filterQueryString.sdgs;
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(queryString).then(function (resp) {
      dispatch(ssearchAllFetchEnd());
      dispatch(searchAllFetchSuccess(resp.data.data, resp.data.count));
    }).catch(function (exception) {
      dispatch(ssearchAllFetchEnd());
      dispatch(searchAllFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "Bp+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_COUNTRY_SELECTED; });
/* unused harmony export setCountrySelected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateCountrySelected; });
var SET_COUNTRY_SELECTED = "SET_COUNTRY_SELECTED";

function setCountrySelected(value) {
  return {
    type: SET_COUNTRY_SELECTED,
    value: value
  };
}

var updateCountrySelected = function updateCountrySelected(value) {
  return function (dispatch, getState) {
    dispatch(setCountrySelected(value));
  };
};

/***/ }),

/***/ "CFDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAR_CHART_DATA; });
/* unused harmony export markerBarChartDataFetchStart */
/* unused harmony export markerBarChartDataFetchEnd */
/* unused harmony export markerBarChartDataClear */
/* unused harmony export markerBarChartDataFetchSuccess */
/* unused harmony export markerBarChartDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchMarkerBarChartData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var BAR_CHART_DATA = {
  start: "fetch_start/bar_chart_data",
  end: "fetch_end/bar_chart_data",
  success: "fetch_success/bar_chart_data",
  failed: "fetch_failed/bar_chart_data",
  clear: "clear/bar_chart_data"
};

var markerBarChartDataFetchStart = function markerBarChartDataFetchStart() {
  return {
    type: BAR_CHART_DATA.start
  };
};

var markerBarChartDataFetchEnd = function markerBarChartDataFetchEnd() {
  return {
    type: BAR_CHART_DATA.end
  };
};
var markerBarChartDataClear = function markerBarChartDataClear() {
  return {
    type: BAR_CHART_DATA.clear
  };
};

var markerBarChartDataFetchSuccess = function markerBarChartDataFetchSuccess(data) {
  return {
    type: BAR_CHART_DATA.success,
    data: data
  };
};

var markerBarChartDataFetchFailed = function markerBarChartDataFetchFailed(error) {
  return {
    type: BAR_CHART_DATA.failed,
    error: error
  };
};

var fetchMarkerBarChartData = function fetchMarkerBarChartData(year, markerId, country, marker_id, levelTwoMarker) {
  country ? null : country = "";
  marker_id ? null : marker_id = "";
  levelTwoMarker = levelTwoMarker ? levelTwoMarker : "";
  return function (dispatch, getState) {
    dispatch(markerBarChartDataFetchStart());
    if (year !== "" && markerId !== "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MARKER_BARCHART_DATA(year, markerId, country, marker_id, levelTwoMarker)).then(function (resp) {
        if (resp.success && resp.data) {
          resp.data.aggregate = resp.data.aggregate && resp.data.aggregate.length ? resp.data.aggregate[0] : {};
          dispatch(markerBarChartDataFetchEnd());
          dispatch(markerBarChartDataFetchSuccess(resp.data));
        } else {
          dispatch(markerBarChartDataFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(markerBarChartDataFetchEnd());
        dispatch(markerBarChartDataFetchFailed(exception));
      });
    } else {
      dispatch(markerBarChartDataClear());
      dispatch(markerBarChartDataFetchEnd());
    }
  };
};

/***/ }),

/***/ "Cdrj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return openInNewTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAPIBaseUrRl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadUrlGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PreviewUrlGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return aggregateCalculator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSSCMarkerColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUniqueLatLngArray; });
/* unused harmony export DownloadCSVUrlGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/**************** open Embed Links In New Tab *************************/

var openInNewTab = function openInNewTab(url, callbk) {
  var param = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "_blank";

  try {
    var win = window.open(url, param);
    if (win) {
      callbk();
    } else {
      throw new Error("window-open-error");
    }
  } catch (err) {
    if (err === "window-open-error") {
      //handle window open error
    }
  }
};

var getAPIBaseUrRl = function getAPIBaseUrRl(dataSet, key) {
  return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].S3_BASE_URL;
};

var DownloadUrlGenerator = function DownloadUrlGenerator(path) {
  return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].DOWNLOAD_PDF(path);
};

var PreviewUrlGenerator = function PreviewUrlGenerator(path) {
  return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_BASE + path;
};

var aggregateCalculator = function aggregateCalculator(dataSet, key) {
  var total = 0;
  dataSet.forEach(function (item, index) {
    total = total + parseFloat(item[key]);
  });
  return total;
};
var getSSCMarkerColor = function getSSCMarkerColor(type) {
  var colors = [{ type: 1, color: "#0099FF" }, { type: 2, color: "#CC0000" }, { type: 3, color: "#FF6600" }],
      item = colors[_.findIndex(colors, { type: type })];
  return item.color;
};
var getUniqueLatLngArray = function getUniqueLatLngArray(array) {
  return _.unique(array, function (e) {
    return e.lat && e.lng;
  });
};

var DownloadCSVUrlGenerator = function DownloadCSVUrlGenerator(path) {
  return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].DOWNLOAD_CSV(path);
};

/***/ }),

/***/ "CeE8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"image_sizewrapper":"image_sizewrapper__aSC4s"};

/***/ }),

/***/ "Cic2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTION_TYPE_FETCH_YEAR_SUMMARY_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE_FETCH_YEAR_SUMMARY_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchYearSummary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var ACTION_TYPE_FETCH_YEAR_SUMMARY_START = "ACTION_TYPE_FETCH_YEAR_SUMMARY_START";
var ACTION_TYPE_FETCH_YEAR_SUMMARY_END = "ACTION_TYPE_FETCH_YEAR_SUMMARY_END";
var ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR = "ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR";

var fetchYearSummaryStart = function fetchYearSummaryStart() {
  return {
    type: ACTION_TYPE_FETCH_YEAR_SUMMARY_START
  };
};

var fetchYearSummaryEnd = function fetchYearSummaryEnd(data) {
  return {
    type: ACTION_TYPE_FETCH_YEAR_SUMMARY_END,
    data: data
  };
};

var fetchYearSummaryError = function fetchYearSummaryError(error) {
  return {
    type: ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR,
    error: error
  };
};

var fetchYearSummary = function fetchYearSummary(year) {
  return function (dispatch) {
    dispatch(fetchYearSummaryStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_HOME_SUMMARY_DATA(year)).then(function (response) {
      dispatch(fetchYearSummaryEnd(response.data));
    }).catch(function (error) {
      dispatch(fetchYearSummaryError(error));
    });
  };
};

/***/ }),

/***/ "CtKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__("u9EY");


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);

/***/ }),

/***/ "D/4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_BASIC; });
/* unused harmony export donorBasicFetchStart */
/* unused harmony export donorBasicFetchEnd */
/* unused harmony export donorBasicClear */
/* unused harmony export donorBasicFetchSuccess */
/* unused harmony export donorBasicFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDonorBasic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var DONOR_BASIC = {
  start: "fetch_start/donor_basic",
  end: "fetch_end/donor_basic",
  success: "fetch_success/donor_basic",
  failed: "fetch_failed/donor_basic",
  clear: "clear/donor_basic"
};

var donorBasicFetchStart = function donorBasicFetchStart() {
  return {
    type: DONOR_BASIC.start
  };
};

var donorBasicFetchEnd = function donorBasicFetchEnd() {
  return {
    type: DONOR_BASIC.end
  };
};
var donorBasicClear = function donorBasicClear() {
  return {
    type: DONOR_BASIC.clear
  };
};

var donorBasicFetchSuccess = function donorBasicFetchSuccess(data) {
  return {
    type: DONOR_BASIC.success,
    data: data
  };
};

var donorBasicFetchFailed = function donorBasicFetchFailed(error) {
  return {
    type: DONOR_BASIC.failed,
    error: error
  };
};

var fetchDonorBasic = function fetchDonorBasic(code, year) {
  return function (dispatch) {
    dispatch(donorBasicFetchStart());
    if (code != "" && year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONOR_COUNTRY_BASIC(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(donorBasicFetchEnd());
          dispatch(donorBasicFetchSuccess(resp.data));
        } else {
          dispatch(donorBasicFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(donorBasicFetchEnd());
        dispatch(donorBasicFetchFailed(exception));
      });
    } else {
      dispatch(donorBasicClear());
      dispatch(donorBasicFetchEnd());
    }
  };
};

/***/ }),

/***/ "DHvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLastYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatNumberNoFractionDigits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDownloadCsvUrl; });
/* eslint-disable no-mixed-operators */
var getLastYear = function getLastYear() {
  return new Date().getFullYear();
};
var getCurrentYear = function getCurrentYear(generalInfo) {
  var current_year = new Date().getFullYear();
  if (generalInfo && generalInfo.timespan) {
    if (current_year > generalInfo.timespan.max) {
      return generalInfo.timespan.max;
    } else if (current_year < generalInfo.timespan.min) {
      return generalInfo.timespan.min;
    } else {
      return current_year;
    }
  }
  return current_year;
};

var formatNumber = function formatNumber(number) {
  return number && number.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }) || "$ 0";
};

var formatNumberNoFractionDigits = function formatNumberNoFractionDigits(number) {
  return number && number.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }) || "0";
};

var getDownloadCsvUrl = function getDownloadCsvUrl(url) {
  return "http://csvdownloader.iatistandard.org/csv/direct_from_registry/?search=&xml=" + url + "&download=true&id=true&format=full";
};

/***/ }),

/***/ "E/bI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* unused harmony export ReactReduxContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connect; });
/* unused harmony export connectAdvanced */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_context__ = __webpack_require__("ZShz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("fpuT");




function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function invariant() {}

var React = {
  createContext: __WEBPACK_IMPORTED_MODULE_1_preact_context__["createContext"],
  forwardRef: invariant,
  createElement: __WEBPACK_IMPORTED_MODULE_0_preact__["h"]
};

var ReactReduxContext = React.createContext(null);

var Provider = function (_Component) {
  _inheritsLoose(Provider, _Component);
  function Provider(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    var store = props.store;
    _this.state = {
      storeState: store.getState(),
      store: store
    };
    return _this;
  }
  var _proto = Provider.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.subscribe();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    this._isMounted = false;
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.store !== prevProps.store) {
      if (this.unsubscribe) this.unsubscribe();
      this.subscribe();
    }
  };
  _proto.subscribe = function subscribe() {
    var _this2 = this;
    var store = this.props.store;
    this.unsubscribe = store.subscribe(function () {
      var newStoreState = store.getState();
      if (!_this2._isMounted) {
        return;
      }
      _this2.setState(function (providerState) {
        if (providerState.storeState === newStoreState) {
          return null;
        }
        return {
          storeState: newStoreState
        };
      });
    });
    var postMountStoreState = store.getState();
    if (postMountStoreState !== this.state.storeState) {
      this.setState({
        storeState: postMountStoreState
      });
    }
  };
  _proto.render = function render() {
    var Context = this.props.context || ReactReduxContext;
    return React.createElement(Context.Provider, {
      value: this.state
    }, this.props.children);
  };
  return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var c = 60103,
      d = 60106,
      e = 60107,
      f = 60108,
      g = 60114,
      h = 60109,
      k = 60110,
      l = 60111,
      m = 60111,
      n = 60112,
      p = 60113,
      q = 60115,
      r = 60116;
  function t(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case r:
        case q:
        case d:
          return u;
      }
    }
  }
  function v(a) {
    return t(a) === m;
  }
  exports.typeOf = t;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = r;
  exports.Memo = q;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;
  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
  };
  exports.isAsyncMode = function (a) {
    return v(a) || t(a) === l;
  };
  exports.isConcurrentMode = v;
  exports.isContextConsumer = function (a) {
    return t(a) === k;
  };
  exports.isContextProvider = function (a) {
    return t(a) === h;
  };
  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  exports.isForwardRef = function (a) {
    return t(a) === n;
  };
  exports.isFragment = function (a) {
    return t(a) === e;
  };
  exports.isLazy = function (a) {
    return t(a) === r;
  };
  exports.isMemo = function (a) {
    return t(a) === q;
  };
  exports.isPortal = function (a) {
    return t(a) === d;
  };
  exports.isProfiler = function (a) {
    return t(a) === g;
  };
  exports.isStrictMode = function (a) {
    return t(a) === f;
  };
  exports.isSuspense = function (a) {
    return t(a) === p;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;

var reactIs = createCommonjsModule(function (module) {
  {
    module.exports = reactIs_production_min;
  }
});
var reactIs_1 = reactIs.isValidElementType;
var reactIs_2 = reactIs.isContextConsumer;

var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
    return targetComponent;
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;

function connectAdvanced(selectorFactory, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === void 0 ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === void 0 ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === void 0 ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === void 0 ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      _ref$forwardRef = _ref.forwardRef,
      forwardRef = _ref$forwardRef === void 0 ? false : _ref$forwardRef,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? ReactReduxContext : _ref$context,
      connectOptions = _objectWithoutPropertiesLoose(_ref, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
  var customStoreWarningMessage = 'To use a custom Redux store for specific components,  create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);
    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });
    var pure = connectOptions.pure;
    var OuterBaseComponent = __WEBPACK_IMPORTED_MODULE_0_preact__["Component"];
    if (pure) {
      OuterBaseComponent = __WEBPACK_IMPORTED_MODULE_0_preact__["Component"];
    }
    function makeDerivedPropsSelector() {
      var lastProps;
      var lastState;
      var lastDerivedProps;
      var lastStore;
      var lastSelectorFactoryOptions;
      var sourceSelector;
      return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
        if (pure && lastProps === props && lastState === state) {
          return lastDerivedProps;
        }
        if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
          lastStore = store;
          lastSelectorFactoryOptions = selectorFactoryOptions;
          sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
        }
        lastProps = props;
        lastState = state;
        var nextProps = sourceSelector(state, props);
        lastDerivedProps = nextProps;
        return lastDerivedProps;
      };
    }
    function makeChildElementSelector() {
      var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
      return function selectChildElement(WrappedComponent, childProps, forwardRef) {
        if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
          lastChildProps = childProps;
          lastForwardRef = forwardRef;
          lastComponent = WrappedComponent;
          lastChildElement = React.createElement(WrappedComponent, _extends({}, childProps, {
            ref: forwardRef
          }));
        }
        return lastChildElement;
      };
    }
    var Connect = function (_OuterBaseComponent) {
      _inheritsLoose(Connect, _OuterBaseComponent);
      function Connect(props) {
        var _this;
        _this = _OuterBaseComponent.call(this, props) || this;
        invariant(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
        _this.selectDerivedProps = makeDerivedPropsSelector();
        _this.selectChildElement = makeChildElementSelector();
        _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind(_assertThisInitialized(_this));
        return _this;
      }
      var _proto = Connect.prototype;
      _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
        return this.renderWrappedComponent(value);
      };
      _proto.renderWrappedComponent = function renderWrappedComponent(value) {
        var storeState = value.storeState,
            store = value.store;
        var wrapperProps = this.props;
        var forwardedRef;
        if (forwardRef) {
          wrapperProps = this.props.wrapperProps;
          forwardedRef = this.props.forwardedRef;
        }
        var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
        return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
      };
      _proto.render = function render() {
        var ContextToUse = this.props.context && this.props.context.Consumer && reactIs_2(React.createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
        return React.createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
      };
      return Connect;
    }(OuterBaseComponent);
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    if (forwardRef) {
      var forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        return React.createElement(Connect, {
          wrapperProps: props,
          forwardedRef: ref
        });
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }
    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}

var hasOwn = Object.prototype.hasOwnProperty;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;
  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);
    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;
    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };
    proxy.dependsOnOwnProps = true;
    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);
      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }
      return props;
    };
    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
      }
      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;
  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }
  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }
  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);
  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }
  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}
function strictEqual(a, b) {
  return a === b;
}
function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;
  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === void 0 ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === void 0 ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === void 0 ? shallowEqual : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === void 0 ? shallowEqual : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === void 0 ? shallowEqual : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref2, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      methodName: 'connect',
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      shouldHandleStateChanges: Boolean(mapStateToProps),
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
var connect = createConnect();

var index = {
  Provider: Provider,
  connect: connect,
  connectAdvanced: connectAdvanced,
  ReactReduxContext: ReactReduxContext
};

/* unused harmony default export */ var _unused_webpack_default_export = (index);

//# sourceMappingURL=preact-redux.esm.js.map

/***/ }),

/***/ "E1kG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_SELCTED_ARC_BAR_CHART_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateBarChartOnArcHover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var UPDATE_SELCTED_ARC_BAR_CHART_DATA = "UPDATE_SELCTED_ARC_BAR_CHART_DATA";

var updateBarChartOnArcHover = function updateBarChartOnArcHover(data) {
  return {
    type: UPDATE_SELCTED_ARC_BAR_CHART_DATA,
    data: data
  };
};

/***/ }),

/***/ "EIKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YEAR_LIST; });
/* unused harmony export yearListFetchStart */
/* unused harmony export yearListFetchEnd */
/* unused harmony export yearListFetchSuccess */
/* unused harmony export yearListFetchFailed */
/* unused harmony export updateCurrentYear */
/* unused harmony export parseYearList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateYearList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCurrentYear; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("DHvs");

var YEAR_LIST = {
  start: "fetch_start/year_list",
  end: "fetch_end/year_list",
  success: "fetch_success/year_list",
  failed: "fetch_failed/year_list",
  setYear: "set_current_year"
};
var yearListFetchStart = function yearListFetchStart() {
  return {
    type: YEAR_LIST.start
  };
};

var yearListFetchEnd = function yearListFetchEnd() {
  return {
    type: YEAR_LIST.end
  };
};

var yearListFetchSuccess = function yearListFetchSuccess(data, parsedList) {
  return {
    type: YEAR_LIST.success,
    data: data,
    parsedList: parsedList
  };
};

var yearListFetchFailed = function yearListFetchFailed(error) {
  return {
    type: YEAR_LIST.failed,
    error: error
  };
};
var updateCurrentYear = function updateCurrentYear(year) {
  return {
    type: YEAR_LIST.setYear,
    year: year
  };
};

var parseYearList = function parseYearList(yearList) {
  return yearList.map(function (item) {
    return {
      label: item + "",
      value: item + ""
    };
  });
};

var updateYearList = function updateYearList(year) {
  return function (dispatch, getState) {
    dispatch(yearListFetchStart());
    var yearList = [].concat(getState().projectTimeline.year);
    dispatch(yearListFetchEnd());
    var parsedList = parseYearList(yearList);
    var curerntYear = localStorage.getItem('globalCurrentYear') ? parseInt(localStorage.getItem('globalCurrentYear')) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* getCurrentYear */])();
    dispatch(yearListFetchSuccess(yearList, parsedList));
    dispatch(updateCurrentYear(year ? year : curerntYear));
  };
};
var setCurrentYear = function setCurrentYear(year) {
  return function (dispatch) {
    dispatch(updateCurrentYear(year));
  };
};

/***/ }),

/***/ "EMSi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEPIENT_BUDGET_VS_EXPENSE; });
/* unused harmony export recepientBudgetVsExpenseFetchStart */
/* unused harmony export recepientBudgetVsExpenseFetchEnd */
/* unused harmony export recepientBudgetVsExpenseFetchClear */
/* unused harmony export recepientBudgetVsExpenseFetchFetchSuccess */
/* unused harmony export recepientBudgetVsExpenseFetchFetchFailed */
/* unused harmony export parseBudgetVsExpense */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRecepientBudgetVsExpense; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__("tokj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3__);


var RECEPIENT_BUDGET_VS_EXPENSE = {
  start: "fetch_start/donor_budget_vs_expense",
  end: "fetch_end/donor_budget_vs_expense",
  success: "fetch_success/donor_budget_vs_expense",
  failed: "fetch_failed/donor_budget_vs_expense",
  clear: "clear/donor_budget_vs_expense"
};

var recepientBudgetVsExpenseFetchStart = function recepientBudgetVsExpenseFetchStart() {
  return {
    type: RECEPIENT_BUDGET_VS_EXPENSE.start
  };
};

var recepientBudgetVsExpenseFetchEnd = function recepientBudgetVsExpenseFetchEnd() {
  return {
    type: RECEPIENT_BUDGET_VS_EXPENSE.end
  };
};
var recepientBudgetVsExpenseFetchClear = function recepientBudgetVsExpenseFetchClear() {
  return {
    type: RECEPIENT_BUDGET_VS_EXPENSE.clear
  };
};

var recepientBudgetVsExpenseFetchFetchSuccess = function recepientBudgetVsExpenseFetchFetchSuccess(data) {
  return {
    type: RECEPIENT_BUDGET_VS_EXPENSE.success,
    data: data
  };
};

var recepientBudgetVsExpenseFetchFetchFailed = function recepientBudgetVsExpenseFetchFetchFailed(error) {
  return {
    type: RECEPIENT_BUDGET_VS_EXPENSE.failed,
    error: error
  };
};

var calcTotalBudgetExpense = function calcTotalBudgetExpense(data) {
  var totalBudget = 0,
      totalExpense = 0,
      total = 0;
  data.forEach(function (item) {
    totalBudget = totalBudget + parseFloat(item.theme_budget);
    totalExpense = totalExpense + parseFloat(item.theme_expense);
  });

  total = totalBudget + totalExpense;

  return total;
};

var calcHighestValue = function calcHighestValue(data) {
  var frmmtedBudgetArray = [],
      frmmtedExpenseArray = [],
      frmttdBudget = 0,
      frmttdExpense = 0,
      budgetMax = 0,
      expenseMax = 0;
  data.forEach(function (element) {
    frmttdBudget = parseFloat(element.theme_budget ? element.theme_budget : 0);
    frmttdExpense = parseFloat(element.theme_expense ? element.theme_expense : 0);
    frmmtedBudgetArray = [].concat(frmmtedBudgetArray, [frmttdBudget]);
    frmmtedExpenseArray = [].concat(frmmtedExpenseArray, [frmttdExpense]);
  });
  budgetMax = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(frmmtedBudgetArray);
  expenseMax = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(frmmtedExpenseArray);
  return budgetMax > expenseMax ? budgetMax : expenseMax;
};

var parseBudgetVsExpense = function parseBudgetVsExpense(data, total) {
  if (data.length !== 0) {
    data.forEach(function (element) {
      element.short_name = element.sector_name;
      element.total_budget = element.theme_budget;
      element.total_expense = element.theme_expense;
      element.color = element.sector_color;
      element.budgetPercentage = total == 0 ? 0 : parseFloat(element.theme_budget) / total * 100;
      element.expensePercentage = total == 0 ? 0 : parseFloat(element.theme_expense) / total * 100;
    });
  }
};

var fetchRecepientBudgetVsExpense = function fetchRecepientBudgetVsExpense(code, year) {
  return function (dispatch) {
    dispatch(recepientBudgetVsExpenseFetchStart());
    if (code != "" && year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_BUDGET_VS_EXPENSE(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(recepientBudgetVsExpenseFetchEnd());
          // const total = calcTotalBudgetExpense(resp.data);
          var highestValue = calcHighestValue(resp.data);
          if (highestValue === 0) {
            dispatch(recepientBudgetVsExpenseFetchFetchSuccess([]));
          } else {
            parseBudgetVsExpense(resp.data, highestValue);
            dispatch(recepientBudgetVsExpenseFetchFetchSuccess(resp.data));
          }
        } else {
          dispatch(recepientBudgetVsExpenseFetchFetchFailed());
        }
      }).catch(function (exception) {
        dispatch(recepientBudgetVsExpenseFetchEnd());
        dispatch(recepientBudgetVsExpenseFetchFetchFailed(exception));
      });
    } else {
      dispatch(recepientBudgetVsExpenseFetchClear());
      dispatch(recepientBudgetVsExpenseFetchEnd());
    }
  };
};

/***/ }),

/***/ "FYbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MARKER_DATA; });
/* unused harmony export markerDataFetchStart */
/* unused harmony export markerDataFetchEnd */
/* unused harmony export markerDataClear */
/* unused harmony export markerDataFetchSuccess */
/* unused harmony export markerDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchMarkerData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var MARKER_DATA = {
  start: "fetch_start/marker_data",
  end: "fetch_end/marker_data",
  success: "fetch_success/marker_data",
  failed: "fetch_failed/marker_data",
  clear: "clear/marker_data"
};

var markerDataFetchStart = function markerDataFetchStart() {
  return {
    type: MARKER_DATA.start
  };
};

var markerDataFetchEnd = function markerDataFetchEnd() {
  return {
    type: MARKER_DATA.end
  };
};
var markerDataClear = function markerDataClear() {
  return {
    type: MARKER_DATA.clear
  };
};

var markerDataFetchSuccess = function markerDataFetchSuccess(data) {
  return {
    type: MARKER_DATA.success,
    data: data
  };
};

var markerDataFetchFailed = function markerDataFetchFailed(error) {
  return {
    type: MARKER_DATA.failed,
    error: error
  };
};

var fetchMarkerData = function fetchMarkerData(year, markerType, country, markerId, level2Marker) {
  year ? null : year = "";
  markerType ? null : markerType = "";
  country ? null : country = "all";
  level2Marker && level2Marker !== "all" ? null : level2Marker = "";
  markerId ? null : markerId = "";
  return function (dispatch, getState) {
    year ? null : year = "";
    markerId ? null : markerId = "";
    country ? null : country = "all";
    markerType = markerType ? markerType : "";
    dispatch(markerDataFetchStart());
    if (year !== "" && markerType !== "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MARKER_DATA(year, markerType, country, markerId, level2Marker)).then(function (resp) {
        if (resp.success && resp.data) {
          resp.data.aggregate = resp.data.aggregate && resp.data.aggregate.length ? resp.data.aggregate[0] : {};
          dispatch(markerDataFetchEnd());
          dispatch(markerDataFetchSuccess(resp.data));
        } else {
          dispatch(markerDataFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(markerDataFetchEnd());
        dispatch(markerDataFetchFailed(exception));
      });
    } else {
      dispatch(markerDataClear());
      dispatch(markerDataFetchEnd());
    }
  };
};

/***/ }),

/***/ "FrMN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUMMARY_DATA; });
/* unused harmony export summaryDataFetchStart */
/* unused harmony export summaryDataFetchEnd */
/* unused harmony export summaryDataFetchSuccess */
/* unused harmony export summaryDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateSummaryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var SUMMARY_DATA = {
  start: "fetch_start/summary_data",
  end: "fetch_end/summary_data",
  success: "fetch_success/summary_data",
  failed: "fetch_failed/summary_data"
};

var summaryDataFetchStart = function summaryDataFetchStart() {
  return {
    type: SUMMARY_DATA.start
  };
};

var summaryDataFetchEnd = function summaryDataFetchEnd() {
  return {
    type: SUMMARY_DATA.end
  };
};

var summaryDataFetchSuccess = function summaryDataFetchSuccess(data) {
  return {
    type: SUMMARY_DATA.success,
    data: data
  };
};

var summaryDataFetchFailed = function summaryDataFetchFailed(error) {
  return {
    type: SUMMARY_DATA.failed,
    error: error
  };
};

var updateSummaryData = function updateSummaryData(year, donor) {
  return function (dispatch) {
    dispatch(summaryDataFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SUMMARY_DATA(year, donor)).then(function (response) {
        dispatch(summaryDataFetchEnd());
        dispatch(summaryDataFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(summaryDataFetchEnd());
        dispatch(summaryDataFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "GbIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OUTPUTS_MAP_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_OUTPUTS_MAP_DATA; });
/* unused harmony export mapDataFetchStart */
/* unused harmony export mapDataFetchEnd */
/* unused harmony export mapDataFetchSuccess */
/* unused harmony export mapDataFetchFailed */
/* unused harmony export donorMapOutputDataFetchStart */
/* unused harmony export donorMapOutputDataFetchEnd */
/* unused harmony export donorMapOutputDataFetchSuccess */
/* unused harmony export donorMapOutputDataFetchFailed */
/* unused harmony export MapOutputsReset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadOutputsMapData; });
/* unused harmony export loadDonorOutputs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return resetOutputsMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/


var OUTPUTS_MAP_DATA = {
  start: "fetch_start/outputs_map_data",
  end: "fetch_end/outputs_map_data",
  success: "fetch_success/outputs_map_data",
  failed: "fetch_failed/outputs_map_data",
  reset: "outputs_reset/outputs_map_data"
};

var DONOR_OUTPUTS_MAP_DATA = {
  start: "fetch_start/donor_outputs_map_data",
  end: "fetch_end/donor_outputs_map_data",
  success: "fetch_success/donor_outputs_map_data",
  failed: "fetch_failed/donor_outputs_map_data",
  reset: "outputs_reset/donor_outputs_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: OUTPUTS_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: OUTPUTS_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data) {
  return {
    type: OUTPUTS_MAP_DATA.success,
    data: data
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: OUTPUTS_MAP_DATA.failed,
    error: error
  };
};

var donorMapOutputDataFetchStart = function donorMapOutputDataFetchStart() {
  return {
    type: DONOR_OUTPUTS_MAP_DATA.start
  };
};

var donorMapOutputDataFetchEnd = function donorMapOutputDataFetchEnd() {
  return {
    type: DONOR_OUTPUTS_MAP_DATA.end
  };
};

var donorMapOutputDataFetchSuccess = function donorMapOutputDataFetchSuccess(data) {
  return {
    type: DONOR_OUTPUTS_MAP_DATA.success,
    data: data
  };
};

var donorMapOutputDataFetchFailed = function donorMapOutputDataFetchFailed(error) {
  return {
    type: DONOR_OUTPUTS_MAP_DATA.failed,
    error: error
  };
};

var MapOutputsReset = function MapOutputsReset() {
  return {
    type: OUTPUTS_MAP_DATA.reset
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var mapDonorOutputsResponseParser = function mapDonorOutputsResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(donorMapOutputDataFetchEnd());
    dispatch(donorMapOutputDataFetchSuccess(data));
  } else {
    dispatch(donorMapOutputDataFetchEnd());
  }
};

var loadOutputsMapData = function loadOutputsMapData(year, unit, sector, source, projectId, budgetType, sdg, marker, markerSubType, sigSoln) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    year = year ? year : "";
    unit = unit ? unit : "";
    sigSoln = sigSoln ? sigSoln : "";
    sector = sector !== undefined && sector !== null ? sector : "";
    source = source ? source : "";
    projectId = projectId ? projectId : "";
    budgetType = budgetType ? budgetType : "";
    marker = marker ? marker : "";
    markerSubType ? null : markerSubType = "";
    sdg = sdg !== undefined && sdg !== null ? sdg : "";
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_OUTPUTS(year, unit, sector, source, projectId, budgetType, sdg, marker, markerSubType, sigSoln)).then(function (resp) {
      return mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};

var loadDonorOutputs = function loadDonorOutputs(year, unit, sector, source, projectId, budgetType, sdg, marker, markerSubType, sigSoln) {
  return function (dispatch) {
    dispatch(donorMapOutputDataFetchStart());
    year = year ? year : "";
    unit = unit ? unit : "";
    sigSoln = sigSoln ? sigSoln : "";
    sector = sector !== undefined && sector !== null ? sector : "";
    source = source ? source : "";
    projectId = projectId ? projectId : "";
    budgetType = budgetType ? budgetType : "";
    marker = marker ? marker : "";
    markerSubType ? null : markerSubType = "";
    sdg = sdg !== undefined && sdg !== null ? sdg : "";
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_OUTPUTS(year, unit, sector, source, projectId, budgetType, sdg, marker, markerSubType, sigSoln)).then(function (resp) {
      return mapDonorOutputsResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(donorMapOutputDataFetchEnd());
      dispatch(donorMapOutputDataFetchFailed(exception));
    });
  };
};

var resetOutputsMapData = function resetOutputsMapData() {
  return function (dispatch) {
    dispatch(MapOutputsReset());
  };
};

/***/ }),

/***/ "Gctp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_LIST; });
/* unused harmony export activitiesListFetchStart */
/* unused harmony export activitiesListFetchEnd */
/* unused harmony export activitiesListFetchSuccess */
/* unused harmony export activitiesListFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateActivitiesList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var ACTIVITIES_LIST = {
  start: "fetch_start/activities_list",
  end: "fetch_end/activities_list",
  success: "fetch_success/activities_list",
  failed: "fetch_failed/activities_list"
};

var activitiesListFetchStart = function activitiesListFetchStart() {
  return {
    type: ACTIVITIES_LIST.start
  };
};

var activitiesListFetchEnd = function activitiesListFetchEnd() {
  return {
    type: ACTIVITIES_LIST.end
  };
};

var activitiesListFetchSuccess = function activitiesListFetchSuccess(data) {
  return {
    type: ACTIVITIES_LIST.success,
    data: data
  };
};

var activitiesListFetchFailed = function activitiesListFetchFailed(error) {
  return {
    type: ACTIVITIES_LIST.failed,
    error: error
  };
};

var updateActivitiesList = function updateActivitiesList(year, page, pageSize, portal, field_of_operation, donor, oecd, sdg) {
  return function (dispatch) {
    dispatch(activitiesListFetchStart());
    var filterPortal = portal || "";
    var filterField_of_operation = field_of_operation || "";
    var filterDonor = donor || "";
    var filterOecd = oecd || "";
    var filterSdg = sdg || "";
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_ACTIVITIES_LIST(year, page, pageSize, filterPortal, filterField_of_operation, filterDonor, filterOecd, filterSdg)).then(function (response) {
        dispatch(activitiesListFetchEnd());
        dispatch(activitiesListFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(activitiesListFetchEnd());
        dispatch(activitiesListFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "H+FH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDG_MAP_DATA; });
/* unused harmony export mapDataFetchStart */
/* unused harmony export mapDataFetchEnd */
/* unused harmony export mapDataFetchSuccess */
/* unused harmony export mapDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadSdgMapData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadTargetMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/


var SDG_MAP_DATA = {
  start: "fetch_start/sdg_map_data",
  end: "fetch_end/sdg_map_data",
  success: "fetch_success/sdg_map_data",
  failed: "fetch_failed/sdg_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: SDG_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: SDG_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data) {
  return {
    type: SDG_MAP_DATA.success,
    data: data
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: SDG_MAP_DATA.failed,
    error: error
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var loadSdgMapData = function loadSdgMapData(year, sdg, unit, source, tab) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    unit = unit ? unit : "";
    source = source ? source : "";
    sdg = sdg ? sdg : "";
    tab = tab ? tab : "";

    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_SDG(year, sdg, unit, source, tab)).then(function (resp) {
      mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};

var loadTargetMapData = function loadTargetMapData(year, target, unit, source, tab) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    unit = unit ? unit : "";
    source = source ? source : "";
    target = target ? target : "";
    tab = tab ? tab : "";

    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_SDG_TARGETS(year, target, unit, source, tab)).then(function (resp) {
      mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "I57u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OUR_APPROACHES_DATA; });
/* unused harmony export ourApproachesDataFetchStart */
/* unused harmony export ourApproachesDataFetchEnd */
/* unused harmony export ourApproachesDataClear */
/* unused harmony export ourApproachesDataFetchSuccess */
/* unused harmony export ourApproachesDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchOurApproachesData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var OUR_APPROACHES_DATA = {
  start: "fetch_start/our_approaches_data",
  end: "fetch_end/our_approaches_data",
  success: "fetch_success/our_approaches_data",
  failed: "fetch_failed/our_approaches_data",
  clear: "clear/our_approaches_data"
};

var ourApproachesDataFetchStart = function ourApproachesDataFetchStart() {
  return {
    type: OUR_APPROACHES_DATA.start
  };
};

var ourApproachesDataFetchEnd = function ourApproachesDataFetchEnd() {
  return {
    type: OUR_APPROACHES_DATA.end
  };
};
var ourApproachesDataClear = function ourApproachesDataClear() {
  return {
    type: OUR_APPROACHES_DATA.clear
  };
};

var ourApproachesDataFetchSuccess = function ourApproachesDataFetchSuccess(data) {
  return {
    type: OUR_APPROACHES_DATA.success,
    data: data
  };
};

var ourApproachesDataFetchFailed = function ourApproachesDataFetchFailed(error) {
  return {
    type: OUR_APPROACHES_DATA.failed,
    error: error
  };
};

var fetchOurApproachesData = function fetchOurApproachesData(country, level2marker, markerType) {
  return function (dispatch, getState) {
    dispatch(ourApproachesDataFetchStart());
    country = country ? country : "";
    level2marker = level2marker ? level2marker : "";
    markerType = markerType ? markerType : "";
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].SSC_OUR_APPROACHES(country, level2marker, markerType)).then(function (resp) {
      if (resp.success && resp.data) {
        resp.data = _.sortByOrder(resp.data, ["title"], ["asc"]);
        dispatch(ourApproachesDataFetchEnd());
        dispatch(ourApproachesDataFetchSuccess(resp.data));
      } else {
        dispatch(ourApproachesDataFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(ourApproachesDataFetchEnd());
      dispatch(ourApproachesDataFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "IKBG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEVEL_TWO_COUNTRY_DATA; });
/* unused harmony export levelTwoCountryFetchStart */
/* unused harmony export levelTwoCountryFetchEnd */
/* unused harmony export levelTwoCountryClear */
/* unused harmony export levelTwoCountryFetchSuccess */
/* unused harmony export levelTwoCountryFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchlevelTwoCountry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var LEVEL_TWO_COUNTRY_DATA = {
  start: "fetch_start/levelTwoCountry_data",
  end: "fetch_end/levelTwoCountry_data",
  success: "fetch_success/levelTwoCountry_data",
  failed: "fetch_failed/levelTwoCountry_data",
  clear: "clear/levelTwoCountry_data"
};

var levelTwoCountryFetchStart = function levelTwoCountryFetchStart() {
  return {
    type: LEVEL_TWO_COUNTRY_DATA.start
  };
};

var levelTwoCountryFetchEnd = function levelTwoCountryFetchEnd() {
  return {
    type: LEVEL_TWO_COUNTRY_DATA.end
  };
};
var levelTwoCountryClear = function levelTwoCountryClear() {
  return {
    type: LEVEL_TWO_COUNTRY_DATA.clear
  };
};

var levelTwoCountryFetchSuccess = function levelTwoCountryFetchSuccess(data) {
  return {
    type: LEVEL_TWO_COUNTRY_DATA.success,
    data: data
  };
};

var levelTwoCountryFetchFailed = function levelTwoCountryFetchFailed(error) {
  return {
    type: LEVEL_TWO_COUNTRY_DATA.failed,
    error: error
  };
};

var fetchlevelTwoCountry = function fetchlevelTwoCountry(opUnit, markerId) {
  opUnit = !opUnit ? "" : opUnit;
  markerId = !markerId ? "" : markerId;
  return function (dispatch, getState) {
    dispatch(levelTwoCountryFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_LEVEL_TWO_COUNTRY_DATA(opUnit, markerId)).then(function (resp) {
      if (resp.success && resp.data) {
        dispatch(levelTwoCountryFetchEnd());
        dispatch(levelTwoCountryFetchSuccess(resp.data));
      } else {
        dispatch(levelTwoCountryFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(levelTwoCountryFetchEnd());
      dispatch(levelTwoCountryFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "IlGz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MARKER_DESC_DATA; });
/* unused harmony export markerDescriptionDataFetchStart */
/* unused harmony export markerDescriptionDataFetchEnd */
/* unused harmony export markerDescriptionDataClear */
/* unused harmony export markerDescriptionDataFetchSuccess */
/* unused harmony export markerDescriptionDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchMarkerDescriptionData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var MARKER_DESC_DATA = {
  start: "fetch_start/marker_desc_data",
  end: "fetch_end/marker_desc_data",
  success: "fetch_success/marker_desc_data",
  failed: "fetch_failed/marker_desc_data",
  clear: "clear/marker_desc_data"
};

var markerDescriptionDataFetchStart = function markerDescriptionDataFetchStart() {
  return {
    type: MARKER_DESC_DATA.start
  };
};

var markerDescriptionDataFetchEnd = function markerDescriptionDataFetchEnd() {
  return {
    type: MARKER_DESC_DATA.end
  };
};
var markerDescriptionDataClear = function markerDescriptionDataClear() {
  return {
    type: MARKER_DESC_DATA.clear
  };
};

var markerDescriptionDataFetchSuccess = function markerDescriptionDataFetchSuccess(data) {
  return {
    type: MARKER_DESC_DATA.success,
    data: data
  };
};

var markerDescriptionDataFetchFailed = function markerDescriptionDataFetchFailed(error) {
  return {
    type: MARKER_DESC_DATA.failed,
    error: error
  };
};

var fetchMarkerDescriptionData = function fetchMarkerDescriptionData(year, markerType, country, markerId) {
  markerId ? null : markerId = "";
  country ? null : country = "";
  return function (dispatch, getState) {
    dispatch(markerDescriptionDataFetchStart());
    if (year !== "" && markerType !== "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MARKER_DESCRIPTION_DATA(year, markerType, country, markerId)).then(function (resp) {
        if (resp.success && resp.data) {
          resp.data.aggregate = resp.data.aggregate && resp.data.aggregate.length ? resp.data.aggregate[0] : {};
          dispatch(markerDescriptionDataFetchEnd());
          dispatch(markerDescriptionDataFetchSuccess(resp.data));
        } else {
          dispatch(markerDescriptionDataFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(markerDescriptionDataFetchEnd());
        dispatch(markerDescriptionDataFetchFailed(exception));
      });
    } else {
      dispatch(markerDescriptionDataClear());
      dispatch(markerDescriptionDataFetchEnd());
    }
  };
};

/***/ }),

/***/ "JZ8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ../node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__("fpuT");

// CONCATENATED MODULE: ../node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var redux_thunk_es = (thunk);
// EXTERNAL MODULE: ../node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__("XYJE");
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);

// EXTERNAL MODULE: ./components/yearSummary/actions/index.js
var actions = __webpack_require__("6cZ9");

// CONCATENATED MODULE: ./components/yearSummary/reducer/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  switch (action.type) {
    case actions["b" /* YEAR_SUMMARY */].start:
      return _extends({}, state, {
        loading: true
      });

    case actions["b" /* YEAR_SUMMARY */].end:
      return _extends({}, state, {
        loading: false
      });

    case actions["b" /* YEAR_SUMMARY */].success:
      return _extends({}, state, {
        data: action.data,
        error: defaultState.error
      });

    case actions["b" /* YEAR_SUMMARY */].failed:
      return _extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/sankey/actions/index.js
var sankey_actions = __webpack_require__("dzhT");

// CONCATENATED MODULE: ./components/sankey/reducer/index.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var reducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  items: []
};

/* harmony default export */ var sankey_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case sankey_actions["a" /* FINANCIAL_FLOW */].start:
      return reducer__extends({}, state, {
        loading: true
      });

    case sankey_actions["a" /* FINANCIAL_FLOW */].end:
      return reducer__extends({}, state, {
        loading: false
      });

    case sankey_actions["a" /* FINANCIAL_FLOW */].success:
      return reducer__extends({}, state, {
        items: action.data,
        error: reducer_defaultState.error
      });

    case sankey_actions["a" /* FINANCIAL_FLOW */].failed:
      return reducer__extends({}, state, {
        error: action.errors
      });
    case sankey_actions["a" /* FINANCIAL_FLOW */].clear:
      return reducer__extends({}, reducer_defaultState, {
        loading: true
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/markerPage/actions/index.js
var markerPage_actions = __webpack_require__("FYbH");

// CONCATENATED MODULE: ./components/markerPage/reducer/index.js
var markerPage_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var markerPage_reducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var markerPage_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : markerPage_reducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case markerPage_actions["a" /* MARKER_DATA */].start:
      return markerPage_reducer__extends({}, markerPage_reducer_defaultState, {
        loading: true
      });

    case markerPage_actions["a" /* MARKER_DATA */].end:
      return markerPage_reducer__extends({}, state, {
        loading: false
      });

    case markerPage_actions["a" /* MARKER_DATA */].success:
      return markerPage_reducer__extends({}, state, {
        data: action.data,
        error: markerPage_reducer_defaultState.error
      });

    case markerPage_actions["a" /* MARKER_DATA */].failed:
      return markerPage_reducer__extends({}, state, {
        error: action.errors
      });
    case markerPage_actions["a" /* MARKER_DATA */].clear:
      return markerPage_reducer__extends({}, markerPage_reducer_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./components/urlBreadCrumb/data/reducer.js
var data_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SET_PAGE_HEADER = "SET_PAGE_HEADER";

var data_reducer_defaultState = {
  title: "",
  subTitle: "",
  breadcrumb: [],
  action: null
};

/* harmony default export */ var data_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : data_reducer_defaultState;
  var action = arguments[1];
  var type = action.type,
      data = action.data;

  if (type.toString() === SET_PAGE_HEADER.toString()) {
    return data_reducer__extends({}, data_reducer_defaultState, data);
  }

  return state;
});
// EXTERNAL MODULE: ./components/tabSection/actions/index.js + 3 modules
var tabSection_actions = __webpack_require__("PeVu");

// CONCATENATED MODULE: ./components/tabSection/reducer/index.js
var tabSection_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var tabSection_reducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  themes: [],
  tabSelected: "country",
  donorFilter: {},
  countryRegionFilter: {
    country: {}
  },
  sdgFilter: {},
  themeFilter: {},
  currentYear: ""
};

/* harmony default export */ var tabSection_reducer = (function () {
  var _extends2, _extends3, _extends4, _extends5, _extends6;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tabSection_reducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case tabSection_actions["h" /* TAB_DATA */].start:
      return tabSection_reducer__extends({}, state, {
        loading: true
      });

    case tabSection_actions["h" /* TAB_DATA */].end:
      return tabSection_reducer__extends({}, state, {
        loading: false
      });

    case tabSection_actions["h" /* TAB_DATA */].success:
      return tabSection_reducer__extends({}, state, {
        themes: action.data,
        error: tabSection_reducer_defaultState.error
      });

    case tabSection_actions["h" /* TAB_DATA */].failed:
      return tabSection_reducer__extends({}, state, {
        error: action.errors
      });

    case tabSection_actions["a" /* ON_TAB_SWITCH */]:
      return tabSection_reducer__extends({}, state, {
        tabSelected: action.tabType
      });

    case tabSection_actions["c" /* ON_UPDATE_DONOR_FILTER */]:
      return tabSection_reducer__extends({}, state, {
        donorFilter: tabSection_reducer__extends({}, state.donorFilter, (_extends2 = {}, _extends2[action.key] = action.data, _extends2))
      });

    case tabSection_actions["f" /* ON_UPDATE_THEME_FILTER */]:
      return tabSection_reducer__extends({}, state, {
        themeFilter: tabSection_reducer__extends({}, state.themeFilter, (_extends3 = {}, _extends3[action.key] = action.data, _extends3))
      });

    case tabSection_actions["e" /* ON_UPDATE_SIGNATURE_FILTER */]:
      return tabSection_reducer__extends({}, state, {
        signatureFilter: tabSection_reducer__extends({}, state.signatureFilter, (_extends4 = {}, _extends4[action.key] = action.data, _extends4))
      });

    case tabSection_actions["b" /* ON_UPDATE_COUNTRYREGION_FILTER */]:
      return tabSection_reducer__extends({}, state, {
        countryRegionFilter: tabSection_reducer__extends({}, state.countryRegionFilter, (_extends5 = {}, _extends5[action.key] = action.data, _extends5))
      });

    case tabSection_actions["d" /* ON_UPDATE_SDG_FILTER */]:
      return tabSection_reducer__extends({}, state, {
        sdgFilter: tabSection_reducer__extends({}, state.sdgFilter, (_extends6 = {}, _extends6[action.key] = action.data, _extends6))
      });

    case tabSection_actions["g" /* ON_UPDATE_YEAR */]:
      return tabSection_reducer__extends({}, state, {
        currentYear: action.year
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/mapActions/globalMapData.js
var globalMapData = __webpack_require__("9KE5");

// EXTERNAL MODULE: ./shared/actions/mapActions/donorsMapData.js
var donorsMapData = __webpack_require__("SDqA");

// EXTERNAL MODULE: ./lib/api.js
var api = __webpack_require__("TOh2");

// CONCATENATED MODULE: ./shared/actions/mapActions/projectDetailMapData.js
/************************* Lib Files ************************/


var PROJECT_DETAIL_MAP_DATA = {
  start: "fetch_start/project_detail_map_data",
  end: "fetch_end/project_detail_map_data",
  success: "fetch_success/project_detail_map_data",
  failed: "fetch_failed/project_detail_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: PROJECT_DETAIL_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: PROJECT_DETAIL_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data) {
  return {
    type: PROJECT_DETAIL_MAP_DATA.success,
    data: data
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: PROJECT_DETAIL_MAP_DATA.failed,
    error: error
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var projectDetailMapData_loadProjectDetailsMapData = function loadProjectDetailsMapData(projectId) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    projectId = projectId ? projectId : "";
    return api["a" /* default */].get(api["a" /* default */].API_MAP_PROJECT_DETAIL(projectId)).then(function (resp) {
      return mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};
// EXTERNAL MODULE: ./shared/actions/mapActions/projectListMapData.js
var projectListMapData = __webpack_require__("ZIP0");

// EXTERNAL MODULE: ./shared/actions/mapActions/themesMapData.js
var themesMapData = __webpack_require__("t4UN");

// EXTERNAL MODULE: ./shared/actions/mapActions/signatureMapData.js
var signatureMapData = __webpack_require__("N97i");

// EXTERNAL MODULE: ./shared/actions/mapActions/sdgMapData.js
var sdgMapData = __webpack_require__("H+FH");

// EXTERNAL MODULE: ./shared/actions/mapActions/recipientProfileMapData.js
var recipientProfileMapData = __webpack_require__("ve3m");

// EXTERNAL MODULE: ./shared/actions/mapActions/fetchMapOutputs.js
var fetchMapOutputs = __webpack_require__("GbIW");

// EXTERNAL MODULE: ./shared/actions/mapActions/donorProfileMapData.js
var mapActions_donorProfileMapData = __webpack_require__("sVsK");

// EXTERNAL MODULE: ./shared/actions/mapActions/yearTimeline.js
var yearTimeline = __webpack_require__("2AgP");

// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__("DHvs");

// CONCATENATED MODULE: ./shared/reducers/mapData.js
var mapData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/













var mapData_defaultState = {
  outputData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  },
  donorOutputData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  },
  yearTimeline: {
    list: [],
    loading: false,
    error: {
      message: "",
      code: ""
    },
    mapCurrentYear: Object(utils["e" /* getLastYear */])()
  },
  globalMapData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  },
  donorsMapData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  },
  projectDetailMapData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  },
  projectListMapData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: [],
    regionalCenter: false
  },
  themesMapData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  },
  sdgMapData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  },
  recipientMapData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  },
  donorProfileMapData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  },
  signatureMapData: {
    loading: false,
    error: {
      message: "",
      code: ""
    },
    data: []
  }
};

/* harmony default export */ var mapData = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mapData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case globalMapData["a" /* GLOBAL_MAP_DATA */].start:
      return mapData__extends({}, state, {
        globalMapData: mapData__extends({}, state.globalMapData, {
          loading: true
        })
      });

    case globalMapData["a" /* GLOBAL_MAP_DATA */].end:
      return mapData__extends({}, state, {
        globalMapData: mapData__extends({}, state.globalMapData, {
          loading: false
        })
      });

    case globalMapData["a" /* GLOBAL_MAP_DATA */].success:
      return mapData__extends({}, state, {
        globalMapData: mapData__extends({}, state.globalMapData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case globalMapData["a" /* GLOBAL_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        globalMapData: mapData__extends({}, state.globalMapData, {
          error: action.errors
        })
      });
    ////////////////////////////// DONORS MAP DATA ///////////////////////////////////////
    case donorsMapData["a" /* DONORS_MAP_DATA */].start:
      return mapData__extends({}, state, {
        donorsMapData: mapData__extends({}, state.donorsMapData, {
          loading: true
        })
      });

    case donorsMapData["a" /* DONORS_MAP_DATA */].end:
      return mapData__extends({}, state, {
        donorsMapData: mapData__extends({}, state.donorsMapData, {
          loading: false
        })
      });

    case donorsMapData["a" /* DONORS_MAP_DATA */].success:
      return mapData__extends({}, state, {
        donorsMapData: mapData__extends({}, state.donorsMapData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case donorsMapData["a" /* DONORS_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        donorsMapData: mapData__extends({}, state.donorsMapData, {
          error: action.errors
        })
      });
    ////////////////////////////// THEMES MAP DATA ///////////////////////////////////////
    case themesMapData["a" /* THEMES_MAP_DATA */].start:
      return mapData__extends({}, state, {
        themesMapData: mapData__extends({}, state.themesMapData, {
          loading: true
        })
      });

    case themesMapData["a" /* THEMES_MAP_DATA */].end:
      return mapData__extends({}, state, {
        themesMapData: mapData__extends({}, state.themesMapData, {
          loading: false
        })
      });

    case themesMapData["a" /* THEMES_MAP_DATA */].success:
      return mapData__extends({}, state, {
        themesMapData: mapData__extends({}, state.themesMapData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case themesMapData["a" /* THEMES_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        themesMapData: mapData__extends({}, state.themesMapData, {
          error: action.errors
        })
      });

    ////////////////////////////// SDG MAP DATA ///////////////////////////////////////
    case sdgMapData["a" /* SDG_MAP_DATA */].start:
      return mapData__extends({}, state, {
        sdgMapData: mapData__extends({}, state.sdgMapData, {
          loading: true
        })
      });

    case sdgMapData["a" /* SDG_MAP_DATA */].end:
      return mapData__extends({}, state, {
        sdgMapData: mapData__extends({}, state.sdgMapData, {
          loading: false
        })
      });

    case sdgMapData["a" /* SDG_MAP_DATA */].success:
      return mapData__extends({}, state, {
        sdgMapData: mapData__extends({}, state.sdgMapData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case sdgMapData["a" /* SDG_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        sdgMapData: mapData__extends({}, state.sdgMapData, {
          error: action.errors
        })
      });

    ////////////////////////////// PROJECT DETAIL MAP DATA ///////////////////////////////////////
    case PROJECT_DETAIL_MAP_DATA.start:
      return mapData__extends({}, state, {
        projectDetailMapData: mapData__extends({}, state.projectDetailMapData, {
          loading: true
        })
      });

    case PROJECT_DETAIL_MAP_DATA.end:
      return mapData__extends({}, state, {
        projectDetailMapData: mapData__extends({}, state.projectDetailMapData, {
          loading: false
        })
      });

    case PROJECT_DETAIL_MAP_DATA.success:
      return mapData__extends({}, state, {
        projectDetailMapData: mapData__extends({}, state.projectDetailMapData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case PROJECT_DETAIL_MAP_DATA.failed:
      return mapData__extends({}, state, {
        projectDetailMapData: mapData__extends({}, state.projectDetailMapData, {
          data: action.data,
          error: action.errors
        })
      });
    ////////////////////////////// PROJECT LIST MAP DATA ///////////////////////////////////////
    case projectListMapData["a" /* PROJECT_LIST_MAP_DATA */].start:
      return mapData__extends({}, state, {
        projectListMapData: mapData__extends({}, state.projectListMapData, {
          loading: true
        })
      });

    case projectListMapData["a" /* PROJECT_LIST_MAP_DATA */].end:
      return mapData__extends({}, state, {
        projectListMapData: mapData__extends({}, state.projectListMapData, {
          loading: false
        })
      });

    case projectListMapData["a" /* PROJECT_LIST_MAP_DATA */].success:
      return mapData__extends({}, state, {
        projectListMapData: mapData__extends({}, state.projectListMapData, {
          data: action.data,
          regionalCenter: action.regionalCenter,
          error: mapData_defaultState.error
        })
      });

    case projectListMapData["a" /* PROJECT_LIST_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        projectListMapData: mapData__extends({}, state.projectListMapData, {
          error: action.errors
        })
      });
    ////////////////////////////// RECIPIENT PROFILE MAP DATA ///////////////////////////////////////
    case recipientProfileMapData["a" /* RECIPIENT_PROFILE_MAP_DATA */].start:
      return mapData__extends({}, state, {
        recipientMapData: mapData__extends({}, state.recipientMapData, {
          loading: true
        })
      });

    case recipientProfileMapData["a" /* RECIPIENT_PROFILE_MAP_DATA */].end:
      return mapData__extends({}, state, {
        recipientMapData: mapData__extends({}, state.recipientMapData, {
          loading: false
        })
      });

    case recipientProfileMapData["a" /* RECIPIENT_PROFILE_MAP_DATA */].success:
      return mapData__extends({}, state, {
        recipientMapData: mapData__extends({}, state.recipientMapData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case recipientProfileMapData["a" /* RECIPIENT_PROFILE_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        recipientMapData: mapData__extends({}, state.recipientMapData, {
          data: action.data,
          error: action.errors
        })
      });
    ////////////////////////////// RECIPIENT PROFILE MAP DATA ///////////////////////////////////////
    case mapActions_donorProfileMapData["a" /* DONOR_PROFILE_MAP_DATA */].start:
      return mapData__extends({}, state, {
        donorProfileMapData: mapData__extends({}, state.donorProfileMapData, {
          loading: true
        })
      });

    case mapActions_donorProfileMapData["a" /* DONOR_PROFILE_MAP_DATA */].end:
      return mapData__extends({}, state, {
        donorProfileMapData: mapData__extends({}, state.donorProfileMapData, {
          loading: false
        })
      });

    case mapActions_donorProfileMapData["a" /* DONOR_PROFILE_MAP_DATA */].success:
      return mapData__extends({}, state, {
        donorProfileMapData: mapData__extends({}, state.donorProfileMapData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case mapActions_donorProfileMapData["a" /* DONOR_PROFILE_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        donorProfileMapData: mapData__extends({}, state.donorProfileMapData, {
          data: action.data,
          error: action.errors
        })
      });
    ////////////////////////////// OUTPUT MAP DATA ///////////////////////////////////////
    case fetchMapOutputs["b" /* OUTPUTS_MAP_DATA */].start:
      return mapData__extends({}, state, {
        outputData: mapData__extends({}, state.outputData, {
          loading: true
        })
      });

    case fetchMapOutputs["b" /* OUTPUTS_MAP_DATA */].end:
      return mapData__extends({}, state, {
        outputData: mapData__extends({}, state.outputData, {
          loading: false
        })
      });

    case fetchMapOutputs["b" /* OUTPUTS_MAP_DATA */].success:
      return mapData__extends({}, state, {
        outputData: mapData__extends({}, state.outputData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case fetchMapOutputs["b" /* OUTPUTS_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        outputData: mapData__extends({}, state.outputData, {
          data: action.data,
          error: action.errors
        })
      });
    case fetchMapOutputs["b" /* OUTPUTS_MAP_DATA */].reset:
      return mapData__extends({}, state, {
        outputData: mapData__extends({}, state.outputData, {
          data: []
        })
      });
    //////////////////////////////////DONOR OUTPUTS//////////////////////////////////////
    case fetchMapOutputs["a" /* DONOR_OUTPUTS_MAP_DATA */].start:
      return mapData__extends({}, state, {
        donorOutputData: mapData__extends({}, state.donorOutputData, {
          loading: true
        })
      });

    case fetchMapOutputs["a" /* DONOR_OUTPUTS_MAP_DATA */].end:
      return mapData__extends({}, state, {
        donorOutputData: mapData__extends({}, state.donorOutputData, {
          loading: false
        })
      });

    case fetchMapOutputs["a" /* DONOR_OUTPUTS_MAP_DATA */].success:
      return mapData__extends({}, state, {
        donorOutputData: mapData__extends({}, state.donorOutputData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case fetchMapOutputs["a" /* DONOR_OUTPUTS_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        donorOutputData: mapData__extends({}, state.donorOutputData, {
          data: action.data,
          error: action.errors
        })
      });
    ////////////////////////////// YEAR TIMELINE /////////////////////////////////////////
    case yearTimeline["a" /* MAP_YEAR_TIMELINE */].start:
      return mapData__extends({}, state, {
        yearTimeline: mapData__extends({}, state.yearTimeline, {
          loading: true
        })
      });

    case yearTimeline["a" /* MAP_YEAR_TIMELINE */].end:
      return mapData__extends({}, state, {
        yearTimeline: mapData__extends({}, state.yearTimeline, {
          loading: false
        })
      });

    case yearTimeline["a" /* MAP_YEAR_TIMELINE */].success:
      return mapData__extends({}, state, {
        yearTimeline: mapData__extends({}, state.yearTimeline, {
          list: action.data,
          error: mapData_defaultState.error
        })
      });

    case yearTimeline["a" /* MAP_YEAR_TIMELINE */].failed:
      return mapData__extends({}, state, {
        yearTimeline: mapData__extends({}, state.yearTimeline, {
          error: action.errors
        })
      });
    case yearTimeline["a" /* MAP_YEAR_TIMELINE */].setYear:
      return mapData__extends({}, state, {
        yearTimeline: mapData__extends({}, state.yearTimeline, {
          mapCurrentYear: action.year
        })
      });
    default:
      return state;

    ////////////////////////////// SIGNATURE MAP DATA ///////////////////////////////////////
    case signatureMapData["a" /* SIGNATURES_MAP_DATA */].start:
      return mapData__extends({}, state, {
        signatureMapData: mapData__extends({}, state.signatureMapData, {
          loading: true
        })
      });

    case signatureMapData["a" /* SIGNATURES_MAP_DATA */].end:
      return mapData__extends({}, state, {
        signatureMapData: mapData__extends({}, state.signatureMapData, {
          loading: false
        })
      });

    case signatureMapData["a" /* SIGNATURES_MAP_DATA */].success:
      return mapData__extends({}, state, {
        signatureMapData: mapData__extends({}, state.signatureMapData, {
          data: action.data,
          error: mapData_defaultState.error
        })
      });

    case signatureMapData["a" /* SIGNATURES_MAP_DATA */].failed:
      return mapData__extends({}, state, {
        signatureMapData: mapData__extends({}, state.signatureMapData, {
          error: action.errors
        })
      });
  }
});
// EXTERNAL MODULE: ./shared/actions/routerActions.js
var routerActions = __webpack_require__("Y9jh");

// CONCATENATED MODULE: ./shared/reducers/router.js
var router__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var router_defaultState = {
  previous: "",
  current: ""
};

/* harmony default export */ var router = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : router_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case routerActions["a" /* ROUTE */].ON_UPDATE_ROUTE_ARRAY:
      return router__extends({}, state, {
        routeArray: action.routeArray
      });
    case routerActions["a" /* ROUTE */].ON_UPDATE_CURRENT:
      return router__extends({}, state, {
        current: action.title
      });
    case routerActions["a" /* ROUTE */].ON_UPDATE_PREVIOUS:
      return router__extends({}, state, {
        previous: action.title
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/countryData.js
var countryData = __webpack_require__("xgQa");

// CONCATENATED MODULE: ./shared/reducers/countryData.js
var countryData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/



var countryData_defaultState = {
  data: {
    country_name: "Global",
    total_budget: 0,
    total_expense: 0,
    project_count: 0,
    donor_count: 0
  },
  loading: false,
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var reducers_countryData = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : countryData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    //////////////////////////// GLOBAL DATA //////////////////////////////////
    case countryData["a" /* COUNTRY_DATA */].start:
      return countryData__extends({}, state, {
        loading: true
      });

    case countryData["a" /* COUNTRY_DATA */].end:
      return countryData__extends({}, state, {
        loading: false
      });

    case countryData["a" /* COUNTRY_DATA */].success:
      return countryData__extends({}, state, {
        data: countryData__extends({}, action.data),
        error: countryData_defaultState.error
      });

    case countryData["a" /* COUNTRY_DATA */].failed:
      return countryData__extends({}, state, {
        error: action.errors
      });
    case countryData["a" /* COUNTRY_DATA */].update:
      return countryData__extends({}, state, {
        data: countryData__extends({}, action.data),
        error: countryData_defaultState.error
      });
    ////////////////////////////////// RECIPIENT COUNTRY DATA ///////////////////////////////
    case countryData["b" /* RECIPIENT_COUNTRY_DATA */].start:
      return countryData__extends({}, state, {
        loading: true
      });

    case countryData["b" /* RECIPIENT_COUNTRY_DATA */].end:
      return countryData__extends({}, state, {
        loading: false
      });

    case countryData["b" /* RECIPIENT_COUNTRY_DATA */].success:
      return countryData__extends({}, state, {
        data: countryData__extends({}, action.data),
        error: countryData_defaultState.error
      });

    case countryData["b" /* RECIPIENT_COUNTRY_DATA */].failed:
      return countryData__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/actions/countryDataBudgetSources.js
/************************* Lib Files ************************/


var COUNTRY_DATA_BUDGET_SOURCES = {
  start: "fetch_start/budget_sources",
  end: "fetch_end/budget_sources",
  success: "fetch_success/budget_sources",
  failed: "fetch_failed/budget_sources"
};

var budgetSourcesFetchStart = function budgetSourcesFetchStart() {
  return {
    type: COUNTRY_DATA_BUDGET_SOURCES.start
  };
};

var budgetSourcesFetchEnd = function budgetSourcesFetchEnd() {
  return {
    type: COUNTRY_DATA_BUDGET_SOURCES.end
  };
};

var budgetSourcesFetchSuccess = function budgetSourcesFetchSuccess(data) {
  return {
    type: COUNTRY_DATA_BUDGET_SOURCES.success,
    data: data
  };
};

var budgetSourcesFetchFailed = function budgetSourcesFetchFailed(error) {
  return {
    type: COUNTRY_DATA_BUDGET_SOURCES.failed,
    error: error
  };
};

var countryDataBudgetSources_fetchBudgetSources = function fetchBudgetSources(year, code) {
  return function (dispatch) {
    dispatch(budgetSourcesFetchStart());
    code = code ? code : "";
    if (year !== null) return api["a" /* default */].get(api["a" /* default */].API_GLOBAL_TOP_BUDGET_SOURCES(year, code)).then(function (resp) {
      if (resp.success && resp.data) {
        dispatch(budgetSourcesFetchEnd());
        dispatch(budgetSourcesFetchSuccess(resp.data));
      } else {
        dispatch(budgetSourcesFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(budgetSourcesFetchEnd());
      dispatch(budgetSourcesFetchFailed());
    });
  };
};
// CONCATENATED MODULE: ./shared/reducers/countryDataBudgetSources.js
var countryDataBudgetSources__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var countryDataBudgetSources_defaultState = {
  data: [],
  loading: false,
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var countryDataBudgetSources = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : countryDataBudgetSources_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case COUNTRY_DATA_BUDGET_SOURCES.start:
      return countryDataBudgetSources__extends({}, state, {
        loading: true
      });

    case COUNTRY_DATA_BUDGET_SOURCES.end:
      return countryDataBudgetSources__extends({}, state, {
        loading: false
      });

    case COUNTRY_DATA_BUDGET_SOURCES.success:
      return countryDataBudgetSources__extends({}, state, {
        data: [].concat(action.data),
        error: countryDataBudgetSources_defaultState.error
      });

    case COUNTRY_DATA_BUDGET_SOURCES.failed:
      return countryDataBudgetSources__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/countryRegionSearch.js
var countryRegionSearch = __webpack_require__("6Ifq");

// CONCATENATED MODULE: ./shared/reducers/countryRegionSearch.js
var countryRegionSearch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var countryRegionSearch_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  list: [],
  searchResult: [],
  searchResultSearchBar: [],
  searchText: ""
};

/* harmony default export */ var reducers_countryRegionSearch = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : countryRegionSearch_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case countryRegionSearch["a" /* COUNTRY_REGIONS_SEARCH */].start:
      return countryRegionSearch__extends({}, state, {
        loading: true
      });

    case countryRegionSearch["a" /* COUNTRY_REGIONS_SEARCH */].end:
      return countryRegionSearch__extends({}, state, {
        loading: false
      });

    case countryRegionSearch["a" /* COUNTRY_REGIONS_SEARCH */].success:
      return countryRegionSearch__extends({}, state, {
        searchResult: action.countryRegionList,
        error: countryRegionSearch_defaultState.error
      });
    case countryRegionSearch["a" /* COUNTRY_REGIONS_SEARCH */].updateList:
      return countryRegionSearch__extends({}, state, {
        list: action.countryRegionList,
        error: countryRegionSearch_defaultState.error
      });

    case countryRegionSearch["a" /* COUNTRY_REGIONS_SEARCH */].failed:
      return countryRegionSearch__extends({}, state, {
        error: action.errors
      });
    case countryRegionSearch["b" /* UPDATE_SEARCH_TEXT */]:
      return countryRegionSearch__extends({}, state, {
        searchText: action.text
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/actions/countryDataThemesBudget.js
/************************* Lib Files ************************/


var COUNTRY_DATA_THEMES = {
  start: "fetch_start/themes_budget",
  end: "fetch_end/themes_budget",
  success: "fetch_success/themes_budget",
  failed: "fetch_failed/themes_budget"
};

var themesBudgetFetchStart = function themesBudgetFetchStart() {
  return {
    type: COUNTRY_DATA_THEMES.start
  };
};

var themesBudgetFetchEnd = function themesBudgetFetchEnd() {
  return {
    type: COUNTRY_DATA_THEMES.end
  };
};

var themesBudgetFetchSuccess = function themesBudgetFetchSuccess(data) {
  return {
    type: COUNTRY_DATA_THEMES.success,
    data: data
  };
};

var themesBudgetFetchFailed = function themesBudgetFetchFailed(error) {
  return {
    type: COUNTRY_DATA_THEMES.failed,
    error: error
  };
};

var parsefetchThemesBudget = function parsefetchThemesBudget(dataArray) {
  dataArray.forEach(function (item) {
    item.color = item.sector_color;
    item.fund_stream = item.sector_name;
  });
};

var countryDataThemesBudget_fetchThemesBudget = function fetchThemesBudget(year, code) {
  return function (dispatch) {
    dispatch(themesBudgetFetchStart());
    code = code ? code : "";
    if (year !== null) return api["a" /* default */].get(api["a" /* default */].API_GLOBAL_THEMES_BUDGET(year, code)).then(function (resp) {
      if (resp.success && resp.data) {
        dispatch(themesBudgetFetchEnd());
        parsefetchThemesBudget(resp.data);
        dispatch(themesBudgetFetchSuccess(resp.data));
      } else {
        dispatch(themesBudgetFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(themesBudgetFetchEnd());
      dispatch(themesBudgetFetchFailed());
    });
  };
};
// CONCATENATED MODULE: ./shared/reducers/countryDataThemesBudget.js
var countryDataThemesBudget__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var countryDataThemesBudget_defaultState = {
  data: [],
  loading: false,
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var countryDataThemesBudget = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : countryDataThemesBudget_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case COUNTRY_DATA_THEMES.start:
      return countryDataThemesBudget__extends({}, state, {
        loading: true
      });

    case COUNTRY_DATA_THEMES.end:
      return countryDataThemesBudget__extends({}, state, {
        loading: false
      });

    case COUNTRY_DATA_THEMES.success:
      return countryDataThemesBudget__extends({}, state, {
        data: [].concat(action.data),
        error: countryDataThemesBudget_defaultState.error
      });

    case COUNTRY_DATA_THEMES.failed:
      return countryDataThemesBudget__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/getYearList.js
var getYearList = __webpack_require__("EIKz");

// CONCATENATED MODULE: ./shared/reducers/yearList.js
var yearList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var yearList_defaultState = {
  list: [],
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: [],
  currentYear: null
};

/* harmony default export */ var yearList = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : yearList_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getYearList["a" /* YEAR_LIST */].start:
      return yearList__extends({}, state, {
        loading: true
      });

    case getYearList["a" /* YEAR_LIST */].end:
      return yearList__extends({}, state, {
        loading: false
      });

    case getYearList["a" /* YEAR_LIST */].success:
      return yearList__extends({}, state, {
        list: action.data,
        data: action.parsedList,
        error: yearList_defaultState.error
      });

    case getYearList["a" /* YEAR_LIST */].failed:
      return yearList__extends({}, state, {
        error: action.errors
      });
    case getYearList["a" /* YEAR_LIST */].setYear:
      localStorage.setItem('globalCurrentYear', parseInt(action.year));
      // console.log("action.year",action.year)
      return yearList__extends({}, state, {
        currentYear: action.year
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/projectDetailActions/basicDataActions.js
var basicDataActions = __webpack_require__("Sw3y");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/timeLineActions.js
var timeLineActions = __webpack_require__("TZwW");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/budgetSourceActions.js
var budgetSourceActions = __webpack_require__("L1Wr");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/budgetUtilization.js
var budgetUtilization = __webpack_require__("w2Oo");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/documentListActions.js
var documentListActions = __webpack_require__("e0UL");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/outputListActions.js
var outputListActions = __webpack_require__("SCCX");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/outputResultsActions.js
var outputResultsActions = __webpack_require__("voeE");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/outputDetailActions.js
var outputDetailActions = __webpack_require__("mFZF");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/purchaseOrderActions.js
var purchaseOrderActions = __webpack_require__("cQmd");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/projectGallery.js
var projectGallery = __webpack_require__("sD71");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/clearProjectDataActions.js
var clearProjectDataActions = __webpack_require__("vp+G");

// CONCATENATED MODULE: ./shared/reducers/projectDetailManagement.js
var projectDetailManagement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/












var projectDetailManagement_defaultState = {
  loading: false,
  project: {},
  error: {
    message: "",
    code: ""
  },
  budget_source: [],
  budget_utilization: {},
  document_list: {
    loading: false,
    categoryList: []
  },
  document_list_filtered: {
    loading: false
  },
  output_results: {},
  output_list: {},
  time_line: {},
  purchase_orders: {
    loading: false
  },
  picture_gallery: {
    loading: false,
    data: []
  }
};

/* harmony default export */ var projectDetailManagement = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : projectDetailManagement_defaultState;
  var action = arguments[1];

  switch (action.type) {
    /////////////////////// PROJECT_BASIC_DATA //////////////////////////
    case basicDataActions["a" /* PROJECT_BASIC_DATA */].start:
      return projectDetailManagement__extends({}, projectDetailManagement_defaultState, {
        loading: true
      });

    case basicDataActions["a" /* PROJECT_BASIC_DATA */].end:
      return projectDetailManagement__extends({}, state, {
        loading: false
      });

    case basicDataActions["a" /* PROJECT_BASIC_DATA */].success:
      return projectDetailManagement__extends({}, state, {
        project: action.data,
        error: projectDetailManagement_defaultState.error
      });

    case basicDataActions["a" /* PROJECT_BASIC_DATA */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
    /////////////////////// PROJECT_BUDGET_SOURCE //////////////////////////
    case budgetSourceActions["a" /* PROJECT_BUDGET_SOURCE */].start:
      return projectDetailManagement__extends({}, state, {
        loading: true
      });

    case budgetSourceActions["a" /* PROJECT_BUDGET_SOURCE */].end:
      return projectDetailManagement__extends({}, state, {
        loading: false
      });

    case budgetSourceActions["a" /* PROJECT_BUDGET_SOURCE */].success:
      return projectDetailManagement__extends({}, state, {
        budget_source: action.data,
        error: projectDetailManagement_defaultState.error
      });

    case budgetSourceActions["a" /* PROJECT_BUDGET_SOURCE */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
    /////////////////////// PROJECT_BUDGET_UTILIZATION //////////////////////////
    case budgetUtilization["a" /* PROJECT_BUDGET_UTILIZATION */].start:
      return projectDetailManagement__extends({}, state, {
        loading: true
      });

    case budgetUtilization["a" /* PROJECT_BUDGET_UTILIZATION */].end:
      return projectDetailManagement__extends({}, state, {
        loading: false
      });

    case budgetUtilization["a" /* PROJECT_BUDGET_UTILIZATION */].success:
      return projectDetailManagement__extends({}, state, {
        budget_utilization: action.data,
        error: projectDetailManagement_defaultState.error
      });

    case budgetUtilization["a" /* PROJECT_BUDGET_UTILIZATION */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
    /////////////////////// PROJECT_DOCUMENT_LIST //////////////////////////
    case documentListActions["b" /* PROJECT_DOCUMENT_LIST */].start:
      return projectDetailManagement__extends({}, state, {
        document_list: projectDetailManagement__extends({}, state.document_list, {
          loading: true
        })
      });

    case documentListActions["b" /* PROJECT_DOCUMENT_LIST */].end:
      return projectDetailManagement__extends({}, state, {
        document_list: projectDetailManagement__extends({}, state.document_list, {
          loading: false
        })
      });

    case documentListActions["b" /* PROJECT_DOCUMENT_LIST */].success:
      return projectDetailManagement__extends({}, state, {
        document_list: projectDetailManagement__extends({}, state.document_list, action.data, {
          categoryList: action.categoryList
        }),
        error: projectDetailManagement_defaultState.error
      });

    case documentListActions["b" /* PROJECT_DOCUMENT_LIST */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
    /////////////////////// PROJECT_OUTPUT_LIST //////////////////////////
    case outputListActions["a" /* PROJECT_OUTPUT_LIST */].start:
      return projectDetailManagement__extends({}, state, {
        output_list: projectDetailManagement__extends({}, state.output_list, {
          loading: true
        })
      });

    case outputListActions["a" /* PROJECT_OUTPUT_LIST */].end:
      return projectDetailManagement__extends({}, state, {
        output_list: projectDetailManagement__extends({}, state.output_list, {
          loading: false
        })
      });

    case outputListActions["a" /* PROJECT_OUTPUT_LIST */].success:
      return projectDetailManagement__extends({}, state, {
        output_list: projectDetailManagement__extends({}, state.output_list, action.data),
        error: projectDetailManagement_defaultState.error
      });

    case outputListActions["a" /* PROJECT_OUTPUT_LIST */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
    /////////////////////// PROJECT_OUTPUT_RESULTS //////////////////////////
    case outputResultsActions["a" /* PROJECT_OUTPUT_RESULTS */].start:
      return projectDetailManagement__extends({}, state, {
        loading: true
      });

    case outputResultsActions["a" /* PROJECT_OUTPUT_RESULTS */].end:
      return projectDetailManagement__extends({}, state, {
        loading: false
      });

    case outputResultsActions["a" /* PROJECT_OUTPUT_RESULTS */].success:
      var data = JSON.parse(JSON.stringify(state.output_list.data));
      data[action.index].output_results = action.data[0];
      return projectDetailManagement__extends({}, state, {
        output_list: projectDetailManagement__extends({}, state.output_list, {
          data: data
        }),
        error: projectDetailManagement_defaultState.error
      });

    case outputResultsActions["a" /* PROJECT_OUTPUT_RESULTS */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
    /////////////////////// PROJECT_OUTPUT_DETAIL //////////////////////////
    case outputDetailActions["a" /* PROJECT_OUTPUT_DETAIL */].start:
      return projectDetailManagement__extends({}, state, {
        loading: true
      });

    case outputDetailActions["a" /* PROJECT_OUTPUT_DETAIL */].end:
      return projectDetailManagement__extends({}, state, {
        loading: false
      });

    case outputDetailActions["a" /* PROJECT_OUTPUT_DETAIL */].success:
      var data = JSON.parse(JSON.stringify(state.output_list.data));
      data[action.index].output_detail = action.data[0];
      return projectDetailManagement__extends({}, state, {
        output_list: projectDetailManagement__extends({}, state.output_list, {
          data: data
        }),
        error: projectDetailManagement_defaultState.error
      });

    case outputDetailActions["a" /* PROJECT_OUTPUT_DETAIL */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });

    /////////////////////// PROJECT_TIMELINE //////////////////////////
    case timeLineActions["a" /* PROJECT_TIME_LINE */].start:
      return projectDetailManagement__extends({}, state, {
        loading: true
      });

    case timeLineActions["a" /* PROJECT_TIME_LINE */].end:
      return projectDetailManagement__extends({}, state, {
        loading: false
      });

    case timeLineActions["a" /* PROJECT_TIME_LINE */].success:
      return projectDetailManagement__extends({}, state, {
        time_line: action.data,
        error: projectDetailManagement_defaultState.error
      });

    case timeLineActions["a" /* PROJECT_TIME_LINE */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
    /////////////////////// DOCUMENTS_FILTERED //////////////////////////
    case documentListActions["a" /* DOCUMENT_LIST_FILTERED */].start:
      return projectDetailManagement__extends({}, state, {
        document_list_filtered: projectDetailManagement__extends({}, state.document_list_filtered, {
          loading: true
        })
      });

    case documentListActions["a" /* DOCUMENT_LIST_FILTERED */].end:
      return projectDetailManagement__extends({}, state, {
        document_list_filtered: projectDetailManagement__extends({}, state.document_list_filtered, {
          loading: false
        })
      });

    case documentListActions["a" /* DOCUMENT_LIST_FILTERED */].success:
      return projectDetailManagement__extends({}, state, {
        document_list_filtered: projectDetailManagement__extends({}, state.document_list_filtered, action.data),
        error: projectDetailManagement_defaultState.error
      });

    case documentListActions["a" /* DOCUMENT_LIST_FILTERED */].swap:
      return projectDetailManagement__extends({}, state, {
        document_list_filtered: action.data
      });

    case documentListActions["a" /* DOCUMENT_LIST_FILTERED */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
    ////////////////// PROJECT PURCHASE_ORDERS //////////////////////

    case purchaseOrderActions["a" /* PROJECT_PURCHASE_ORDERS */].start:
      return projectDetailManagement__extends({}, state, {
        purchase_orders: projectDetailManagement__extends({}, state.purchase_orders, {
          loading: true
        })
      });

    case purchaseOrderActions["a" /* PROJECT_PURCHASE_ORDERS */].end:
      return projectDetailManagement__extends({}, state, {
        purchase_orders: projectDetailManagement__extends({}, state.purchase_orders, {
          loading: false
        })
      });

    case purchaseOrderActions["a" /* PROJECT_PURCHASE_ORDERS */].success:
      return projectDetailManagement__extends({}, state, {
        purchase_orders: projectDetailManagement__extends({}, state.purchase_orders, action.data),
        error: projectDetailManagement_defaultState.error
      });

    case purchaseOrderActions["a" /* PROJECT_PURCHASE_ORDERS */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
    case clearProjectDataActions["a" /* PROJECT_DATA_CLEAR */].clear:
      {
        return projectDetailManagement_defaultState;
      }
    ////////////////// PROJECT PICTURE_GALLERY //////////////////////

    case projectGallery["a" /* PROJECT_GALLERY */].start:
      return projectDetailManagement__extends({}, state, {
        picture_gallery: projectDetailManagement__extends({}, state.picture_gallery, {
          loading: true
        })
      });

    case projectGallery["a" /* PROJECT_GALLERY */].end:
      return projectDetailManagement__extends({}, state, {
        picture_gallery: projectDetailManagement__extends({}, state.picture_gallery, {
          loading: false
        })
      });

    case projectGallery["a" /* PROJECT_GALLERY */].success:
      return projectDetailManagement__extends({}, state, {
        picture_gallery: projectDetailManagement__extends({}, state.picture_gallery, {
          data: action.pictureList
        }),
        error: projectDetailManagement_defaultState.error
      });

    case projectGallery["a" /* PROJECT_GALLERY */].failed:
      return projectDetailManagement__extends({}, state, {
        error: action.errors
      });
  }
});
// EXTERNAL MODULE: ./shared/actions/getProjectList.js
var getProjectList = __webpack_require__("STnb");

// CONCATENATED MODULE: ./shared/reducers/projectList.js
var projectList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var projectList_defaultState = {
  projectList: {
    count: "",
    links: {},
    data: []
  },
  loading: false,
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var projectList = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : projectList_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getProjectList["a" /* PROJECT_LIST */].start:
      return projectList__extends({}, state, {
        loading: true
      });

    case getProjectList["a" /* PROJECT_LIST */].end:
      return projectList__extends({}, state, {
        loading: false
      });

    case getProjectList["a" /* PROJECT_LIST */].success:
      return projectList__extends({}, state, {
        projectList: action.data,
        error: projectList_defaultState.error
      });

    case getProjectList["a" /* PROJECT_LIST */].failed:
      return projectList__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecipientBasicDetails.js
var getRecipientBasicDetails = __webpack_require__("4SAh");

// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/getRecipientBasicDetails.js
var getRecipientBasicDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getRecipientBasicDetails_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {
    budget: "",
    expense: "",
    project_count: "",
    budget_sources: ""
  }
};

/* harmony default export */ var recipientReducer_getRecipientBasicDetails = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRecipientBasicDetails_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecipientBasicDetails["a" /* RECIPIENT_BASIC */].start:
      return getRecipientBasicDetails__extends({}, getRecipientBasicDetails_defaultState, {
        loading: true
      });

    case getRecipientBasicDetails["a" /* RECIPIENT_BASIC */].end:
      return getRecipientBasicDetails__extends({}, state, {
        loading: false
      });

    case getRecipientBasicDetails["a" /* RECIPIENT_BASIC */].success:
      return getRecipientBasicDetails__extends({}, state, {
        data: action.data,
        error: getRecipientBasicDetails_defaultState.error
      });

    case getRecipientBasicDetails["a" /* RECIPIENT_BASIC */].failed:
      return getRecipientBasicDetails__extends({}, state, {
        error: action.errors
      });
    case getRecipientBasicDetails["a" /* RECIPIENT_BASIC */].clear:
      return getRecipientBasicDetails__extends({}, getRecipientBasicDetails_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecipientTheme.js
var getRecipientTheme = __webpack_require__("gaAf");

// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/getRecipientTheme.js
var getRecipientTheme__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getRecipientTheme_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: [
    // {
    //     sector_name: '',
    //     sector: '',
    //     expense: '',
    //     theme_budget: '',
    //     percentage: ''
    // }
  ],
  themeAggregate: 0
};

/* harmony default export */ var recipientReducer_getRecipientTheme = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRecipientTheme_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecipientTheme["a" /* RECIPIENT_THEME */].start:
      return getRecipientTheme__extends({}, getRecipientTheme_defaultState, {
        loading: true
      });

    case getRecipientTheme["a" /* RECIPIENT_THEME */].end:
      return getRecipientTheme__extends({}, state, {
        loading: false
      });

    case getRecipientTheme["a" /* RECIPIENT_THEME */].success:
      return getRecipientTheme__extends({}, state, {
        data: action.data,
        error: getRecipientTheme_defaultState.error
      });

    case getRecipientTheme["a" /* RECIPIENT_THEME */].failed:
      return getRecipientTheme__extends({}, state, {
        error: action.errors
      });
    case getRecipientTheme["b" /* RECIPIENT_THEME_AGGREGATE */]:
      return getRecipientTheme__extends({}, state, {
        themeAggregate: action.themeAggregate
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecipientDocuments.js
var getRecipientDocuments = __webpack_require__("14MA");

// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/getRecipientDocuments.js
var getRecipientDocuments__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getRecipientDocuments_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: [],
  categoryList: []
};

/* harmony default export */ var recipientReducer_getRecipientDocuments = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRecipientDocuments_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecipientDocuments["a" /* RECIPIENT_DOCUMENTS */].start:
      return getRecipientDocuments__extends({}, state, {
        loading: true
      });

    case getRecipientDocuments["a" /* RECIPIENT_DOCUMENTS */].end:
      return getRecipientDocuments__extends({}, state, {
        loading: false
      });

    case getRecipientDocuments["a" /* RECIPIENT_DOCUMENTS */].success:
      return getRecipientDocuments__extends({}, state, {
        data: action.data,
        error: getRecipientDocuments_defaultState.error,
        categoryList: action.categoryList
      });

    case getRecipientDocuments["a" /* RECIPIENT_DOCUMENTS */].failed:
      return getRecipientDocuments__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecipientTopBugetSources.js
var getRecipientTopBugetSources = __webpack_require__("0Z3F");

// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/getRecipientTopBugetSources.js
var getRecipientTopBugetSources__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getRecipientTopBugetSources_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var recipientReducer_getRecipientTopBugetSources = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRecipientTopBugetSources_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecipientTopBugetSources["a" /* RECIPIENT_TOP_BUDGET_SOURCES */].start:
      return getRecipientTopBugetSources__extends({}, getRecipientTopBugetSources_defaultState, {
        loading: true
      });

    case getRecipientTopBugetSources["a" /* RECIPIENT_TOP_BUDGET_SOURCES */].end:
      return getRecipientTopBugetSources__extends({}, state, {
        loading: false
      });

    case getRecipientTopBugetSources["a" /* RECIPIENT_TOP_BUDGET_SOURCES */].success:
      return getRecipientTopBugetSources__extends({}, state, {
        data: action.data,
        error: getRecipientTopBugetSources_defaultState.error
      });

    case getRecipientTopBugetSources["a" /* RECIPIENT_TOP_BUDGET_SOURCES */].failed:
      return getRecipientTopBugetSources__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecipientWindRoseDetails.js
var getRecipientWindRoseDetails = __webpack_require__("8YPz");

// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/getRecipientWindRoseDetails.js
var getRecipientWindRoseDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getRecipientWindRoseDetails_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: [],
  sectorColor: "",
  initialSector: "",
  year: ""
};

/* harmony default export */ var recipientReducer_getRecipientWindRoseDetails = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRecipientWindRoseDetails_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecipientWindRoseDetails["a" /* RECIPIENT_WIND_ROSE */].start:
      return getRecipientWindRoseDetails__extends({}, getRecipientWindRoseDetails_defaultState, {
        loading: true
      });

    case getRecipientWindRoseDetails["a" /* RECIPIENT_WIND_ROSE */].end:
      return getRecipientWindRoseDetails__extends({}, state, {
        loading: false
      });

    case getRecipientWindRoseDetails["a" /* RECIPIENT_WIND_ROSE */].success:
      return getRecipientWindRoseDetails__extends({}, state, {
        data: action.data,
        initialSector: action.initialSector,
        sectorColor: action.sectorColor,
        year: action.year,
        error: getRecipientWindRoseDetails_defaultState.error
      });

    case getRecipientWindRoseDetails["a" /* RECIPIENT_WIND_ROSE */].failed:
      return getRecipientWindRoseDetails__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecepientBudgetVsExpense.js
var getRecepientBudgetVsExpense = __webpack_require__("EMSi");

// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/getRecipientBudgetVsExpenseDetails.js
var getRecipientBudgetVsExpenseDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getRecipientBudgetVsExpenseDetails_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var getRecipientBudgetVsExpenseDetails = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRecipientBudgetVsExpenseDetails_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecepientBudgetVsExpense["a" /* RECEPIENT_BUDGET_VS_EXPENSE */].start:
      return getRecipientBudgetVsExpenseDetails__extends({}, getRecipientBudgetVsExpenseDetails_defaultState, {
        loading: true
      });

    case getRecepientBudgetVsExpense["a" /* RECEPIENT_BUDGET_VS_EXPENSE */].end:
      return getRecipientBudgetVsExpenseDetails__extends({}, state, {
        loading: false
      });

    case getRecepientBudgetVsExpense["a" /* RECEPIENT_BUDGET_VS_EXPENSE */].success:
      return getRecipientBudgetVsExpenseDetails__extends({}, state, {
        data: action.data,
        error: getRecipientBudgetVsExpenseDetails_defaultState.error
      });

    case getRecepientBudgetVsExpense["a" /* RECEPIENT_BUDGET_VS_EXPENSE */].failed:
      return getRecipientBudgetVsExpenseDetails__extends({}, state, {
        error: action.errors
      });
    case getRecepientBudgetVsExpense["a" /* RECEPIENT_BUDGET_VS_EXPENSE */].clear:
      return getRecipientBudgetVsExpenseDetails__extends({}, getRecipientBudgetVsExpenseDetails_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/budgetVsExpenseCharts.js
var budgetVsExpenseCharts = __webpack_require__("E1kG");

// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/budgetVsExpenseCharts.js
var budgetVsExpenseCharts__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var budgetVsExpenseCharts_defaultState = {
  groupedBarChartData: {
    sectorName: "",
    budget: "",
    expense: "",
    displayWrapper: false
  }
};

/* harmony default export */ var recipientReducer_budgetVsExpenseCharts = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : budgetVsExpenseCharts_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case budgetVsExpenseCharts["a" /* UPDATE_SELCTED_ARC_BAR_CHART_DATA */]:
      return budgetVsExpenseCharts__extends({}, state, {
        sectorName: action.data.sectorName,
        budget: action.data.budget,
        expense: action.data.expense,
        displayWrapper: action.data.displayWrapper
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecepientbudgetVsExpenseSdg.js
var getRecepientbudgetVsExpenseSdg = __webpack_require__("X5/k");

// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/getRecepientbudgetVsExpenseSdg.js
var getRecepientbudgetVsExpenseSdg__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getRecepientbudgetVsExpenseSdg_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var recipientReducer_getRecepientbudgetVsExpenseSdg = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRecepientbudgetVsExpenseSdg_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecepientbudgetVsExpenseSdg["a" /* RECIPIENT_BUDGET_VS_EXPENSE_SDG */].start:
      return getRecepientbudgetVsExpenseSdg__extends({}, getRecepientbudgetVsExpenseSdg_defaultState, {
        loading: true
      });

    case getRecepientbudgetVsExpenseSdg["a" /* RECIPIENT_BUDGET_VS_EXPENSE_SDG */].end:
      return getRecepientbudgetVsExpenseSdg__extends({}, state, {
        loading: false
      });

    case getRecepientbudgetVsExpenseSdg["a" /* RECIPIENT_BUDGET_VS_EXPENSE_SDG */].success:
      return getRecepientbudgetVsExpenseSdg__extends({}, state, {
        data: action.data,
        error: getRecepientbudgetVsExpenseSdg_defaultState.error
      });

    case getRecepientbudgetVsExpenseSdg["a" /* RECIPIENT_BUDGET_VS_EXPENSE_SDG */].failed:
      return getRecepientbudgetVsExpenseSdg__extends({}, state, {
        error: action.errors
      });
    case getRecepientbudgetVsExpenseSdg["a" /* RECIPIENT_BUDGET_VS_EXPENSE_SDG */].clear:
      return getRecepientbudgetVsExpenseSdg__extends({}, getRecepientbudgetVsExpenseSdg_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecepientSdg.js
var getRecepientSdg = __webpack_require__("wD7O");

// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/getRecepientSdg.js
var getRecepientSdg__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getRecepientSdg_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: [],
  sdgAggregate: 0
};

/* harmony default export */ var recipientReducer_getRecepientSdg = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRecepientSdg_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecepientSdg["a" /* RECIPIENT_SDG */].start:
      return getRecepientSdg__extends({}, getRecepientSdg_defaultState, {
        loading: true
      });

    case getRecepientSdg["a" /* RECIPIENT_SDG */].end:
      return getRecepientSdg__extends({}, state, {
        loading: false
      });

    case getRecepientSdg["a" /* RECIPIENT_SDG */].success:
      return getRecepientSdg__extends({}, state, {
        data: action.data,
        error: getRecepientSdg_defaultState.error
      });

    case getRecepientSdg["a" /* RECIPIENT_SDG */].failed:
      return getRecepientSdg__extends({}, state, {
        error: action.errors
      });

    case getRecepientSdg["b" /* RECIPIENT_SDG_AGGREGATE */]:
      return getRecepientSdg__extends({}, state, {
        sdgAggregate: action.sdgAggregate
      });

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./components/profilePage/reducer/recipientReducer/index.js










/* harmony default export */ var recipientReducer = (Object(es["c" /* combineReducers */])({
  basicDetails: recipientReducer_getRecipientBasicDetails,
  themeBudget: recipientReducer_getRecipientTheme,
  documentList: recipientReducer_getRecipientDocuments,
  topBudgetSources: recipientReducer_getRecipientTopBugetSources,
  windRose: recipientReducer_getRecipientWindRoseDetails,
  budgetVsExpense: getRecipientBudgetVsExpenseDetails,
  budgetVsExpenseSdg: recipientReducer_getRecepientbudgetVsExpenseSdg,
  budgetExpenseChartData: recipientReducer_budgetVsExpenseCharts,
  recepientSdg: recipientReducer_getRecepientSdg
}));
// EXTERNAL MODULE: ./components/profilePage/actions/donorActions/getDonorBasicDetails.js
var getDonorBasicDetails = __webpack_require__("D/4b");

// CONCATENATED MODULE: ./components/profilePage/reducer/donorReducer/getDonorBasicDetails.js
var getDonorBasicDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getDonorBasicDetails_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {
    budget: "",
    direct_funded_projects: "",
    regular_resources: ""
  }
};

/* harmony default export */ var donorReducer_getDonorBasicDetails = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDonorBasicDetails_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getDonorBasicDetails["a" /* DONOR_BASIC */].start:
      return getDonorBasicDetails__extends({}, getDonorBasicDetails_defaultState, {
        loading: true
      });

    case getDonorBasicDetails["a" /* DONOR_BASIC */].end:
      return getDonorBasicDetails__extends({}, state, {
        loading: false
      });

    case getDonorBasicDetails["a" /* DONOR_BASIC */].success:
      return getDonorBasicDetails__extends({}, state, {
        data: action.data,
        error: getDonorBasicDetails_defaultState.error
      });

    case getDonorBasicDetails["a" /* DONOR_BASIC */].failed:
      return getDonorBasicDetails__extends({}, state, {
        error: action.errors
      });
    case getDonorBasicDetails["a" /* DONOR_BASIC */].clear:
      return getDonorBasicDetails__extends({}, getDonorBasicDetails_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/donorActions/getRegularAndOtherDetails.js
var getRegularAndOtherDetails = __webpack_require__("LBmb");

// CONCATENATED MODULE: ./components/profilePage/reducer/donorReducer/getRegularAndOtherDetails.js
var getRegularAndOtherDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getRegularAndOtherDetails_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {
    total: [],
    country: []
  },
  countryAggregate: 0
};

/* harmony default export */ var donorReducer_getRegularAndOtherDetails = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRegularAndOtherDetails_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRegularAndOtherDetails["a" /* REGULAR_AND_OTHERS */].start:
      return getRegularAndOtherDetails__extends({}, getRegularAndOtherDetails_defaultState, {
        loading: true
      });

    case getRegularAndOtherDetails["a" /* REGULAR_AND_OTHERS */].end:
      return getRegularAndOtherDetails__extends({}, state, {
        loading: false
      });

    case getRegularAndOtherDetails["a" /* REGULAR_AND_OTHERS */].success:
      return getRegularAndOtherDetails__extends({}, state, {
        data: action.data,
        error: getRegularAndOtherDetails_defaultState.error
      });

    case getRegularAndOtherDetails["a" /* REGULAR_AND_OTHERS */].failed:
      return getRegularAndOtherDetails__extends({}, state, {
        error: action.errors
      });
    case getRegularAndOtherDetails["a" /* REGULAR_AND_OTHERS */].clear:
      return getRegularAndOtherDetails__extends({}, getRegularAndOtherDetails_defaultState, {
        loading: true
      });

    case getRegularAndOtherDetails["b" /* REGULAR_AND_OTHERS_UPDATE_COUNTRY_AGGREGATE */]:
      return getRegularAndOtherDetails__extends({}, state, {
        countryAggregate: action.countryAggregate
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/donorActions/getResourcesModalityContribution.js
var getResourcesModalityContribution = __webpack_require__("Wc36");

// CONCATENATED MODULE: ./components/profilePage/reducer/donorReducer/getResourcesModalityContribution.js
var getResourcesModalityContribution__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getResourcesModalityContribution_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {
    total: [],
    country: []
  },
  countryAggregate: 0
};

/* harmony default export */ var donorReducer_getResourcesModalityContribution = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getResourcesModalityContribution_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getResourcesModalityContribution["a" /* RESOURCES_MODALITY_CONTRIBUTION */].start:
      return getResourcesModalityContribution__extends({}, getResourcesModalityContribution_defaultState, {
        loading: true
      });

    case getResourcesModalityContribution["a" /* RESOURCES_MODALITY_CONTRIBUTION */].end:
      return getResourcesModalityContribution__extends({}, state, {
        loading: false
      });

    case getResourcesModalityContribution["a" /* RESOURCES_MODALITY_CONTRIBUTION */].success:
      return getResourcesModalityContribution__extends({}, state, {
        data: action.data,
        error: getResourcesModalityContribution_defaultState.error
      });

    case getResourcesModalityContribution["a" /* RESOURCES_MODALITY_CONTRIBUTION */].failed:
      return getResourcesModalityContribution__extends({}, state, {
        error: action.errors
      });
    case getResourcesModalityContribution["a" /* RESOURCES_MODALITY_CONTRIBUTION */].clear:
      return getResourcesModalityContribution__extends({}, getResourcesModalityContribution_defaultState, {
        loading: true
      });
    case getResourcesModalityContribution["b" /* RESOURCES_MODALITY_CONTRIBUTION_COUNTRY_AGGREGATE */]:
      return getResourcesModalityContribution__extends({}, state, {
        countryAggregate: action.countryAggregate
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/donorActions/getTopRecipientOffices.js
var getTopRecipientOffices = __webpack_require__("XId4");

// CONCATENATED MODULE: ./components/profilePage/reducer/donorReducer/getTopRecipientOffices.js
var getTopRecipientOffices__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getTopRecipientOffices_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var donorReducer_getTopRecipientOffices = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getTopRecipientOffices_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getTopRecipientOffices["a" /* RECIPIENT_TOP_OFFICES */].start:
      return getTopRecipientOffices__extends({}, getTopRecipientOffices_defaultState, {
        loading: true
      });

    case getTopRecipientOffices["a" /* RECIPIENT_TOP_OFFICES */].end:
      return getTopRecipientOffices__extends({}, state, {
        loading: false
      });

    case getTopRecipientOffices["a" /* RECIPIENT_TOP_OFFICES */].success:
      return getTopRecipientOffices__extends({}, state, {
        data: action.data,
        error: getTopRecipientOffices_defaultState.error
      });

    case getTopRecipientOffices["a" /* RECIPIENT_TOP_OFFICES */].failed:
      return getTopRecipientOffices__extends({}, state, {
        error: action.errors
      });
    case getTopRecipientOffices["a" /* RECIPIENT_TOP_OFFICES */].clear:
      return getTopRecipientOffices__extends({}, getTopRecipientOffices_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/profilePage/actions/donorActions/getBudgetSources.js
var getBudgetSources = __webpack_require__("zXJO");

// CONCATENATED MODULE: ./components/profilePage/reducer/donorReducer/getBudgetSources.js
var getBudgetSources__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var getBudgetSources_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var donorReducer_getBudgetSources = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getBudgetSources_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getBudgetSources["a" /* DONOR_BUDGET_SOURCES */].start:
      return getBudgetSources__extends({}, getBudgetSources_defaultState, {
        loading: true
      });

    case getBudgetSources["a" /* DONOR_BUDGET_SOURCES */].end:
      return getBudgetSources__extends({}, state, {
        loading: false
      });

    case getBudgetSources["a" /* DONOR_BUDGET_SOURCES */].success:
      return getBudgetSources__extends({}, state, {
        data: action.data,
        error: getBudgetSources_defaultState.error
      });

    case getBudgetSources["a" /* DONOR_BUDGET_SOURCES */].failed:
      return getBudgetSources__extends({}, state, {
        error: action.errors
      });
    case getBudgetSources["a" /* DONOR_BUDGET_SOURCES */].clear:
      return getBudgetSources__extends({}, getBudgetSources_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./components/profilePage/reducer/donorReducer/index.js






/* harmony default export */ var donorReducer = (Object(es["c" /* combineReducers */])({
  basicDetails: donorReducer_getDonorBasicDetails,
  regularAndOthers: donorReducer_getRegularAndOtherDetails,
  resourcesModalityContribution: donorReducer_getResourcesModalityContribution,
  topRecipientOffices: donorReducer_getTopRecipientOffices,
  budgetSources: donorReducer_getBudgetSources
}));
// CONCATENATED MODULE: ./shared/actions/yearSelectActions.js
var YEAR_SELECTION = {
  start: "fetch_start/year_selection",
  end: "fetch_end/year_selection",
  success: "fetch_success/year_selection",
  failed: "fetch_failed/year_selection"
};
// On Project Select
var yearSelectionFetchStart = function yearSelectionFetchStart() {
  return {
    type: YEAR_SELECTION.start
  };
};

var yearSelectionFetchEnd = function yearSelectionFetchEnd() {
  return {
    type: YEAR_SELECTION.end
  };
};

var yearSelectionFetchSuccess = function yearSelectionFetchSuccess(year) {
  return {
    type: YEAR_SELECTION.success,
    year: year
  };
};

var yearSelectionFetchFailed = function yearSelectionFetchFailed(error) {
  return {
    type: YEAR_SELECTION.failed,
    error: error
  };
};
// CONCATENATED MODULE: ./shared/reducers/yearSelectManagement.js
var yearSelectManagement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var yearSelectManagement_defaultState = {
  loading: false,
  year: "",
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var yearSelectManagement = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : yearSelectManagement_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case YEAR_SELECTION.start:
      return yearSelectManagement__extends({}, state, {
        loading: true
      });

    case YEAR_SELECTION.end:
      return yearSelectManagement__extends({}, state, {
        loading: false
      });

    case YEAR_SELECTION.success:
      return yearSelectManagement__extends({}, state, {
        year: action.year,
        error: yearSelectManagement_defaultState.error
      });

    case YEAR_SELECTION.failed:
      return yearSelectManagement__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/commonDataActions.js
var commonDataActions = __webpack_require__("b7sF");

// CONCATENATED MODULE: ./shared/reducers/countryListManagement.js
var countryListManagement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/



var countryListManagement_defaultState = {
  loading: false,
  countries: [],
  error: {
    message: "",
    code: ""
  },
  filteredCountryList: []
};

/* harmony default export */ var countryListManagement = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : countryListManagement_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["a" /* COUNTRY_LIST */].start:
      return countryListManagement__extends({}, state, {
        loading: true
      });

    case commonDataActions["a" /* COUNTRY_LIST */].end:
      return countryListManagement__extends({}, state, {
        loading: false
      });

    case commonDataActions["a" /* COUNTRY_LIST */].success:
      return countryListManagement__extends({}, state, {
        countries: action.countries,
        filteredCountryList: action.countries,
        error: countryListManagement_defaultState.error
      });

    case commonDataActions["a" /* COUNTRY_LIST */].failed:
      return countryListManagement__extends({}, state, {
        error: action.errors
      });
    case commonDataActions["i" /* SEARCH_COUNTRY_LIST */].start:
      return countryListManagement__extends({}, state, {
        loading: true
      });

    case commonDataActions["i" /* SEARCH_COUNTRY_LIST */].end:
      return countryListManagement__extends({}, state, {
        loading: false
      });

    case commonDataActions["i" /* SEARCH_COUNTRY_LIST */].success:
      return countryListManagement__extends({}, state, {
        filteredCountryList: action.countries,
        error: countryListManagement_defaultState.error
      });

    case commonDataActions["i" /* SEARCH_COUNTRY_LIST */].failed:
      return countryListManagement__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/reducers/projectTimelineRangeManagement.js
var projectTimelineRangeManagement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var projectTimelineRangeManagement_defaultState = {
  loading: false,
  year: [],
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var projectTimelineRangeManagement = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : projectTimelineRangeManagement_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["h" /* PROJECT_TIMELINE */].start:
      return projectTimelineRangeManagement__extends({}, state, {
        loading: true
      });

    case commonDataActions["h" /* PROJECT_TIMELINE */].end:
      return projectTimelineRangeManagement__extends({}, state, {
        loading: false
      });

    case commonDataActions["h" /* PROJECT_TIMELINE */].success:
      return projectTimelineRangeManagement__extends({}, state, {
        year: action.year,
        error: projectTimelineRangeManagement_defaultState.error
      });

    case commonDataActions["h" /* PROJECT_TIMELINE */].failed:
      return projectTimelineRangeManagement__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/getGeneralInfo.js
var getGeneralInfo = __webpack_require__("2Ed7");

// CONCATENATED MODULE: ./shared/reducers/generalInfo.js
var generalInfo__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var generalInfo_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: null
};

/* harmony default export */ var generalInfo = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generalInfo_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getGeneralInfo["a" /* GENERAL_INFO */].start:
      return generalInfo__extends({}, state, {
        loading: true
      });

    case getGeneralInfo["a" /* GENERAL_INFO */].end:
      return generalInfo__extends({}, state, {
        loading: false
      });

    case getGeneralInfo["a" /* GENERAL_INFO */].success:
      return generalInfo__extends({}, state, {
        data: action.data.data,
        error: generalInfo_defaultState.error
      });

    case getGeneralInfo["a" /* GENERAL_INFO */].failed:
      return generalInfo__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/reducers/themeDataManagement.js
var themeDataManagement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var themeDataManagement_defaultState = {
  loading: false,
  themes: [],
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var themeDataManagement = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeDataManagement_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case actions["a" /* THEME_SUMMARY */].start:
      return themeDataManagement__extends({}, state, {
        loading: true
      });

    case actions["a" /* THEME_SUMMARY */].end:
      return themeDataManagement__extends({}, state, {
        loading: false
      });

    case actions["a" /* THEME_SUMMARY */].success:
      return themeDataManagement__extends({}, state, {
        themes: action.data,
        error: themeDataManagement_defaultState.error
      });

    case actions["a" /* THEME_SUMMARY */].failed:
      return themeDataManagement__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/reducers/themeListManagement.js
var themeListManagement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var themeListManagement_defaultState = {
  loading: false,
  masterThemeList: [],
  themes: [],
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var themeListManagement = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeListManagement_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["k" /* THEME_LIST */].start:
      return themeListManagement__extends({}, state, {
        loading: true
      });

    case commonDataActions["k" /* THEME_LIST */].end:
      return themeListManagement__extends({}, state, {
        loading: false
      });

    case commonDataActions["k" /* THEME_LIST */].success:
      return themeListManagement__extends({}, state, {
        themes: action.themes
      });

    case commonDataActions["k" /* THEME_LIST */].failed:
      return themeListManagement__extends({}, state, {
        error: action.errors
      });

    case commonDataActions["k" /* THEME_LIST */].updateList:
      return themeListManagement__extends({}, state, {
        masterThemeList: action.themes
      });

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/reducers/operatingUnits.js
var operatingUnits__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var operatingUnits_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var reducers_operatingUnits = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : operatingUnits_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["g" /* OPERATING_UNITS */].start:
      return operatingUnits__extends({}, state, {
        loading: true
      });

    case commonDataActions["g" /* OPERATING_UNITS */].end:
      return operatingUnits__extends({}, state, {
        loading: false
      });

    case commonDataActions["g" /* OPERATING_UNITS */].success:
      return operatingUnits__extends({}, state, action.operatingUnitlist, {
        error: operatingUnits_defaultState.error
      });

    case commonDataActions["g" /* OPERATING_UNITS */].failed:
      return operatingUnits__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/reducers/masterDonorListManagement.js
var masterDonorListManagement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var masterDonorListManagement_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var masterDonorListManagement = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : masterDonorListManagement_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["d" /* DONOR_LIST */].start:
      return masterDonorListManagement__extends({}, state, {
        loading: true
      });

    case commonDataActions["d" /* DONOR_LIST */].end:
      return masterDonorListManagement__extends({}, state, {
        loading: false
      });

    case commonDataActions["d" /* DONOR_LIST */].success:
      return masterDonorListManagement__extends({}, state, action.donorList, {
        error: masterDonorListManagement_defaultState.error
      });

    case commonDataActions["d" /* DONOR_LIST */].failed:
      return masterDonorListManagement__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/reducers/documentCategories.js
var documentCategories__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var documentCategories_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var documentCategories = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : documentCategories_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["b" /* DOCUMENT_CATEGORIES */].start:
      return documentCategories__extends({}, state, {
        loading: true
      });

    case commonDataActions["b" /* DOCUMENT_CATEGORIES */].end:
      return documentCategories__extends({}, state, {
        loading: false
      });

    case commonDataActions["b" /* DOCUMENT_CATEGORIES */].success:
      return documentCategories__extends({}, state, {
        data: [].concat(action.DocumentCategories),
        error: documentCategories_defaultState.error
      });

    case commonDataActions["b" /* DOCUMENT_CATEGORIES */].failed:
      return documentCategories__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/reducers/documentCategoryAll.js
var documentCategoryAll__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var documentCategoryAll_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var documentCategoryAll = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : documentCategoryAll_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["c" /* DOCUMENT_CATEGORIES_ALL */].start:
      return documentCategoryAll__extends({}, state, {
        loading: true
      });

    case commonDataActions["c" /* DOCUMENT_CATEGORIES_ALL */].end:
      return documentCategoryAll__extends({}, state, {
        loading: false
      });

    case commonDataActions["c" /* DOCUMENT_CATEGORIES_ALL */].success:
      return documentCategoryAll__extends({}, state, {
        data: [].concat(action.DocumentCategories),
        error: documentCategoryAll_defaultState.error
      });

    case commonDataActions["c" /* DOCUMENT_CATEGORIES_ALL */].failed:
      return documentCategoryAll__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/nestedDropList/actions/index.js
var nestedDropList_actions = __webpack_require__("doLN");

// CONCATENATED MODULE: ./components/nestedDropList/reducer/index.js
var nestedDropList_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var nestedDropList_reducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  searchResultLoading: false,
  searchCountryField: "",
  searchThemesField: "",
  searchSdgField: "",
  searchBarResultLoading: false,
  searchResult: [],
  searchResultTemp: {
    key: {
      countryFieldKey: "",
      sdgFieldKey: "",
      themesFieldKey: ""
    },
    data: []
  },
  searchResultSearchBar: [],
  searchText: "",
  searchDonorText: ""
};

/* harmony default export */ var nestedDropList_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : nestedDropList_reducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case nestedDropList_actions["c" /* OPERATING_UNITS_SEARCH */].start:
      return nestedDropList_reducer__extends({}, state, {
        searchResultLoading: true
      });

    case nestedDropList_actions["c" /* OPERATING_UNITS_SEARCH */].end:
      return nestedDropList_reducer__extends({}, state, {
        searchResultLoading: false
      });

    case nestedDropList_actions["c" /* OPERATING_UNITS_SEARCH */].failed:
      return nestedDropList_reducer__extends({}, state, {
        error: action.errors
      });

    //----------------------
    case nestedDropList_actions["d" /* OPERATING_UNITS_SEARCH_BAR */].start:
      return nestedDropList_reducer__extends({}, state, {
        searchBarResultLoading: true
      });

    case nestedDropList_actions["d" /* OPERATING_UNITS_SEARCH_BAR */].end:
      return nestedDropList_reducer__extends({}, state, {
        searchBarResultLoading: false
      });

    case nestedDropList_actions["d" /* OPERATING_UNITS_SEARCH_BAR */].failed:
      return nestedDropList_reducer__extends({}, state, {
        error: action.errors
      });
    //----------------------

    case nestedDropList_actions["e" /* UPDATE_SEARCH_COUNTRY_FIELD */]:
      return nestedDropList_reducer__extends({}, state, {
        searchCountryField: action.data
      });

    case nestedDropList_actions["k" /* UPDATE_SEARCH_THEMES */]:
      return nestedDropList_reducer__extends({}, state, {
        searchThemesField: action.data
      });
    case nestedDropList_actions["i" /* UPDATE_SEARCH_SDG */]:
      return nestedDropList_reducer__extends({}, state, {
        searchSdgField: action.data
      });

    case nestedDropList_actions["a" /* CLEAR_SEARCH_COUNTRY_FIELD */]:
      return nestedDropList_reducer__extends({}, state, {
        searchCountryField: "",
        searchThemesField: "",
        searchSdgField: ""
      });

    case nestedDropList_actions["g" /* UPDATE_SEARCH_RESULT */]:
      return nestedDropList_reducer__extends({}, state, {
        searchResult: action.data
      });

    case nestedDropList_actions["h" /* UPDATE_SEARCH_RESULT_SEARCH_BAR */]:
      return nestedDropList_reducer__extends({}, state, {
        searchResultSearchBar: action.data
      });

    case nestedDropList_actions["b" /* CLEAR_SEARCH_RESUlt */]:
      return {
        searchResult: []
      };

    case nestedDropList_actions["j" /* UPDATE_SEARCH_TEXT */]:
      return nestedDropList_reducer__extends({}, state, {
        searchText: action.text
      });

    case nestedDropList_actions["f" /* UPDATE_SEARCH_DONOR_TEXT */]:
      return nestedDropList_reducer__extends({}, state, {
        searchDonorText: action.text
      });

    case nestedDropList_actions["l" /* UPDATE_TEMP_SEARCH_RESULT */]:
      return nestedDropList_reducer__extends({}, state, {
        searchResultTemp: nestedDropList_reducer__extends({}, state.searchResultTemp, {
          data: action.data,
          key: nestedDropList_reducer__extends({}, state.searchResultTemp.key, {
            countryFieldKey: action.countryFieldKey,
            sdgFieldKey: action.sdgFieldKey,
            themesFieldKey: action.themesFieldKey
          })
        })
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/getDonorFundAggrList.js
var getDonorFundAggrList = __webpack_require__("6ofl");

// CONCATENATED MODULE: ./shared/reducers/donorFundList.js
var donorFundList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/

var donorFundList_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var donorFundList = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorFundList_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getDonorFundAggrList["a" /* DONOR_FUND_LIST */].start:
      return donorFundList__extends({}, state, {
        loading: true
      });

    case getDonorFundAggrList["a" /* DONOR_FUND_LIST */].end:
      return donorFundList__extends({}, state, {
        loading: false
      });

    case getDonorFundAggrList["a" /* DONOR_FUND_LIST */].success:
      return donorFundList__extends({}, state, {
        data: action.data,
        error: donorFundList_defaultState.error
      });

    case getDonorFundAggrList["a" /* DONOR_FUND_LIST */].failed:
      return donorFundList__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/exportPDF.js
var exportPDF = __webpack_require__("0+k3");

// CONCATENATED MODULE: ./shared/reducers/exportPDF.js
var exportPDF__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/

var exportPDF_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  downloadUrl: undefined,
  previewUrl: undefined
};

/* harmony default export */ var reducers_exportPDF = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exportPDF_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case exportPDF["a" /* EXPORT_PDF */].start:
      return exportPDF__extends({}, state, {
        loading: true
      });

    case exportPDF["a" /* EXPORT_PDF */].end:
      return exportPDF__extends({}, state, {
        loading: false
      });

    case exportPDF["a" /* EXPORT_PDF */].success:
      return exportPDF__extends({}, state, {
        downloadUrl: action.downloadUrl,
        previewUrl: action.previewUrl,
        error: exportPDF_defaultState.error
      });

    case exportPDF["a" /* EXPORT_PDF */].failed:
      return exportPDF__extends({}, state, {
        error: action.errors
      });
    case exportPDF["a" /* EXPORT_PDF */].reset:
      return exportPDF_defaultState;
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/donorsPage/actions/index.js
var donorsPage_actions = __webpack_require__("faXx");

// CONCATENATED MODULE: ./components/donorsPage/reducer/index.js
var donorsPage_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var donorsPage_reducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {},
  totalData: {},
  regularData: {},
  otherData: {},
  totalDataLoading: false,
  regularDataLoading: false,
  otherDataLoading: false
};

/* harmony default export */ var donorsPage_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorsPage_reducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case donorsPage_actions["a" /* DONOR_DATA */].start:
      return donorsPage_reducer__extends({}, state, {
        loading: true
      });

    case donorsPage_actions["a" /* DONOR_DATA */].end:
      return donorsPage_reducer__extends({}, state, {
        loading: false
      });

    case donorsPage_actions["a" /* DONOR_DATA */].success:
      return donorsPage_reducer__extends({}, state, {
        data: action.data,
        error: donorsPage_reducer_defaultState.error
      });

    case donorsPage_actions["a" /* DONOR_DATA */].failed:
      return donorsPage_reducer__extends({}, state, {
        error: action.errors
      });
    case donorsPage_actions["l" /* UPDATE_DONOR_TOTAL_DATA */]:
      return donorsPage_reducer__extends({}, state, {
        totalData: donorsPage_reducer__extends({}, action.data)
      });
    case donorsPage_actions["k" /* UPDATE_DONOR_REGULAR_DATA */]:
      return donorsPage_reducer__extends({}, state, {
        regularData: donorsPage_reducer__extends({}, action.data)
      });
    case donorsPage_actions["j" /* UPDATE_DONOR_OTHER_DATA */]:
      return donorsPage_reducer__extends({}, state, {
        otherData: donorsPage_reducer__extends({}, action.data)
      });

    case donorsPage_actions["g" /* DONOR_TOTAL_DATA_FETCH_START */]:
      return donorsPage_reducer__extends({}, state, {
        totalDataLoading: true
      });
    case donorsPage_actions["c" /* DONOR_OTHER_DATA_FETCH_START */]:
      return donorsPage_reducer__extends({}, state, {
        otherDataLoading: true
      });
    case donorsPage_actions["e" /* DONOR_REGULAR_DATA_FETCH_START */]:
      return donorsPage_reducer__extends({}, state, {
        regularDataLoading: true
      });

    case donorsPage_actions["f" /* DONOR_TOTAL_DATA_FETCH_END */]:
      return donorsPage_reducer__extends({}, state, {
        totalDataLoading: false
      });

    case donorsPage_actions["b" /* DONOR_OTHER_DATA_FETCH_END */]:
      return donorsPage_reducer__extends({}, state, {
        otherDataLoading: false
      });

    case donorsPage_actions["d" /* DONOR_REGULAR_DATA_FETCH_END */]:
      return donorsPage_reducer__extends({}, state, {
        regularDataLoading: false
      });

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./components/donorsPage/reducer/donorTypes.js
var donorTypes__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var donorTypes_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var donorTypes = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorTypes_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case donorsPage_actions["h" /* DONOR_TYPES */].start:
      return donorTypes__extends({}, state, {
        loading: true
      });

    case donorsPage_actions["h" /* DONOR_TYPES */].end:
      return donorTypes__extends({}, state, {
        loading: false
      });

    case donorsPage_actions["h" /* DONOR_TYPES */].success:
      return donorTypes__extends({}, state, {
        data: action.data,
        error: donorTypes_defaultState.error
      });

    case donorsPage_actions["h" /* DONOR_TYPES */].failed:
      return donorTypes__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./components/donorsPage/reducer/fundStreams.js
var fundStreams__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var fundStreams_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var fundStreams = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fundStreams_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case donorsPage_actions["i" /* FUND_STREAMS */].start:
      return fundStreams__extends({}, state, {
        loading: true
      });

    case donorsPage_actions["i" /* FUND_STREAMS */].end:
      return fundStreams__extends({}, state, {
        loading: false
      });

    case donorsPage_actions["i" /* FUND_STREAMS */].success:
      return fundStreams__extends({}, state, {
        data: action.data,
        error: fundStreams_defaultState.error
      });

    case donorsPage_actions["i" /* FUND_STREAMS */].failed:
      return fundStreams__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/themeSlider/actions/index.js
var themeSlider_actions = __webpack_require__("yuQp");

// CONCATENATED MODULE: ./components/themeSlider/reducer/themeSliderData.js
var themeSliderData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var themeSliderData_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var themeSliderData = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeSliderData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case themeSlider_actions["a" /* THEME_SLIDER_DATA */].start:
      return themeSliderData__extends({}, themeSliderData_defaultState, {
        loading: true
      });

    case themeSlider_actions["a" /* THEME_SLIDER_DATA */].end:
      return themeSliderData__extends({}, state, {
        loading: false
      });

    case themeSlider_actions["a" /* THEME_SLIDER_DATA */].success:
      return themeSliderData__extends({}, state, {
        data: action.data,
        error: themeSliderData_defaultState.error
      });

    case themeSlider_actions["a" /* THEME_SLIDER_DATA */].failed:
      return themeSliderData__extends({}, state, {
        error: action.errors
      });
    case themeSlider_actions["a" /* THEME_SLIDER_DATA */].clear:
      return themeSliderData__extends({}, themeSliderData_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/themeSlider/actions/signatureOutcome.js
var signatureOutcome = __webpack_require__("A1ba");

// CONCATENATED MODULE: ./components/themeSlider/reducer/signatureOutcome.js
var signatureOutcome__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var signatureOutcome_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {
    total: [],
    country: []
  },
  countryAggregate: 0
};

/* harmony default export */ var reducer_signatureOutcome = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : signatureOutcome_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case signatureOutcome["b" /* SIGNATURE_OUTCOME_DATA */].start:
      return signatureOutcome__extends({}, signatureOutcome_defaultState, {
        loading: true
      });

    case signatureOutcome["b" /* SIGNATURE_OUTCOME_DATA */].end:
      return signatureOutcome__extends({}, state, {
        loading: false
      });

    case signatureOutcome["b" /* SIGNATURE_OUTCOME_DATA */].success:
      return signatureOutcome__extends({}, state, {
        data: action.data,
        error: signatureOutcome_defaultState.error
      });

    case signatureOutcome["b" /* SIGNATURE_OUTCOME_DATA */].failed:
      return signatureOutcome__extends({}, state, {
        error: action.errors
      });
    case signatureOutcome["b" /* SIGNATURE_OUTCOME_DATA */].clear:
      return signatureOutcome__extends({}, signatureOutcome_defaultState, {
        loading: true
      });
    case signatureOutcome["a" /* SIGNATURE_OUTCOME_AGGREGATE */]:
      return signatureOutcome__extends({}, state, {
        countryAggregate: action.countryAggregate
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/themeSlider/actions/signatureDonor.js
var signatureDonor = __webpack_require__("6W2b");

// CONCATENATED MODULE: ./components/themeSlider/reducer/signatureDonor.js
var signatureDonor__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var signatureDonor_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var reducer_signatureDonor = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : signatureDonor_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case signatureDonor["a" /* SIGNATURE_SLIDER_DATA */].start:
      return signatureDonor__extends({}, signatureDonor_defaultState, {
        loading: true
      });

    case signatureDonor["a" /* SIGNATURE_SLIDER_DATA */].end:
      return signatureDonor__extends({}, state, {
        loading: false
      });

    case signatureDonor["a" /* SIGNATURE_SLIDER_DATA */].success:
      return signatureDonor__extends({}, state, {
        data: action.data,
        error: signatureDonor_defaultState.error
      });

    case signatureDonor["a" /* SIGNATURE_SLIDER_DATA */].failed:
      return signatureDonor__extends({}, state, {
        error: action.errors
      });
    case signatureDonor["a" /* SIGNATURE_SLIDER_DATA */].clear:
      return signatureDonor__extends({}, signatureDonor_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/sdgSlider/actions/index.js
var sdgSlider_actions = __webpack_require__("aYEV");

// CONCATENATED MODULE: ./components/sdgSlider/reducer/index.js
var sdgSlider_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var sdgSlider_reducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var sdgSlider_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sdgSlider_reducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case sdgSlider_actions["a" /* SDG_SLIDER_DATA */].start:
      return sdgSlider_reducer__extends({}, sdgSlider_reducer_defaultState, {
        loading: true
      });

    case sdgSlider_actions["a" /* SDG_SLIDER_DATA */].end:
      return sdgSlider_reducer__extends({}, state, {
        loading: false
      });

    case sdgSlider_actions["a" /* SDG_SLIDER_DATA */].success:
      return sdgSlider_reducer__extends({}, state, {
        data: action.data,
        error: sdgSlider_reducer_defaultState.error
      });

    case sdgSlider_actions["a" /* SDG_SLIDER_DATA */].failed:
      return sdgSlider_reducer__extends({}, state, {
        error: action.errors
      });
    case sdgSlider_actions["a" /* SDG_SLIDER_DATA */].clear:
      return sdgSlider_reducer__extends({}, sdgSlider_reducer_defaultState, {
        loading: true
      });
    case sdgSlider_actions["a" /* SDG_SLIDER_DATA */].targetTitle:
      return sdgSlider_reducer__extends({}, state, {
        targetTitle: action.data
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/searchActions.js
var searchActions = __webpack_require__("B37S");

// CONCATENATED MODULE: ./shared/reducers/searchResult.js
var searchResult__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var searchResult_defaultState = {
  loading: false,
  data: [],
  error: {
    message: "",
    code: ""
  },
  searchText: "",
  totalCount: 0,
  draw: ""
};

/* harmony default export */ var searchResult = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchResult_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case searchActions["a" /* SEARCH_ALL_RESULTS */].start:
      return searchResult__extends({}, state, {
        loading: true
      });

    case searchActions["a" /* SEARCH_ALL_RESULTS */].end:
      return searchResult__extends({}, state, {
        loading: false
      });

    case searchActions["a" /* SEARCH_ALL_RESULTS */].success:
      return searchResult__extends({}, state, {
        data: action.data,
        error: searchResult_defaultState.error,
        totalCount: action.totalCount
      });

    case searchActions["a" /* SEARCH_ALL_RESULTS */].failed:
      return searchResult__extends({}, state, {
        error: action.errors
      });

    case searchActions["b" /* UPDATE_SEARCH_TEXT */]:
      return searchResult__extends({}, state, {
        searchText: action.text
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/aboutUs.js
var aboutUs = __webpack_require__("UXBR");

// CONCATENATED MODULE: ./shared/reducers/aboutUs.js
var aboutUs__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var aboutUs_defaultState = {
  contentList: [],
  loading: false,
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var reducers_aboutUs = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : aboutUs_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case aboutUs["a" /* ABOUT_US */].start:
      return aboutUs__extends({}, state, {
        loading: true
      });

    case aboutUs["a" /* ABOUT_US */].end:
      return aboutUs__extends({}, state, {
        loading: false
      });

    case aboutUs["a" /* ABOUT_US */].success:
      return aboutUs__extends({}, state, {
        contentList: action.content,
        error: aboutUs_defaultState.error
      });

    case aboutUs["a" /* ABOUT_US */].failed:
      return aboutUs__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/sdgListActions.js
var sdgListActions = __webpack_require__("8R5k");

// CONCATENATED MODULE: ./shared/reducers/sdgManagement.js
var sdgManagement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var sdgManagement_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  masterSdgList: [],
  data: []
};

/* harmony default export */ var sdgManagement = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sdgManagement_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case sdgListActions["a" /* SDG_LIST */].start:
      return sdgManagement__extends({}, state, {
        loading: true
      });

    case sdgListActions["a" /* SDG_LIST */].end:
      return sdgManagement__extends({}, state, {
        loading: false
      });

    case sdgListActions["a" /* SDG_LIST */].success:
      return sdgManagement__extends({}, state, {
        data: action.data,
        error: sdgManagement_defaultState.error
      });

    case sdgListActions["a" /* SDG_LIST */].failed:
      return sdgManagement__extends({}, state, {
        error: action.errors
      });

    case sdgListActions["a" /* SDG_LIST */].updateList:
      return sdgManagement__extends({}, state, {
        masterSdgList: action.data
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/sdgAggregate.js
var sdgAggregate = __webpack_require__("/Krw");

// CONCATENATED MODULE: ./shared/reducers/sdgAggregate.js
var sdgAggregate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/

var sdgAggregate_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var reducers_sdgAggregate = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sdgAggregate_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case sdgAggregate["a" /* SDG_LIST_AGGREGATE */].start:
      return sdgAggregate__extends({}, state, {
        loading: true
      });

    case sdgAggregate["a" /* SDG_LIST_AGGREGATE */].end:
      return sdgAggregate__extends({}, state, {
        loading: false
      });

    case sdgAggregate["a" /* SDG_LIST_AGGREGATE */].success:
      return sdgAggregate__extends({}, state, {
        data: action.data,
        error: sdgAggregate_defaultState.error
      });

    case sdgAggregate["a" /* SDG_LIST_AGGREGATE */].failed:
      return sdgAggregate__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/reducers/lastUpdatedDate.js
var lastUpdatedDate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/

var lastUpdatedDate_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var lastUpdatedDate = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : lastUpdatedDate_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["f" /* LAST_UPDATED_DATE */].start:
      return lastUpdatedDate__extends({}, state, {
        loading: true
      });

    case commonDataActions["f" /* LAST_UPDATED_DATE */].end:
      return lastUpdatedDate__extends({}, state, {
        loading: false
      });

    case commonDataActions["f" /* LAST_UPDATED_DATE */].success:
      return lastUpdatedDate__extends({}, state, {
        data: action.date,
        error: lastUpdatedDate_defaultState.error
      });

    case commonDataActions["f" /* LAST_UPDATED_DATE */].failed:
      return lastUpdatedDate__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./shared/reducers/lastUpdate.js
var lastUpdate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/

var lastUpdate_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var lastUpdate = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : lastUpdate_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["e" /* LAST_UPDATE */].start:
      return lastUpdate__extends({}, state, {
        loading: true
      });

    case commonDataActions["e" /* LAST_UPDATE */].end:
      return lastUpdate__extends({}, state, {
        loading: false
      });

    case commonDataActions["e" /* LAST_UPDATE */].success:
      return lastUpdate__extends({}, state, {
        data: action.date,
        error: lastUpdate_defaultState.error
      });

    case commonDataActions["e" /* LAST_UPDATE */].failed:
      return lastUpdate__extends({}, state, {
        error: action.errors
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/sdgSlider/actions/targetAction.js
var targetAction = __webpack_require__("TVaU");

// CONCATENATED MODULE: ./components/sdgSlider/reducer/targetReducer.js
var targetReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var targetReducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var targetReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : targetReducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case targetAction["a" /* SDG_SLIDER_TARGET_DATA */].start:
      return targetReducer__extends({}, targetReducer_defaultState, {
        loading: true
      });

    case targetAction["a" /* SDG_SLIDER_TARGET_DATA */].end:
      return targetReducer__extends({}, state, {
        loading: false
      });

    case targetAction["a" /* SDG_SLIDER_TARGET_DATA */].success:
      return targetReducer__extends({}, state, {
        data: action.data,
        error: targetReducer_defaultState.error
      });

    case targetAction["a" /* SDG_SLIDER_TARGET_DATA */].failed:
      return targetReducer__extends({}, state, {
        error: action.errors
      });
    case targetAction["a" /* SDG_SLIDER_TARGET_DATA */].clear:
      return targetReducer__extends({}, targetReducer_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/sdgLandingPage/actions/index.js
var sdgLandingPage_actions = __webpack_require__("qYVk");

// CONCATENATED MODULE: ./components/sdgLandingPage/reducer/index.js
var sdgLandingPage_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var sdgLandingPage_reducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var sdgLandingPage_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sdgLandingPage_reducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case sdgLandingPage_actions["a" /* SECTOR_DATA */].start:
      return sdgLandingPage_reducer__extends({}, sdgLandingPage_reducer_defaultState, {
        loading: true
      });

    case sdgLandingPage_actions["a" /* SECTOR_DATA */].end:
      return sdgLandingPage_reducer__extends({}, state, {
        loading: false
      });

    case sdgLandingPage_actions["a" /* SECTOR_DATA */].success:
      return sdgLandingPage_reducer__extends({}, state, {
        data: action.data,
        error: sdgLandingPage_reducer_defaultState.error
      });

    case sdgLandingPage_actions["a" /* SECTOR_DATA */].failed:
      return sdgLandingPage_reducer__extends({}, state, {
        error: action.errors
      });
    case sdgLandingPage_actions["a" /* SECTOR_DATA */].clear:
      return sdgLandingPage_reducer__extends({}, sdgLandingPage_reducer_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./components/sdgLandingPage/actions/donorsAction.js

var SDG_TOP_FIVE_DONORS = {
  start: "fetch_start/sdg_top_five_donors",
  end: "fetch_end/sdg_top_five_donors",
  success: "fetch_success/sdg_top_five_donors",
  failed: "fetch_failed/sdg_top_five_donors",
  clear: "clear/sdg_top_five_donors"
};

var sdgTopFIveDataFetchStart = function sdgTopFIveDataFetchStart() {
  return {
    type: SDG_TOP_FIVE_DONORS.start
  };
};

var sdgTopFIveDataFetchEnd = function sdgTopFIveDataFetchEnd() {
  return {
    type: SDG_TOP_FIVE_DONORS.end
  };
};
var sdgTopFIveDataClear = function sdgTopFIveDataClear() {
  return {
    type: SDG_TOP_FIVE_DONORS.clear
  };
};

var sdgTopFIveDataFetchSuccess = function sdgTopFIveDataFetchSuccess(data) {
  return {
    type: SDG_TOP_FIVE_DONORS.success,
    data: data
  };
};

var sdgTopFIveDataFetchFailed = function sdgTopFIveDataFetchFailed(error) {
  return {
    type: SDG_TOP_FIVE_DONORS.failed,
    error: error
  };
};

var donorsAction_fetchsdgTopFiveData = function fetchsdgTopFiveData(year, sdg) {
  return function (dispatch, getState) {
    budgetSources;
    var operatingUnits = "",
        budgetSources = "";
    // const operatingUnits = getState().tabData.themeFilter.operatingUnits?getState().tabData.themeFilter.operatingUnits:"",
    // budgetSources = getState().tabData.themeFilter.budgetSources?getState().tabData.themeFilter.budgetSources:""
    dispatch(sdgTopFIveDataFetchStart());
    if (year != "" && sdg != "") {
      return api["a" /* default */].get(api["a" /* default */].API_SDG_SLIDER_DATA(year, sdg, operatingUnits, budgetSources)).then(function (resp) {
        if (resp.success && resp.data) {
          var budget_sources = [],
              top_recipient_offices = [];
          resp.data.budget_sources.map(function (obj) {
            if (budget_sources.length != 5) budget_sources.push(obj);
          });
          resp.data.budget_sources = budget_sources;
          resp.data.top_recipient_offices.map(function (obj) {
            if (top_recipient_offices.length != 5) top_recipient_offices.push(obj);
          });
          resp.data.top_recipient_offices = top_recipient_offices;
          dispatch(sdgTopFIveDataFetchEnd());
          dispatch(sdgTopFIveDataFetchSuccess(resp.data));
        } else {
          dispatch(sdgTopFIveDataFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(sdgTopFIveDataFetchEnd());
        dispatch(sdgTopFIveDataFetchFailed(exception));
      });
    } else {
      dispatch(sdgTopFIveDataClear());
      dispatch(sdgTopFIveDataFetchEnd());
    }
  };
};
// CONCATENATED MODULE: ./components/sdgLandingPage/reducer/donors.js
var donors__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var donors_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var donors = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donors_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case SDG_TOP_FIVE_DONORS.start:
      return donors__extends({}, donors_defaultState, {
        loading: true
      });

    case SDG_TOP_FIVE_DONORS.end:
      return donors__extends({}, state, {
        loading: false
      });

    case SDG_TOP_FIVE_DONORS.success:
      return donors__extends({}, state, {
        data: action.data,
        error: donors_defaultState.error
      });

    case SDG_TOP_FIVE_DONORS.failed:
      return donors__extends({}, state, {
        error: action.errors
      });
    case SDG_TOP_FIVE_DONORS.clear:
      return donors__extends({}, donors_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./utils/commonMethods.js
var commonMethods = __webpack_require__("Cdrj");

// CONCATENATED MODULE: ./components/sdgLandingPage/actions/sdgBarChart.js



var SDG_BAR_CHART_DATA = {
  start: "fetch_start/sdg_bar_chart_data",
  end: "fetch_end/sdg_bar_chart_data",
  success: "fetch_success/sdg_bar_chart_data",
  failed: "fetch_failed/sdg_bar_chart_data",
  clear: "clear/sdg_bar_chart_data"
};

var SDG_BAR_CHART_DATA_COUNTRY_AGGREGATE = "RESOURCES_MODALITY_CONTRIBUTION_COUNTRY_AGGREGATE";

var sdgBarChartFetchStart = function sdgBarChartFetchStart() {
  return {
    type: SDG_BAR_CHART_DATA.start
  };
};

var sdgBarChartFetchEnd = function sdgBarChartFetchEnd() {
  return {
    type: SDG_BAR_CHART_DATA.end
  };
};

var sdgBarChartFetchSuccess = function sdgBarChartFetchSuccess(data) {
  return {
    type: SDG_BAR_CHART_DATA.success,
    data: data
  };
};
var sdgBarChartClear = function sdgBarChartClear() {
  return {
    type: SDG_BAR_CHART_DATA.clear
  };
};

var sdgBarChartFetchFailed = function sdgBarChartFetchFailed(error) {
  return {
    type: SDG_BAR_CHART_DATA.failed,
    error: error
  };
};

var updateCountryAggregate = function updateCountryAggregate(countryAggregate) {
  return {
    type: SDG_BAR_CHART_DATA_COUNTRY_AGGREGATE,
    countryAggregate: countryAggregate
  };
};

var sdgBarChart_fetchSdgBarChart = function fetchSdgBarChart(code, year) {
  return function (dispatch) {
    dispatch(sdgBarChartFetchStart());
    if (code != "" && year != null) {
      return api["a" /* default */].get(api["a" /* default */].API_SDG_BAR_CHART(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          if (resp.data.country.length) {
            var countryAggregate = Object(commonMethods["c" /* aggregateCalculator */])(resp.data.country, "total_contribution");
            dispatch(updateCountryAggregate(countryAggregate));
          }
          resp.data.total[0].color = "cae1f7";
          resp.data.total = [resp.data.total[0]];
          dispatch(sdgBarChartFetchEnd());
          dispatch(sdgBarChartFetchSuccess(resp.data));
        } else {
          dispatch(sdgBarChartFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(sdgBarChartFetchEnd());
        dispatch(sdgBarChartFetchFailed(exception));
      });
    } else {
      dispatch(sdgBarChartClear());
      dispatch(sdgBarChartFetchEnd());
    }
  };
};
// CONCATENATED MODULE: ./components/sdgLandingPage/reducer/sdgBarChart.js
var sdgBarChart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var sdgBarChart_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {
    total: [],
    country: []
  },
  countryAggregate: 0
};

/* harmony default export */ var sdgBarChart = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sdgBarChart_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case SDG_BAR_CHART_DATA.start:
      return sdgBarChart__extends({}, sdgBarChart_defaultState, {
        loading: true
      });

    case SDG_BAR_CHART_DATA.end:
      return sdgBarChart__extends({}, state, {
        loading: false
      });

    case SDG_BAR_CHART_DATA.success:
      return sdgBarChart__extends({}, state, {
        data: action.data,
        error: sdgBarChart_defaultState.error
      });

    case SDG_BAR_CHART_DATA.failed:
      return sdgBarChart__extends({}, state, {
        error: action.errors
      });
    case SDG_BAR_CHART_DATA.clear:
      return sdgBarChart__extends({}, sdgBarChart_defaultState, {
        loading: true
      });
    case SDG_BAR_CHART_DATA_COUNTRY_AGGREGATE:
      return sdgBarChart__extends({}, state, {
        countryAggregate: action.countryAggregate
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/sscMarker/action/index.js
var sscMarker_action = __webpack_require__("MpUg");

// CONCATENATED MODULE: ./components/sscMarker/reducer/index.js
var sscMarker_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var sscMarker_reducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var sscMarker_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sscMarker_reducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case sscMarker_action["a" /* SSC_MARKER_DATA */].start:
      return sscMarker_reducer__extends({}, sscMarker_reducer_defaultState, {
        loading: true
      });

    case sscMarker_action["a" /* SSC_MARKER_DATA */].end:
      return sscMarker_reducer__extends({}, state, {
        loading: false
      });

    case sscMarker_action["a" /* SSC_MARKER_DATA */].success:
      return sscMarker_reducer__extends({}, state, {
        data: action.data,
        error: sscMarker_reducer_defaultState.error
      });

    case sscMarker_action["a" /* SSC_MARKER_DATA */].failed:
      return sscMarker_reducer__extends({}, state, {
        error: action.errors
      });
    case sscMarker_action["a" /* SSC_MARKER_DATA */].clear:
      return sscMarker_reducer__extends({}, sscMarker_reducer_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./components/sscMarker/reducer/selectCountry.js
var selectCountry__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SELECT_SSC_COUNTRY = "SELECT_SSC_COUNTRY";

var selectCountry_defaultState = {
  country_iso3: "",
  isSelected: 0
};

/* harmony default export */ var selectCountry = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectCountry_defaultState;
  var action = arguments[1];
  var type = action.type,
      data = action.data;

  if (type.toString() === SELECT_SSC_COUNTRY.toString()) {
    return selectCountry__extends({}, selectCountry_defaultState, data);
  }

  return state;
});
// CONCATENATED MODULE: ./shared/reducers/sectorListManagement.js
var sectorListManagement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Redux Actions ************************/


var sectorListManagement_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  }
};

/* harmony default export */ var sectorListManagement = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sectorListManagement_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case commonDataActions["j" /* SECTOR_LIST */].start:
      return sectorListManagement__extends({}, state, {
        loading: true
      });

    case commonDataActions["j" /* SECTOR_LIST */].end:
      return sectorListManagement__extends({}, state, {
        loading: false
      });

    case commonDataActions["j" /* SECTOR_LIST */].success:
      return sectorListManagement__extends({}, state, action.sectorList, {
        error: sectorListManagement_defaultState.error
      });

    case commonDataActions["j" /* SECTOR_LIST */].failed:
      return sectorListManagement__extends({}, state, {
        error: action.errors
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/sscMarker/action/ourApproaches.js
var ourApproaches = __webpack_require__("I57u");

// CONCATENATED MODULE: ./components/sscMarker/reducer/ourApproaches.js
var ourApproaches__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var ourApproaches_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var reducer_ourApproaches = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ourApproaches_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case ourApproaches["a" /* OUR_APPROACHES_DATA */].start:
      return ourApproaches__extends({}, ourApproaches_defaultState, {
        loading: true
      });

    case ourApproaches["a" /* OUR_APPROACHES_DATA */].end:
      return ourApproaches__extends({}, state, {
        loading: false
      });

    case ourApproaches["a" /* OUR_APPROACHES_DATA */].success:
      return ourApproaches__extends({}, state, {
        data: action.data,
        error: ourApproaches_defaultState.error
      });

    case ourApproaches["a" /* OUR_APPROACHES_DATA */].failed:
      return ourApproaches__extends({}, state, {
        error: action.errors
      });
    case ourApproaches["a" /* OUR_APPROACHES_DATA */].clear:
      return ourApproaches__extends({}, ourApproaches_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./shared/actions/projectDetailActions/markerDetailsAction.js
var markerDetailsAction = __webpack_require__("x4+R");

// CONCATENATED MODULE: ./shared/reducers/markerReducer.js
var markerReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var markerReducer_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  output_list_markers: {
    data: []
  }
};

/* harmony default export */ var markerReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : markerReducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case markerDetailsAction["a" /* MARKER_DETAIL */].start:
      return markerReducer__extends({}, state, {
        loading: true
      });

    case markerDetailsAction["a" /* MARKER_DETAIL */].end:
      return markerReducer__extends({}, state, {
        loading: false
      });

    case markerDetailsAction["a" /* MARKER_DETAIL */].success:
      var data = JSON.parse(JSON.stringify(state.output_list_markers.data));
      data[action.index] = action.data;
      return markerReducer__extends({}, state, {
        output_list_markers: {
          data: data
        },
        error: markerReducer_defaultState.error
      });
    // return {
    // 	...state,
    //     data: action.data,
    // 	error: defaultState.error
    // };

    case markerDetailsAction["a" /* MARKER_DETAIL */].failed:
      return markerReducer__extends({}, state, {
        error: action.errors
      });
    default:
      return markerReducer__extends({}, state);
  }
});
// EXTERNAL MODULE: ./components/markerPage/actions/typeAndDesc.js
var typeAndDesc = __webpack_require__("IlGz");

// CONCATENATED MODULE: ./components/markerPage/reducer/typeAndDesc.js
var typeAndDesc__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var typeAndDesc_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var reducer_typeAndDesc = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeAndDesc_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case typeAndDesc["a" /* MARKER_DESC_DATA */].start:
      return typeAndDesc__extends({}, typeAndDesc_defaultState, {
        loading: true
      });

    case typeAndDesc["a" /* MARKER_DESC_DATA */].end:
      return typeAndDesc__extends({}, state, {
        loading: false
      });

    case typeAndDesc["a" /* MARKER_DESC_DATA */].success:
      return typeAndDesc__extends({}, state, {
        data: action.data,
        error: typeAndDesc_defaultState.error
      });

    case typeAndDesc["a" /* MARKER_DESC_DATA */].failed:
      return typeAndDesc__extends({}, state, {
        error: action.errors
      });
    case typeAndDesc["a" /* MARKER_DESC_DATA */].clear:
      return typeAndDesc__extends({}, typeAndDesc_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/markerPage/actions/barchartDataFetch.js
var barchartDataFetch = __webpack_require__("CFDo");

// CONCATENATED MODULE: ./components/markerPage/reducer/markerBarChart.js
var markerBarChart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var markerBarChart_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var markerBarChart = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : markerBarChart_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case barchartDataFetch["a" /* BAR_CHART_DATA */].start:
      return markerBarChart__extends({}, markerBarChart_defaultState, {
        loading: true
      });

    case barchartDataFetch["a" /* BAR_CHART_DATA */].end:
      return markerBarChart__extends({}, state, {
        loading: false
      });

    case barchartDataFetch["a" /* BAR_CHART_DATA */].success:
      return markerBarChart__extends({}, state, {
        data: action.data,
        error: markerBarChart_defaultState.error
      });

    case barchartDataFetch["a" /* BAR_CHART_DATA */].failed:
      return markerBarChart__extends({}, state, {
        error: action.errors
      });
    case barchartDataFetch["a" /* BAR_CHART_DATA */].clear:
      return markerBarChart__extends({}, markerBarChart_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./components/markerPage/actions/projectListing.js

var PROJECT_LIST_DATA = {
  start: "fetch_start/project_list_data",
  end: "fetch_end/project_list_data",
  success: "fetch_success/project_list_data",
  failed: "fetch_failed/project_list_data",
  clear: "clear/project_list_data"
};

var markerProjectListFetchStart = function markerProjectListFetchStart() {
  return {
    type: PROJECT_LIST_DATA.start
  };
};

var markerProjectListFetchEnd = function markerProjectListFetchEnd() {
  return {
    type: PROJECT_LIST_DATA.end
  };
};
var markerProjectListClear = function markerProjectListClear() {
  return {
    type: PROJECT_LIST_DATA.clear
  };
};

var markerProjectListFetchSuccess = function markerProjectListFetchSuccess(data) {
  return {
    type: PROJECT_LIST_DATA.success,
    data: data
  };
};

var markerProjectListFetchFailed = function markerProjectListFetchFailed(error) {
  return {
    type: PROJECT_LIST_DATA.failed,
    error: error
  };
};

var projectListing_fetchMarkerProjectList = function fetchMarkerProjectList(year, markerId) {
  return function (dispatch, getState) {
    dispatch(markerProjectListFetchStart());
    if (year !== "" && markerId !== "") {
      return api["a" /* default */].get(api["a" /* default */].API_MARKER_PROJECTLIST_DATA(year, markerId)).then(function (resp) {
        if (resp.success && resp.data) {
          resp.data.aggregate = resp.data.aggregate && resp.data.aggregate.length ? resp.data.aggregate[0] : {};
          dispatch(markerProjectListFetchEnd());
          dispatch(markerProjectListFetchSuccess(resp.data));
        } else {
          dispatch(markerProjectListFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(markerProjectListFetchEnd());
        dispatch(markerProjectListFetchFailed(exception));
      });
    } else {
      dispatch(markerProjectListClear());
      dispatch(markerProjectListFetchEnd());
    }
  };
};
// CONCATENATED MODULE: ./components/markerPage/reducer/projectList.js
var reducer_projectList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var reducer_projectList_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: {}
};

/* harmony default export */ var reducer_projectList = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_projectList_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case PROJECT_LIST_DATA.start:
      return reducer_projectList__extends({}, reducer_projectList_defaultState, {
        loading: true
      });

    case PROJECT_LIST_DATA.end:
      return reducer_projectList__extends({}, state, {
        loading: false
      });

    case PROJECT_LIST_DATA.success:
      return reducer_projectList__extends({}, state, {
        data: action.data,
        error: reducer_projectList_defaultState.error
      });

    case PROJECT_LIST_DATA.failed:
      return reducer_projectList__extends({}, state, {
        error: action.errors
      });
    case PROJECT_LIST_DATA.clear:
      return reducer_projectList__extends({}, reducer_projectList_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/markerPage/actions/markerSubTypes.js
var markerSubTypes = __webpack_require__("UPaS");

// CONCATENATED MODULE: ./components/markerPage/reducer/markerSubTypes.js
var markerSubTypes__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var markerSubTypes_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var reducer_markerSubTypes = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : markerSubTypes_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case markerSubTypes["a" /* MARKER_SUBTYPE_DATA */].start:
      return markerSubTypes__extends({}, markerSubTypes_defaultState, {
        loading: true
      });

    case markerSubTypes["a" /* MARKER_SUBTYPE_DATA */].end:
      return markerSubTypes__extends({}, state, {
        loading: false
      });

    case markerSubTypes["a" /* MARKER_SUBTYPE_DATA */].success:
      return markerSubTypes__extends({}, state, {
        data: action.data,
        error: markerSubTypes_defaultState.error
      });

    case markerSubTypes["a" /* MARKER_SUBTYPE_DATA */].failed:
      return markerSubTypes__extends({}, state, {
        error: action.errors
      });
    case markerSubTypes["a" /* MARKER_SUBTYPE_DATA */].clear:
      return markerSubTypes__extends({}, markerSubTypes_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/markerPage/actions/setMarkerSubtype.js
var setMarkerSubtype = __webpack_require__("Tlhi");

// CONCATENATED MODULE: ./components/markerPage/reducer/setMarkerSubtype.js
var setMarkerSubtype__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var setMarkerSubtype_defaultState = {
  markerSubType: ""
};
/* harmony default export */ var reducer_setMarkerSubtype = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : setMarkerSubtype_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case setMarkerSubtype["a" /* SET_MARKER_SUBTYPE */]:
      return setMarkerSubtype__extends({}, state, {
        markerSubType: action.data
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./components/sscMarker/reducer/selectMarker.js
var selectMarker__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SELECT_SSC_MARKER = "SELECT_SSC_MARKER";

var selectMarker_defaultState = {
  type: ""
};

/* harmony default export */ var selectMarker = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectMarker_defaultState;
  var action = arguments[1];
  var type = action.type,
      data = action.data;

  if (type.toString() === SELECT_SSC_MARKER.toString()) {
    return selectMarker__extends({}, selectMarker_defaultState, data);
  }

  return state;
});
// CONCATENATED MODULE: ./components/sscMarker/reducer/selectL2Country.js
var selectL2Country__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SELECT_L2_COUNTRY = "SELECT_L2_COUNTRY";

var selectL2Country_defaultState = {
  country_iso3: "",
  isSelected: 0,
  name: name
};

/* harmony default export */ var selectL2Country = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectL2Country_defaultState;
  var action = arguments[1];
  var type = action.type,
      data = action.data;

  if (type.toString() === SELECT_L2_COUNTRY.toString()) {
    return selectL2Country__extends({}, selectL2Country_defaultState, data);
  }

  return state;
});
// EXTERNAL MODULE: ./components/bootstraptable/actions/setMarkerType.js
var setMarkerType = __webpack_require__("zNX7");

// CONCATENATED MODULE: ./components/bootstraptable/reducer/setMarkerType.js
var setMarkerType__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var setMarkerType_defaultState = {
  markerSubType: ""
};

/* harmony default export */ var reducer_setMarkerType = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : setMarkerType_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case setMarkerType["a" /* SET_MARKER_SUBTYPE */]:
      return setMarkerType__extends({}, state, {
        markerSubType: action.value
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/nestedDropList/actions/setCountryField.js
var setCountryField = __webpack_require__("Bp+V");

// CONCATENATED MODULE: ./components/nestedDropList/reducer/setCountryField.js


var setCountryField_defaultState = {
  countrySelected: ""
};

/* harmony default export */ var reducer_setCountryField = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : setCountryField_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case setCountryField["a" /* SET_COUNTRY_SELECTED */]:
      return {
        countrySelected: action.value
      };

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./routes/themes/actions/setEndYear.js
var setEndYear = __webpack_require__("rw4c");

// CONCATENATED MODULE: ./routes/themes/reducers/setEndYear.js


var setEndYear_defaultState = {
  endYear: "",
  startYear: ""
};

/* harmony default export */ var reducers_setEndYear = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : setEndYear_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case setEndYear["a" /* SET_END_YEAR */]:
      return {
        endYear: action.endYear,
        startYear: action.startYear
      };

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/markerPage/actions/levelTwoCountry.js
var levelTwoCountry = __webpack_require__("IKBG");

// CONCATENATED MODULE: ./components/markerPage/reducer/levelTwoCountry.js
var levelTwoCountry__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var levelTwoCountry_defaultState = {
  loading: false,
  error: {
    message: "",
    code: ""
  },
  data: []
};

/* harmony default export */ var reducer_levelTwoCountry = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : levelTwoCountry_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case levelTwoCountry["a" /* LEVEL_TWO_COUNTRY_DATA */].start:
      return levelTwoCountry__extends({}, levelTwoCountry_defaultState, {
        loading: true
      });

    case levelTwoCountry["a" /* LEVEL_TWO_COUNTRY_DATA */].end:
      return levelTwoCountry__extends({}, state, {
        loading: false
      });

    case levelTwoCountry["a" /* LEVEL_TWO_COUNTRY_DATA */].success:
      return levelTwoCountry__extends({}, state, {
        data: action.data,
        error: levelTwoCountry_defaultState.error
      });

    case levelTwoCountry["a" /* LEVEL_TWO_COUNTRY_DATA */].failed:
      return levelTwoCountry__extends({}, state, {
        error: action.errors
      });
    case levelTwoCountry["a" /* LEVEL_TWO_COUNTRY_DATA */].clear:
      return levelTwoCountry__extends({}, levelTwoCountry_defaultState, {
        loading: true
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./components/sideBar/action/updateSS.js
var updateSS = __webpack_require__("yg2x");

// CONCATENATED MODULE: ./components/sideBar/reducer/updateSS.js
var updateSS__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var updateSS_defaultState = {
  selectedSignature: ""
};

/* harmony default export */ var reducer_updateSS = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : updateSS_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case updateSS["a" /* SET_SIGNATURE_SOLUTION */]:
      return updateSS__extends({}, state, {
        selectedSignature: action.value
      });

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./routes/sdgLanding/action/index.js
var sdgLanding_action = __webpack_require__("24AF");

// CONCATENATED MODULE: ./routes/sdgLanding/reducer/index.js


var sdgLanding_reducer_defaultState = {
  sdg_code_selected: ""
};

/* harmony default export */ var sdgLanding_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sdgLanding_reducer_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case sdgLanding_action["a" /* SET_SELECTED_SDG */]:
      return {
        sdg_code_selected: action.sdgSelected
      };

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./routes/home/actions/index.js
var home_actions = __webpack_require__("Cic2");

// CONCATENATED MODULE: ./routes/home/reducers/index.js



var reducers_yearSummary = function yearSummary() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { loading: false, data: {}, error: undefined };
  var action = arguments[1];

  switch (action.type) {
    case home_actions["c" /* ACTION_TYPE_FETCH_YEAR_SUMMARY_START */]:
      return { loading: true, data: {}, error: undefined };
    case home_actions["a" /* ACTION_TYPE_FETCH_YEAR_SUMMARY_END */]:
      return { loading: false, data: action.data, error: undefined };
    case home_actions["b" /* ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR */]:
      return { loading: false, data: {}, error: action.error };
    default:
      return state;
  }
};

/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({ yearSummary: reducers_yearSummary }));
// EXTERNAL MODULE: ./shared/actions/getActivitiesList.js
var getActivitiesList = __webpack_require__("Gctp");

// CONCATENATED MODULE: ./shared/reducers/activitiesList.js
var activitiesList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var activitiesList_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var activitiesList_activitiesList = function activitiesList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activitiesList_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getActivitiesList["a" /* ACTIVITIES_LIST */].start:
      return activitiesList__extends({}, state, {
        loading: true
      });
    case getActivitiesList["a" /* ACTIVITIES_LIST */].end:
      return activitiesList__extends({}, state, {
        loading: false
      });
    case getActivitiesList["a" /* ACTIVITIES_LIST */].success:
      return activitiesList__extends({}, state, {
        data: action.data
      });
    case getActivitiesList["a" /* ACTIVITIES_LIST */].failed:
      return activitiesList__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_activitiesList = (activitiesList_activitiesList);
// EXTERNAL MODULE: ./shared/actions/getActivityDetails.js
var getActivityDetails = __webpack_require__("pfIV");

// CONCATENATED MODULE: ./shared/reducers/activityDetails.js
var activityDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var activityDetails_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var activityDetails_activityDetails = function activityDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activityDetails_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getActivityDetails["a" /* ACTIVITY_DETAILS */].start:
      return activityDetails__extends({}, state, {
        loading: true
      });
    case getActivityDetails["a" /* ACTIVITY_DETAILS */].end:
      return activityDetails__extends({}, state, {
        loading: false
      });
    case getActivityDetails["a" /* ACTIVITY_DETAILS */].success:
      return activityDetails__extends({}, state, {
        data: action.data
      });
    case getActivityDetails["a" /* ACTIVITY_DETAILS */].failed:
      return activityDetails__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_activityDetails = (activityDetails_activityDetails);
// EXTERNAL MODULE: ./shared/actions/mapActions/getActivitiesMapData.js
var getActivitiesMapData = __webpack_require__("t7ns");

// CONCATENATED MODULE: ./shared/reducers/activitiesMapData.js
var activitiesMapData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var activitiesMapData_defaultState = {
  data: [],
  loading: false,
  error: {}
};

var activitiesMapData_activitiesMapData = function activitiesMapData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activitiesMapData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getActivitiesMapData["a" /* ACTIVITIES_MAP_DATA */].start:
      return activitiesMapData__extends({}, state, {
        loading: true
      });
    case getActivitiesMapData["a" /* ACTIVITIES_MAP_DATA */].end:
      return activitiesMapData__extends({}, state, {
        loading: false
      });
    case getActivitiesMapData["a" /* ACTIVITIES_MAP_DATA */].success:
      return activitiesMapData__extends({}, state, {
        data: action.data
      });
    case getActivitiesMapData["a" /* ACTIVITIES_MAP_DATA */].failed:
      return activitiesMapData__extends({}, state, {
        error: action.error
      });
    case getActivitiesMapData["a" /* ACTIVITIES_MAP_DATA */].reset:
      return activitiesMapData__extends({}, state, {
        defaultState: activitiesMapData_defaultState
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_activitiesMapData = (activitiesMapData_activitiesMapData);
// EXTERNAL MODULE: ./shared/actions/getFiltersData.js
var getFiltersData = __webpack_require__("6dIb");

// CONCATENATED MODULE: ./shared/reducers/filtersData.js
var filtersData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var filtersData_defaultState = {
  data: [],
  loading: false,
  error: {}
};

var filtersData_getResourceReducer = function getResourceReducer(resource) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filtersData_defaultState;
    var action = arguments[1];

    switch (action.type) {
      case Object(getFiltersData["b" /* getActions */])(resource).start:
        return filtersData__extends({}, state, {
          loading: true
        });
      case Object(getFiltersData["b" /* getActions */])(resource).success:
        return filtersData__extends({}, state, {
          data: action.data
        });
      case Object(getFiltersData["b" /* getActions */])(resource).error:
        return filtersData__extends({}, state, {
          error: action.error
        });
      default:
        return state;
    }
  };
};

var filtersData_reducers = {
  donors: filtersData_getResourceReducer("donors"),
  fields: filtersData_getResourceReducer("fields"),
  portals: filtersData_getResourceReducer("portals"),
  sdgs: filtersData_getResourceReducer("sdgs"),
  oecds: filtersData_getResourceReducer("oecds"),
  homeFields: filtersData_getResourceReducer("homeFields"),
  homeDonors: filtersData_getResourceReducer("homeDonors"),
  homeSdgs: filtersData_getResourceReducer("homeSdgs"),
  homeSectors: filtersData_getResourceReducer("homeSectors")
};

/* harmony default export */ var filtersData = (filtersData_reducers);
// EXTERNAL MODULE: ./shared/actions/getPieChartData.js
var getPieChartData = __webpack_require__("2q2G");

// CONCATENATED MODULE: ./shared/reducers/pieChartData.js


var pieChartData_defaultState = {
  data: [],
  loading: false,
  error: {}
};

var pieChartData_getResourceReducer = function getResourceReducer(resource) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pieChartData_defaultState;
    var action = arguments[1];

    switch (action.type) {
      case Object(getPieChartData["b" /* getActions */])(resource).start:
        return {
          data: {},
          error: {},
          loading: true
        };
      case Object(getPieChartData["b" /* getActions */])(resource).success:
        return {
          data: action.data,
          error: {},
          loading: false
        };
      case Object(getPieChartData["b" /* getActions */])(resource).error:
        return {
          data: {},
          error: action.error,
          loading: false
        };
      default:
        return state;
    }
  };
};

var pieChartData_reducers = {
  portalData: pieChartData_getResourceReducer("portal"),
  sectorsData: pieChartData_getResourceReducer("sectors"),
  sdgData: pieChartData_getResourceReducer("sgd"),
  homePortalsPieChartData: pieChartData_getResourceReducer("homePortals"),
  homeSdgsPieChartData: pieChartData_getResourceReducer("homeSdgs"),
  homeSectorsPieChartData: pieChartData_getResourceReducer("homeSectors")
};

/* harmony default export */ var pieChartData = (pieChartData_reducers);
// EXTERNAL MODULE: ./shared/actions/getDonorsContributionsList.js
var getDonorsContributionsList = __webpack_require__("fBVf");

// CONCATENATED MODULE: ./shared/reducers/donorsContributionsList.js
var donorsContributionsList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var donorsContributionsList_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var donorsContributionsList_donorsContributions = function donorsContributions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorsContributionsList_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getDonorsContributionsList["a" /* DONORS_CONTRIBUTIONS_LIST */].start:
      return donorsContributionsList__extends({}, state, {
        loading: true
      });
    case getDonorsContributionsList["a" /* DONORS_CONTRIBUTIONS_LIST */].end:
      return donorsContributionsList__extends({}, state, {
        loading: false
      });
    case getDonorsContributionsList["a" /* DONORS_CONTRIBUTIONS_LIST */].success:
      return donorsContributionsList__extends({}, state, {
        data: action.data
      });
    case getDonorsContributionsList["a" /* DONORS_CONTRIBUTIONS_LIST */].failed:
      return donorsContributionsList__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var donorsContributionsList = (donorsContributionsList_donorsContributions);
// EXTERNAL MODULE: ./shared/actions/getDonorsContributionsDetails.js
var getDonorsContributionsDetails = __webpack_require__("QTo+");

// CONCATENATED MODULE: ./shared/reducers/donorsContributionsDetails.js
var donorsContributionsDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var donorsContributionsDetails_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var donorsContributionsDetails_donorsContributions = function donorsContributions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorsContributionsDetails_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getDonorsContributionsDetails["a" /* DONORS_CONTRIBUTIONS_DETAILS */].start:
      return donorsContributionsDetails__extends({}, state, {
        loading: true
      });
    case getDonorsContributionsDetails["a" /* DONORS_CONTRIBUTIONS_DETAILS */].end:
      return donorsContributionsDetails__extends({}, state, {
        loading: false
      });
    case getDonorsContributionsDetails["a" /* DONORS_CONTRIBUTIONS_DETAILS */].success:
      return donorsContributionsDetails__extends({}, state, {
        data: action.data
      });
    case getDonorsContributionsDetails["a" /* DONORS_CONTRIBUTIONS_DETAILS */].failed:
      return donorsContributionsDetails__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var donorsContributionsDetails = (donorsContributionsDetails_donorsContributions);
// EXTERNAL MODULE: ./shared/actions/getSummaryData.js
var getSummaryData = __webpack_require__("FrMN");

// CONCATENATED MODULE: ./shared/reducers/summaryData.js
var summaryData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var summaryData_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var summaryData_summaryData = function summaryData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : summaryData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getSummaryData["a" /* SUMMARY_DATA */].start:
      return summaryData__extends({}, state, {
        loading: true
      });
    case getSummaryData["a" /* SUMMARY_DATA */].end:
      return summaryData__extends({}, state, {
        loading: false
      });
    case getSummaryData["a" /* SUMMARY_DATA */].success:
      return summaryData__extends({}, state, {
        data: action.data
      });
    case getSummaryData["a" /* SUMMARY_DATA */].failed:
      return summaryData__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_summaryData = (summaryData_summaryData);
// EXTERNAL MODULE: ./shared/actions/getDonorDetails.js
var getDonorDetails = __webpack_require__("QMfV");

// CONCATENATED MODULE: ./shared/reducers/donorDetails.js
var donorDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var donorDetails_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var donorDetails_donorDetails = function donorDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorDetails_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getDonorDetails["a" /* DONOR_DETAILS */].start:
      return donorDetails__extends({}, state, {
        loading: true
      });
    case getDonorDetails["a" /* DONOR_DETAILS */].end:
      return donorDetails__extends({}, state, {
        loading: false
      });
    case getDonorDetails["a" /* DONOR_DETAILS */].success:
      return donorDetails__extends({}, state, {
        data: action.data
      });
    case getDonorDetails["a" /* DONOR_DETAILS */].failed:
      return donorDetails__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_donorDetails = (donorDetails_donorDetails);
// EXTERNAL MODULE: ./shared/actions/mapActions/getDonorProfileMapData.js
var getDonorProfileMapData = __webpack_require__("Lf5/");

// CONCATENATED MODULE: ./shared/reducers/donorProfileMapData.js
var donorProfileMapData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var donorProfileMapData_defaultState = {
  data: [],
  loading: false,
  error: {}
};

var donorProfileMapData_donorProfileMapData = function donorProfileMapData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorProfileMapData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getDonorProfileMapData["a" /* DONOR_PROFILE_MAP_DATA */].start:
      return donorProfileMapData__extends({}, state, {
        loading: true
      });
    case getDonorProfileMapData["a" /* DONOR_PROFILE_MAP_DATA */].end:
      return donorProfileMapData__extends({}, state, {
        loading: false
      });
    case getDonorProfileMapData["a" /* DONOR_PROFILE_MAP_DATA */].success:
      return donorProfileMapData__extends({}, state, {
        data: action.data
      });
    case getDonorProfileMapData["a" /* DONOR_PROFILE_MAP_DATA */].failed:
      return donorProfileMapData__extends({}, state, {
        error: action.error
      });
    case getDonorProfileMapData["a" /* DONOR_PROFILE_MAP_DATA */].reset:
      return donorProfileMapData__extends({}, state, {
        defaultState: donorProfileMapData_defaultState
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_donorProfileMapData = (donorProfileMapData_donorProfileMapData);
// EXTERNAL MODULE: ./shared/actions/getDonorActivitiesList.js
var getDonorActivitiesList = __webpack_require__("eid4");

// CONCATENATED MODULE: ./shared/reducers/donorActivitiesList.js
var donorActivitiesList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var donorActivitiesList_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var donorActivitiesList_donorActivitiesList = function donorActivitiesList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorActivitiesList_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getDonorActivitiesList["a" /* DONOR_ACTIVITIES_LIST */].start:
      return donorActivitiesList__extends({}, state, {
        loading: true
      });
    case getDonorActivitiesList["a" /* DONOR_ACTIVITIES_LIST */].end:
      return donorActivitiesList__extends({}, state, {
        loading: false
      });
    case getDonorActivitiesList["a" /* DONOR_ACTIVITIES_LIST */].success:
      return donorActivitiesList__extends({}, state, {
        data: action.data
      });
    case getDonorActivitiesList["a" /* DONOR_ACTIVITIES_LIST */].failed:
      return donorActivitiesList__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_donorActivitiesList = (donorActivitiesList_donorActivitiesList);
// EXTERNAL MODULE: ./shared/actions/getDonorFieldsContributions.js
var getDonorFieldsContributions = __webpack_require__("V3Sb");

// CONCATENATED MODULE: ./shared/reducers/donorFieldsContributions.js
var donorFieldsContributions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var donorFieldsContributions_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var donorFieldsContributions_donorFieldsContributions = function donorFieldsContributions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorFieldsContributions_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getDonorFieldsContributions["a" /* DONOR_FIELDS_CONTRIBUTIONS */].start:
      return donorFieldsContributions__extends({}, state, {
        loading: true
      });
    case getDonorFieldsContributions["a" /* DONOR_FIELDS_CONTRIBUTIONS */].end:
      return donorFieldsContributions__extends({}, state, {
        loading: false
      });
    case getDonorFieldsContributions["a" /* DONOR_FIELDS_CONTRIBUTIONS */].success:
      return donorFieldsContributions__extends({}, state, {
        data: action.data
      });
    case getDonorFieldsContributions["a" /* DONOR_FIELDS_CONTRIBUTIONS */].failed:
      return donorFieldsContributions__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_donorFieldsContributions = (donorFieldsContributions_donorFieldsContributions);
// EXTERNAL MODULE: ./shared/actions/getRecipientActivitiesData.js
var getRecipientActivitiesData = __webpack_require__("faE3");

// CONCATENATED MODULE: ./shared/reducers/recipientActivitiesData.js
var recipientActivitiesData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var recipientActivitiesData_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var recipientActivitiesData_recipientActivitiesData = function recipientActivitiesData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : recipientActivitiesData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecipientActivitiesData["a" /* RECIPIENT_ACTIVITIES_DATA */].start:
      return recipientActivitiesData__extends({}, state, {
        loading: true
      });
    case getRecipientActivitiesData["a" /* RECIPIENT_ACTIVITIES_DATA */].end:
      return recipientActivitiesData__extends({}, state, {
        loading: false
      });
    case getRecipientActivitiesData["a" /* RECIPIENT_ACTIVITIES_DATA */].success:
      return recipientActivitiesData__extends({}, state, {
        data: action.data
      });
    case getRecipientActivitiesData["a" /* RECIPIENT_ACTIVITIES_DATA */].failed:
      return recipientActivitiesData__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_recipientActivitiesData = (recipientActivitiesData_recipientActivitiesData);
// EXTERNAL MODULE: ./shared/actions/getRecipientMapData.js
var getRecipientMapData = __webpack_require__("RhfR");

// CONCATENATED MODULE: ./shared/reducers/recipientMapData.js
var recipientMapData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var recipientMapData_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var recipientMapData_recipientMapData = function recipientMapData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : recipientMapData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecipientMapData["a" /* RECIPIENT_MAP_DATA */].start:
      return recipientMapData__extends({}, state, {
        loading: true
      });
    case getRecipientMapData["a" /* RECIPIENT_MAP_DATA */].end:
      return recipientMapData__extends({}, state, {
        loading: false
      });
    case getRecipientMapData["a" /* RECIPIENT_MAP_DATA */].success:
      return recipientMapData__extends({}, state, {
        data: action.data
      });
    case getRecipientMapData["a" /* RECIPIENT_MAP_DATA */].failed:
      return recipientMapData__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_recipientMapData = (recipientMapData_recipientMapData);
// EXTERNAL MODULE: ./shared/actions/getRecipientSummaryData.js
var getRecipientSummaryData = __webpack_require__("52Cq");

// CONCATENATED MODULE: ./shared/reducers/recipientSummaryData.js
var recipientSummaryData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var recipientSummaryData_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var recipientSummaryData_recipientSummaryData = function recipientSummaryData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : recipientSummaryData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecipientSummaryData["a" /* RECIPIENT_SUMMARY_DATA */].start:
      return recipientSummaryData__extends({}, state, {
        loading: true
      });
    case getRecipientSummaryData["a" /* RECIPIENT_SUMMARY_DATA */].end:
      return recipientSummaryData__extends({}, state, {
        loading: false
      });
    case getRecipientSummaryData["a" /* RECIPIENT_SUMMARY_DATA */].success:
      return recipientSummaryData__extends({}, state, {
        data: action.data
      });
    case getRecipientSummaryData["a" /* RECIPIENT_SUMMARY_DATA */].failed:
      return recipientSummaryData__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_recipientSummaryData = (recipientSummaryData_recipientSummaryData);
// EXTERNAL MODULE: ./shared/actions/getRecipientContributionsData.js
var getRecipientContributionsData = __webpack_require__("tz0A");

// CONCATENATED MODULE: ./shared/reducers/recipientContributionsData.js
var recipientContributionsData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var recipientContributionsData_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var recipientContributionsData_recipientContributionsData = function recipientContributionsData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : recipientContributionsData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getRecipientContributionsData["a" /* RECIPIENT_CONTRIBUTIONS_DATA */].start:
      return recipientContributionsData__extends({}, state, {
        loading: true
      });
    case getRecipientContributionsData["a" /* RECIPIENT_CONTRIBUTIONS_DATA */].end:
      return recipientContributionsData__extends({}, state, {
        loading: false
      });
    case getRecipientContributionsData["a" /* RECIPIENT_CONTRIBUTIONS_DATA */].success:
      return recipientContributionsData__extends({}, state, {
        data: action.data
      });
    case getRecipientContributionsData["a" /* RECIPIENT_CONTRIBUTIONS_DATA */].failed:
      return recipientContributionsData__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_recipientContributionsData = (recipientContributionsData_recipientContributionsData);
// EXTERNAL MODULE: ./shared/actions/mapActions/getHomeMapData.js
var getHomeMapData = __webpack_require__("Ann0");

// CONCATENATED MODULE: ./shared/reducers/homeMapData.js
var homeMapData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var homeMapData_defaultState = {
  data: [],
  loading: false,
  error: {}
};

var homeMapData_homeMapData = function homeMapData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : homeMapData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getHomeMapData["a" /* HOME_MAP_DATA */].start:
      return homeMapData__extends({}, state, {
        loading: true
      });
    case getHomeMapData["a" /* HOME_MAP_DATA */].end:
      return homeMapData__extends({}, state, {
        loading: false
      });
    case getHomeMapData["a" /* HOME_MAP_DATA */].success:
      return homeMapData__extends({}, state, {
        data: action.data
      });
    case getHomeMapData["a" /* HOME_MAP_DATA */].failed:
      return homeMapData__extends({}, state, {
        error: action.error
      });
    case getHomeMapData["a" /* HOME_MAP_DATA */].reset:
      return homeMapData__extends({}, state, {
        defaultState: homeMapData_defaultState
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_homeMapData = (homeMapData_homeMapData);
// EXTERNAL MODULE: ./shared/actions/getHomeMapSummaryData.js
var getHomeMapSummaryData = __webpack_require__("lwp9");

// CONCATENATED MODULE: ./shared/reducers/homeMapSummaryData.js
var homeMapSummaryData__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var homeMapSummaryData_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var homeMapSummaryData_homeMapSummaryData = function homeMapSummaryData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : homeMapSummaryData_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getHomeMapSummaryData["a" /* HOME_MAP_SUMMARY_DATA */].start:
      return homeMapSummaryData__extends({}, state, {
        loading: true
      });
    case getHomeMapSummaryData["a" /* HOME_MAP_SUMMARY_DATA */].end:
      return homeMapSummaryData__extends({}, state, {
        loading: false
      });
    case getHomeMapSummaryData["a" /* HOME_MAP_SUMMARY_DATA */].success:
      return homeMapSummaryData__extends({}, state, {
        data: action.data
      });
    case getHomeMapSummaryData["a" /* HOME_MAP_SUMMARY_DATA */].failed:
      return homeMapSummaryData__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_homeMapSummaryData = (homeMapSummaryData_homeMapSummaryData);
// EXTERNAL MODULE: ./shared/actions/getHomeDonorsContributionsList.js
var getHomeDonorsContributionsList = __webpack_require__("Onlx");

// CONCATENATED MODULE: ./shared/reducers/homeDonorsContributionsList.js
var homeDonorsContributionsList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var homeDonorsContributionsList_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var homeDonorsContributionsList_homeDonorsContributionsList = function homeDonorsContributionsList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : homeDonorsContributionsList_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getHomeDonorsContributionsList["a" /* HOME_DONORS_CONTRIBUTIONS_LIST */].start:
      return homeDonorsContributionsList__extends({}, state, {
        loading: true
      });
    case getHomeDonorsContributionsList["a" /* HOME_DONORS_CONTRIBUTIONS_LIST */].end:
      return homeDonorsContributionsList__extends({}, state, {
        loading: false
      });
    case getHomeDonorsContributionsList["a" /* HOME_DONORS_CONTRIBUTIONS_LIST */].success:
      return homeDonorsContributionsList__extends({}, state, {
        data: action.data
      });
    case getHomeDonorsContributionsList["a" /* HOME_DONORS_CONTRIBUTIONS_LIST */].failed:
      return homeDonorsContributionsList__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_homeDonorsContributionsList = (homeDonorsContributionsList_homeDonorsContributionsList);
// EXTERNAL MODULE: ./shared/actions/getMasterDonorsContributionsList.js
var getMasterDonorsContributionsList = __webpack_require__("xKz7");

// CONCATENATED MODULE: ./shared/reducers/donorsMasterContributionsList.js
var donorsMasterContributionsList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var donorsMasterContributionsList_defaultState = {
  data: {},
  loading: false,
  error: {}
};

var donorsMasterContributionsList_donorsMasterContributions = function donorsMasterContributions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : donorsMasterContributionsList_defaultState;
  var action = arguments[1];

  switch (action.type) {
    case getMasterDonorsContributionsList["a" /* DONORS_MASTER_CONTRIBUTIONS_LIST */].start:
      return donorsMasterContributionsList__extends({}, state, {
        loading: true
      });
    case getMasterDonorsContributionsList["a" /* DONORS_MASTER_CONTRIBUTIONS_LIST */].end:
      return donorsMasterContributionsList__extends({}, state, {
        loading: false
      });
    case getMasterDonorsContributionsList["a" /* DONORS_MASTER_CONTRIBUTIONS_LIST */].success:
      return donorsMasterContributionsList__extends({}, state, {
        data: action.data
      });
    case getMasterDonorsContributionsList["a" /* DONORS_MASTER_CONTRIBUTIONS_LIST */].failed:
      return donorsMasterContributionsList__extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

/* harmony default export */ var donorsMasterContributionsList = (donorsMasterContributionsList_donorsMasterContributions);
// CONCATENATED MODULE: ./store/rootReducer.js
var rootReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
























































































/* harmony default export */ var rootReducer = (Object(es["c" /* combineReducers */])(rootReducer__extends({
  yearSummary: reducer,
  aboutUsContent: reducers_aboutUs,
  sankeyData: sankey_reducer,
  tabData: tabSection_reducer,
  mapData: mapData,
  breadCrumb: data_reducer,
  exportPDF: reducers_exportPDF,
  generalInfo: generalInfo,
  router: router,
  countryData: reducers_countryData,
  countryDataBudgetSources: countryDataBudgetSources,
  countryDataThemesBudget: countryDataThemesBudget,
  masterDonorList: masterDonorListManagement,
  countryRegionSearch: reducers_countryRegionSearch,
  projectDetail: projectDetailManagement,
  projectList: projectList,
  yearSelection: yearSelectManagement,
  recipientProfile: recipientReducer,
  yearList: yearList,
  projectTimeline: projectTimelineRangeManagement,
  themeList: themeListManagement,
  countryList: countryListManagement,
  themeSummary: themeDataManagement,
  operationUnits: reducers_operatingUnits,
  documentCategories: documentCategories,
  budgetSourceSearch: nestedDropList_reducer,
  donorFundList: donorFundList,
  sdgAggregate: reducers_sdgAggregate,
  donorData: donorsPage_reducer,
  donorProfile: donorReducer,
  donorTypes: donorTypes,
  fundStreams: fundStreams,
  themeSliderData: themeSliderData,
  sdgSliderData: sdgSlider_reducer,
  searchAllResult: searchResult,
  startAndEndYears: reducers_setEndYear,
  documentCategoriesAll: documentCategoryAll,
  sdgData: sdgManagement,
  lastUpdatedDate: lastUpdatedDate,
  lastUpdate: lastUpdate,
  signatureOutcome: reducer_signatureOutcome,
  signatureDonor: reducer_signatureDonor,
  sdgTargetSliderData: targetReducer,
  sectorData: sdgLandingPage_reducer,
  sdgTopFiveData: donors,
  individualMarkerData: markerPage_reducer,
  sdgBarChartData: sdgBarChart,
  sscMarkerPathData: sscMarker_reducer,
  sscCountry: selectCountry,
  sscApproachesData: reducer_ourApproaches,
  sectorListData: sectorListManagement,
  markerDescData: reducer_typeAndDesc,
  markerProjectListData: reducer_projectList,
  markerBarChartData: markerBarChart,
  markerDetails: markerReducer,
  markerSubTypes: reducer_markerSubTypes,
  currentMarkerSubType: reducer_setMarkerSubtype,
  sscMarkerType: selectMarker,
  sscL2Country: selectL2Country,
  markerSubTypeSelected: reducer_setMarkerType,
  countrySelected: reducer_setCountryField,
  selectedSignatureSolution: reducer_updateSS,
  levelTwoCountries: reducer_levelTwoCountry,
  sdgSelected: sdgLanding_reducer,
  home: reducers,
  activitiesList: reducers_activitiesList,
  activityDetails: reducers_activityDetails,
  activitiesMapData: reducers_activitiesMapData,
  donorsContributionsList: donorsContributionsList,
  donorsContributionsDetails: donorsContributionsDetails,
  summaryData: reducers_summaryData,
  donorDetails: reducers_donorDetails,
  donorProfileMapData: reducers_donorProfileMapData,
  donorActivitiesList: reducers_donorActivitiesList,
  donorFieldsContributions: reducers_donorFieldsContributions,
  recipientActivitiesData: reducers_recipientActivitiesData,
  recipientMapData: reducers_recipientMapData,
  recipientSummaryData: reducers_recipientSummaryData,
  recipientContributionsData: reducers_recipientContributionsData,
  homeMapData: reducers_homeMapData,
  homeMapSummaryData: reducers_homeMapSummaryData,
  homeDonorsContributionsList: reducers_homeDonorsContributionsList
}, filtersData, pieChartData, {
  donorsMasterContributionsList: donorsMasterContributionsList
})));
// CONCATENATED MODULE: ./store/index.js
/************************* Redux Files ************************/




/************************* Reducer Files ************************/


var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || es["d" /* compose */];
var loggerMiddleware = Object(redux_logger["createLogger"])();

function configureStore(preloadedState) {
  return Object(es["e" /* createStore */])(rootReducer, preloadedState, composeEnhancers(Object(es["a" /* applyMiddleware */])(redux_thunk_es
  // loggerMiddleware
  )));
}
// EXTERNAL MODULE: ../node_modules/react-ga/dist/esm/index.js + 11 modules
var esm = __webpack_require__("91gb");

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("RBXn") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes = (async_default()(load));
	
// CONCATENATED MODULE: ./components/app.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var store = configureStore();

var _ref = Object(preact_min["h"])(
  preact_redux_esm["a" /* Provider */],
  { store: store },
  Object(preact_min["h"])(routes, null)
);

var app_App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      someData: null
    };
    esm["a" /* default */].initialize(api["a" /* default */].GA_TRACKING_ID);
    esm["a" /* default */].pageview(window.location.pathname);
    return _this;
  }

  App.prototype.render = function render() {
    return _ref;
  };

  return App;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./style/index.css
var style = __webpack_require__("rq4c");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./assets/styles/vendor.css
var vendor = __webpack_require__("dAhp");
var vendor_default = /*#__PURE__*/__webpack_require__.n(vendor);

// CONCATENATED MODULE: ./index.js




/* harmony default export */ var index = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "L1Wr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_BUDGET_SOURCE; });
/* unused harmony export projectBudgetSourceFetchStart */
/* unused harmony export projectBudgetSourceFetchEnd */
/* unused harmony export projectBudgetSourceFetchSuccess */
/* unused harmony export projectBudgetSourceFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectBudgetSource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Budget Sources //////////////////////////

var PROJECT_BUDGET_SOURCE = {
  start: "fetch_start/project_budget_source",
  end: "fetch_end/project_budget_source",
  success: "fetch_success/project_budget_source",
  failed: "fetch_failed/project_budget_source"
};
var projectBudgetSourceFetchStart = function projectBudgetSourceFetchStart() {
  return {
    type: PROJECT_BUDGET_SOURCE.start
  };
};

var projectBudgetSourceFetchEnd = function projectBudgetSourceFetchEnd() {
  return {
    type: PROJECT_BUDGET_SOURCE.end
  };
};

var projectBudgetSourceFetchSuccess = function projectBudgetSourceFetchSuccess(data) {
  return {
    type: PROJECT_BUDGET_SOURCE.success,
    data: data
  };
};

var projectBudgetSourceFetchFailed = function projectBudgetSourceFetchFailed(error) {
  return {
    type: PROJECT_BUDGET_SOURCE.failed,
    error: error
  };
};

var fetchProjectBudgetSource = function fetchProjectBudgetSource(id) {
  return function (dispatch, getState) {
    dispatch(projectBudgetSourceFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_BUDGET_SOURCE(id)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(projectBudgetSourceFetchEnd());
        dispatch(projectBudgetSourceFetchSuccess(resp.data));
      } else {
        dispatch(projectBudgetSourceFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectBudgetSourceFetchEnd());
      dispatch(projectBudgetSourceFetchFailed());
    });
  };
};

/***/ }),

/***/ "LBmb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REGULAR_AND_OTHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REGULAR_AND_OTHERS_UPDATE_COUNTRY_AGGREGATE; });
/* unused harmony export regularAndOthersFetchStart */
/* unused harmony export regularAndOthersFetchEnd */
/* unused harmony export regularAndOthersFetchSuccess */
/* unused harmony export regularAndOthersClear */
/* unused harmony export updateCountryAggregate */
/* unused harmony export regularAndOthersFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchDonorRegularAndOthers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__ = __webpack_require__("Cdrj");



var REGULAR_AND_OTHERS = {
  start: "fetch_start/regular_and_others",
  end: "fetch_end/regular_and_others",
  success: "fetch_success/regular_and_others",
  failed: "fetch_failed/regular_and_others",
  clear: "clear/regular_and_others"
};

var REGULAR_AND_OTHERS_UPDATE_COUNTRY_AGGREGATE = "REGULAR_AND_OTHERS_UPDATE_COUNTRY_AGGREGATE";

var regularAndOthersFetchStart = function regularAndOthersFetchStart() {
  return {
    type: REGULAR_AND_OTHERS.start
  };
};

var regularAndOthersFetchEnd = function regularAndOthersFetchEnd() {
  return {
    type: REGULAR_AND_OTHERS.end
  };
};

var regularAndOthersFetchSuccess = function regularAndOthersFetchSuccess(data) {
  return {
    type: REGULAR_AND_OTHERS.success,
    data: data
  };
};

var regularAndOthersClear = function regularAndOthersClear() {
  return {
    type: REGULAR_AND_OTHERS.clear
  };
};

var updateCountryAggregate = function updateCountryAggregate(countryAggregate) {
  return {
    type: REGULAR_AND_OTHERS_UPDATE_COUNTRY_AGGREGATE,
    countryAggregate: countryAggregate
  };
};

var regularAndOthersFetchFailed = function regularAndOthersFetchFailed(error) {
  return {
    type: REGULAR_AND_OTHERS.failed,
    error: error
  };
};

var fetchDonorRegularAndOthers = function fetchDonorRegularAndOthers(code, year) {
  return function (dispatch) {
    dispatch(regularAndOthersFetchStart());
    if (code != "" && year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONOR_REGULAR_AND_OTHERS(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          if (resp.data && resp.data.country.length) {
            var countryAggregate = Object(__WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__["c" /* aggregateCalculator */])(resp.data.country, "total_contribution");
            dispatch(updateCountryAggregate(countryAggregate));
          }
          dispatch(regularAndOthersFetchEnd());
          dispatch(regularAndOthersFetchSuccess(resp.data));
        } else {
          dispatch(regularAndOthersFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(regularAndOthersFetchEnd());
        dispatch(regularAndOthersFetchFailed(exception));
      });
    } else {
      dispatch(regularAndOthersClear());
      dispatch(regularAndOthersFetchEnd());
    }
  };
};

/***/ }),

/***/ "Lf5/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_PROFILE_MAP_DATA; });
/* unused harmony export donorProfileMapDataFetchStart */
/* unused harmony export donorProfileMapDataFetchEnd */
/* unused harmony export donorProfileMapDataFetchSuccess */
/* unused harmony export donorProfileMapDataFetchFailed */
/* unused harmony export donorProfileMapDataReset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDonorProfileMapData; });
/* unused harmony export resetDonorProfileMapData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var DONOR_PROFILE_MAP_DATA = {
  start: "fetch_start/donor_profile_map_data",
  end: "fetch_end/donor_profile_map_data",
  success: "fetch_success/donor_profile_map_data",
  failed: "fetch_failed/donor_profile_map_data",
  reset: "reset/donor_profile_map_data"
};

var donorProfileMapDataFetchStart = function donorProfileMapDataFetchStart() {
  return {
    type: DONOR_PROFILE_MAP_DATA.start
  };
};

var donorProfileMapDataFetchEnd = function donorProfileMapDataFetchEnd() {
  return {
    type: DONOR_PROFILE_MAP_DATA.end
  };
};

var donorProfileMapDataFetchSuccess = function donorProfileMapDataFetchSuccess(data) {
  return {
    type: DONOR_PROFILE_MAP_DATA.success,
    data: data
  };
};

var donorProfileMapDataFetchFailed = function donorProfileMapDataFetchFailed(error) {
  return {
    type: DONOR_PROFILE_MAP_DATA.failed,
    error: error
  };
};

var donorProfileMapDataReset = function donorProfileMapDataReset() {
  return {
    type: DONOR_PROFILE_MAP_DATA.success
  };
};

var getDonorProfileMapData = function getDonorProfileMapData(year, donor) {
  return function (dispatch) {
    dispatch(donorProfileMapDataFetchStart());
    var filterYear = year || "";
    var filterDonor = donor || "";
    if (year !== "") return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONOR_PROFILE_MAP_DATA(filterYear, filterDonor)).then(function (response) {
      dispatch(donorProfileMapDataFetchEnd());
      dispatch(donorProfileMapDataFetchSuccess(response.data));
    }).catch(function (exception) {
      dispatch(donorProfileMapDataFetchEnd());
      dispatch(donorProfileMapDataFetchFailed(exception));
    });else {
      dispatch(donorProfileMapDataFetchEnd());
      dispatch(donorProfileMapDataFetchFailed());
    }
  };
};

var resetDonorProfileMapData = function resetDonorProfileMapData(dispatch) {
  dispatch(donorProfileMapDataReset());
};

/***/ }),

/***/ "LkZ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__("JZ8d");
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac"), __webpack_require__("pv+l")(module)))

/***/ }),

/***/ "MpUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SSC_MARKER_DATA; });
/* unused harmony export sscMarkerDataFetchStart */
/* unused harmony export sscMarkerDataFetchEnd */
/* unused harmony export sscMarkerDataClear */
/* unused harmony export sscMarkerDataFetchSuccess */
/* unused harmony export sscMarkerDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSscMarkerData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var SSC_MARKER_DATA = {
  start: "fetch_start/ssc_marker_data",
  end: "fetch_end/ssc_marker_data",
  success: "fetch_success/ssc_marker_data",
  failed: "fetch_failed/ssc_marker_data",
  clear: "clear/ssc_marker_data"
};

var sscMarkerDataFetchStart = function sscMarkerDataFetchStart() {
  return {
    type: SSC_MARKER_DATA.start
  };
};

var sscMarkerDataFetchEnd = function sscMarkerDataFetchEnd() {
  return {
    type: SSC_MARKER_DATA.end
  };
};
var sscMarkerDataClear = function sscMarkerDataClear() {
  return {
    type: SSC_MARKER_DATA.clear
  };
};

var sscMarkerDataFetchSuccess = function sscMarkerDataFetchSuccess(data) {
  return {
    type: SSC_MARKER_DATA.success,
    data: data
  };
};

var sscMarkerDataFetchFailed = function sscMarkerDataFetchFailed(error) {
  return {
    type: SSC_MARKER_DATA.failed,
    error: error
  };
};

var fetchSscMarkerData = function fetchSscMarkerData(year) {
  return function (dispatch, getState) {
    dispatch(sscMarkerDataFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SSC_MARKER_PATH).then(function (resp) {
      if (resp.success && resp.data) {
        dispatch(sscMarkerDataFetchEnd());
        dispatch(sscMarkerDataFetchSuccess(resp.data));
      } else {
        dispatch(sscMarkerDataFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(sscMarkerDataFetchEnd());
      dispatch(sscMarkerDataFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "N97i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIGNATURES_MAP_DATA; });
/* unused harmony export mapDataFetchStart */
/* unused harmony export mapDataFetchEnd */
/* unused harmony export mapDataFetchSuccess */
/* unused harmony export mapDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadSignatureMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/


var SIGNATURES_MAP_DATA = {
  start: "fetch_start/signatures_map_data",
  end: "fetch_end/signatures_map_data",
  success: "fetch_success/signatures_map_data",
  failed: "fetch_failed/signatures_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: SIGNATURES_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: SIGNATURES_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data) {
  return {
    type: SIGNATURES_MAP_DATA.success,
    data: data
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: SIGNATURES_MAP_DATA.failed,
    error: error
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var loadSignatureMapData = function loadSignatureMapData(year, sector, unit, source) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    unit = unit ? unit : "";
    source = source ? source : "";
    sector = sector && sector !== -1 ? sector : "";
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_SIGNATURE(year, sector, unit, source)).then(function (resp) {
      return mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "Oi8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("ygki");


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);

/***/ }),

/***/ "Onlx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HOME_DONORS_CONTRIBUTIONS_LIST; });
/* unused harmony export homeDonorsContributionsListFetchStart */
/* unused harmony export homeDonorsContributionsListFetchEnd */
/* unused harmony export homeDonorsContributionsListFetchSuccess */
/* unused harmony export homeDonorsContributionsListFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHomeDonorsContributionsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var HOME_DONORS_CONTRIBUTIONS_LIST = {
  start: "fetch_start/home_donors_contributions_list",
  end: "fetch_end/home_donors_contributions_list",
  success: "fetch_success/home_donors_contributions_list",
  failed: "fetch_failed/home_donors_contributions_list"
};

var homeDonorsContributionsListFetchStart = function homeDonorsContributionsListFetchStart() {
  return {
    type: HOME_DONORS_CONTRIBUTIONS_LIST.start
  };
};

var homeDonorsContributionsListFetchEnd = function homeDonorsContributionsListFetchEnd() {
  return {
    type: HOME_DONORS_CONTRIBUTIONS_LIST.end
  };
};

var homeDonorsContributionsListFetchSuccess = function homeDonorsContributionsListFetchSuccess(data) {
  return {
    type: HOME_DONORS_CONTRIBUTIONS_LIST.success,
    data: data
  };
};

var homeDonorsContributionsListFetchFailed = function homeDonorsContributionsListFetchFailed(error) {
  return {
    type: HOME_DONORS_CONTRIBUTIONS_LIST.failed,
    error: error
  };
};

var getHomeDonorsContributionsList = function getHomeDonorsContributionsList(year, field_of_operation, donor) {
  return function (dispatch) {
    dispatch(homeDonorsContributionsListFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_HOME_DONORS_CONTRIBUTIONS_LIST(year, field_of_operation, donor)).then(function (response) {
        dispatch(homeDonorsContributionsListFetchEnd());
        dispatch(homeDonorsContributionsListFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(homeDonorsContributionsListFetchEnd());
        dispatch(homeDonorsContributionsListFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "PeVu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./static/assets/json/themeData.js
var themeData = {
  data: [{
    theme_name: "Responsive Institutions",
    budget: "38323265",
    expense: "19016394",
    alloted_budget: "$151.51M",
    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "32",
    point: "121",
    color: "#029fd9"
  }, {
    theme_name: "Inclusive & Sustainable Growth",
    budget: "141313365",
    expense: "133901694",
    alloted_budget: "$151.51M",
    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "30",
    point: "105",
    color: "#c8c607"
  }, {
    theme_name: "Crisis Prevention & Recovery",
    budget: "141313365",
    expense: "133901694",
    alloted_budget: "$151.51M",
    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "15",
    point: "121",
    color: "#ff5640"
  }, {
    theme_name: "Democratic Governance",
    budget: "141313365",
    expense: "133901694",
    alloted_budget: "$151.51M",
    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "12",
    point: "121",
    color: "#ff8500"
  }, {
    theme_name: "Climate Change & Disaster Resilience",
    budget: "141313365",
    expense: "133901694",
    alloted_budget: "$151.51M",
    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "6",
    point: "121",
    color: "#d9d73a"
  }, {
    theme_name: "Development Impact & Effectiveness",
    budget: "141313365",
    expense: "133901694",
    alloted_budget: "$151.51M",
    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "4",
    point: "121",
    color: "#993399"
  }, {
    theme_name: "Gender Equality",
    budget: "141313365",
    expense: "133901694",
    alloted_budget: "$151.51M",
    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "1",
    point: "121",
    color: "#69b13a"
  }]
};
// CONCATENATED MODULE: ./static/assets/json/donorData.js
var donorData = {
  data: [{
    donor_name: "United States of America",
    budget: "141135550",
    expense: "133113695",
    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "30",
    point: "105",
    color: "#ff8500"
  }, {
    donor_name: "European Union",
    budget: "38323265",
    expense: "19016394",

    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "15",
    point: "121",
    color: "#c8c607"
  }, {
    donor_name: "Japan",
    budget: "38323265",
    expense: "19016394",

    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "10",
    point: "121",
    color: "#ff5640"
  }, {
    donor_name: "United Kingdom",
    budget: "38323265",
    expense: "19016394",

    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "25",
    point: "121",
    color: "#69b13a"
  }, {
    donor_name: "Norway",
    budget: "38323265",
    expense: "19016394",

    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "12",
    point: "121",
    color: "#029fd9"
  }, {
    donor_name: "Sweden",
    budget: "38323265",
    expense: "19016394",

    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "5",
    point: "121",
    color: "#d9d73a"
  }, {
    donor_name: "Canada",
    budget: "38323265",
    expense: "19016394",

    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "3",
    point: "121",
    color: "#993399"
  }, {
    donor_name: "Germany",
    budget: "38323265",
    expense: "19016394",

    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "3",
    point: "121",
    color: "#ff8500"
  }, {
    donor_name: "France",
    budget: "38323265",
    expense: "19016394",

    projects: "20",
    budget_sources: "05",
    "recipeint Offices": "05",
    share_percent: "3",
    point: "121",
    color: "#c8c607"
  }]
};
// CONCATENATED MODULE: ./static/assets/json/sdgData.js
var sdgData = {
  data: [{
    sdg_name: "No Poverty",
    budget: "$141.13M",
    expense: "$133.11M",
    alloted_budget: "$151.51M",
    sdg_projects: "20",
    sdg_sources: "05",
    share_percent: "30",
    point: "105",
    color: "#D8223F"
  }, {
    sdg_name: "Zero Hunger",
    budget: "$38.32M",
    expense: "$19.01M",
    alloted_budget: "$151.51M",
    sdg_projects: "20",
    sdg_sources: "05",
    share_percent: "30",
    point: "121",
    color: "#D7AA3C"
  }, {
    sdg_name: "Good Health and Well-being",
    budget: "$38.32M",
    expense: "$19.01M",
    alloted_budget: "$151.51M",
    sdg_projects: "20",
    sdg_sources: "05",
    share_percent: "15",
    point: "121",
    color: "#54A144"
  }, {
    sdg_name: "Quality Education",
    budget: "$38.32M",
    expense: "$19.01M",
    alloted_budget: "$151.51M",
    sdg_projects: "20",
    sdg_sources: "05",
    share_percent: "12",
    point: "121",
    color: "#BB1E32"
  }, {
    sdg_name: "Gender Equality",
    budget: "$38.32M",
    expense: "$19.01M",
    alloted_budget: "$151.51M",
    sdg_projects: "20",
    sdg_sources: "05",
    share_percent: "6",
    point: "121",
    color: "#E34032"
  }, {
    sdg_name: "Clean Water and Sanitation",
    budget: "$38.32M",
    expense: "$19.01M",
    alloted_budget: "$151.51M",
    sdg_projects: "20",
    sdg_sources: "05",
    share_percent: "4",
    point: "121",
    color: "#52BBE0"
  }, {
    sdg_name: "Affordable and Clean Energy",
    budget: "$38.32M",
    expense: "$19.01M",
    alloted_budget: "$151.51M",
    sdg_projects: "20",
    sdg_sources: "05",
    share_percent: "1",
    point: "121",
    color: "#F2C71F"
  }, {
    sdg_name: "Decent Work Economic Growth",
    budget: "$38.32M",
    expense: "$19.01M",
    alloted_budget: "$151.51M",
    sdg_projects: "20",
    sdg_sources: "05",
    share_percent: "1",
    point: "121",
    color: "#991544"
  }]
};
// CONCATENATED MODULE: ./components/tabSection/actions/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TAB_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ON_TAB_SWITCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ON_UPDATE_DONOR_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ON_UPDATE_THEME_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ON_UPDATE_COUNTRYREGION_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ON_UPDATE_SDG_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ON_UPDATE_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ON_UPDATE_SIGNATURE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return onTabSwitch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return onTabSelection; });
/* unused harmony export tabDataFetchStart */
/* unused harmony export tabDataFetchEnd */
/* unused harmony export tabDataFetchSuccess */
/* unused harmony export tabDataFetchFailed */
/* unused harmony export onUpdateYear */
/* unused harmony export themeItemFetchData */
/* unused harmony export donorItemFetchData */
/* unused harmony export sdgItemFetchData */
/* unused harmony export signatureItemFetchData */
/* unused harmony export updateDonorFilter */
/* unused harmony export updateThemeFilter */
/* unused harmony export updateCountryRegionFilter */
/* unused harmony export updateSdgFilter */
/* unused harmony export updateSignatureFilter */



var TAB_DATA = {
  start: "fetch_start/tab_data",
  end: "fetch_end/tab_data",
  success: "fetch_success/tab_data",
  failed: "fetch_failed/tab_data"
};
var ON_TAB_SWITCH = "ON_TAB_SWITCH";
var ON_UPDATE_DONOR_FILTER = "ON_UPDATE_DONOR_FILTER";
var ON_UPDATE_THEME_FILTER = "ON_UPDATE_THEME_FILTER";
var ON_UPDATE_COUNTRYREGION_FILTER = "ON_UPDATE_COUNTRYREGION_FILTER";
var ON_UPDATE_SDG_FILTER = "ON_UPDATE_SDG_FILTER";
var ON_UPDATE_YEAR = "ON_UPDATE_YEAR";
var ON_UPDATE_SIGNATURE_FILTER = "ON_UPDATE_SIGNATURE_FILTER";

var onTabSwitch = function onTabSwitch(tabType) {
  return {
    type: ON_TAB_SWITCH,
    tabType: tabType
  };
};

var onTabSelection = function onTabSelection(tab) {
  return function (dispatch, getState) {
    switch (tab) {
      case "country":
        dispatch(onTabSwitch("country"));
        // dispatch(countryItemFetchData())
        break;
      case "themes":
        dispatch(onTabSwitch("themes"));
        dispatch(themeItemFetchData());
        break;
      case "sdg":
        dispatch(onTabSwitch("sdg"));
        dispatch(sdgItemFetchData());
        break;
      case "donors":
        dispatch(onTabSwitch("donors"));
        dispatch(donorItemFetchData());
        break;
      case "signature":
        dispatch(onTabSwitch("signature"));
        dispatch(signatureItemFetchData());
        break;
    }
  };
};

var tabDataFetchStart = function tabDataFetchStart() {
  return {
    type: TAB_DATA.start
  };
};

var tabDataFetchEnd = function tabDataFetchEnd() {
  return {
    type: TAB_DATA.end
  };
};

var tabDataFetchSuccess = function tabDataFetchSuccess(data) {
  return {
    type: TAB_DATA.success,
    data: data
  };
};

var tabDataFetchFailed = function tabDataFetchFailed(error) {
  return {
    type: TAB_DATA.failed,
    error: error
  };
};

var onUpdateYear = function onUpdateYear(year) {
  return {
    type: ON_UPDATE_YEAR,
    year: year
  };
};

var themeItemFetchData = function themeItemFetchData() {
  return function (dispatch, getState) {
    var themeData = getState().themeSummary.themes;

    dispatch(tabDataFetchStart());
    dispatch(tabDataFetchEnd());
    dispatch(tabDataFetchSuccess({ data: themeData }));
  };
};
var donorItemFetchData = function donorItemFetchData() {
  return function (dispatch, getState) {
    var donorFundAggr = getState().donorFundList.data;
    dispatch(tabDataFetchStart());
    dispatch(tabDataFetchEnd());
    dispatch(tabDataFetchSuccess({ data: donorFundAggr }));
  };
};
var sdgItemFetchData = function sdgItemFetchData() {
  return function (dispatch, getState) {
    var sdgAggr = getState().sdgAggregate.data;
    dispatch(tabDataFetchStart());
    dispatch(tabDataFetchEnd());
    dispatch(tabDataFetchSuccess({ data: sdgAggr }));
  };
};
var signatureItemFetchData = function signatureItemFetchData() {
  return function (dispatch, getState) {
    var signatureData = getState().themeSummary.themes;
    dispatch(tabDataFetchStart());
    dispatch(tabDataFetchEnd());
    dispatch(tabDataFetchSuccess({ data: signatureData }));
  };
};

// update donor filter selection
var updateDonorFilter = function updateDonorFilter(key, data) {
  return {
    type: ON_UPDATE_DONOR_FILTER,
    key: key,
    data: data
  };
};

// update theme filter selection

var updateThemeFilter = function updateThemeFilter(key, data) {
  return {
    type: ON_UPDATE_THEME_FILTER,
    key: key,
    data: data
  };
};

// update country-region filter selection

var updateCountryRegionFilter = function updateCountryRegionFilter(key, data) {
  return {
    type: ON_UPDATE_COUNTRYREGION_FILTER,
    key: key,
    data: data
  };
};

var updateSdgFilter = function updateSdgFilter(key, data) {
  return {
    type: ON_UPDATE_SDG_FILTER,
    key: key,
    data: data
  };
};

var updateSignatureFilter = function updateSignatureFilter(key, data) {
  return {
    type: ON_UPDATE_SIGNATURE_FILTER,
    key: key,
    data: data
  };
};
// export const countryItemFetchData = () => {
//     return (dispatch) => {
//         dispatch(tabDataFetchStart())
//         dispatch(tabDataFetchEnd())
//         dispatch(tabDataFetchSuccess({}))

//     }
// }

/***/ }),

/***/ "QMfV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_DETAILS; });
/* unused harmony export donorDerailsFetchStart */
/* unused harmony export donorDerailsFetchEnd */
/* unused harmony export donorDerailsFetchSuccess */
/* unused harmony export donorDerailsFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDonorDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var DONOR_DETAILS = {
  start: "fetch_start/donor_details",
  end: "fetch_end/donor_details",
  success: "fetch_success/donor_details",
  failed: "fetch_failed/donor_details"
};

var donorDerailsFetchStart = function donorDerailsFetchStart() {
  return {
    type: DONOR_DETAILS.start
  };
};

var donorDerailsFetchEnd = function donorDerailsFetchEnd() {
  return {
    type: DONOR_DETAILS.end
  };
};

var donorDerailsFetchSuccess = function donorDerailsFetchSuccess(data) {
  return {
    type: DONOR_DETAILS.success,
    data: data
  };
};

var donorDerailsFetchFailed = function donorDerailsFetchFailed(error) {
  return {
    type: DONOR_DETAILS.failed,
    error: error
  };
};

var getDonorDetails = function getDonorDetails(donor) {
  return function (dispatch) {
    dispatch(donorDerailsFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONOR_DETAILS(donor)).then(function (response) {
      dispatch(donorDerailsFetchEnd());
      dispatch(donorDerailsFetchSuccess(response.data));
    }).catch(function (exception) {
      dispatch(donorDerailsFetchEnd());
      dispatch(donorDerailsFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "QTo+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONORS_CONTRIBUTIONS_DETAILS; });
/* unused harmony export donorsContributionsDetailsFetchStart */
/* unused harmony export donorsContributionsDetailsFetchEnd */
/* unused harmony export donorsContributionsDetailsFetchSuccess */
/* unused harmony export donorsContributionsDetailsFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateContributionsDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var DONORS_CONTRIBUTIONS_DETAILS = {
  start: "fetch_start/donors_contributions_details",
  end: "fetch_end/donors_contributions_details",
  success: "fetch_success/donors_contributions_details",
  failed: "fetch_failed/donors_contributions_details"
};

var donorsContributionsDetailsFetchStart = function donorsContributionsDetailsFetchStart() {
  return {
    type: DONORS_CONTRIBUTIONS_DETAILS.start
  };
};

var donorsContributionsDetailsFetchEnd = function donorsContributionsDetailsFetchEnd() {
  return {
    type: DONORS_CONTRIBUTIONS_DETAILS.end
  };
};

var donorsContributionsDetailsFetchSuccess = function donorsContributionsDetailsFetchSuccess(data) {
  return {
    type: DONORS_CONTRIBUTIONS_DETAILS.success,
    data: data
  };
};

var donorsContributionsDetailsFetchFailed = function donorsContributionsDetailsFetchFailed(error) {
  return {
    type: DONORS_CONTRIBUTIONS_DETAILS.failed,
    error: error
  };
};

var updateContributionsDetails = function updateContributionsDetails(year, portal, donor) {
  return function (dispatch) {
    dispatch(donorsContributionsDetailsFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONORS_CONTRIBUTIONS_DETAILS(year, portal, donor)).then(function (response) {
        dispatch(donorsContributionsDetailsFetchEnd());
        dispatch(donorsContributionsDetailsFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(donorsContributionsDetailsFetchEnd());
        dispatch(donorsContributionsDetailsFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "RhfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_MAP_DATA; });
/* unused harmony export recipientMapDataFetchStart */
/* unused harmony export recipientMapDataFetchEnd */
/* unused harmony export recipientMapDataFetchSuccess */
/* unused harmony export recipientMapDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRecipientMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var RECIPIENT_MAP_DATA = {
  start: "fetch_start/recipient_map_data",
  end: "fetch_end/recipient_map_data",
  success: "fetch_success/recipient_map_data",
  failed: "fetch_failed/recipient_map_data"
};

var recipientMapDataFetchStart = function recipientMapDataFetchStart() {
  return {
    type: RECIPIENT_MAP_DATA.start
  };
};

var recipientMapDataFetchEnd = function recipientMapDataFetchEnd() {
  return {
    type: RECIPIENT_MAP_DATA.end
  };
};

var recipientMapDataFetchSuccess = function recipientMapDataFetchSuccess(data) {
  return {
    type: RECIPIENT_MAP_DATA.success,
    data: data
  };
};

var recipientMapDataFetchFailed = function recipientMapDataFetchFailed(error) {
  return {
    type: RECIPIENT_MAP_DATA.failed,
    error: error
  };
};

var getRecipientMapData = function getRecipientMapData(year, field_of_operation) {
  return function (dispatch) {
    dispatch(recipientMapDataFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_MAP_DATA(year, field_of_operation)).then(function (response) {
        dispatch(recipientMapDataFetchEnd());
        dispatch(recipientMapDataFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(recipientMapDataFetchEnd());
        dispatch(recipientMapDataFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "SCCX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_OUTPUT_LIST; });
/* unused harmony export projectOutputListFetchStart */
/* unused harmony export projectOutputListFetchEnd */
/* unused harmony export projectOutputListFetchSuccess */
/* unused harmony export projectOutputListFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectOutputList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Output List //////////////////////////

var PROJECT_OUTPUT_LIST = {
  start: "fetch_start/project_output_list",
  end: "fetch_end/project_output_list",
  success: "fetch_success/project_output_list",
  failed: "fetch_failed/project_output_list"
};
var projectOutputListFetchStart = function projectOutputListFetchStart() {
  return {
    type: PROJECT_OUTPUT_LIST.start
  };
};

var projectOutputListFetchEnd = function projectOutputListFetchEnd() {
  return {
    type: PROJECT_OUTPUT_LIST.end
  };
};

var projectOutputListFetchSuccess = function projectOutputListFetchSuccess(data) {
  return {
    type: PROJECT_OUTPUT_LIST.success,
    data: data
  };
};

var projectOutputListFetchFailed = function projectOutputListFetchFailed(error) {
  return {
    type: PROJECT_OUTPUT_LIST.failed,
    error: error
  };
};

var fetchProjectOutputList = function fetchProjectOutputList(id) {
  return function (dispatch, getState) {
    dispatch(projectOutputListFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_OUTPUT_LIST(id)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(projectOutputListFetchEnd());
        dispatch(projectOutputListFetchSuccess(resp.data));
      } else {
        dispatch(projectOutputListFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectOutputListFetchEnd());
      dispatch(projectOutputListFetchFailed());
    });
  };
};

/***/ }),

/***/ "SDqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONORS_MAP_DATA; });
/* unused harmony export mapDataFetchStart */
/* unused harmony export mapDataFetchEnd */
/* unused harmony export mapDataFetchSuccess */
/* unused harmony export mapDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadDonorsMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/


var DONORS_MAP_DATA = {
  start: "fetch_start/donors_map_data",
  end: "fetch_end/donors_map_data",
  success: "fetch_success/donors_map_data",
  failed: "fetch_failed/donors_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: DONORS_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: DONORS_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data) {
  return {
    type: DONORS_MAP_DATA.success,
    data: data
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: DONORS_MAP_DATA.failed,
    error: error
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var loadDonorsMapData = function loadDonorsMapData(year, unit, sector, budgetSource, sdg) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    unit = unit ? unit : "";
    sector = sector ? sector : "";
    budgetSource = budgetSource ? budgetSource : "";
    sdg = sdg ? sdg : "";
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_DONORS(year, unit, sector, budgetSource, sdg)).then(function (resp) {
      return mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "STnb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_LIST; });
/* unused harmony export projectListFetchStart */
/* unused harmony export projectListFetchEnd */
/* unused harmony export projectListFetchSuccess */
/* unused harmony export projectListFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateProjectList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchMarkerProjectList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var PROJECT_LIST = {
  start: "fetch_start/project_list",
  end: "fetch_end/project_list",
  success: "fetch_success/project_list",
  failed: "fetch_failed/project_list"
};

var projectListFetchStart = function projectListFetchStart() {
  return {
    type: PROJECT_LIST.start
  };
};

var projectListFetchEnd = function projectListFetchEnd() {
  return {
    type: PROJECT_LIST.end
  };
};

var projectListFetchSuccess = function projectListFetchSuccess(data) {
  return {
    type: PROJECT_LIST.success,
    data: data
  };
};

var projectListFetchFailed = function projectListFetchFailed(error) {
  return {
    type: PROJECT_LIST.failed,
    error: error
  };
};

var updateProjectList = function updateProjectList(year, operatingUnit, budgetSource, themes, keyword, limit, offset, budgetType, sdg, target, signatureSolution) {
  return function (dispatch) {
    dispatch(projectListFetchStart());
    operatingUnit = operatingUnit !== null ? operatingUnit : "";
    budgetType = budgetType !== null ? budgetType : "";
    year = year !== null ? year : "";
    budgetSource = budgetSource !== null ? budgetSource : "";
    themes = themes !== null ? themes : "";
    keyword = keyword !== null ? keyword : "";
    sdg = sdg ? sdg : sdg === 0 ? 0 : "";
    signatureSolution = signatureSolution ? signatureSolution : "";
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_LIST(year, operatingUnit, budgetSource, themes, keyword, limit, offset, budgetType, sdg, target, signatureSolution)).then(function (response) {
        dispatch(projectListFetchEnd());
        dispatch(projectListFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(projectListFetchEnd());
        dispatch(projectListFetchFailed(exception));
      });
    }
  };
};

var fetchMarkerProjectList = function fetchMarkerProjectList(year, markerId, keyword, limit, offset, country, markerType, levelTwoMarker) {
  keyword = keyword !== null ? keyword : "";
  markerType = markerType !== null ? markerType : "";
  country = country && country.country_iso3 ? country.country_iso3 : "";
  limit = limit !== null ? limit : "10";
  offset = offset !== null ? offset : "0";
  levelTwoMarker = levelTwoMarker ? levelTwoMarker : "";
  return function (dispatch, getState) {
    dispatch(projectListFetchStart());
    if (year !== "" && markerId !== "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MARKER_PROJECTLIST_DATA(year, markerId, keyword, limit, offset, country, markerType, levelTwoMarker)).then(function (response) {
        if (response.success && response.data) {
          response.data.aggregate = response.data.aggregate && response.data.aggregate.length ? response.data.aggregate[0] : {};
          dispatch(projectListFetchEnd());
          dispatch(projectListFetchSuccess(response.data));
        } else {
          dispatch(projectListFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(projectListFetchEnd());
        dispatch(projectListFetchFailed(exception));
      });
    } else {
      dispatch(projectListFetchEnd());
    }
  };
};

/***/ }),

/***/ "Sw3y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_BASIC_DATA; });
/* unused harmony export projectBasicDataFetchStart */
/* unused harmony export projectBasicDataFetchEnd */
/* unused harmony export projectBasicDataFetchSuccess */
/* unused harmony export projectBasicDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectBasicData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Basic Data //////////////////////////


var PROJECT_BASIC_DATA = {
  start: "fetch_start/project_basic_data",
  end: "fetch_end/project_basic_data",
  success: "fetch_success/project_basic_data",
  failed: "fetch_failed/project_basic_data"
};

var projectBasicDataFetchStart = function projectBasicDataFetchStart() {
  return {
    type: PROJECT_BASIC_DATA.start
  };
};

var projectBasicDataFetchEnd = function projectBasicDataFetchEnd() {
  return {
    type: PROJECT_BASIC_DATA.end
  };
};

var projectBasicDataFetchSuccess = function projectBasicDataFetchSuccess(data) {
  return {
    type: PROJECT_BASIC_DATA.success,
    data: data
  };
};

var projectBasicDataFetchFailed = function projectBasicDataFetchFailed(error) {
  return {
    type: PROJECT_BASIC_DATA.failed,
    error: error
  };
};

var fetchProjectBasicData = function fetchProjectBasicData(id) {
  return function (dispatch, getState) {
    dispatch(projectBasicDataFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_DETAILS + id).then(function (resp) {
      if (resp.data && resp.success) {
        resp.data.storyMap = [{
          location: "Ubari",
          source: "https://unosat.maps.arcgis.com/apps/Cascade/index.html?appid=1e216a4f58624dfd8fd88e4d10792d3b"
        }, {
          location: "Benghazi",
          source: "https://unosat.maps.arcgis.com/apps/Cascade/index.html?appid=eb29652914fe4cfb9f10fb910b6c9b6a"
        }];
        dispatch(projectBasicDataFetchEnd());
        dispatch(projectBasicDataFetchSuccess(resp.data));
      } else {
        dispatch(projectBasicDataFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectBasicDataFetchEnd());
      dispatch(projectBasicDataFetchFailed());
    });
  };
};

/***/ }),

/***/ "TOh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable max-len */

var CircularJSON = __webpack_require__("0GGf");
var API_BASE_URL = "https://open.unrwa.org/";

var Api = (_temp = _class = function () {
  function Api() {
    _classCallCheck(this, Api);
  }

  Api.headers = function headers() {
    return {
      Accept: "application/json",
      "Content-Type": "application/json"
    };
  };

  Api.headerForceDownLoad = function headerForceDownLoad() {
    return {
      "Content-Type": "text/csv"
    };
  };

  Api.get = function get(route) {
    return this.xhr(route, undefined, "GET");
  };

  Api.put = function put(route, params) {
    return this.xhr(route, params, "PUT");
  };

  Api.post = function post(route, params) {
    return this.xhr(route, params, "POST");
  };

  Api.postPDF = function postPDF(route, params) {
    return this.xhrPDF(route, params, "POST");
  };

  Api.downLoadCSV = function downLoadCSV(route, params) {
    return this.xhrCSV(route, params, "GET");
  };

  Api.delete = function _delete(route, params) {
    return this.xhr(route, params, "DELETE");
  };

  Api.xhr = function xhr(route, params, verb) {
    var options = _extends({ method: verb });
    options.headers = Api.headers();
    options.body = JSON.stringify(params);
    options.mode = "cors";
    return fetch(Api.API_BASE + route, options).then(function (resp) {
      var json = resp.json();
      if (resp.ok) {
        return json;
      }
      return json.then(function (err) {
        throw err;
      });
    }).then(function (json) {
      return json;
    });
  };

  Api.xhrCSV = function xhrCSV(route, params, verb) {
    var options = _extends({ method: verb });
    options.headers = Api.headerForceDownLoad();
    options.mode = "cors";
    // options.body = JSON.stringify(params);
    return fetch(Api.API_BASE + route, options).then(function (resp) {
      var blob = resp.blob();
      return blob;
    }).then(function (blob) {
      return blob;
    });
  };

  Api.xhrPDF = function xhrPDF(route, params, verb) {
    var options = _extends({ method: verb });
    options.headers = Api.headers();
    options.body = params.template_name === "sdgChart" || params.template_name === "sscMarker" ? CircularJSON.stringify(params) : JSON.stringify(params);
    options.mode = "cors";
    return fetch(Api.API_BASE + route, options).then(function (resp) {
      var json = resp.json();
      if (resp.ok) {
        return json;
      }
      return json.then(function (err) {
        throw err;
      });
    }).then(function (json) {
      return json;
    });
  };

  /// API LISTS
  // QA    Original
  // Client

  ////////////////////  RECIPIENT PROFILE  ////////////////////

  //   static API_RECIPIENT_BUDGET_VS_EXPENSE = (code, year) => '/api/v1/project/recipient_profile/' + code + '/theme/budget_vs_expense?year=' + year;
  // static API_RECIPIENT_BUDGET_VS_EXPENSE_SDG = (code, year) => '/api/v1/project/recipient_profile/' + code + '/sdg/budget_vs_expense?year=' + year;

  /////////////////////////////////////////////////////////////////////
  ////////////////////  DONOR PROFILE  ////////////////////

  // static API_RECIPIENT_WIND_ROSE = (code, year, sector) => "/api/v1/project/country_result/?year=" + year + "&operating_unit=" + code + "&sector=" + sector
  /////////////////////////////////////////////////////////////////////
  ////////////////////      FINANCIAL_FLOW         ////////////////////

  /////////////////////////////////////////////////////////////////////
  ////////////////////  PROJECT DETAILS API LISTS  ////////////////////

  /////////////////////////////////////////////////////////////////////

  // static API_DONOR_FUND_LIST = '/api/v1/donor/fund_aggregate/';

  /////////////////////////// MAP APIs ///////////////////////////////////

  ////////////////////////////////////////////////////////////////////////

  /////////////////SEARCH API ///////////////

  /////////////////////////////////


  return Api;
}(), _class.API_BASE = API_BASE_URL, _class.API_LOCAL = "", _class.S3_BASE_URL = "", _class.DOWNLOAD_PDF = function (path) {
  return Api.API_BASE + "/api/v1/unrwa/export_download_pdf?file=" + path;
}, _class.DOWNLOAD_CSV = function (path) {
  return Api.API_BASE + "/api/v1/unrwa/export_csv?file=" + path;
}, _class.GA_TRACKING_ID = "", _class.MAP_API_KEY = "pk.eyJ1IjoiYW5qYWxpMjkiLCJhIjoiY2tsOHUwNGRiMDM5cDJxbnkyMjNpcTh5dyJ9.e70S4F80t0b4UnjlB3zJ9A", _class.API_PROJECT_LIST = function (year, operatingUnit, budgetSource, themes, keyword, limit, offset, budget_type, sdg, target, signatureSolution) {
  return "/api/v1/project/list/?budget_sources=" + budgetSource + "&keyword=" + keyword + "&limit=" + limit + "&offset=" + offset + "&operating_units=" + operatingUnit + "&sectors=" + themes + "&year=" + year + "&budget_type=" + budget_type + (target ? "&sdg_targets=" + target : "&sdgs=" + sdg) + "&signature_solution=" + signatureSolution;
}, _class.API_PROJECT_AGGREGATE = "/api/v1/project/project_aggregate/?year=", _class.API_YEAR_LIST = "/api/v1/master/project_time_line", _class.API_GENERAL_INFO = "/api/v1/unrwa/general_info", _class.API_COUNTRY_LIST = "/api/v1/master/country?&donor=", _class.API_THEME_LIST = "/api/v1/master/sector", _class.API_SIGNATURE_LIST = "/api/v1/master/sector", _class.API_PROJECT_TIMELINE_RANGE = "/api/v1/master/project_time_line", _class.API_THEME_AGGREGATE = "/api/v1/project/sector_aggregate/?year=", _class.API_SIGNATURE_AGGREGATE = "/api/v1/project/signature_solutions_aggregate/?year=", _class.API_SDG_AGGREGATE = function (year, operatingUnit, budgetSources) {
  return "/api/v1/project/sdg_aggregate/?year=" + year + "&operating_unit=" + operatingUnit + "&budget_source=" + budgetSources;
}, _class.API_DONOR_SLIDER_DATA = function (year, sector, operatingUnits, budgetSources) {
  return "/api/v1/sector/details?year=" + year + "&sector=" + sector + "&operating_unit=" + operatingUnits + "&budget_source=" + budgetSources;
}, _class.API_DONOR_SDG_DATA = function (year, sdg, operatingUnits, budgetSources) {
  return "/api/v1/project/signature_solutions/" + sdg + "/details?year=" + year + "&ss_id=" + sdg + "&operating_unit=" + operatingUnits + "&budget_source=" + budgetSources;
}, _class.API_SIGNATURE_SLIDER_DATA = function (year, sector, operatingUnits, budgetSources) {
  return "/api/v1/project/signature_solutions/" + sector + "/details?year=" + year + "&ss_id=" + sector + "&operating_unit=" + operatingUnits + "&budget_source=" + budgetSources;
}, _class.API_SDG_SLIDER_DATA = function (year, sdg, operatingUnits, budgetSources) {
  return "/api/v1/project/sdg/details?year=" + year + "&sdg=" + sdg + "&operating_unit=" + operatingUnits + "&budget_source=" + budgetSources;
}, _class.API_SDG_SUNBURST_DATA = function (year) {
  return "/api/v1/project/sdg?year=" + year;
}, _class.API_SECTOR_DATA = function (vocabulary, year) {
  return "/api/v1/unrwa/pie_chart?year=" + year + "&sector_vocabulary=" + vocabulary;
}, _class.API_SDG_TARGET_PERCENTAGE_DATA = function (year, sdg) {
  return "/api/v1/project/sdg_target?year=" + year + "&sdg=" + sdg;
}, _class.API_SDG_TARGET_DATA = function (year, targetId) {
  return "/api/v1/project/sdg_target/details?year=" + year + "&sdg_target=" + targetId;
}, _class.API_ABOUT = "/api/v1/about_us/list", _class.API_RECIPIENT_COUNTRY_BASIC = function (code, year) {
  return "/api/v1/project/recipient_profile/" + code + "/?year=" + year;
}, _class.API_RECIPIENT_COUNTRY_THEME = function (code, year) {
  return "/api/v1/global/themes?year=" + year + "&operating_unit=" + code;
}, _class.API_RECIPIENT_COUNTRY_SDG = function (code, year) {
  return "/api/v1/project/recipient_profile/" + code + "/sdg?year=" + year;
}, _class.API_RECIPIENT_COUNTRTY_DOCUMENTS = function (code, year, category) {
  return "/api/v1/project/recipient_profile/" + code + "/documents?year=" + year + "&category=" + category;
}, _class.API_RECIPIENT_COUNTRTY_TOP_BUDGET_SOURCES = function (code, year) {
  return "/api/v1/donor/recipient_budget_sources/?year=" + year + "&operating_unit=" + code;
}, _class.API_RECIPIENT_WIND_ROSE = function (code, year, sector) {
  return "/api/v1/project/country_result/?year=" + year + "&operating_unit=" + code + "&sector=" + sector;
}, _class.API_RECIPIENT_BUDGET_VS_EXPENSE_SDG = function (code, year) {
  return "/api/v1/project/recipient_profile/" + code + "/sdg?year=" + year;
}, _class.API_RECIPIENT_BUDGET_VS_EXPENSE = function (code, year) {
  return "/api/v1/global/themes?year=" + year + "&operating_unit=" + code;
}, _class.API_DONOR_COUNTRY_BASIC = function (code, year) {
  return "/api/v1/donor/aggregate?year=" + year + "&country=" + code;
}, _class.API_DONOR_REGULAR_AND_OTHERS = function (code, year) {
  return "/api/v1/donor/fund_modality?year=" + year + "&country=" + code;
}, _class.API_RECIPIENT_RESOURCES_MODALITY_CONTRIBUTION = function (code, year) {
  return "/api/v1/donor/fund_modality?year=" + year + "&country=" + code + "&group_by=1";
}, _class.API_SDG_BAR_CHART = function (code, year) {
  return "/api/v1/donor/fund_modality?year=" + year + "&country=" + code + "&group_by=1";
}, _class.API_SIGNATURE_OUTCOME = function (code, year) {
  return "/api/v1/project/signature_solutions/1/outcomes?year=" + year + "&ss_id=" + code;
}, _class.API_FETCH_SIGNATURE_SOLUTION_CHART_DATA = function (code, year) {
  return "/api/v1/project/sector/1/signature_solution?year=" + year + "&code=" + code;
}, _class.RECIPIENT_TOP_OFFICES = function (code, year) {
  return "/api/v1/donor/top_recipient_offices?year=" + year + "&donor=" + code;
}, _class.API_DONOR_TYPES = "/api/v1/master/donor_types", _class.API_FUND_STREAMS = "/api/v1/master/fund_streams", _class.API_SDGS = "/api/v1/master/sdg", _class.API_DONOR_BUDGET_SOURCES = function (code, year) {
  return "/api/v1/donor/budget_sources?year=" + year + "&donor_level_3_code=" + code;
}, _class.API_BUDGET_FINANCIAL_FLOW = function (year) {
  return "/api/v1/unrwa/sankey_budget?year=" + year;
}, _class.API_EXPENSE_FINANCIAL_FLOW = function (year) {
  return "/api/v1/unrwa/sankey_expense?year=" + year;
}, _class.API_PROJECT_DETAILS = "/api/v1/project/details/", _class.API_PROJECT_BUDGET_SOURCE = function (project_id) {
  return "/api/v1/project/" + project_id + "/budget_sources";
}, _class.API_PROJECT_BUDGET_UTILIZATION = function (project_id) {
  return "/api/v1/project/" + project_id + "/budget_utilization";
}, _class.API_PROJECT_DOCUMENT_LIST = function (project_id, category) {
  return "/api/v1/project/" + project_id + "/documents";
}, _class.API_PROJECT_DOCUMENT_LIST_FILTERED = function (project_id, category) {
  return "/api/v1/project/" + project_id + "/documents?search=&category=" + category;
}, _class.API_PROJECT_OUTPUT_LIST = function (project_id) {
  return "/api/v1/output/list?project=" + project_id;
}, _class.API_PROJECT_OUTPUT_DETAIL = function (project_id) {
  return "/api/v1/output/details/" + project_id;
}, _class.API_MARKER_DETAIL = function (project_id) {
  return "/api/v1/output/markers/" + project_id;
}, _class.API_PROJECT_OUTPUT_RESULTS = function (project_id) {
  return "/api/v1/output/" + project_id + "/results";
}, _class.API_PROJECT_TIME_LINE = function (project_id) {
  return "/api/v1/project/" + project_id + "/timeline";
}, _class.API_PROJECT_PURCHASE_ORDERS = function (project_id) {
  return "/api/v1/purchase_order/list?year=&project_id=" + project_id;
}, _class.API_OPERATING_UNITS = "/api/v1/master/budget_sources", _class.API_DONOR_FUND_LIST = "/api/v1/donor/donor_fund_aggregate/", _class.API_PROJECT_DETAIL_GALLERY = function (project_id) {
  return "/api/v1/project/" + project_id + "/pictures";
}, _class.API_MAP_GLOBAL = function (year, unit) {
  return "/api/v1/project/map?year=" + year + "&operating_unit=" + unit;
}, _class.API_MAP_PROJECT_LIST = function (year, sector, unit, source, sdg, marker, marker_id, levelTwoMarker) {
  return "/api/v1/project/map?year=" + year + "&operating_unit=" + unit + "&budget_source=" + source + "&sector=" + sector + "&sdg=" + sdg + "&marker_type=" + marker + "&marker_id=" + marker_id + "&level_two_marker=" + levelTwoMarker;
}, _class.API_MAP_PROJECT_DETAIL = function (project_id) {
  return "/api/v1/project/map?project_id=" + project_id;
}, _class.API_MAP_THEMES = function (year, sector, unit, source, signatureSolution) {
  return "/api/v1/project/map?year=" + year + "&operating_unit=" + unit + "&budget_source=" + source + "&sector=" + sector + "&signature_solution=" + signatureSolution;
}, _class.API_MAP_SIGNATURE = function (year, sector, unit, source) {
  return "/api/v1/project/map?year=" + year + "&operating_unit=" + unit + "&budget_source=" + source + "&signature_solution=" + sector;
}, _class.API_MAP_DONORS = function (year, unit, sector, source, sdg) {
  return "/api/v1/project/map?year=" + year + "&operating_unit=" + unit + "&sector=" + sector + "&budget_source=" + source + "&sdg=" + sdg;
}, _class.API_MAP_SDG = function (year, sdg, unit, source, tab) {
  return "/api/v1/project/map?year=" + year + "&operating_unit=" + unit + "&sdg=" + sdg + "&budget_source=" + source + "&tab=" + tab;
}, _class.API_MAP_RECIPIENT = function (year, unit) {
  return "/api/v1/project/map?year=" + year + "&operating_unit=" + unit;
}, _class.API_MAP_OUTPUTS = function (year, unit, sector, source, project_id, budget_type, sdg, marker, markerSubtype, sigSoln) {
  return "/api/v1/project/map?year=" + year + "&operating_unit=" + unit + "&sector=" + sector + "&project_id=" + project_id + "&sdg=" + sdg + "&budget_source=" + source + "&budget_type=" + budget_type + "&provide_output=1" + "&marker_type=" + marker + "&marker_id=" + markerSubtype + "&signature_solution=" + sigSoln;
}, _class.API_MAP_DONOR = function (year, source, budget_type) {
  return "/api/v1/project/map?year=" + year + "&budget_source=" + source + "&budget_type=" + budget_type;
}, _class.API_MAP_SDG_TARGETS = function (year, target, unit, source, tab) {
  return "/api/v1/project/map?year=" + year + "&sdg_target=" + target;
}, _class.API_DONOR_DATA = "/api/v1/donor/contribution/", _class.API_THEME_SLIDER = function (year, sector) {
  return "/api/v1/sector/details?year=" + year + "&sector=" + sector;
}, _class.API_SEARCH_RESULT = "/api/v1/project/search_full_text/?", _class.API_GLOBAL_TOP_BUDGET_SOURCES = function (year, code) {
  return "/api/v1/donor/top_budget_sources?year=" + year + "&operating_unit=" + code;
}, _class.API_GLOBAL_THEMES_BUDGET = function (year, code) {
  return "/api/v1/global/themes?year=" + year + "&operating_unit=" + code;
}, _class.API_DOCUMENT_CATEGORY_FILTER = "/api/v1/master/document_categories", _class.API_COUNTRYREGION_SEARCH = function (search, theme, sdg, donor, currentYear) {
  return "/api/v1/master/country_regions?search=" + search + "&sector=" + theme + "&sdg=" + sdg + "&donor=" + donor + "&year=" + currentYear;
}, _class.API_SIGNATURE_COUNTRYREGION_SEARCH = function (search, theme, sdg, donor, currentYear) {
  return "/api/v1/master/country_regions?search=" + search + "&ss_id=" + theme + "&sdg=" + sdg + "&donor=" + donor + "&year=" + currentYear;
}, _class.API_COUNTRYREGION_MASTER = "/api/v1/master/country_regions", _class.API_LAST_UPDATED = "/api/v1/admin_log/last_modified", _class.API_LAST_UPDATE = "/api/v1/unrwa/last_update", _class.API_EXPORTPDF = "/api/v1/unrwa/export_pdf/?", _class.API_DOWNLOAD_CSV_PROJECT_LISTS = function (year, keyword, source, sectors, units, sdgs, type, signatureSolution, target, markerId, markerSubType, l2marker) {
  return "/api/v1/unrwa/export_csv/?" + "year=" + year + "&keyword=" + keyword + "&budget_sources=" + source + "&operating_units=" + units + "&sdgs=" + sdgs + "&budget_type=" + type + "&sectors=" + sectors + "&signature_solution=" + signatureSolution + "&sdg_target=" + target + "&marker_type=" + markerId + "&marker_id=" + markerSubType + "&level_two_marker=" + l2marker;
}, _class.API_DOWNLOAD_CSV_PROJECT_DETAILS = function (projectId, item, search, category) {
  return "/api/v1/unrwa/export_csv/projectdetails/?" + "project_id=" + projectId + "&item=" + item + "&search=" + search + "&category=" + category;
}, _class.API_DOWNLOAD_CSV_DONORS = function (year, fundType, fundStream, donorType) {
  return "/api/v1/unrwa/export_donors_csv?" + "year=" + year + "&fund_type=" + fundType + "&fund_stream=" + fundStream + "&donor_type=" + donorType;
}, _class.API_FETCH_SDG_TARGETS = function (year, sdgTargetId) {
  return "/api/v1/project/sdg_target/details?year=" + year + "&sdg_target=" + sdgTargetId;
}, _class.API_SSC_MARKER_PATH = "/api/v1/output/flight_map", _class.API_MARKER_DATA = function (year, markerType, country, markerId, level2Marker) {
  return "/api/v1/output/marker_aggregate/" + country + "?year=" + year + "&type=" + markerType + "&level_two_marker=" + level2Marker + "&marker_id=" + markerId;
}, _class.API_MARKER_DESCRIPTION_DATA = function (year, type, country, markerId) {
  if (type !== 5) {
    return "/api/v1/output/marker_details/?year=" + year + "&type=" + type + (country ? "&operating_unit=" + country : "") + "&marker_id=" + markerId;
  }
  return "/api/v1/output/partner_description?year=" + year + (country ? "&operating_unit=" + country : "") + "&description=" + markerId;
}, _class.API_MARKER_BARCHART_DATA = function (year, type, country, marker_id, levelTwoMarker) {
  return "/api/v1/output/marker/details?year=" + year + "&marker_type=" + type + "&operating_unit=" + country + "&marker_id=" + marker_id + "&level_two_marker=" + levelTwoMarker;
}, _class.API_MARKER_PROJECTLIST_DATA = function (year, type, keyword, limit, offset, country, markerType, levelTwoMarker) {
  return "/api/v1/output/project_list?keyword=" + keyword + "&limit=" + limit + "&offset=" + offset + "&marker_type=" + type + "&year=" + year + "&operating_unit=" + country + "&marker_id=" + markerType + "&level_two_marker=" + levelTwoMarker;
}, _class.API_MARKER_SUBTYPE_DATA = function (markerId, country) {
  return "/api/v1/output/marker_dropdown/" + markerId + "?operating_unit=" + country;
}, _class.API_SECTOR_LIST = "/api/v1/project/sector_list", _class.SSC_OUR_APPROACHES = function (country, levelTwoMarker, markerType) {
  return "/api/v1/output/marker_description?operating_unit=" + country + "&level_two_marker=" + levelTwoMarker + "&marker_id=" + markerType;
}, _class.API_LEVEL_TWO_COUNTRY_DATA = function (opUnit, markerId) {
  return "/api/v1/output/level_two_dropdown?operating_unit=" + opUnit + "&marker_id=" + markerId;
}, _class.API_SSC_COUNTRY_REGION_SEARCH = function (search, theme, sdg, donor, currentYear, markerType, markerId, levelTwoMarker) {
  return "/api/v1/master/country_regions?search=" + search + "&sector=" + theme + "&sdg=" + sdg + "&donor=" + donor + "&year=" + currentYear + "&marker_type=" + markerType + "&marker_id=" + markerId + "&level_two_marker=" + levelTwoMarker;
}, _class.API_ACTIVITIES_LIST = function (year, page, pageSize, portal, field_of_operation, donor, oecd, sdg) {
  return "/api/v1/unrwa/activities?year=" + year + "&page=" + page + "&page_size=" + pageSize + "&portal=" + portal + "&field_of_operation=" + field_of_operation + "&donor=" + donor + "&oecd=" + oecd + "&sdg=" + sdg;
}, _class.API_ACTIVITY_DETAILS = function (identifier) {
  return "/api/v1/unrwa/activities/" + identifier;
}, _class.API_ACTIVITIES_MAP_DATA = function (year, portal, field_of_operation, donor, oecd, sdg) {
  return "/api/v1/unrwa/map?year=" + year + "&portal=" + portal + "&field_of_operation=" + field_of_operation + "&donor=" + donor + "&oecd=" + oecd + "&sdg=" + sdg;
}, _class.API_FILTERS = function (resource, filter) {
  return "/api/v1/unrwa/" + resource + filter;
}, _class.API_DONORS_CONTRIBUTIONS_LIST = function (year, portal) {
  return portal ? "/api/v1/unrwa/donors/contributions?year=" + year + "&portal=" + portal : "/api/v1/unrwa/donors/contributions?year=" + year;
}, _class.API_DONORS_CONTRIBUTIONS_DETAILS = function (year, portal, donor) {
  return portal ? "/api/v1/unrwa/donors/contributions?year=" + year + "&portal=" + portal + "&donor=" + donor : "/api/v1/unrwa/donors/contributions?year=" + year + "&donor=" + donor;
}, _class.API_SUMMARY_DATA = function (year, donor) {
  return donor ? "/api/v1/unrwa/summary?year=" + year + "&donor=" + donor : "/api/v1/unrwa/summary?year=" + year;
}, _class.API_DONOR_DETAILS = function (donor) {
  return "/api/v1/unrwa/donors/" + donor;
}, _class.API_DONOR_PROFILE_MAP_DATA = function (year, donor) {
  return "/api/v1/unrwa/map?year=" + year + "&donor=" + donor;
}, _class.API_DONOR_ACTIVITIES_LIST = function (year, donor, page, pageSize) {
  return "/api/v1/unrwa/activities?year=" + year + "&donor=" + donor + "&page=" + page + "&page_size=" + pageSize;
}, _class.API_DONOR_FIELDS_CONTRIBUTIONS = function (year, donor) {
  return "/api/v1/unrwa/fields/contributions?year=" + year + "&donor=" + donor;
}, _class.API_HOME_SUMMARY_DATA = function (year, portal) {
  return portal ? "/api/v1/unrwa/summary?year=" + year + "&portal=" + portal : "/api/v1/unrwa/summary?year=" + year;
}, _class.API_RECIPIENT_SUMMARY_DATA = function (year, field_of_operation) {
  return "/api/v1/unrwa/summary?year=" + year + "&field_of_operation=" + field_of_operation;
}, _class.API_RECIPIENT_MAP_DATA = function (year, field_of_operation) {
  return "/api/v1/unrwa/map?year=" + year + "&field_of_operation=" + field_of_operation;
}, _class.API_RECIPIENT_ACTIVITIES_DATA = function (year, field_of_operation, page, pageSize) {
  return "/api/v1/unrwa/activities?year=" + year + "&field_of_operation=" + field_of_operation + "&page=" + page + "&page_size=" + pageSize;
}, _class.API_PIE_CHART_DATA = function (year, field_of_operation, sector_vocabulary) {
  var url = "/api/v1/unrwa/pie_chart?year=" + year;
  if (field_of_operation) url += "&field_of_operation=" + field_of_operation;
  if (sector_vocabulary) url += "&sector_vocabulary=" + sector_vocabulary;
  return url;
}, _class.API_RECIPIENT_CONTRIBUTIONS_DATA = function (year, field_of_operation) {
  return "/api/v1/unrwa/donors/contributions?year=" + year + "&field_of_operation=" + field_of_operation;
}, _class.API_HOME_MAP_DATA = function (year, field_of_operation, donor, sector_vocabulary) {
  var url = "/api/v1/unrwa/map?year=" + year;
  if (field_of_operation) url += "&field_of_operation=" + field_of_operation;
  if (donor) url += "&donor=" + donor;
  if (sector_vocabulary) url += "&sector_vocabulary=" + sector_vocabulary;
  return url;
}, _class.API_HOME_MAP_SUMMARY_DATA = function (year, field_of_operation, donor, sector_vocabulary) {
  var url = "/api/v1/unrwa/summary?year=" + year;
  if (field_of_operation) url += "&field_of_operation=" + field_of_operation;
  if (donor) url += "&donor=" + donor;
  if (sector_vocabulary) url += "&sector_vocabulary=" + sector_vocabulary;
  return url;
}, _class.API_HOME_DONORS_CONTRIBUTIONS_LIST = function (year, field_of_operation, donor) {
  var url = "/api/v1/unrwa/donors/contributions?year=" + year;
  if (field_of_operation) url += "&field_of_operation=" + field_of_operation;
  if (donor) url += "&donor=" + donor;
  return url;
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),

/***/ "TVaU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDG_SLIDER_TARGET_DATA; });
/* unused harmony export sdgSliderTargetDataFetchStart */
/* unused harmony export sdgSliderTargetDataFetchEnd */
/* unused harmony export sdgSliderTargetDataClear */
/* unused harmony export sdgSliderTargetDataFetchSuccess */
/* unused harmony export sdgSliderTargetDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSdgSliderTargetData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var SDG_SLIDER_TARGET_DATA = {
  start: "fetch_start/sdg_slider_target_data",
  end: "fetch_end/sdg_slider_target_data",
  success: "fetch_success/sdg_slider_target_data",
  failed: "fetch_failed/sdg_slider_target_data",
  clear: "clear/sdg_slider_target_data"
};

var sdgSliderTargetDataFetchStart = function sdgSliderTargetDataFetchStart() {
  return {
    type: SDG_SLIDER_TARGET_DATA.start
  };
};

var sdgSliderTargetDataFetchEnd = function sdgSliderTargetDataFetchEnd() {
  return {
    type: SDG_SLIDER_TARGET_DATA.end
  };
};
var sdgSliderTargetDataClear = function sdgSliderTargetDataClear() {
  return {
    type: SDG_SLIDER_TARGET_DATA.clear
  };
};

var sdgSliderTargetDataFetchSuccess = function sdgSliderTargetDataFetchSuccess(data) {
  return {
    type: SDG_SLIDER_TARGET_DATA.success,
    data: data
  };
};

var sdgSliderTargetDataFetchFailed = function sdgSliderTargetDataFetchFailed(error) {
  return {
    type: SDG_SLIDER_TARGET_DATA.failed,
    error: error
  };
};

var fetchSdgSliderTargetData = function fetchSdgSliderTargetData(year, sdg) {
  return function (dispatch, getState) {
    dispatch(sdgSliderTargetDataFetchStart());

    if (year !== "" && sdg !== "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SDG_TARGET_PERCENTAGE_DATA(year, sdg)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(sdgSliderTargetDataFetchEnd());
          dispatch(sdgSliderTargetDataFetchSuccess(resp.data));
        } else {
          dispatch(sdgSliderTargetDataFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(sdgSliderTargetDataFetchEnd());
        dispatch(sdgSliderTargetDataFetchFailed(exception));
      });
    } else {
      dispatch(sdgSliderTargetDataClear());
      dispatch(sdgSliderTargetDataFetchEnd());
    }
  };
};

/***/ }),

/***/ "TZwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_TIME_LINE; });
/* unused harmony export projectTimeLineFetchStart */
/* unused harmony export projectTimeLineFetchEnd */
/* unused harmony export projectTimeLineFetchSuccess */
/* unused harmony export projectTimeLineFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectTimeLine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Timeline //////////////////////////


var PROJECT_TIME_LINE = {
  start: "fetch_start/project_time_line",
  end: "fetch_end/project_time_line",
  success: "fetch_success/project_time_line",
  failed: "fetch_failed/project_time_line"
};

var projectTimeLineFetchStart = function projectTimeLineFetchStart() {
  return {
    type: PROJECT_TIME_LINE.start
  };
};

var projectTimeLineFetchEnd = function projectTimeLineFetchEnd() {
  return {
    type: PROJECT_TIME_LINE.end
  };
};

var projectTimeLineFetchSuccess = function projectTimeLineFetchSuccess(data) {
  return {
    type: PROJECT_TIME_LINE.success,
    data: data
  };
};

var projectTimeLineFetchFailed = function projectTimeLineFetchFailed(error) {
  return {
    type: PROJECT_TIME_LINE.failed,
    error: error
  };
};

var fetchProjectTimeLine = function fetchProjectTimeLine(id) {
  return function (dispatch, getState) {
    dispatch(projectTimeLineFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_TIME_LINE(id)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(projectTimeLineFetchEnd());
        dispatch(projectTimeLineFetchSuccess(resp.data));
      } else {
        dispatch(projectTimeLineFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectTimeLineFetchEnd());
      dispatch(projectTimeLineFetchFailed());
    });
  };
};

/***/ }),

/***/ "Tlhi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_MARKER_SUBTYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setMarkerSubtype; });
var SET_MARKER_SUBTYPE = "set/marker_sub-type";

var setMarkerSubtype = function setMarkerSubtype(data) {
  return function (dispatch, getState) {
    dispatch({ type: SET_MARKER_SUBTYPE, data: data });
  };
};

/***/ }),

/***/ "UKR9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);

/***/ }),

/***/ "UPaS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MARKER_SUBTYPE_DATA; });
/* unused harmony export markerSubTypeFetchStart */
/* unused harmony export markerSubTypeFetchEnd */
/* unused harmony export markerSubTypeClear */
/* unused harmony export markerSubTypeFetchSuccess */
/* unused harmony export markerSubTypeFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchmarkerSubType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var MARKER_SUBTYPE_DATA = {
  start: "fetch_start/markerSubType_data",
  end: "fetch_end/markerSubType_data",
  success: "fetch_success/markerSubType_data",
  failed: "fetch_failed/markerSubType_data",
  clear: "clear/markerSubType_data"
};

var markerSubTypeFetchStart = function markerSubTypeFetchStart() {
  return {
    type: MARKER_SUBTYPE_DATA.start
  };
};

var markerSubTypeFetchEnd = function markerSubTypeFetchEnd() {
  return {
    type: MARKER_SUBTYPE_DATA.end
  };
};
var markerSubTypeClear = function markerSubTypeClear() {
  return {
    type: MARKER_SUBTYPE_DATA.clear
  };
};

var markerSubTypeFetchSuccess = function markerSubTypeFetchSuccess(data) {
  return {
    type: MARKER_SUBTYPE_DATA.success,
    data: data
  };
};

var markerSubTypeFetchFailed = function markerSubTypeFetchFailed(error) {
  return {
    type: MARKER_SUBTYPE_DATA.failed,
    error: error
  };
};

var fetchmarkerSubType = function fetchmarkerSubType(markerId, country) {
  country ? null : country = "";
  return function (dispatch, getState) {
    dispatch(markerSubTypeFetchStart());
    if (markerId !== "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MARKER_SUBTYPE_DATA(markerId, country)).then(function (resp) {
        if (resp.success && resp.data) {
          resp.data.aggregate = resp.data.aggregate && resp.data.aggregate.length ? resp.data.aggregate[0] : {};
          dispatch(markerSubTypeFetchEnd());
          dispatch(markerSubTypeFetchSuccess(resp.data));
        } else {
          dispatch(markerSubTypeFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(markerSubTypeFetchEnd());
        dispatch(markerSubTypeFetchFailed(exception));
      });
    } else {
      dispatch(markerSubTypeClear());
      dispatch(markerSubTypeFetchEnd());
    }
  };
};

/***/ }),

/***/ "UXBR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABOUT_US; });
/* unused harmony export aboutUsFetchStart */
/* unused harmony export aboutUsFetchEnd */
/* unused harmony export aboutUsFetchSuccess */
/* unused harmony export aboutUsFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchaboutUsContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/

var ABOUT_US = {
  start: "fetch_start/about_us",
  end: "fetch_end/about_us",
  success: "fetch_success/about_us",
  failed: "fetch_failed/about_us"
};

var aboutUsFetchStart = function aboutUsFetchStart() {
  return {
    type: ABOUT_US.start
  };
};

var aboutUsFetchEnd = function aboutUsFetchEnd() {
  return {
    type: ABOUT_US.end
  };
};

var aboutUsFetchSuccess = function aboutUsFetchSuccess(content) {
  return {
    type: ABOUT_US.success,
    content: content
  };
};

var aboutUsFetchFailed = function aboutUsFetchFailed(error) {
  return {
    type: ABOUT_US.failed,
    error: error
  };
};
var fetchaboutUsContent = function fetchaboutUsContent() {
  return function (dispatch) {
    dispatch(aboutUsFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_ABOUT).then(function (resp) {
      if (resp.success) {
        dispatch(aboutUsFetchEnd());
        dispatch(aboutUsFetchSuccess(resp.data.data));
      } else {
        dispatch(aboutUsFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(aboutUsFetchEnd());
      dispatch(aboutUsFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "V3Sb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_FIELDS_CONTRIBUTIONS; });
/* unused harmony export donorFieldsContributionsFetchStart */
/* unused harmony export donorFieldsContributionsFetchEnd */
/* unused harmony export donorFieldsContributionsFetchSuccess */
/* unused harmony export donorFieldsContributionsFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDonorFieldsContributions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var DONOR_FIELDS_CONTRIBUTIONS = {
  start: "fetch_start/donor_FIELD_CONTRIBUTIONS",
  end: "fetch_end/donor_FIELD_CONTRIBUTIONS",
  success: "fetch_success/donor_FIELD_CONTRIBUTIONS",
  failed: "fetch_failed/donor_FIELD_CONTRIBUTIONS"
};

var donorFieldsContributionsFetchStart = function donorFieldsContributionsFetchStart() {
  return {
    type: DONOR_FIELDS_CONTRIBUTIONS.start
  };
};

var donorFieldsContributionsFetchEnd = function donorFieldsContributionsFetchEnd() {
  return {
    type: DONOR_FIELDS_CONTRIBUTIONS.end
  };
};

var donorFieldsContributionsFetchSuccess = function donorFieldsContributionsFetchSuccess(data) {
  return {
    type: DONOR_FIELDS_CONTRIBUTIONS.success,
    data: data
  };
};

var donorFieldsContributionsFetchFailed = function donorFieldsContributionsFetchFailed(error) {
  return {
    type: DONOR_FIELDS_CONTRIBUTIONS.failed,
    error: error
  };
};

var getDonorFieldsContributions = function getDonorFieldsContributions(year, donor) {
  return function (dispatch) {
    dispatch(donorFieldsContributionsFetchStart());
    var filterDonor = donor || "";
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONOR_FIELDS_CONTRIBUTIONS(year, filterDonor)).then(function (response) {
        dispatch(donorFieldsContributionsFetchEnd());
        dispatch(donorFieldsContributionsFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(donorFieldsContributionsFetchEnd());
        dispatch(donorFieldsContributionsFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "Wc36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESOURCES_MODALITY_CONTRIBUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESOURCES_MODALITY_CONTRIBUTION_COUNTRY_AGGREGATE; });
/* unused harmony export resourcesModalityContributionFetchStart */
/* unused harmony export resourcesModalityContributionFetchEnd */
/* unused harmony export resourcesModalityContributionFetchSuccess */
/* unused harmony export resourcesModalityContributionClear */
/* unused harmony export resourcesModalityContributionFetchFailed */
/* unused harmony export updateCountryAggregate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchDonorResourcesModalityContribution; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__ = __webpack_require__("Cdrj");



var RESOURCES_MODALITY_CONTRIBUTION = {
  start: "fetch_start/resources_modality_contribution",
  end: "fetch_end/resources_modality_contribution",
  success: "fetch_success/resources_modality_contribution",
  failed: "fetch_failed/resources_modality_contribution",
  clear: "clear/resources_modality_contribution"
};

var RESOURCES_MODALITY_CONTRIBUTION_COUNTRY_AGGREGATE = "RESOURCES_MODALITY_CONTRIBUTION_COUNTRY_AGGREGATE";

var resourcesModalityContributionFetchStart = function resourcesModalityContributionFetchStart() {
  return {
    type: RESOURCES_MODALITY_CONTRIBUTION.start
  };
};

var resourcesModalityContributionFetchEnd = function resourcesModalityContributionFetchEnd() {
  return {
    type: RESOURCES_MODALITY_CONTRIBUTION.end
  };
};

var resourcesModalityContributionFetchSuccess = function resourcesModalityContributionFetchSuccess(data) {
  return {
    type: RESOURCES_MODALITY_CONTRIBUTION.success,
    data: data
  };
};
var resourcesModalityContributionClear = function resourcesModalityContributionClear() {
  return {
    type: RESOURCES_MODALITY_CONTRIBUTION.clear
  };
};

var resourcesModalityContributionFetchFailed = function resourcesModalityContributionFetchFailed(error) {
  return {
    type: RESOURCES_MODALITY_CONTRIBUTION.failed,
    error: error
  };
};

var updateCountryAggregate = function updateCountryAggregate(countryAggregate) {
  return {
    type: RESOURCES_MODALITY_CONTRIBUTION_COUNTRY_AGGREGATE,
    countryAggregate: countryAggregate
  };
};

var fetchDonorResourcesModalityContribution = function fetchDonorResourcesModalityContribution(code, year) {
  return function (dispatch) {
    dispatch(resourcesModalityContributionFetchStart());
    if (code != "" && year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_RESOURCES_MODALITY_CONTRIBUTION(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          if (resp.data.country.length) {
            var countryAggregate = Object(__WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__["c" /* aggregateCalculator */])(resp.data.country, "total_contribution");
            dispatch(updateCountryAggregate(countryAggregate));
          }
          dispatch(resourcesModalityContributionFetchEnd());
          dispatch(resourcesModalityContributionFetchSuccess(resp.data));
        } else {
          dispatch(resourcesModalityContributionFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(resourcesModalityContributionFetchEnd());
        dispatch(resourcesModalityContributionFetchFailed(exception));
      });
    } else {
      dispatch(resourcesModalityContributionClear());
      dispatch(resourcesModalityContributionFetchEnd());
    }
  };
};

/***/ }),

/***/ "X5/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_BUDGET_VS_EXPENSE_SDG; });
/* unused harmony export recepientBudgetVsExpenseSdgFetchStart */
/* unused harmony export recepientBudgetVsExpenseSdgFetchEnd */
/* unused harmony export recepientBudgetVsExpenseSdgFetchClear */
/* unused harmony export recepientBudgetVsExpenseSdgFetchSuccess */
/* unused harmony export recepientBudgetVsExpenseSdgFailed */
/* unused harmony export parseBudgetVsExpense */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRecepientBudgetVsExpenseSdg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__("tokj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3__);


var RECIPIENT_BUDGET_VS_EXPENSE_SDG = {
  start: "fetch_start/budget_vs_expense_sdg",
  end: "fetch_end/budget_vs_expense_sdg",
  success: "fetch_success/budget_vs_expense_sdg",
  failed: "fetch_failed/budget_vs_expense_sdg",
  clear: "clear/budget_vs_expense_sdg"
};

var recepientBudgetVsExpenseSdgFetchStart = function recepientBudgetVsExpenseSdgFetchStart() {
  return {
    type: RECIPIENT_BUDGET_VS_EXPENSE_SDG.start
  };
};

var recepientBudgetVsExpenseSdgFetchEnd = function recepientBudgetVsExpenseSdgFetchEnd() {
  return {
    type: RECIPIENT_BUDGET_VS_EXPENSE_SDG.end
  };
};
var recepientBudgetVsExpenseSdgFetchClear = function recepientBudgetVsExpenseSdgFetchClear() {
  return {
    type: RECIPIENT_BUDGET_VS_EXPENSE_SDG.clear
  };
};

var recepientBudgetVsExpenseSdgFetchSuccess = function recepientBudgetVsExpenseSdgFetchSuccess(data) {
  return {
    type: RECIPIENT_BUDGET_VS_EXPENSE_SDG.success,
    data: data
  };
};

var recepientBudgetVsExpenseSdgFailed = function recepientBudgetVsExpenseSdgFailed(error) {
  return {
    type: RECIPIENT_BUDGET_VS_EXPENSE_SDG.failed,
    error: error
  };
};

var calcHighestValue = function calcHighestValue(data) {
  var frmmtedBudgetArray = [],
      frmmtedExpenseArray = [],
      frmttdBudget = 0,
      frmttdExpense = 0,
      budgetMax = 0,
      expenseMax = 0;
  data.forEach(function (element) {
    frmttdBudget = parseFloat(element.sdg_budget ? element.sdg_budget : 0);
    frmttdExpense = parseFloat(element.sdg_expense ? element.sdg_expense : 0);
    frmmtedBudgetArray = [].concat(frmmtedBudgetArray, [frmttdBudget]);
    frmmtedExpenseArray = [].concat(frmmtedExpenseArray, [frmttdExpense]);
  });
  budgetMax = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(frmmtedBudgetArray);
  expenseMax = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(frmmtedExpenseArray);
  return budgetMax > expenseMax ? budgetMax : expenseMax;
};

var parseBudgetVsExpense = function parseBudgetVsExpense(data, total) {
  if (data.length !== 0) {
    data.forEach(function (element) {
      element.sector_name = element.sdg_name;
      element.theme_budget = element.sdg_budget;
      element.theme_expense = element.sdg_expense;
      element.total_budget = element.sdg_budget;
      element.total_expense = element.sdg_expense;
      element.color = element.color;
      element.budgetPercentage = parseFloat(element.theme_budget) / total * 100;
      element.expensePercentage = parseFloat(element.theme_expense) / total * 100;
    });
  }
};

// budgetPercentage
// expensePercentage
// sector
// sector_color
// sector_name
// short_name
// theme_budget
// theme_expense
// total_budget
// total_expense

// color
// sdg_budget
// sdg_code
// sdg_expense
// sdg_name

var fetchRecepientBudgetVsExpenseSdg = function fetchRecepientBudgetVsExpenseSdg(code, year) {
  return function (dispatch) {
    dispatch(recepientBudgetVsExpenseSdgFetchStart());
    if (code != "" && year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_BUDGET_VS_EXPENSE_SDG(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(recepientBudgetVsExpenseSdgFetchEnd());
          // const total = calcTotalBudgetExpense(resp.data);
          var highestValue = calcHighestValue(resp.data);
          if (highestValue === 0) {
            dispatch(recepientBudgetVsExpenseSdgFetchSuccess([]));
          } else {
            parseBudgetVsExpense(resp.data, highestValue);
            dispatch(recepientBudgetVsExpenseSdgFetchSuccess(resp.data));
          }
        } else {
          dispatch(recepientBudgetVsExpenseSdgFetchEnd());
          dispatch(recepientBudgetVsExpenseSdgFailed());
        }
      }).catch(function (exception) {
        dispatch(recepientBudgetVsExpenseSdgFetchEnd());
        dispatch(recepientBudgetVsExpenseSdgFailed(exception));
      });
    } else {
      dispatch(recepientBudgetVsExpenseSdgFetchClear());
      dispatch(recepientBudgetVsExpenseSdgFetchEnd());
    }
  };
};

/***/ }),

/***/ "XId4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_TOP_OFFICES; });
/* unused harmony export recipientTopOfficesFetchStart */
/* unused harmony export recipientTopOfficesFetchEnd */
/* unused harmony export recipientTopOfficesFetchSuccess */
/* unused harmony export recipientTopOfficesClear */
/* unused harmony export recipientTopOfficesFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRecipientTopOffices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var RECIPIENT_TOP_OFFICES = {
  start: "fetch_start/recipient_top_offices",
  end: "fetch_end/recipient_top_offices",
  success: "fetch_success/recipient_top_offices",
  failed: "fetch_failed/recipient_top_offices",
  clear: "clear/recipient_top_offices"
};

var recipientTopOfficesFetchStart = function recipientTopOfficesFetchStart() {
  return {
    type: RECIPIENT_TOP_OFFICES.start
  };
};

var recipientTopOfficesFetchEnd = function recipientTopOfficesFetchEnd() {
  return {
    type: RECIPIENT_TOP_OFFICES.end
  };
};

var recipientTopOfficesFetchSuccess = function recipientTopOfficesFetchSuccess(data) {
  return {
    type: RECIPIENT_TOP_OFFICES.success,
    data: data
  };
};
var recipientTopOfficesClear = function recipientTopOfficesClear() {
  return {
    type: RECIPIENT_TOP_OFFICES.clear
  };
};

var recipientTopOfficesFetchFailed = function recipientTopOfficesFetchFailed(error) {
  return {
    type: RECIPIENT_TOP_OFFICES.failed,
    error: error
  };
};

var fetchRecipientTopOffices = function fetchRecipientTopOffices(code, year) {
  return function (dispatch) {
    dispatch(recipientTopOfficesFetchStart());
    if (code != "" && year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].RECIPIENT_TOP_OFFICES(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(recipientTopOfficesFetchEnd());
          dispatch(recipientTopOfficesFetchSuccess(resp.data));
        } else {
          dispatch(recipientTopOfficesFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(recipientTopOfficesFetchEnd());
        dispatch(recipientTopOfficesFetchFailed(exception));
      });
    } else {
      dispatch(recipientTopOfficesClear());
      dispatch(recipientTopOfficesFetchEnd());
    }
  };
};

/***/ }),

/***/ "XYJE":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

!function (e, t) {
   true ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(e.reduxLogger = e.reduxLogger || {});
}(this, function (e) {
  "use strict";
  function t(e, t) {
    e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } });
  }function r(e, t) {
    Object.defineProperty(this, "kind", { value: e, enumerable: !0 }), t && t.length && Object.defineProperty(this, "path", { value: t, enumerable: !0 });
  }function n(e, t, r) {
    n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", { value: t, enumerable: !0 }), Object.defineProperty(this, "rhs", { value: r, enumerable: !0 });
  }function o(e, t) {
    o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", { value: t, enumerable: !0 });
  }function i(e, t) {
    i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", { value: t, enumerable: !0 });
  }function a(e, t, r) {
    a.super_.call(this, "A", e), Object.defineProperty(this, "index", { value: t, enumerable: !0 }), Object.defineProperty(this, "item", { value: r, enumerable: !0 });
  }function f(e, t, r) {
    var n = e.slice((r || t) + 1 || e.length);return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
  }function u(e) {
    var t = "undefined" == typeof e ? "undefined" : N(e);return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
  }function l(e, t, r, c, s, d, p) {
    s = s || [], p = p || [];var g = s.slice(0);if ("undefined" != typeof d) {
      if (c) {
        if ("function" == typeof c && c(g, d)) return;if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
          if (c.prefilter && c.prefilter(g, d)) return;if (c.normalize) {
            var h = c.normalize(g, d, e, t);h && (e = h[0], t = h[1]);
          }
        }
      }g.push(d);
    }"regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());var y = "undefined" == typeof e ? "undefined" : N(e),
        v = "undefined" == typeof t ? "undefined" : N(t),
        b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d),
        m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);if (!b && m) r(new o(g, t));else if (!m && b) r(new i(g, e));else if (u(e) !== u(t)) r(new n(g, e, t));else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));else if ("object" === y && null !== e && null !== t) {
      if (p.filter(function (t) {
        return t.lhs === e;
      }).length) e !== t && r(new n(g, e, t));else {
        if (p.push({ lhs: e, rhs: t }), Array.isArray(e)) {
          var w;e.length;for (w = 0; w < e.length; w++) {
            w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
          }for (; w < t.length;) {
            r(new a(g, w, new o(void 0, t[w++])));
          }
        } else {
          var x = Object.keys(e),
              S = Object.keys(t);x.forEach(function (n, o) {
            var i = S.indexOf(n);i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
          }), S.forEach(function (e) {
            l(void 0, t[e], r, c, g, e, p);
          });
        }p.length = p.length - 1;
      }
    } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
  }function c(e, t, r, n) {
    return n = n || [], l(e, t, function (e) {
      e && n.push(e);
    }, r), n.length ? n : void 0;
  }function s(e, t, r) {
    if (r.path && r.path.length) {
      var n,
          o = e[t],
          i = r.path.length - 1;for (n = 0; n < i; n++) {
        o = o[r.path[n]];
      }switch (r.kind) {case "A":
          s(o[r.path[n]], r.index, r.item);break;case "D":
          delete o[r.path[n]];break;case "E":case "N":
          o[r.path[n]] = r.rhs;}
    } else switch (r.kind) {case "A":
        s(e[t], r.index, r.item);break;case "D":
        e = f(e, t);break;case "E":case "N":
        e[t] = r.rhs;}return e;
  }function d(e, t, r) {
    if (e && t && r && r.kind) {
      for (var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;) {
        "undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
      }switch (r.kind) {case "A":
          s(r.path ? n[r.path[o]] : n, r.index, r.item);break;case "D":
          delete n[r.path[o]];break;case "E":case "N":
          n[r.path[o]] = r.rhs;}
    }
  }function p(e, t, r) {
    if (r.path && r.path.length) {
      var n,
          o = e[t],
          i = r.path.length - 1;for (n = 0; n < i; n++) {
        o = o[r.path[n]];
      }switch (r.kind) {case "A":
          p(o[r.path[n]], r.index, r.item);break;case "D":
          o[r.path[n]] = r.lhs;break;case "E":
          o[r.path[n]] = r.lhs;break;case "N":
          delete o[r.path[n]];}
    } else switch (r.kind) {case "A":
        p(e[t], r.index, r.item);break;case "D":
        e[t] = r.lhs;break;case "E":
        e[t] = r.lhs;break;case "N":
        e = f(e, t);}return e;
  }function g(e, t, r) {
    if (e && t && r && r.kind) {
      var n,
          o,
          i = e;for (o = r.path.length - 1, n = 0; n < o; n++) {
        "undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
      }switch (r.kind) {case "A":
          p(i[r.path[n]], r.index, r.item);break;case "D":
          i[r.path[n]] = r.lhs;break;case "E":
          i[r.path[n]] = r.lhs;break;case "N":
          delete i[r.path[n]];}
    }
  }function h(e, t, r) {
    if (e && t) {
      var n = function n(_n) {
        r && !r(e, t, _n) || d(e, t, _n);
      };l(e, t, n);
    }
  }function y(e) {
    return "color: " + F[e].color + "; font-weight: bold";
  }function v(e) {
    var t = e.kind,
        r = e.path,
        n = e.lhs,
        o = e.rhs,
        i = e.index,
        a = e.item;switch (t) {case "E":
        return [r.join("."), n, "→", o];case "N":
        return [r.join("."), o];case "D":
        return [r.join(".")];case "A":
        return [r.join(".") + "[" + i + "]", a];default:
        return [];}
  }function b(e, t, r, n) {
    var o = c(e, t);try {
      n ? r.groupCollapsed("diff") : r.group("diff");
    } catch (e) {
      r.log("diff");
    }o ? o.forEach(function (e) {
      var t = e.kind,
          n = v(e);r.log.apply(r, ["%c " + F[t].text, y(t)].concat(P(n)));
    }) : r.log("—— no diff ——");try {
      r.groupEnd();
    } catch (e) {
      r.log("—— diff end —— ");
    }
  }function m(e, t, r, n) {
    switch ("undefined" == typeof e ? "undefined" : N(e)) {case "object":
        return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];case "function":
        return e(t);default:
        return e;}
  }function w(e) {
    var t = e.timestamp,
        r = e.duration;return function (e, n, o) {
      var i = ["action"];return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
    };
  }function x(e, t) {
    var r = t.logger,
        n = t.actionTransformer,
        o = t.titleFormatter,
        i = void 0 === o ? w(t) : o,
        a = t.collapsed,
        f = t.colors,
        u = t.level,
        l = t.diff,
        c = "undefined" == typeof t.titleFormatter;e.forEach(function (o, s) {
      var d = o.started,
          p = o.startedTime,
          g = o.action,
          h = o.prevState,
          y = o.error,
          v = o.took,
          w = o.nextState,
          x = e[s + 1];x && (w = x.prevState, v = x.started - d);var S = n(g),
          k = "function" == typeof a ? a(function () {
        return w;
      }, g, o) : a,
          j = D(p),
          E = f.title ? "color: " + f.title(S) + ";" : "",
          A = ["color: gray; font-weight: lighter;"];A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");var O = i(S, j, v);try {
        k ? f.title && c ? r.groupCollapsed.apply(r, ["%c " + O].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, ["%c " + O].concat(A)) : r.group(O);
      } catch (e) {
        r.log(O);
      }var N = m(u, S, [h], "prevState"),
          P = m(u, S, [S], "action"),
          C = m(u, S, [y, h], "error"),
          F = m(u, S, [w], "nextState");if (N) if (f.prevState) {
        var L = "color: " + f.prevState(h) + "; font-weight: bold";r[N]("%c prev state", L, h);
      } else r[N]("prev state", h);if (P) if (f.action) {
        var T = "color: " + f.action(S) + "; font-weight: bold";r[P]("%c action    ", T, S);
      } else r[P]("action    ", S);if (y && C) if (f.error) {
        var M = "color: " + f.error(y, h) + "; font-weight: bold;";r[C]("%c error     ", M, y);
      } else r[C]("error     ", y);if (F) if (f.nextState) {
        var _ = "color: " + f.nextState(w) + "; font-weight: bold";r[F]("%c next state", _, w);
      } else r[F]("next state", w);l && b(h, w, r, k);try {
        r.groupEnd();
      } catch (e) {
        r.log("—— log end ——");
      }
    });
  }function S() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = _extends({}, L, e),
        r = t.logger,
        n = t.stateTransformer,
        o = t.errorTransformer,
        i = t.predicate,
        a = t.logErrors,
        f = t.diffPredicate;if ("undefined" == typeof r) return function () {
      return function (e) {
        return function (t) {
          return e(t);
        };
      };
    };if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function () {
      return function (e) {
        return function (t) {
          return e(t);
        };
      };
    };var u = [];return function (e) {
      var r = e.getState;return function (e) {
        return function (l) {
          if ("function" == typeof i && !i(r, l)) return e(l);var c = {};u.push(c), c.started = O.now(), c.startedTime = new Date(), c.prevState = n(r()), c.action = l;var s = void 0;if (a) try {
            s = e(l);
          } catch (e) {
            c.error = o(e);
          } else s = e(l);c.took = O.now() - c.started, c.nextState = n(r());var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;if (x(u, _extends({}, t, { diff: d })), u.length = 0, c.error) throw c.error;return s;
        };
      };
    };
  }var k,
      j,
      E = function E(e, t) {
    return new Array(t + 1).join(e);
  },
      A = function A(e, t) {
    return E("0", t - e.toString().length) + e;
  },
      D = function D(e) {
    return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
  },
      O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date,
      N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      P = function P(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }return r;
    }return Array.from(e);
  },
      C = [];k = "object" === ("undefined" == typeof global ? "undefined" : N(global)) && global ? global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function () {
    "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
  }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, { diff: { value: c, enumerable: !0 }, observableDiff: { value: l, enumerable: !0 }, applyDiff: { value: h, enumerable: !0 }, applyChange: { value: d, enumerable: !0 }, revertChange: { value: g, enumerable: !0 }, isConflict: { value: function value() {
        return "undefined" != typeof j;
      }, enumerable: !0 }, noConflict: { value: function value() {
        return C && (C.forEach(function (e) {
          e();
        }), C = null), c;
      }, enumerable: !0 } });var F = { E: { color: "#2196F3", text: "CHANGED:" }, N: { color: "#4CAF50", text: "ADDED:" }, D: { color: "#F44336", text: "DELETED:" }, A: { color: "#2196F3", text: "ARRAY:" } },
      L = { level: "log", logger: console, logErrors: !0, collapsed: void 0, predicate: void 0, duration: !1, timestamp: !0, stateTransformer: function stateTransformer(e) {
      return e;
    }, actionTransformer: function actionTransformer(e) {
      return e;
    }, errorTransformer: function errorTransformer(e) {
      return e;
    }, colors: { title: function title() {
        return "inherit";
      }, prevState: function prevState() {
        return "#9E9E9E";
      }, action: function action() {
        return "#03A9F4";
      }, nextState: function nextState() {
        return "#4CAF50";
      }, error: function error() {
        return "#F20404";
      } }, diff: !1, diffPredicate: void 0, transformer: void 0 },
      T = function T() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.dispatch,
        r = e.getState;return "function" == typeof t || "function" == typeof r ? S()({ dispatch: t, getState: r }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
  };e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", { value: !0 });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "Y9jh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROUTE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = onChangeRoute;
/* unused harmony export updateCurrent */
/* unused harmony export updatePrevious */
/* unused harmony export updateRouteArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_ga__ = __webpack_require__("91gb");
/************************* Third party Files ************************/

var ROUTE = {
  ON_UPDATE_ROUTE_ARRAY: "ON_UPDATE_ROUTE_ARRAY",
  ON_UPDATE_CURRENT: "ON_UPDATE_CURRENT",
  ON_UPDATE_PREVIOUS: "ON_UPDATE_PREVIOUS"
};

function onChangeRoute(title) {
  return function (dispatch, getState) {
    if (getState().router.current === "") {
      dispatch(updateCurrent(title));
    } else {
      var current = getState().router.current;
      dispatch(updatePrevious(current));
      dispatch(updateCurrent(title));
    }
    __WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].ga("send", "event", "Navigation", "From - To", getState().router.previous + " - " + getState().router.current);
  };
}

function updateCurrent(title) {
  return {
    type: ROUTE.ON_UPDATE_CURRENT,
    title: title
  };
}
function updatePrevious(title) {
  return {
    type: ROUTE.ON_UPDATE_PREVIOUS,
    title: title
  };
}
function updateRouteArray(routeArray) {
  return {
    type: ROUTE.ON_UPDATE_ROUTE_ARRAY,
    routeArray: routeArray
  };
}

/***/ }),

/***/ "ZIP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_LIST_MAP_DATA; });
/* unused harmony export mapDataFetchStart */
/* unused harmony export mapDataFetchEnd */
/* unused harmony export mapDataFetchSuccess */
/* unused harmony export mapDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadProjectListMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var PROJECT_LIST_MAP_DATA = {
  start: "fetch_start/project_list_map_data",
  end: "fetch_end/project_list_map_data",
  success: "fetch_success/project_list_map_data",
  failed: "fetch_failed/project_list_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: PROJECT_LIST_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: PROJECT_LIST_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data, regionalCenter) {
  return {
    type: PROJECT_LIST_MAP_DATA.success,
    data: data,
    regionalCenter: regionalCenter
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: PROJECT_LIST_MAP_DATA.failed,
    error: error
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var regionalCenter = false;
    if (resp.data.length === 1) {
      if (resp.data[0].latitude == null && resp.data[0].longitude == null && resp.data[0].total_budget !== null && resp.data[0].total_expense !== null) {
        regionalCenter = true;
      }
    }
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data, regionalCenter));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var loadProjectListMapData = function loadProjectListMapData(year, sector, unit, source, sdg, marker, marker_id, l2Country) {
  return function (dispatch, getState) {
    dispatch(mapDataFetchStart());
    unit = unit ? unit : "";
    source = source ? source : "";
    sector = sector !== undefined && sector !== null ? sector : "";
    year = year ? year : getState().mapData.yearTimeline.mapCurrentYear;
    sdg = sdg !== undefined && sdg !== null ? sdg : "";
    marker = marker ? marker : "";
    marker_id = marker_id ? marker_id : "";
    l2Country = l2Country ? l2Country : "";
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_PROJECT_LIST(year, sector, unit, source, sdg, marker, marker_id, l2Country)).then(function (resp) {
      return mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });else {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed());
    }
  };
};

/***/ }),

/***/ "ZShz":
/***/ (function(module, exports, __webpack_require__) {

!function (n, t) {
   true ? t(exports, __webpack_require__("KM04")) : "function" == typeof define && define.amd ? define(["exports", "preact"], t) : t((n = n || self).preactContext = {}, n.preact);
}(this, function (n, t) {
  "use strict";
  var _i = function i(n, t) {
    return (_i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (n, t) {
      n.__proto__ = t;
    } || function (n, t) {
      for (var i in t) {
        t.hasOwnProperty(i) && (n[i] = t[i]);
      }
    })(n, t);
  };function r(n, t) {
    function r() {
      this.constructor = n;
    }_i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  }var e = { register: function register(n) {
      console.warn("Consumer used without a Provider");
    }, unregister: function unregister(n) {}, val: function val(n) {} };function u(n) {
    var t = n.children;return { child: 1 === t.length ? t[0] : null, children: t };
  }function o(n) {
    return u(n).child || "render" in n && n.render;
  }var c = 1073741823,
      f = function f() {
    return c;
  },
      s = 0;function a(n, i) {
    var a = "_preactContextProvider-" + s++;return { Provider: function (n) {
        function e(t) {
          var r = n.call(this, t) || this;return r.t = function (n, t) {
            var i = [],
                r = n,
                e = function e(n) {
              return 0 | t(r, n);
            };return { register: function register(n) {
                i.push(n), n(r, e(r));
              }, unregister: function unregister(n) {
                i = i.filter(function (t) {
                  return t !== n;
                });
              }, val: function val(n) {
                if (void 0 === n || n == r) return r;var t = e(n);return r = n, i.forEach(function (i) {
                  return i(n, t);
                }), r;
              } };
          }(t.value, i || f), r;
        }return r(e, n), e.prototype.getChildContext = function () {
          var n;return (n = {})[a] = this.t, n;
        }, e.prototype.componentDidUpdate = function () {
          this.t.val(this.props.value);
        }, e.prototype.render = function () {
          var n = u(this.props),
              i = n.child,
              r = n.children;return i || t.h("span", null, r);
        }, e;
      }(t.Component), Consumer: function (t) {
        function i(i, r) {
          var e = t.call(this, i, r) || this;return e.i = function (n, t) {
            var i = e.props.unstable_observedBits,
                r = void 0 === i || null === i ? c : i;0 != ((r |= 0) & t) && e.setState({ value: n });
          }, e.state = { value: e.u().val() || n }, e;
        }return r(i, t), i.prototype.componentDidMount = function () {
          this.u().register(this.i);
        }, i.prototype.shouldComponentUpdate = function (n, t) {
          return this.state.value !== t.value || o(this.props) !== o(n);
        }, i.prototype.componentWillUnmount = function () {
          this.u().unregister(this.i);
        }, i.prototype.componentDidUpdate = function (n, t, i) {
          var r = i[a];r !== this.context[a] && ((r || e).unregister(this.i), this.componentDidMount());
        }, i.prototype.render = function () {
          var n = "render" in this.props && this.props.render,
              t = o(this.props);if (n && n !== t && console.warn("Both children and a render function are defined. Children will be used"), "function" == typeof t) return t(this.state.value);console.warn("Consumer is expecting a function as one and only child but didn't find any");
        }, i.prototype.u = function () {
          return this.context[a] || e;
        }, i;
      }(t.Component) };
  }var h = a;n.default = a, n.createContext = h, Object.defineProperty(n, "__esModule", { value: !0 });
});

/***/ }),

/***/ "aYEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDG_SLIDER_DATA; });
/* unused harmony export sdgSliderDataFetchStart */
/* unused harmony export sdgSliderDataFetchEnd */
/* unused harmony export sdgSliderDataClear */
/* unused harmony export sdgSliderDataFetchSuccess */
/* unused harmony export setTargetTitle */
/* unused harmony export sdgSliderDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSdgSliderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchSdgTargetData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var SDG_SLIDER_DATA = {
  start: "fetch_start/sdg_slider_data",
  end: "fetch_end/sdg_slider_data",
  success: "fetch_success/sdg_slider_data",
  failed: "fetch_failed/sdg_slider_data",
  targetTitle: "fetch_success/sdg_target_title",
  clear: "clear/sdg_slider_data"
};

var sdgSliderDataFetchStart = function sdgSliderDataFetchStart() {
  return {
    type: SDG_SLIDER_DATA.start
  };
};

var sdgSliderDataFetchEnd = function sdgSliderDataFetchEnd() {
  return {
    type: SDG_SLIDER_DATA.end
  };
};
var sdgSliderDataClear = function sdgSliderDataClear() {
  return {
    type: SDG_SLIDER_DATA.clear
  };
};

var sdgSliderDataFetchSuccess = function sdgSliderDataFetchSuccess(data) {
  return {
    type: SDG_SLIDER_DATA.success,
    data: data
  };
};

var setTargetTitle = function setTargetTitle(data) {
  return {
    type: SDG_SLIDER_DATA.targetTitle,
    data: data
  };
};

var sdgSliderDataFetchFailed = function sdgSliderDataFetchFailed(error) {
  return {
    type: SDG_SLIDER_DATA.failed,
    error: error
  };
};

var fetchSdgSliderData = function fetchSdgSliderData(year, sdg, targetId) {
  return function (dispatch, getState) {
    var operatingUnits = "",
        budgetSources = "";
    dispatch(sdgSliderDataFetchStart());
    if (year != "" && sdg != "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SDG_SLIDER_DATA(year, sdg, operatingUnits, budgetSources, targetId)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(sdgSliderDataFetchEnd());
          dispatch(sdgSliderDataFetchSuccess(resp.data));
        } else {
          dispatch(sdgSliderDataFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(sdgSliderDataFetchEnd());
        dispatch(sdgSliderDataFetchFailed(exception));
      });
    } else {
      dispatch(sdgSliderDataClear());
      dispatch(sdgSliderDataFetchEnd());
    }
  };
};

var fetchSdgTargetData = function fetchSdgTargetData(year, targetId) {
  return function (dispatch, getState) {
    var operatingUnits = "",
        budgetSources = "";
    dispatch(sdgSliderDataFetchStart());
    if (year != "" && targetId != "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SDG_TARGET_DATA(year, targetId, operatingUnits, budgetSources)).then(function (resp) {
        if (resp.success && resp.data) {
          if (resp.data.aggregate && resp.data.aggregate.length) resp.data.aggregate = resp.data.aggregate[0];
          dispatch(sdgSliderDataFetchEnd());
          dispatch(sdgSliderDataFetchSuccess(resp.data));
          dispatch(setTargetTitle(resp.data.aggregate.target_desc));
        } else {
          dispatch(sdgSliderDataFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(sdgSliderDataFetchEnd());
        dispatch(sdgSliderDataFetchFailed(exception));
      });
    } else {
      dispatch(sdgSliderDataClear());
      dispatch(sdgSliderDataFetchEnd());
    }
  };
};

/***/ }),

/***/ "b7sF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PROJECT_TIMELINE; });
/* unused harmony export projectTimelineFetchStart */
/* unused harmony export projectTimelineFetchEnd */
/* unused harmony export projectTimelineFetchSuccess */
/* unused harmony export projectTimelineFetchFailed */
/* unused harmony export fetchProjectTimelineData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COUNTRY_LIST; });
/* unused harmony export countryListFetchStart */
/* unused harmony export countryListFetchEnd */
/* unused harmony export countryListFetchSuccess */
/* unused harmony export countryListFetchFailed */
/* unused harmony export fetchCountryListData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SEARCH_COUNTRY_LIST; });
/* unused harmony export countryListSearchStart */
/* unused harmony export countryListSearchEnd */
/* unused harmony export countryListSearchSuccess */
/* unused harmony export countryListSearchFailed */
/* unused harmony export searchCountryListData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return THEME_LIST; });
/* unused harmony export themeListFetchStart */
/* unused harmony export themeListFetchEnd */
/* unused harmony export themeListFetchSuccess */
/* unused harmony export themeListFetchFailed */
/* unused harmony export updateThemeList */
/* unused harmony export getMasterThemeList */
/* unused harmony export fetchthemeListData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DONOR_LIST; });
/* unused harmony export donorListFetchStart */
/* unused harmony export donorListFetchEnd */
/* unused harmony export donorListFetchSuccess */
/* unused harmony export donorListFetchFailed */
/* unused harmony export fetchDonorListData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SECTOR_LIST; });
/* unused harmony export sectorListFetchStart */
/* unused harmony export sectorListFetchEnd */
/* unused harmony export sectorListFetchSuccess */
/* unused harmony export sectorListFetchFailed */
/* unused harmony export fetchSectorListData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OPERATING_UNITS; });
/* unused harmony export operatingUnitsFetchStart */
/* unused harmony export operatingUnitsFetchEnd */
/* unused harmony export operatingUnitsFetchSuccess */
/* unused harmony export operatingUnitsFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchOperatingUnitsListData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOCUMENT_CATEGORIES; });
/* unused harmony export documentCategoriesFetchStart */
/* unused harmony export documentCategoriesFetchEnd */
/* unused harmony export documentCategoriesFetchSuccess */
/* unused harmony export documentCategoriesFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchDocumentCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DOCUMENT_CATEGORIES_ALL; });
/* unused harmony export documentCategoriesAllFetchStart */
/* unused harmony export documentCategoriesAllFetchEnd */
/* unused harmony export documentCategoriesAllFetchSuccess */
/* unused harmony export documentCategoriesAllFetchFailed */
/* unused harmony export fetchAllDocumentCategoriesAlltCategories */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LAST_UPDATED_DATE; });
/* unused harmony export lastUpdatedDateFetchStart */
/* unused harmony export lastUpdatedDateFetchEnd */
/* unused harmony export lastUpdatedDateFetchSuccess */
/* unused harmony export lastUpdatedDateFetchFailed */
/* unused harmony export fetchLastUpdatedDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LAST_UPDATE; });
/* unused harmony export lastUpdateFetchStart */
/* unused harmony export lastUpdateFetchEnd */
/* unused harmony export lastUpdateFetchSuccess */
/* unused harmony export lastUpdateFetchFailed */
/* unused harmony export fetchLastUpdate */
/* unused harmony export SIGNATURE_LIST */
/* unused harmony export signatureListFetchStart */
/* unused harmony export signatureListFetchEnd */
/* unused harmony export signatureListFetchSuccess */
/* unused harmony export signatureListFetchFailed */
/* unused harmony export updateSignatureList */
/* unused harmony export getMasterSignatureList */
/* unused harmony export fetchsignatureListData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return onAppInit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_nestedDropList_actions__ = __webpack_require__("doLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sdgListActions__ = __webpack_require__("8R5k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getGeneralInfo__ = __webpack_require__("2Ed7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__countryRegionSearch__ = __webpack_require__("6Ifq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getYearList__ = __webpack_require__("EIKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mapActions_yearTimeline__ = __webpack_require__("2AgP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("DHvs");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/************************* Lib Files **********************************/


/************************* Redux Actions Files ************************/








/////////////////////// Fetch Project Timeline Data //////////////////////////
var PROJECT_TIMELINE = {
  start: "fetch_start/project_timeline",
  end: "fetch_end/project_timeline",
  success: "fetch_success/project_timeline",
  failed: "fetch_failed/project_timeline"
};
var projectTimelineFetchStart = function projectTimelineFetchStart() {
  return {
    type: PROJECT_TIMELINE.start
  };
};

var projectTimelineFetchEnd = function projectTimelineFetchEnd() {
  return {
    type: PROJECT_TIMELINE.end
  };
};

var projectTimelineFetchSuccess = function projectTimelineFetchSuccess(year) {
  return {
    type: PROJECT_TIMELINE.success,
    year: year
  };
};

var projectTimelineFetchFailed = function projectTimelineFetchFailed(error) {
  return {
    type: PROJECT_TIMELINE.failed,
    error: error
  };
};
var fetchProjectTimelineData = function fetchProjectTimelineData() {
  return function (dispatch) {
    dispatch(projectTimelineFetchStart());
    return Promise.resolve([Object(__WEBPACK_IMPORTED_MODULE_7__utils__["e" /* getLastYear */])() - 1, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["e" /* getLastYear */])(), Object(__WEBPACK_IMPORTED_MODULE_7__utils__["e" /* getLastYear */])() + 1]).then(function (resp) {
      if (resp && resp.length) {
        var selectedYr = localStorage.getItem('globalCurrentYear') ? parseInt(localStorage.getItem('globalCurrentYear')) : Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* getCurrentYear */])();
        dispatch(projectTimelineFetchEnd());
        dispatch(projectTimelineFetchSuccess(resp));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__mapActions_yearTimeline__["b" /* setMapCurrentYear */])(selectedYr));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__getYearList__["b" /* setCurrentYear */])(selectedYr));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__countryRegionSearch__["c" /* searchCountryRegionsListData */])()); //Fetch Country Region List
        dispatch(fetchthemeListData("", "", selectedYr));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sdgListActions__["c" /* fetchSdgData */])("", "", ""));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sdgListActions__["b" /* fetchMasterSdgList */])(selectedYr)); // Fetch SDG Data
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__getYearList__["c" /* updateYearList */])());
      } else {
        dispatch(projectTimelineFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectTimelineFetchEnd());
      dispatch(projectTimelineFetchFailed());
    });
  };
};

/////////////////////// Fetch Country List Data //////////////////////////

var COUNTRY_LIST = {
  start: "fetch_start/country_list",
  end: "fetch_end/country_list",
  success: "fetch_success/country_list",
  failed: "fetch_failed/country_list"
};
var countryListFetchStart = function countryListFetchStart() {
  return {
    type: COUNTRY_LIST.start
  };
};

var countryListFetchEnd = function countryListFetchEnd() {
  return {
    type: COUNTRY_LIST.end
  };
};

var countryListFetchSuccess = function countryListFetchSuccess(countries) {
  return {
    type: COUNTRY_LIST.success,
    countries: countries
  };
};

var countryListFetchFailed = function countryListFetchFailed(error) {
  return {
    type: COUNTRY_LIST.failed,
    error: error
  };
};
var fetchCountryListData = function fetchCountryListData() {
  return function (dispatch) {
    dispatch(countryListFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_COUNTRY_LIST).then(function (resp) {
      if (resp.success && resp.data) {
        var pasrsedData = resp.data.map(function (item) {
          return _extends({}, item, {
            label: item.name,
            value: item.iso3
          });
        });
        dispatch(countryListFetchEnd());
        dispatch(countryListFetchSuccess(pasrsedData));
      } else {
        dispatch(countryListFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(countryListFetchEnd());
      dispatch(countryListFetchFailed());
    });
  };
};
/////////////////////// Search Country List Data //////////////////////////

var SEARCH_COUNTRY_LIST = {
  start: "fetch_start/search_country_list",
  end: "fetch_end/search_country_list",
  success: "fetch_success/search_country_list",
  failed: "fetch_failed/search_country_list"
};
var countryListSearchStart = function countryListSearchStart() {
  return {
    type: SEARCH_COUNTRY_LIST.start
  };
};

var countryListSearchEnd = function countryListSearchEnd() {
  return {
    type: SEARCH_COUNTRY_LIST.end
  };
};

var countryListSearchSuccess = function countryListSearchSuccess(countries) {
  return {
    type: SEARCH_COUNTRY_LIST.success,
    countries: countries
  };
};

var countryListSearchFailed = function countryListSearchFailed(error) {
  return {
    type: SEARCH_COUNTRY_LIST.failed,
    error: error
  };
};
var searchCountryListData = function searchCountryListData(donor) {
  return function (dispatch) {
    dispatch(countryListSearchStart());
    donor = donor ? donor : "";
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_COUNTRY_LIST + donor).then(function (resp) {
      if (resp.success && resp.data) {
        var pasrsedData = resp.data.map(function (item) {
          return _extends({}, item, {
            label: item.name,
            value: item.iso3
          });
        });
        dispatch(countryListSearchEnd());
        dispatch(countryListSearchSuccess(pasrsedData));
      } else {
        dispatch(countryListSearchEnd());
      }
    }).catch(function (exception) {
      dispatch(countryListSearchEnd());
      dispatch(countryListSearchFailed());
    });
  };
};

////////////////////////////Theme List /////////////////////////////

var THEME_LIST = {
  start: "fetch_start/theme_list",
  end: "fetch_end/theme_list",
  success: "fetch_success/theme_list",
  failed: "fetch_failed/theme_list",
  updateList: "update_list/theme_list"
};
var themeListFetchStart = function themeListFetchStart() {
  return {
    type: THEME_LIST.start
  };
};

var themeListFetchEnd = function themeListFetchEnd() {
  return {
    type: THEME_LIST.end
  };
};

var themeListFetchSuccess = function themeListFetchSuccess(themes) {
  return {
    type: THEME_LIST.success,
    themes: themes
  };
};

var themeListFetchFailed = function themeListFetchFailed(error) {
  return {
    type: THEME_LIST.failed,
    error: error
  };
};

var updateThemeList = function updateThemeList(themes) {
  return {
    type: THEME_LIST.updateList,
    themes: themes
  };
};

var getMasterThemeList = function getMasterThemeList() {
  return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_THEME_LIST).then(function (resp) {
      if (resp && resp.length) {
        resp.forEach(function (data) {
          data.label = data.sector;
          data.value = data.code;
        });
        dispatch(updateThemeList(resp));
      }
    });
  };
};

var fetchthemeListData = function fetchthemeListData(unit, donor, year, appendOthers) {
  return function (dispatch, getState) {
    dispatch(themeListFetchStart());
    unit = unit ? unit : "";
    donor = donor ? donor : "";
    var currentYear = year ? year : "";
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_THEME_LIST + ("?operating_unit=" + unit + "&donor=" + donor + "&year=" + currentYear + (appendOthers === 1 ? "&append_others=1" : ""))).then(function (resp) {
      if (resp && resp.length) {
        resp.forEach(function (data) {
          data.label = data.sector;
          data.value = data.code;
        });
      }
      dispatch(themeListFetchEnd());
      dispatch(themeListFetchSuccess(resp));
    }).catch(function (exception) {
      dispatch(themeListFetchEnd());
      dispatch(themeListFetchFailed());
    });
  };
};

//////////////// ------------------ Master Donor List -------------------- ////////////////////

var DONOR_LIST = {
  start: "fetch_start/donor_list",
  end: "fetch_end/donor_list",
  success: "fetch_success/donor_list",
  failed: "fetch_failed/donor_list"
};
var donorListFetchStart = function donorListFetchStart() {
  return {
    type: DONOR_LIST.start
  };
};

var donorListFetchEnd = function donorListFetchEnd() {
  return {
    type: DONOR_LIST.end
  };
};

var donorListFetchSuccess = function donorListFetchSuccess(donorList) {
  return {
    type: DONOR_LIST.success,
    donorList: donorList
  };
};

var donorListFetchFailed = function donorListFetchFailed(error) {
  return {
    type: DONOR_LIST.failed,
    error: error
  };
};

var fetchDonorListData = function fetchDonorListData() {
  return function (dispatch, getState) {
    dispatch(donorListFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_OPERATING_UNITS).then(function (resp) {
      if (resp && resp.data) {
        dispatch(donorListFetchEnd());
        dispatch(donorListFetchSuccess(resp));
      } else {
        dispatch(donorListFetchFailed());
      }
    }).catch(function (exception) {
      dispatch(donorListFetchEnd());
      dispatch(donorListFetchFailed(exception));
    });
  };
};

//////////////// ------------------ Sector List -------------------- ////////////////////

var SECTOR_LIST = {
  start: "fetch_start/sector_list",
  end: "fetch_end/sector_list",
  success: "fetch_success/sector_list",
  failed: "fetch_failed/sector_list"
};
var sectorListFetchStart = function sectorListFetchStart() {
  return {
    type: SECTOR_LIST.start
  };
};

var sectorListFetchEnd = function sectorListFetchEnd() {
  return {
    type: SECTOR_LIST.end
  };
};

var sectorListFetchSuccess = function sectorListFetchSuccess(sectorList) {
  return {
    type: SECTOR_LIST.success,
    sectorList: sectorList
  };
};

var sectorListFetchFailed = function sectorListFetchFailed(error) {
  return {
    type: SECTOR_LIST.failed,
    error: error
  };
};

var fetchSectorListData = function fetchSectorListData() {
  return function (dispatch, getState) {
    dispatch(sectorListFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_SECTOR_LIST).then(function (resp) {
      if (resp && resp.data) {
        dispatch(sectorListFetchEnd());
        dispatch(sectorListFetchSuccess(resp));
      } else {
        dispatch(sectorListFetchFailed());
      }
    }).catch(function (exception) {
      dispatch(sectorListFetchEnd());
      dispatch(sectorListFetchFailed(exception));
    });
  };
};
//////////////// ------------------ Operating Units -------------------- ////////////////////

var OPERATING_UNITS = {
  start: "fetch_start/operating_units",
  end: "fetch_end/operating_units",
  success: "fetch_success/operating_units",
  failed: "fetch_failed/operating_units"
};
var operatingUnitsFetchStart = function operatingUnitsFetchStart() {
  return {
    type: OPERATING_UNITS.start
  };
};

var operatingUnitsFetchEnd = function operatingUnitsFetchEnd() {
  return {
    type: OPERATING_UNITS.end
  };
};

var operatingUnitsFetchSuccess = function operatingUnitsFetchSuccess(operatingUnitlist) {
  return {
    type: OPERATING_UNITS.success,
    operatingUnitlist: operatingUnitlist
  };
};

var operatingUnitsFetchFailed = function operatingUnitsFetchFailed(error) {
  return {
    type: OPERATING_UNITS.failed,
    error: error
  };
};

var fetchOperatingUnitsListData = function fetchOperatingUnitsListData(year) {
  return function (dispatch, getState) {
    dispatch(operatingUnitsFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get("" + __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_OPERATING_UNITS).then(function (resp) {
      if (resp && resp.data) {
        dispatch(operatingUnitsFetchEnd());
        dispatch(operatingUnitsFetchSuccess(resp));
      } else {
        dispatch(operatingUnitsFetchFailed());
      }
    }).catch(function (exception) {
      dispatch(operatingUnitsFetchEnd());
      dispatch(operatingUnitsFetchFailed(exception));
    });
  };
};

//////////////// ------------------ Document Categories -------------------- ////////////////////

var DOCUMENT_CATEGORIES = {
  start: "fetch_start/document_categories",
  end: "fetch_end/document_categories",
  success: "fetch_success/document_categories",
  failed: "fetch_failed/document_categories"
};
var documentCategoriesFetchStart = function documentCategoriesFetchStart() {
  return {
    type: DOCUMENT_CATEGORIES.start
  };
};

var documentCategoriesFetchEnd = function documentCategoriesFetchEnd() {
  return {
    type: DOCUMENT_CATEGORIES.end
  };
};

var documentCategoriesFetchSuccess = function documentCategoriesFetchSuccess(documentCategories) {
  return {
    type: DOCUMENT_CATEGORIES.success,
    documentCategories: documentCategories
  };
};

var documentCategoriesFetchFailed = function documentCategoriesFetchFailed(error) {
  return {
    type: DOCUMENT_CATEGORIES.failed,
    error: error
  };
};

var fetchDocumentCategories = function fetchDocumentCategories() {
  return function (dispatch) {
    dispatch(documentCategoriesFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_DOCUMENT_CATEGORY_FILTER).then(function (resp) {
      if (resp && resp.length) {
        resp.forEach(function (data) {
          data.label = data.title;
          data.value = data.category;
        });
        dispatch(documentCategoriesFetchEnd());
        dispatch(documentCategoriesFetchSuccess(resp));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__components_nestedDropList_actions__["q" /* updateSearchResult */])(resp));
      } else {
        dispatch(documentCategoriesFetchFailed());
      }
    }).catch(function (exception) {
      dispatch(documentCategoriesFetchEnd());
      dispatch(documentCategoriesFetchFailed(exception));
    });
  };
};

//////////////// ------------------ Document Categories --ALL---------------- ////////////////////

var DOCUMENT_CATEGORIES_ALL = {
  start: "fetch_start/document_categories_all",
  end: "fetch_end/document_categories_all",
  success: "fetch_success/document_categories_all",
  failed: "fetch_failed/document_categories_all"
};
var documentCategoriesAllFetchStart = function documentCategoriesAllFetchStart() {
  return {
    type: DOCUMENT_CATEGORIES_ALL.start
  };
};

var documentCategoriesAllFetchEnd = function documentCategoriesAllFetchEnd() {
  return {
    type: DOCUMENT_CATEGORIES_ALL.end
  };
};

var documentCategoriesAllFetchSuccess = function documentCategoriesAllFetchSuccess(DocumentCategories) {
  return {
    type: DOCUMENT_CATEGORIES_ALL.success,
    DocumentCategories: DocumentCategories
  };
};

var documentCategoriesAllFetchFailed = function documentCategoriesAllFetchFailed(error) {
  return {
    type: DOCUMENT_CATEGORIES_ALL.failed,
    error: error
  };
};

var fetchAllDocumentCategoriesAlltCategories = function fetchAllDocumentCategoriesAlltCategories() {
  return function (dispatch) {
    dispatch(documentCategoriesAllFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_DOCUMENT_CATEGORY_FILTER + "?show_all").then(function (resp) {
      if (resp && resp.length) {
        resp.forEach(function (data) {
          data.label = data.title;
          data.value = data.category;
        });
        dispatch(documentCategoriesAllFetchEnd());
        dispatch(documentCategoriesAllFetchSuccess(resp));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__components_nestedDropList_actions__["q" /* updateSearchResult */])(resp));
      } else {
        dispatch(documentCategoriesAllFetchFailed());
      }
    }).catch(function (exception) {
      dispatch(documentCategoriesAllFetchEnd());
      dispatch(documentCategoriesAllFetchFailed(exception));
    });
  };
};

///////////////////////////// update Filters /////////////////////////

var updateFilters = function updateFilters(unit, theme, sdg, donor, year, appendOthers) {
  return function (dispatch) {
    dispatch(fetchthemeListData(unit, donor, year, appendOthers)); // Fetch Theme List Data
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sdgListActions__["c" /* fetchSdgData */])(unit, donor, year)); // Fetch SDG Data
  };
};

//////////////////////// Last Updated Date ///////////////////////////
var LAST_UPDATED_DATE = {
  start: "fetch_start/last_updated_date",
  end: "fetch_end/last_updated_date",
  success: "fetch_success/last_updated_date",
  failed: "fetch_failed/last_updated_date"
};
var lastUpdatedDateFetchStart = function lastUpdatedDateFetchStart() {
  return {
    type: LAST_UPDATED_DATE.start
  };
};

var lastUpdatedDateFetchEnd = function lastUpdatedDateFetchEnd() {
  return {
    type: LAST_UPDATED_DATE.end
  };
};

var lastUpdatedDateFetchSuccess = function lastUpdatedDateFetchSuccess(date) {
  return {
    type: LAST_UPDATED_DATE.success,
    date: date
  };
};

var lastUpdatedDateFetchFailed = function lastUpdatedDateFetchFailed(error) {
  return {
    type: LAST_UPDATED_DATE.failed,
    error: error
  };
};

var fetchLastUpdatedDate = function fetchLastUpdatedDate() {
  return function (dispatch) {
    dispatch(lastUpdatedDateFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get("" + __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_LAST_UPDATED).then(function (resp) {
      if (resp && resp.data) {
        dispatch(lastUpdatedDateFetchEnd());
        dispatch(lastUpdatedDateFetchSuccess(resp.data));
      } else {
        dispatch(lastUpdatedDateFetchFailed());
      }
    }).catch(function (exception) {
      dispatch(lastUpdatedDateFetchEnd());
      dispatch(lastUpdatedDateFetchFailed(exception));
    });
  };
};

//////////////////////// Last Update ///////////////////////////
var LAST_UPDATE = {
  start: "fetch_start/last_update",
  end: "fetch_end/last_update",
  success: "fetch_success/last_update",
  failed: "fetch_failed/last_update"
};
var lastUpdateFetchStart = function lastUpdateFetchStart() {
  return {
    type: LAST_UPDATE.start
  };
};

var lastUpdateFetchEnd = function lastUpdateFetchEnd() {
  return {
    type: LAST_UPDATE.end
  };
};

var lastUpdateFetchSuccess = function lastUpdateFetchSuccess(date) {
  return {
    type: LAST_UPDATE.success,
    date: date
  };
};

var lastUpdateFetchFailed = function lastUpdateFetchFailed(error) {
  return {
    type: LAST_UPDATE.failed,
    error: error
  };
};

var fetchLastUpdate = function fetchLastUpdate() {
  return function (dispatch) {
    dispatch(lastUpdateFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get("" + __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_LAST_UPDATE).then(function (resp) {
      if (resp && resp.data) {
        dispatch(lastUpdateFetchEnd());
        dispatch(lastUpdateFetchSuccess(resp.data));
      } else {
        dispatch(lastUpdateFetchFailed());
      }
    }).catch(function (exception) {
      dispatch(lastUpdateFetchEnd());
      dispatch(lastUpdateFetchFailed(exception));
    });
  };
};

////////////////////////////Signature List /////////////////////////////

var SIGNATURE_LIST = {
  start: "fetch_start/signature_list",
  end: "fetch_end/signature_list",
  success: "fetch_success/signature_list",
  failed: "fetch_failed/signature_list",
  updateList: "update_list/signature_list"
};
var signatureListFetchStart = function signatureListFetchStart() {
  return {
    type: SIGNATURE_LIST.start
  };
};

var signatureListFetchEnd = function signatureListFetchEnd() {
  return {
    type: SIGNATURE_LIST.end
  };
};

var signatureListFetchSuccess = function signatureListFetchSuccess(signatures) {
  return {
    type: SIGNATURE_LIST.success,
    signatures: signatures
  };
};

var signatureListFetchFailed = function signatureListFetchFailed(error) {
  return {
    type: SIGNATURE_LIST.failed,
    error: error
  };
};

var updateSignatureList = function updateSignatureList(signatures) {
  return {
    type: SIGNATURE_LIST.updateList,
    signatures: signatures
  };
};

var getMasterSignatureList = function getMasterSignatureList() {
  return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_SIGNATURE_LIST).then(function (resp) {
      if (resp && resp.length) {
        resp.forEach(function (data) {
          data.label = data.sector;
          data.value = data.code;
        });
        dispatch(updateSignatureList(resp));
      }
    });
  };
};

var fetchsignatureListData = function fetchsignatureListData(unit, donor, year) {
  return function (dispatch, getState) {
    dispatch(signatureListFetchStart());
    unit = unit ? unit : "";
    donor = donor ? donor : "";
    var currentYear = year ? year : "";
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_SIGNATURE_LIST + ("?operating_unit=" + unit + "&donor=" + donor + "&year=" + currentYear)).then(function (resp) {
      if (resp && resp.length) {
        resp.forEach(function (data) {
          data.label = data.sector;
          data.value = data.code;
        });
        dispatch(signatureListFetchEnd());
        dispatch(signatureListFetchSuccess(resp));
      } else {
        dispatch(signatureListFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(signatureListFetchEnd());
      dispatch(signatureListFetchFailed());
    });
  };
};

////////////////////////////  App Init ///////////////////////////////

var onAppInit = function onAppInit() {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__getGeneralInfo__["b" /* fetchGeneralInfoData */])()); // Fetch GeneralInfo Data
    dispatch(fetchProjectTimelineData()); // Fetch Project Timeline Data
    dispatch(fetchLastUpdate()); // Fetch Project Timeline Data
  };
};

/***/ }),

/***/ "cQmd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_PURCHASE_ORDERS; });
/* unused harmony export projectPurchaseOrdersFetchStart */
/* unused harmony export projectPurchaseOrdersFetchEnd */
/* unused harmony export projectPurchaseOrdersFetchSuccess */
/* unused harmony export projectPurchaseOrdersFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectPurchaseOrders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Basic Data //////////////////////////


var PROJECT_PURCHASE_ORDERS = {
  start: "fetch_start/project_purchase_orders",
  end: "fetch_end/project_purchase_orders",
  success: "fetch_success/project_purchase_orders",
  failed: "fetch_failed/project_purchase_orders"
};

var projectPurchaseOrdersFetchStart = function projectPurchaseOrdersFetchStart() {
  return {
    type: PROJECT_PURCHASE_ORDERS.start
  };
};

var projectPurchaseOrdersFetchEnd = function projectPurchaseOrdersFetchEnd() {
  return {
    type: PROJECT_PURCHASE_ORDERS.end
  };
};

var projectPurchaseOrdersFetchSuccess = function projectPurchaseOrdersFetchSuccess(data) {
  return {
    type: PROJECT_PURCHASE_ORDERS.success,
    data: data
  };
};

var projectPurchaseOrdersFetchFailed = function projectPurchaseOrdersFetchFailed(error) {
  return {
    type: PROJECT_PURCHASE_ORDERS.failed,
    error: error
  };
};

var fetchProjectPurchaseOrders = function fetchProjectPurchaseOrders(id) {
  return function (dispatch, getState) {
    dispatch(projectPurchaseOrdersFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_PURCHASE_ORDERS(id)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(projectPurchaseOrdersFetchEnd());
        dispatch(projectPurchaseOrdersFetchSuccess(resp.data));
      } else {
        dispatch(projectPurchaseOrdersFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectPurchaseOrdersFetchEnd());
      dispatch(projectPurchaseOrdersFetchFailed());
    });
  };
};

/***/ }),

/***/ "dAhp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "doLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OPERATING_UNITS_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OPERATING_UNITS_SEARCH_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_SEARCH_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_SEARCH_RESUlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_SEARCH_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_SEARCH_DONOR_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_SEARCH_RESULT_SEARCH_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_SEARCH_COUNTRY_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SEARCH_COUNTRY_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_TEMP_SEARCH_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_SEARCH_THEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_SEARCH_SDG; });
/* unused harmony export updateSearchText */
/* unused harmony export updateSearchDonorsText */
/* unused harmony export updateTempSearchResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return clearSearchCountryField; });
/* unused harmony export upDateBudgetSourceField */
/* unused harmony export operatingUnitsFetchStart */
/* unused harmony export operatingUnitsFetchEnd */
/* unused harmony export operatingUnitsFetchSuccess */
/* unused harmony export operatingUnitsFetchFailed */
/* unused harmony export operatingUnitsFetchStartSearchBar */
/* unused harmony export operatingUnitsFetchEndSearchBar */
/* unused harmony export operatingUnitsFetchSuccessSearchBar */
/* unused harmony export operatingUnitsFetchFailedSearchBar */
/* unused harmony export searchBarOpearatingUnitsListData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return searchOperatingUnitsListData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateSearchResult; });
/* unused harmony export updateSearchResultSearchBar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateSearchCountryField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return updateSearchThemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return updateSearchSgd; });
/* unused harmony export clearSearchResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return searchResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_actions_commonDataActions__ = __webpack_require__("b7sF");



var OPERATING_UNITS_SEARCH = {
  start: "fetch_start/operating_units_search_list",
  end: "fetch_end/operating_units_search_list",
  success: "fetch_success/operating_units_search_list",
  failed: "fetch_failed/operating_units_search_list"
};

var OPERATING_UNITS_SEARCH_BAR = {
  start: "fetch_start/operating_units_search_bar",
  end: "fetch_end/operating_units_search_bar",
  success: "fetch_success/operating_units_search_bar",
  failed: "fetch_failed/operating_units_search_bar"
};

var UPDATE_SEARCH_RESULT = "UPDATE_SEARCH_RESULT";
var CLEAR_SEARCH_RESUlt = "CLEAR_SEARCH_RESUlt";
var UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT_NESTED";
var UPDATE_SEARCH_DONOR_TEXT = "UPDATE_SEARCH_DONOR_TEXT";
var UPDATE_SEARCH_RESULT_SEARCH_BAR = "UPDATE_SEARCH_RESULT_SEARCH_BAR";
var UPDATE_SEARCH_COUNTRY_FIELD = "UPDATE_SEARCH_COUNTRY_FIELD";
var CLEAR_SEARCH_COUNTRY_FIELD = "CLEAR_SEARCH_COUNTRY_FIELD";
var UPDATE_TEMP_SEARCH_RESULT = "UPDATE_TEMP_SEARCH_RESULT";
var UPDATE_SEARCH_THEMES = "UPDATE_SEARCH_THEMES";
var UPDATE_SEARCH_SDG = "UPDATE_SEARCH_SDG";

var updateSearchText = function updateSearchText(text) {
  return {
    type: UPDATE_SEARCH_TEXT,
    text: text
  };
};

var updateSearchDonorsText = function updateSearchDonorsText(text) {
  return {
    type: UPDATE_SEARCH_DONOR_TEXT,
    text: text
  };
};

var updateTempSearchResult = function updateTempSearchResult(data, countryFieldKey, sdgFieldKey, themesFieldKey) {
  return {
    type: UPDATE_TEMP_SEARCH_RESULT,
    data: data,
    countryFieldKey: countryFieldKey,
    sdgFieldKey: sdgFieldKey,
    themesFieldKey: themesFieldKey
  };
};

// update budgetSource fields

var clearSearchCountryField = function clearSearchCountryField() {
  return {
    type: CLEAR_SEARCH_COUNTRY_FIELD
  };
};

// update budgetSource fields

var upDateBudgetSourceField = function upDateBudgetSourceField() {
  var themes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var sdg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var country = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

  return function (dispatch, getState) {
    dispatch(updateSearchThemes(themes));
    dispatch(updateSearchSgd(sdg));
    dispatch(updateSearchCountryField(country));
  };
};

//Operating Units drop list

var operatingUnitsFetchStart = function operatingUnitsFetchStart() {
  return {
    type: OPERATING_UNITS_SEARCH.start
  };
};

var operatingUnitsFetchEnd = function operatingUnitsFetchEnd() {
  return {
    type: OPERATING_UNITS_SEARCH.end
  };
};

var operatingUnitsFetchSuccess = function operatingUnitsFetchSuccess(operatingUnitlist) {
  return {
    type: OPERATING_UNITS_SEARCH.success,
    operatingUnitlist: operatingUnitlist
  };
};

var operatingUnitsFetchFailed = function operatingUnitsFetchFailed(error) {
  return {
    type: OPERATING_UNITS_SEARCH.failed,
    error: error
  };
};

//Operating Units search bar

var operatingUnitsFetchStartSearchBar = function operatingUnitsFetchStartSearchBar() {
  return {
    type: OPERATING_UNITS_SEARCH_BAR.start
  };
};

var operatingUnitsFetchEndSearchBar = function operatingUnitsFetchEndSearchBar() {
  return {
    type: OPERATING_UNITS_SEARCH_BAR.end
  };
};

var operatingUnitsFetchSuccessSearchBar = function operatingUnitsFetchSuccessSearchBar(operatingUnitlist) {
  return {
    type: OPERATING_UNITS_SEARCH_BAR.success,
    operatingUnitlist: operatingUnitlist
  };
};

var operatingUnitsFetchFailedSearchBar = function operatingUnitsFetchFailedSearchBar(error) {
  return {
    type: OPERATING_UNITS_SEARCH_BAR.failed,
    error: error
  };
};

var searchBarOpearatingUnitsListData = function searchBarOpearatingUnitsListData(searchParam, key, operatingUnit) {
  return function (dispatch, getState) {
    var currentYear = getState().mapData.yearTimeline.mapCurrentYear;

    dispatch(operatingUnitsFetchStartSearchBar());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_OPERATING_UNITS + ("?search=" + searchParam) + ("&year=" + currentYear) + ("&country=" + operatingUnit)).then(function (resp) {
      if (resp && resp.data) {
        if (getState().budgetSourceSearch.searchDonorText == resp.data.draw) {
          dispatch(updateSearchResultSearchBar(resp.data.donors));
          dispatch(operatingUnitsFetchEndSearchBar());
        }
      } else {
        dispatch(operatingUnitsFetchFailedSearchBar());
        dispatch(operatingUnitsFetchEndSearchBar());
      }
    }).catch(function (exception) {
      dispatch(operatingUnitsFetchEndSearchBar());
      dispatch(operatingUnitsFetchFailedSearchBar());
    });
  };
};

var searchOperatingUnitsListData = function searchOperatingUnitsListData(searchParam, key) {
  var year = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return function (dispatch, getState) {
    var currentYear = year === "" ? "" : year || getState().mapData.yearTimeline.mapCurrentYear;
    var country = getState().budgetSourceSearch.searchCountryField;
    var themes = getState().budgetSourceSearch.searchThemesField ? getState().budgetSourceSearch.searchThemesField : "";
    var searchtext = getState().budgetSourceSearch.searchText;
    var searchParameter = searchParam === null ? searchtext : searchParam;
    var sdg = getState().budgetSourceSearch.searchSdgField ? getState().budgetSourceSearch.searchSdgField : "";
    dispatch(operatingUnitsFetchStart());
    var searchParamURL = getState().tabData.tabSelected === "signature" ? "?search=" + searchParameter + ("&year=" + currentYear) + ("&country=" + country) + ("&ss_id=" + (themes && themes !== -1 ? themes : "")) + ("&sdg=" + sdg) : "?search=" + searchParameter + ("&year=" + currentYear) + ("&country=" + country) + ("&sector=" + (themes && themes !== -1 ? themes : "")) + ("&sdg=" + sdg);
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_OPERATING_UNITS + searchParamURL).then(function (resp) {
      if (resp && resp.data) {
        if (getState().budgetSourceSearch.searchText == resp.data.draw) {
          dispatch(updateSearchResult(resp.data.donors));
          if (searchParameter == "") {
            dispatch(updateTempSearchResult(resp.data.donors, country, sdg, themes));
          }
          dispatch(operatingUnitsFetchEnd());
        }
      } else {
        dispatch(operatingUnitsFetchFailed());
        dispatch(operatingUnitsFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(operatingUnitsFetchEnd());
      dispatch(operatingUnitsFetchFailed());
    });
  };
};

var updateSearchResult = function updateSearchResult(data) {
  return {
    type: UPDATE_SEARCH_RESULT,
    data: data
  };
};

var updateSearchResultSearchBar = function updateSearchResultSearchBar(data) {
  return {
    type: UPDATE_SEARCH_RESULT_SEARCH_BAR,
    data: data
  };
};

//drop list params

/// Country Field

var updateSearchCountryField = function updateSearchCountryField(data) {
  return {
    type: UPDATE_SEARCH_COUNTRY_FIELD,
    data: data
  };
};

// Themes
var updateSearchThemes = function updateSearchThemes(data) {
  return {
    type: UPDATE_SEARCH_THEMES,
    data: data
  };
};

// Sdg

var updateSearchSgd = function updateSearchSgd(data) {
  return {
    type: UPDATE_SEARCH_SDG,
    data: data
  };
};

var clearSearchResult = function clearSearchResult() {
  return {
    type: CLEAR_SEARCH_RESUlt
  };
};

var searchResult = function searchResult(searchParam, key) {
  var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return function (dispatch, getState) {
    var country = getState().budgetSourceSearch.searchCountryField ? getState().budgetSourceSearch.searchCountryField : "";
    var themes = getState().budgetSourceSearch.searchThemesField;
    var sdg = getState().budgetSourceSearch.searchSdgField;
    var operatingUnit = getState().tabData.donorFilter.operatingUnits;

    if (key === "dropList") {
      dispatch(updateSearchText(searchParam));
      if (searchParam == "") {
        dispatch(updateSearchResult(getState().budgetSourceSearch.searchResultTemp.data));

        if (source) {
          dispatch(operatingUnitsFetchEnd());
        }
      } else {
        dispatch(searchOperatingUnitsListData(searchParam, key));
      }
    } else {
      dispatch(updateSearchDonorsText(searchParam));
      if (searchParam !== "") {
        dispatch(searchBarOpearatingUnitsListData(searchParam, key, operatingUnit && getState().tabData.tabSelected === "donors" ? operatingUnit : ""));
      } else {
        dispatch(updateSearchResultSearchBar([]));
      }
    }
  };
};

/***/ }),

/***/ "dzhT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FINANCIAL_FLOW; });
var FINANCIAL_FLOW = {
  start: "fetch_start/financial_flow",
  end: "fetch_end/financial_flow",
  success: "fetch_success/financial_flow",
  failed: "fetch_failed/financial_flow",
  clear: "clear/financial_flow"
};

/***/ }),

/***/ "e0UL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROJECT_DOCUMENT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOCUMENT_LIST_FILTERED; });
/* unused harmony export projectDocumentListFetchStart */
/* unused harmony export projectDocumentListFetchEnd */
/* unused harmony export projectDocumentListFetchSuccess */
/* unused harmony export projectDocumentListFetchFailed */
/* unused harmony export documentListFilteredFetchStart */
/* unused harmony export documentListFilteredFetchEnd */
/* unused harmony export documentListFilteredFetchSuccess */
/* unused harmony export documentListFilteredFetchFailed */
/* unused harmony export swapDocumentListInit */
/* unused harmony export createDocumentCategoryList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchProjectDocumentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateProjectDocumentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return swapDocumentList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Document List //////////////////////////

var PROJECT_DOCUMENT_LIST = {
  start: "fetch_start/project_document_list",
  end: "fetch_end/project_document_list",
  success: "fetch_success/project_document_list",
  failed: "fetch_failed/project_document_list"
};
var DOCUMENT_LIST_FILTERED = {
  start: "fetch_start/document_list_filtered",
  swap: "update_document_cache/document_list_filtered",
  end: "fetch_end/document_list_filtered",
  success: "fetch_success/document_list_filtered",
  failed: "fetch_failed/document_list_filtered"
};
var projectDocumentListFetchStart = function projectDocumentListFetchStart() {
  return {
    type: PROJECT_DOCUMENT_LIST.start
  };
};

var projectDocumentListFetchEnd = function projectDocumentListFetchEnd() {
  return {
    type: PROJECT_DOCUMENT_LIST.end
  };
};

var projectDocumentListFetchSuccess = function projectDocumentListFetchSuccess(data, categoryList) {
  return {
    type: PROJECT_DOCUMENT_LIST.success,
    data: data,
    categoryList: categoryList
  };
};

var projectDocumentListFetchFailed = function projectDocumentListFetchFailed(error) {
  return {
    type: PROJECT_DOCUMENT_LIST.failed,
    error: error
  };
};

var documentListFilteredFetchStart = function documentListFilteredFetchStart() {
  return {
    type: DOCUMENT_LIST_FILTERED.start
  };
};

var documentListFilteredFetchEnd = function documentListFilteredFetchEnd() {
  return {
    type: DOCUMENT_LIST_FILTERED.end
  };
};

var documentListFilteredFetchSuccess = function documentListFilteredFetchSuccess(data) {
  return {
    type: DOCUMENT_LIST_FILTERED.success,
    data: data
  };
};

var documentListFilteredFetchFailed = function documentListFilteredFetchFailed(error) {
  return {
    type: DOCUMENT_LIST_FILTERED.failed,
    error: error
  };
};

var swapDocumentListInit = function swapDocumentListInit(data) {
  return {
    type: DOCUMENT_LIST_FILTERED.swap,
    data: data
  };
};

var createDocumentCategoryList = function createDocumentCategoryList(dataArray) {
  var array = [];
  dataArray.forEach(function (item) {
    if (array.length !== 0) {
      var flag = true;
      array.forEach(function (data) {
        if (data.label === item.category_name) {
          flag = false;
        }
      });
      if (flag) {
        array.push({
          label: item.category_name,
          value: item.category
        });
      }
    } else {
      array.push({
        label: item.category_name,
        value: item.category
      });
    }
  });
  return array;
};

var fetchProjectDocumentList = function fetchProjectDocumentList(id) {
  return function (dispatch, getState) {
    dispatch(projectDocumentListFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_DOCUMENT_LIST(id)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(projectDocumentListFetchEnd());
        var categoryList = createDocumentCategoryList(resp.data.data);

        dispatch(projectDocumentListFetchSuccess(resp.data, categoryList));
        dispatch(swapDocumentListInit(resp.data));
      } else {
        dispatch(projectDocumentListFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectDocumentListFetchEnd());
      dispatch(projectDocumentListFetchFailed());
    });
  };
};

var updateProjectDocumentList = function updateProjectDocumentList(id, category) {
  return function (dispatch, getState) {
    dispatch(documentListFilteredFetchStart());
    !category ? category = "" : null;
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_DOCUMENT_LIST_FILTERED(id, category)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(documentListFilteredFetchEnd());
        dispatch(documentListFilteredFetchSuccess(resp.data));
      } else {
        dispatch(documentListFilteredFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(documentListFilteredFetchEnd());
      dispatch(documentListFilteredFetchFailed());
    });
  };
};
var swapDocumentList = function swapDocumentList() {
  return function (dispatch, getState) {
    var projectDetail = getState().projectDetail.document_list;
    dispatch(swapDocumentListInit(projectDetail));
  };
};

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1_preact__, "createRef")) __webpack_require__.d(__webpack_exports__, "createRef", function() { return __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context__ = __webpack_require__("ZShz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_context__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_2_preact_context__, "createContext")) __webpack_require__.d(__webpack_exports__, "createContext", function() { return __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"]; });







var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = "production" !== 'production';
} catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	hydrate: render$1,
	createClass: createClass,
	createContext: __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"],
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	createRef: __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"],
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);

//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "eid4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_ACTIVITIES_LIST; });
/* unused harmony export donorActivitiesListFetchStart */
/* unused harmony export donorActivitiesListFetchEnd */
/* unused harmony export donorActivitiesListFetchSuccess */
/* unused harmony export donorActivitiesListFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateDonorActivitiesList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var DONOR_ACTIVITIES_LIST = {
  start: "fetch_start/donor_activities_list",
  end: "fetch_end/donor_activities_list",
  success: "fetch_success/donor_activities_list",
  failed: "fetch_failed/donor_activities_list"
};

var donorActivitiesListFetchStart = function donorActivitiesListFetchStart() {
  return {
    type: DONOR_ACTIVITIES_LIST.start
  };
};

var donorActivitiesListFetchEnd = function donorActivitiesListFetchEnd() {
  return {
    type: DONOR_ACTIVITIES_LIST.end
  };
};

var donorActivitiesListFetchSuccess = function donorActivitiesListFetchSuccess(data) {
  return {
    type: DONOR_ACTIVITIES_LIST.success,
    data: data
  };
};

var donorActivitiesListFetchFailed = function donorActivitiesListFetchFailed(error) {
  return {
    type: DONOR_ACTIVITIES_LIST.failed,
    error: error
  };
};

var updateDonorActivitiesList = function updateDonorActivitiesList(year, donor, page, pageSize) {
  return function (dispatch) {
    dispatch(donorActivitiesListFetchStart());
    var filterDonor = donor || "";
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONOR_ACTIVITIES_LIST(year, filterDonor, page, pageSize)).then(function (response) {
        dispatch(donorActivitiesListFetchEnd());
        dispatch(donorActivitiesListFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(donorActivitiesListFetchEnd());
        dispatch(donorActivitiesListFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "fBVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONORS_CONTRIBUTIONS_LIST; });
/* unused harmony export donorsContributionsListFetchStart */
/* unused harmony export donorsContributionsListFetchEnd */
/* unused harmony export donorsContributionsListFetchSuccess */
/* unused harmony export donorsContributionsListFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateContributionsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var DONORS_CONTRIBUTIONS_LIST = {
  start: "fetch_start/donors_contributions_list",
  end: "fetch_end/donors_contributions_list",
  success: "fetch_success/donors_contributions_list",
  failed: "fetch_failed/donors_contributions_list"
};

var donorsContributionsListFetchStart = function donorsContributionsListFetchStart() {
  return {
    type: DONORS_CONTRIBUTIONS_LIST.start
  };
};

var donorsContributionsListFetchEnd = function donorsContributionsListFetchEnd() {
  return {
    type: DONORS_CONTRIBUTIONS_LIST.end
  };
};

var donorsContributionsListFetchSuccess = function donorsContributionsListFetchSuccess(data) {
  return {
    type: DONORS_CONTRIBUTIONS_LIST.success,
    data: data
  };
};

var donorsContributionsListFetchFailed = function donorsContributionsListFetchFailed(error) {
  return {
    type: DONORS_CONTRIBUTIONS_LIST.failed,
    error: error
  };
};

var updateContributionsList = function updateContributionsList(year, portal) {
  return function (dispatch) {
    dispatch(donorsContributionsListFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONORS_CONTRIBUTIONS_LIST(year, portal)).then(function (response) {
        dispatch(donorsContributionsListFetchEnd());
        dispatch(donorsContributionsListFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(donorsContributionsListFetchEnd());
        dispatch(donorsContributionsListFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "faE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_ACTIVITIES_DATA; });
/* unused harmony export recipientActivitiesDataFetchStart */
/* unused harmony export recipientActivitiesDataFetchEnd */
/* unused harmony export recipientActivitiesDataFetchSuccess */
/* unused harmony export recipientActivitiesDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRecipientActivitiesData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var RECIPIENT_ACTIVITIES_DATA = {
  start: "fetch_start/recipient_activities_data",
  end: "fetch_end/recipient_activities_data",
  success: "fetch_success/recipient_activities_data",
  failed: "fetch_failed/recipient_activities_data"
};

var recipientActivitiesDataFetchStart = function recipientActivitiesDataFetchStart() {
  return {
    type: RECIPIENT_ACTIVITIES_DATA.start
  };
};

var recipientActivitiesDataFetchEnd = function recipientActivitiesDataFetchEnd() {
  return {
    type: RECIPIENT_ACTIVITIES_DATA.end
  };
};

var recipientActivitiesDataFetchSuccess = function recipientActivitiesDataFetchSuccess(data) {
  return {
    type: RECIPIENT_ACTIVITIES_DATA.success,
    data: data
  };
};

var recipientActivitiesDataFetchFailed = function recipientActivitiesDataFetchFailed(error) {
  return {
    type: RECIPIENT_ACTIVITIES_DATA.failed,
    error: error
  };
};

var getRecipientActivitiesData = function getRecipientActivitiesData(year, field_of_operation, page, pageSize) {
  return function (dispatch) {
    dispatch(recipientActivitiesDataFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_ACTIVITIES_DATA(year, field_of_operation, page, pageSize)).then(function (response) {
        dispatch(recipientActivitiesDataFetchEnd());
        dispatch(recipientActivitiesDataFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(recipientActivitiesDataFetchEnd());
        dispatch(recipientActivitiesDataFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "faXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_DONOR_TOTAL_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_DONOR_OTHER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_DONOR_REGULAR_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DONOR_TOTAL_DATA_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DONOR_OTHER_DATA_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DONOR_REGULAR_DATA_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DONOR_TOTAL_DATA_FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DONOR_OTHER_DATA_FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DONOR_REGULAR_DATA_FETCH_END; });
/* unused harmony export donorTotalDataFetchStart */
/* unused harmony export donorOtherDataFetchStart */
/* unused harmony export donorRegularDataFetchStart */
/* unused harmony export donorTotalDataFetchEnd */
/* unused harmony export donorOtherDataFetchEnd */
/* unused harmony export donorRegularDataFetchEnd */
/* unused harmony export dataFetchStart */
/* unused harmony export dataFetchEnd */
/* unused harmony export donorDataFetchStart */
/* unused harmony export donorDataFetchEnd */
/* unused harmony export donorDataFetchSuccess */
/* unused harmony export donorDataFetchFailed */
/* unused harmony export updateTotalData */
/* unused harmony export updateRegularData */
/* unused harmony export updateOtherData */
/* unused harmony export updateTabData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return donorFetchData; });
/* unused harmony export parseDonorData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DONOR_TYPES; });
/* unused harmony export donorTypesFetchStart */
/* unused harmony export donorTypesFetchEnd */
/* unused harmony export donorTypesFetchSuccess */
/* unused harmony export donorTypesFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return donorTypesFetchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FUND_STREAMS; });
/* unused harmony export fundStreamsFetchStart */
/* unused harmony export fundStreamsFetchEnd */
/* unused harmony export fundStreamsFetchSuccess */
/* unused harmony export fundStreamsFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fundStreamsFetchData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_numberFormatter_js__ = __webpack_require__("Au7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabSection_actions__ = __webpack_require__("PeVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3__ = __webpack_require__("tokj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_d3__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TAB_OTHER = "Other Resources",
    TAB_REGULAR = "Regular Resources",
    TAB_TOTAL = "";

var DONOR_DATA = {
  start: "fetch_start/donors",
  end: "fetch_end/donors",
  success: "fetch_success/donors",
  failed: "fetch_failed/donors"
};

// ----------------- tab switch data ------ >>>>>>>>>>>

var UPDATE_DONOR_TOTAL_DATA = "UPDATE_DONOR_TOTAL_DATA";
var UPDATE_DONOR_OTHER_DATA = "UPDATE_DONOR_OTHER_DATA";
var UPDATE_DONOR_REGULAR_DATA = "UPDATE_DONOR_REGULAR_DATA";

var DONOR_TOTAL_DATA_FETCH_START = "DONOR_TOTAL_DATA_FETCH_START";
var DONOR_OTHER_DATA_FETCH_START = "DONOR_OTHER_DATA_FETCH_START";
var DONOR_REGULAR_DATA_FETCH_START = "DONOR_REGULAR_DATA_FETCH_START";

var DONOR_TOTAL_DATA_FETCH_END = "DONOR_TOTAL_DATA_FETCH_END";
var DONOR_OTHER_DATA_FETCH_END = "DONOR_OTHER_DATA_FETCH_END";
var DONOR_REGULAR_DATA_FETCH_END = "DONOR_REGULAR_DATA_FETCH_END";

// ------------------ > Individual Loading --- for Embed Section ---------------------->>>>>>

//Fectch Start
var donorTotalDataFetchStart = function donorTotalDataFetchStart() {
  return {
    type: DONOR_TOTAL_DATA_FETCH_START
  };
};
var donorOtherDataFetchStart = function donorOtherDataFetchStart() {
  return {
    type: DONOR_OTHER_DATA_FETCH_START
  };
};
var donorRegularDataFetchStart = function donorRegularDataFetchStart() {
  return {
    type: DONOR_REGULAR_DATA_FETCH_START
  };
};

//Fetch End

var donorTotalDataFetchEnd = function donorTotalDataFetchEnd() {
  return {
    type: DONOR_TOTAL_DATA_FETCH_END
  };
};
var donorOtherDataFetchEnd = function donorOtherDataFetchEnd() {
  return {
    type: DONOR_OTHER_DATA_FETCH_END
  };
};
var donorRegularDataFetchEnd = function donorRegularDataFetchEnd() {
  return {
    type: DONOR_REGULAR_DATA_FETCH_END
  };
};

// for loading prop only
var dataFetchStart = function dataFetchStart(type) {
  return function (dispatch) {
    switch (type) {
      case TAB_TOTAL:
        dispatch(donorTotalDataFetchStart());
        break;
      case TAB_REGULAR:
        dispatch(donorRegularDataFetchStart());
        break;
      case TAB_OTHER:
        dispatch(donorOtherDataFetchStart());

        break;
      default:
    }
  };
};

var dataFetchEnd = function dataFetchEnd(type) {
  return function (dispatch) {
    switch (type) {
      case TAB_TOTAL:
        dispatch(donorTotalDataFetchEnd());
        break;
      case TAB_REGULAR:
        dispatch(donorRegularDataFetchEnd());

        break;
      case TAB_OTHER:
        dispatch(donorOtherDataFetchEnd());

        break;
      default:
    }
  };
};

//--------------------- >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

var donorDataFetchStart = function donorDataFetchStart() {
  return {
    type: DONOR_DATA.start
  };
};

var donorDataFetchEnd = function donorDataFetchEnd() {
  return {
    type: DONOR_DATA.end
  };
};

var donorDataFetchSuccess = function donorDataFetchSuccess(data) {
  return {
    type: DONOR_DATA.success,
    data: data
  };
};

var donorDataFetchFailed = function donorDataFetchFailed(error) {
  return {
    type: DONOR_DATA.failed,
    error: error
  };
};

// tab switch data

var updateTotalData = function updateTotalData(data) {
  return {
    type: UPDATE_DONOR_TOTAL_DATA,
    data: data
  };
};

var updateRegularData = function updateRegularData(data) {
  return {
    type: UPDATE_DONOR_REGULAR_DATA,
    data: data
  };
};

var updateOtherData = function updateOtherData(data) {
  return {
    type: UPDATE_DONOR_OTHER_DATA,
    data: data
  };
};

var updateTabData = function updateTabData(data, tabSelected) {
  return function (dispatch) {
    switch (tabSelected) {
      case TAB_TOTAL:
        dispatch(updateTotalData(data));
        break;
      case TAB_REGULAR:
        dispatch(updateRegularData(data));
        break;

      case TAB_OTHER:
        dispatch(updateOtherData(data));
        break;
      default:
        dispatch(updateTotalData(data));
    }
  };
};

// --------------------------- >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

var donorFetchData = function donorFetchData(filterObj, tabSelected) {
  return function (dispatch, getState) {
    var map = {
      "Other Resources": "otherData",
      "Regular Resources": "regularData",
      "": "totalData"
    },
        tabData = getState().donorData[map[tabSelected]],
        year = tabData.filterObj && tabData.filterObj.year ? tabData.filterObj.year : "",
        donorType = tabData.filterObj && tabData.filterObj.donorType && tabData.filterObj.donorType.value ? tabData.filterObj.donorType.value : "",
        fundStream = tabData.filterObj && tabData.filterObj.fundStream && tabData.filterObj.fundStream.value ? tabData.filterObj.fundStream.value : "";

    if (tabData.filterObj === undefined || filterObj.year !== year || filterObj.donorType.value !== donorType || filterObj.fundStream.value !== fundStream) {
      var fundType = filterObj.fundType === null ? tabSelected : filterObj.fundType;

      if (filterObj.year != null) {
        dispatch(donorDataFetchStart());
        dispatch(dataFetchStart(tabSelected));

        return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_DONOR_DATA + "?year=" + filterObj.year + "&fund_type=" + fundType + "&donor_type=" + filterObj.donorType.value + "&fund_stream=" + filterObj.fundStream.value).then(function (resp) {
          if (resp.success && resp.data) {
            dispatch(donorDataFetchEnd(tabSelected));

            var newData = parseDonorData(resp.data, filterObj, tabSelected);
            dispatch(updateTabData(newData, tabSelected));
            dispatch(donorDataFetchSuccess(newData));
            dispatch(dataFetchEnd(tabSelected));
          } else {
            dispatch(donorDataFetchEnd());
            dispatch(dataFetchEnd(tabSelected));
          }
        }).catch(function (exception) {
          dispatch(donorDataFetchEnd());
          dispatch(dataFetchEnd(tabSelected));
          dispatch(donorDataFetchFailed());
        });
      }
    } else {
      dispatch(donorDataFetchSuccess(tabData));
    }
  };
};

var parseDonorData = function parseDonorData(dataArray, filterObj, tabSelected) {
  var newObj = _extends({}, dataArray, {
    data: {
      country: []
    },
    key: [],
    filterObj: filterObj
  });

  if (filterObj.fundType === TAB_TOTAL || tabSelected === TAB_TOTAL) {
    var HighestValue = __WEBPACK_IMPORTED_MODULE_3_d3___default.a.max([].concat(dataArray.contributions), function (d) {
      return d.total_contribution;
    });
    if (dataArray.contributions.length) {
      newObj.data.country = dataArray.contributions.map(function (item) {
        var regular_contribution = item.regular_contribution,
            country = item.country,
            other_contribution = item.other_contribution,
            total_contribution = item.total_contribution;

        return {
          name: item.country ? item.country : "",
          donor_code: item.country_iso3 ? item.country_iso3 : "",
          contribution: item.total_contribution ? item.total_contribution : 0,
          regular: regular_contribution && regular_contribution.amount ? regular_contribution.amount : 0,
          other: other_contribution && other_contribution.amount ? other_contribution.amount : 0,
          perc: HighestValue === 0 ? 0 : item.total_contribution / HighestValue * 100
        };
      });
    }

    newObj.data.key = ["regular", "other"];
  } else if (filterObj.fundType === TAB_REGULAR || tabSelected === TAB_REGULAR) {
    var _HighestValue = __WEBPACK_IMPORTED_MODULE_3_d3___default.a.max([].concat(dataArray.contributions), function (d) {
      return d.regular_contribution.amount;
    });

    if (dataArray.contributions.length) {
      newObj.data.country = dataArray.contributions.map(function (item) {
        var regular_contribution = item.regular_contribution,
            country = item.country,
            other_contribution = item.other_contribution;

        return {
          name: item.country ? item.country : "",
          donor_code: item.country_iso3 ? item.country_iso3 : "",
          contribution: regular_contribution && regular_contribution.amount ? regular_contribution.amount : 0,
          regular: regular_contribution && regular_contribution.amount ? regular_contribution.amount : 0,
          other: 0,
          perc: _HighestValue == 0 ? 0 : regular_contribution.amount / _HighestValue * 100
        };
      });
    }

    newObj.data.key = ["regular", "other"];
  } else if (filterObj.fundType === TAB_OTHER || tabSelected === TAB_OTHER) {
    var _HighestValue2 = __WEBPACK_IMPORTED_MODULE_3_d3___default.a.max([].concat(dataArray.contributions), function (d) {
      return d.other_contribution.amount;
    });

    if (dataArray.contributions.length) {
      newObj.data.country = dataArray.contributions.map(function (item) {
        var regular_contribution = item.regular_contribution,
            country = item.country,
            other_contribution = item.other_contribution;

        return {
          name: item.country ? item.country : "",
          donor_code: item.country_iso3 ? item.country_iso3 : "",
          contribution: other_contribution && other_contribution.amount ? other_contribution.amount : 0,
          regular: 0,
          other: other_contribution && other_contribution.amount ? other_contribution.amount : 0,
          perc: _HighestValue2 == 0 ? 0 : other_contribution.amount / _HighestValue2 * 100
        };
      });
    }

    newObj.data.key = ["other", "regular"];
  }
  return newObj;
};

//Donor types

var DONOR_TYPES = {
  start: "fetch_start/donor_types",
  end: "fetch_end/donor_types",
  success: "fetch_success/donor_types",
  failed: "fetch_failed/donor_types"
};

var donorTypesFetchStart = function donorTypesFetchStart() {
  return {
    type: DONOR_TYPES.start
  };
};

var donorTypesFetchEnd = function donorTypesFetchEnd() {
  return {
    type: DONOR_TYPES.end
  };
};

var donorTypesFetchSuccess = function donorTypesFetchSuccess(data) {
  return {
    type: DONOR_TYPES.success,
    data: data
  };
};

var donorTypesFetchFailed = function donorTypesFetchFailed(error) {
  return {
    type: DONOR_TYPES.failed,
    error: error
  };
};

var parseDonorTypesFetchData = function parseDonorTypesFetchData(data) {
  if (data.length !== 0) {
    data.forEach(function (item) {
      item.label = item.value;
      item.value = item.code;
    });
  }
};

var donorTypesFetchData = function donorTypesFetchData() {
  return function (dispatch) {
    dispatch(donorTypesFetchStart());
    dispatch(donorTypesFetchEnd());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get("" + __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_DONOR_TYPES).then(function (resp) {
      if (resp.success && resp.data) {
        dispatch(donorTypesFetchEnd());
        parseDonorTypesFetchData(resp.data);
        dispatch(donorTypesFetchSuccess(resp.data));
      } else {
        dispatch(donorTypesFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(donorTypesFetchEnd());
      dispatch(donorTypesFetchFailed());
    });
  };
};

//API_FUND_STREAMS

var FUND_STREAMS = {
  start: "fetch_start/fund_streams",
  end: "fetch_end/fund_streams",
  success: "fetch_success/fund_streams",
  failed: "fetch_failed/fund_streams"
};

var fundStreamsFetchStart = function fundStreamsFetchStart() {
  return {
    type: FUND_STREAMS.start
  };
};

var fundStreamsFetchEnd = function fundStreamsFetchEnd() {
  return {
    type: FUND_STREAMS.end
  };
};

var fundStreamsFetchSuccess = function fundStreamsFetchSuccess(data) {
  return {
    type: FUND_STREAMS.success,
    data: data
  };
};

var fundStreamsFetchFailed = function fundStreamsFetchFailed(error) {
  return {
    type: FUND_STREAMS.failed,
    error: error
  };
};

var parsefundStreamsFetchData = function parsefundStreamsFetchData(data) {
  if (data.length !== 0) {
    data.forEach(function (item) {
      item.label = item.value;
    });
  }
};

var fundStreamsFetchData = function fundStreamsFetchData() {
  return function (dispatch) {
    dispatch(fundStreamsFetchStart());
    dispatch(fundStreamsFetchEnd());
    return __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].get("" + __WEBPACK_IMPORTED_MODULE_0__src_lib_api__["a" /* default */].API_FUND_STREAMS).then(function (resp) {
      if (resp.success && resp.data) {
        dispatch(fundStreamsFetchEnd());
        parsefundStreamsFetchData(resp.data);
        dispatch(fundStreamsFetchSuccess(resp.data));
      } else {
        dispatch(fundStreamsFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(fundStreamsFetchEnd());
      dispatch(fundStreamsFetchFailed());
    });
  };
};

/***/ }),

/***/ "fpuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/isPlainObject.js
var isPlainObject = __webpack_require__("9TS5");

// EXTERNAL MODULE: ../node_modules/symbol-observable/es/index.js
var es = __webpack_require__("LkZ7");

// CONCATENATED MODULE: ../node_modules/redux/es/createStore.js



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(isPlainObject["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[es["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[es["a" /* default */]] = observable, _ref2;
}
// CONCATENATED MODULE: ../node_modules/redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning_warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ../node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(isPlainObject["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
// CONCATENATED MODULE: ../node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}
// CONCATENATED MODULE: ../node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return createStore_createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return compose; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),

/***/ "g+aD":
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

/***/ }),

/***/ "gaAf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECIPIENT_THEME_AGGREGATE; });
/* unused harmony export RecipientThemeFetchStart */
/* unused harmony export RecipientThemeFetchEnd */
/* unused harmony export RecipientThemeFetchSuccess */
/* unused harmony export RecipientThemeFetchFailed */
/* unused harmony export filterZero */
/* unused harmony export updateRecipientThemeAggregate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadRecipientTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__ = __webpack_require__("Cdrj");



var RECIPIENT_THEME = {
  start: "fetch_start/recipient_theme",
  end: "fetch_end/recipient_theme",
  success: "fetch_success/recipient_theme",
  failed: "fetch_failed/recipient_theme"
};

var RECIPIENT_THEME_AGGREGATE = "RECIPIENT_THEME_AGGREGATE";

var RecipientThemeFetchStart = function RecipientThemeFetchStart() {
  return {
    type: RECIPIENT_THEME.start
  };
};

var RecipientThemeFetchEnd = function RecipientThemeFetchEnd() {
  return {
    type: RECIPIENT_THEME.end
  };
};

var RecipientThemeFetchSuccess = function RecipientThemeFetchSuccess(data) {
  return {
    type: RECIPIENT_THEME.success,
    data: data
  };
};

var RecipientThemeFetchFailed = function RecipientThemeFetchFailed(error) {
  return {
    type: RECIPIENT_THEME.failed,
    error: error
  };
};

var filterZero = function filterZero(data) {
  return data.filter(function (item) {
    if (item.percentage && item.percentage != 0 && item.theme_budget && item.theme_budget != 0) {
      return true;
    } else {
      return false;
    }
  });
};

var updateRecipientThemeAggregate = function updateRecipientThemeAggregate(themeAggregate) {
  return {
    type: RECIPIENT_THEME_AGGREGATE,
    themeAggregate: themeAggregate
  };
};

var loadRecipientTheme = function loadRecipientTheme(code, year) {
  return function (dispatch) {
    dispatch(RecipientThemeFetchStart());
    if (year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_COUNTRY_THEME(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(RecipientThemeFetchEnd());
          if (resp.data.length) {
            var themeAggregate = Object(__WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__["c" /* aggregateCalculator */])(resp.data, "theme_budget");
            dispatch(updateRecipientThemeAggregate(themeAggregate));
          }

          var filteredArray = filterZero(resp.data);
          dispatch(RecipientThemeFetchSuccess(filteredArray));
        } else {
          dispatch(RecipientThemeFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(RecipientThemeFetchEnd());
        dispatch(RecipientThemeFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "i/J7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "lwp9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HOME_MAP_SUMMARY_DATA; });
/* unused harmony export homeMapSummaryDataFetchStart */
/* unused harmony export homeMapSummaryDataFetchEnd */
/* unused harmony export homeMapSummaryDataFetchSuccess */
/* unused harmony export homeMapSummaryDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHomeMapSummaryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var HOME_MAP_SUMMARY_DATA = {
  start: "fetch_start/home_map_summary_data",
  end: "fetch_end/home_map_summary_data",
  success: "fetch_success/home_map_summary_data",
  failed: "fetch_failed/home_map_summary_data"
};

var homeMapSummaryDataFetchStart = function homeMapSummaryDataFetchStart() {
  return {
    type: HOME_MAP_SUMMARY_DATA.start
  };
};

var homeMapSummaryDataFetchEnd = function homeMapSummaryDataFetchEnd() {
  return {
    type: HOME_MAP_SUMMARY_DATA.end
  };
};

var homeMapSummaryDataFetchSuccess = function homeMapSummaryDataFetchSuccess(data) {
  return {
    type: HOME_MAP_SUMMARY_DATA.success,
    data: data
  };
};

var homeMapSummaryDataFetchFailed = function homeMapSummaryDataFetchFailed(error) {
  return {
    type: HOME_MAP_SUMMARY_DATA.failed,
    error: error
  };
};

var getHomeMapSummaryData = function getHomeMapSummaryData(year, field, donor, vocabulary) {
  return function (dispatch) {
    dispatch(homeMapSummaryDataFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_HOME_MAP_SUMMARY_DATA(year, field, donor, vocabulary)).then(function (response) {
        dispatch(homeMapSummaryDataFetchEnd());
        dispatch(homeMapSummaryDataFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(homeMapSummaryDataFetchEnd());
        dispatch(homeMapSummaryDataFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "mFZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_OUTPUT_DETAIL; });
/* unused harmony export projectOutputDetailFetchStart */
/* unused harmony export projectOutputDetailFetchEnd */
/* unused harmony export projectOutputDetailFetchSuccess */
/* unused harmony export projectOutputDetailFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectOutputDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Output Details //////////////////////////

var PROJECT_OUTPUT_DETAIL = {
  start: "fetch_start/project_output_detail",
  end: "fetch_end/project_output_detail",
  success: "fetch_success/project_output_detail",
  failed: "fetch_failed/project_output_detail"
};
var projectOutputDetailFetchStart = function projectOutputDetailFetchStart() {
  return {
    type: PROJECT_OUTPUT_DETAIL.start
  };
};

var projectOutputDetailFetchEnd = function projectOutputDetailFetchEnd() {
  return {
    type: PROJECT_OUTPUT_DETAIL.end
  };
};

var projectOutputDetailFetchSuccess = function projectOutputDetailFetchSuccess(data, index) {
  return {
    type: PROJECT_OUTPUT_DETAIL.success,
    data: data,
    index: index
  };
};

var projectOutputDetailFetchFailed = function projectOutputDetailFetchFailed(error) {
  return {
    type: PROJECT_OUTPUT_DETAIL.failed,
    error: error
  };
};

var fetchProjectOutputDetail = function fetchProjectOutputDetail(id, index) {
  return function (dispatch, getState) {
    dispatch(projectOutputDetailFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_OUTPUT_DETAIL(id)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(projectOutputDetailFetchEnd());
        dispatch(projectOutputDetailFetchSuccess(resp.data, index));
      } else {
        dispatch(projectOutputDetailFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectOutputDetailFetchEnd());
      dispatch(projectOutputDetailFetchFailed());
    });
  };
};

/***/ }),

/***/ "nq70":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
  var keys = Object.keys(obj);
  var descriptors = {};
  for (var i = 0; i < keys.length; i++) {
    descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
  }
  return descriptors;
};

var formatRegExp = /%[sdj%]/g;
exports.format = function (f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function (x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s':
        return String(args[i++]);
      case '%d':
        return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};

// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function (fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function () {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};

var debugs = {};
var debugEnviron;
exports.debuglog = function (set) {
  if (isUndefined(debugEnviron)) debugEnviron = Object({"PREACT_APP_API_URL":"https://open.unrwa.org/"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function () {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function () {};
    }
  }
  return debugs[set];
};

/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;

// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold': [1, 22],
  'italic': [3, 23],
  'underline': [4, 24],
  'inverse': [7, 27],
  'white': [37, 39],
  'grey': [90, 39],
  'black': [30, 39],
  'blue': [34, 39],
  'cyan': [36, 39],
  'green': [32, 39],
  'magenta': [35, 39],
  'red': [31, 39],
  'yellow': [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};

function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\x1B[' + inspect.colors[style][0] + 'm' + str + '\x1B[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}

function stylizeNoColor(str, styleType) {
  return str;
}

function arrayToHash(array) {
  var hash = {};

  array.forEach(function (val, idx) {
    hash[val] = true;
  });

  return hash;
}

function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect && value && isFunction(value.inspect) &&
  // Filter out the util module, it's inspect function is special
  value.inspect !== exports.inspect &&
  // Also filter out any prototype objects using the circular check.
  !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '',
      array = false,
      braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function (key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}

function formatPrimitive(ctx, value) {
  if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value)) return ctx.stylize('' + value, 'number');
  if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value)) return ctx.stylize('null', 'null');
}

function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}

function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function (key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    }
  });
  return output;
}

function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function (line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function (line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}

function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function (prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
  typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("g+aD");

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}

var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}

// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function () {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__("3UWZ");

exports._extend = function (origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
};

exports.promisify.custom = kCustomPromisifiedSymbol;

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function cb() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args).then(function (ret) {
      process.nextTick(cb, null, ret);
    }, function (rej) {
      process.nextTick(callbackifyOnRejected, rej, cb);
    });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/***/ }),

/***/ "pfIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITY_DETAILS; });
/* unused harmony export activityDetailsFetchStart */
/* unused harmony export activityDetailsFetchEnd */
/* unused harmony export activityDetailsFetchSuccess */
/* unused harmony export activityDetailsFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateActivityDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var ACTIVITY_DETAILS = {
  start: "fetch_start/activity_details",
  end: "fetch_end/activity_details",
  success: "fetch_success/activity_details",
  failed: "fetch_failed/activity_details"
};

var activityDetailsFetchStart = function activityDetailsFetchStart() {
  return {
    type: ACTIVITY_DETAILS.start
  };
};

var activityDetailsFetchEnd = function activityDetailsFetchEnd() {
  return {
    type: ACTIVITY_DETAILS.end
  };
};

var activityDetailsFetchSuccess = function activityDetailsFetchSuccess(data) {
  return {
    type: ACTIVITY_DETAILS.success,
    data: data
  };
};

var activityDetailsFetchFailed = function activityDetailsFetchFailed(error) {
  return {
    type: ACTIVITY_DETAILS.failed,
    error: error
  };
};

var updateActivityDetails = function updateActivityDetails(identifier) {
  return function (dispatch) {
    dispatch(activityDetailsFetchStart());
    if (identifier !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_ACTIVITY_DETAILS(identifier)).then(function (response) {
        dispatch(activityDetailsFetchEnd());
        dispatch(activityDetailsFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(activityDetailsFetchEnd());
        dispatch(activityDetailsFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "pv+l":
/***/ (function(module, exports) {

module.exports = function (originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "qYVk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SECTOR_DATA; });
/* unused harmony export fetchSectorDataStart */
/* unused harmony export fetchSectorDataEnd */
/* unused harmony export fetchSectorDataReset */
/* unused harmony export fetchSectorDataSuccess */
/* unused harmony export fetchSectorDataError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSectorData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var SECTOR_DATA = {
  start: "fetch_start/sdg_sunburst_data",
  end: "fetch_end/sdg_sunburst_data",
  success: "fetch_success/sdg_sunburst_data",
  failed: "fetch_failed/sdg_sunburst_data",
  clear: "clear/sdg_sunburst_data"
};

var fetchSectorDataStart = function fetchSectorDataStart() {
  return {
    type: SECTOR_DATA.start
  };
};

var fetchSectorDataEnd = function fetchSectorDataEnd() {
  return {
    type: SECTOR_DATA.end
  };
};

var fetchSectorDataReset = function fetchSectorDataReset() {
  return {
    type: SECTOR_DATA.clear
  };
};

var fetchSectorDataSuccess = function fetchSectorDataSuccess(data) {
  return {
    type: SECTOR_DATA.success,
    data: data
  };
};

var fetchSectorDataError = function fetchSectorDataError(error) {
  return {
    type: SECTOR_DATA.failed,
    error: error
  };
};

var fetchSectorData = function fetchSectorData(vocabulary, year) {
  return function (dispatch) {
    dispatch(fetchSectorDataStart());
    if (year !== "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_SECTOR_DATA(vocabulary, year)).then(function (response) {
        if (response.success && response.data) {
          var result = response.data.sectors.map(function (item) {
            return _extends({}, item, {
              image: "/static/assets/icons/sdg/SDG-" + item.code + ".svg"
            });
          });
          dispatch(fetchSectorDataEnd());
          dispatch(fetchSectorDataSuccess(result));
        } else {
          dispatch(fetchSectorDataEnd());
        }
      }).catch(function (exception) {
        dispatch(fetchSectorDataEnd());
        dispatch(fetchSectorDataError(exception));
      });
    } else {
      dispatch(fetchSectorDataReset());
      dispatch(fetchSectorDataEnd());
    }
  };
};

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rw4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_END_YEAR; });
/* unused harmony export setEndYear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateEndYear; });
var SET_END_YEAR = "SET_END_YEAR";

function setEndYear(startYear, endYear) {
  return {
    type: SET_END_YEAR,
    startYear: startYear,
    endYear: endYear
  };
}

var updateEndYear = function updateEndYear(startYear, endYear) {
  return function (dispatch, getState) {
    dispatch(setEndYear(startYear, endYear));
  };
};

/***/ }),

/***/ "sD71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_GALLERY; });
/* unused harmony export projectGalleryFetchStart */
/* unused harmony export projectGalleryFetchEnd */
/* unused harmony export projectGalleryFetchSuccess */
/* unused harmony export projectGalleryFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return projectGallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PictureGallery_style__ = __webpack_require__("CeE8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PictureGallery_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PictureGallery_style__);
/************************* Lib Files ************************/


/************************* Style Files ************************/

var PROJECT_GALLERY = {
  start: "fetch_start/project_gallery",
  end: "fetch_end/project_gallery",
  success: "fetch_success/project_gallery",
  failed: "fetch_failed/project_gallery"
};

var projectGalleryFetchStart = function projectGalleryFetchStart() {
  return {
    type: PROJECT_GALLERY.start
  };
};

var projectGalleryFetchEnd = function projectGalleryFetchEnd() {
  return {
    type: PROJECT_GALLERY.end
  };
};

var projectGalleryFetchSuccess = function projectGalleryFetchSuccess(pictureList) {
  return {
    type: PROJECT_GALLERY.success,
    pictureList: pictureList
  };
};

var projectGalleryFetchFailed = function projectGalleryFetchFailed(error) {
  return {
    type: PROJECT_GALLERY.failed,
    error: error
  };
};

var parseList = function parseList(dataList) {
  var itemList = dataList.map(function (item, index) {
    item.original = item.document_url;
    item.thumbnail = item.document_url;
    item.originalClass = __WEBPACK_IMPORTED_MODULE_1__components_PictureGallery_style___default.a.image_sizewrapper;
    return item;
  });
  return itemList;
};

var projectGallery = function projectGallery(project_id) {
  return function (dispatch) {
    dispatch(projectGalleryFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_DETAIL_GALLERY(project_id)).then(function (resp) {
      if (resp.success) {
        dispatch(projectGalleryFetchEnd());
        var parsedDataList = parseList(resp.data.data);
        dispatch(projectGalleryFetchSuccess(parsedDataList));
      } else {
        dispatch(projectGalleryFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectGalleryFetchEnd());
      dispatch(projectGalleryFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "sVsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_PROFILE_MAP_DATA; });
/* unused harmony export mapDataFetchStart */
/* unused harmony export mapDataFetchEnd */
/* unused harmony export mapDataFetchSuccess */
/* unused harmony export mapDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadDonorProfileMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/


var DONOR_PROFILE_MAP_DATA = {
  start: "fetch_start/donor_profile_map_data",
  end: "fetch_end/donor_profile_map_data",
  success: "fetch_success/donor_profile_map_data",
  failed: "fetch_failed/donor_profile_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: DONOR_PROFILE_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: DONOR_PROFILE_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data) {
  return {
    type: DONOR_PROFILE_MAP_DATA.success,
    data: data
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: DONOR_PROFILE_MAP_DATA.failed,
    error: error
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var loadDonorProfileMapData = function loadDonorProfileMapData(year, unit, budgetType) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    unit = unit ? unit : "";
    budgetType = budgetType ? budgetType : "";
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_DONOR(year, unit, budgetType)).then(function (resp) {
      return mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "svpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__("Oi8n");

// CONCATENATED MODULE: ../node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol["a" /* default */] ? _Symbol["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);
// CONCATENATED MODULE: ../node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);
// CONCATENATED MODULE: ../node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol["a" /* default */] ? _Symbol["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return _baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = __webpack_exports__["a"] = (baseGetTag);

/***/ }),

/***/ "t4UN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THEMES_MAP_DATA; });
/* unused harmony export mapDataFetchStart */
/* unused harmony export mapDataFetchEnd */
/* unused harmony export mapDataFetchSuccess */
/* unused harmony export mapDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadThemesMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/


var THEMES_MAP_DATA = {
  start: "fetch_start/themes_map_data",
  end: "fetch_end/themes_map_data",
  success: "fetch_success/themes_map_data",
  failed: "fetch_failed/themes_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: THEMES_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: THEMES_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data) {
  return {
    type: THEMES_MAP_DATA.success,
    data: data
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: THEMES_MAP_DATA.failed,
    error: error
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var loadThemesMapData = function loadThemesMapData(year, sector, unit, source, signatureSolution) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    unit = unit ? unit : "";
    source = source ? source : "";
    sector = sector && sector !== -1 ? sector : "";
    signatureSolution = signatureSolution ? signatureSolution : "";
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_THEMES(year, sector, unit, source, signatureSolution)).then(function (resp) {
      return mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "t7ns":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_MAP_DATA; });
/* unused harmony export activitiesMapDataFetchStart */
/* unused harmony export activitiesMapDataFetchEnd */
/* unused harmony export activitiesMapDataFetchSuccess */
/* unused harmony export activitiesMapDataFetchFailed */
/* unused harmony export activitiesMapDataReset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActivitiesMapData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetActivitiesMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var ACTIVITIES_MAP_DATA = {
  start: "fetch_start/activities_map_data",
  end: "fetch_end/activities_map_data",
  success: "fetch_success/activities_map_data",
  failed: "fetch_failed/activities_map_data",
  reset: "reset/activities_map_data"
};

var activitiesMapDataFetchStart = function activitiesMapDataFetchStart() {
  return {
    type: ACTIVITIES_MAP_DATA.start
  };
};

var activitiesMapDataFetchEnd = function activitiesMapDataFetchEnd() {
  return {
    type: ACTIVITIES_MAP_DATA.end
  };
};

var activitiesMapDataFetchSuccess = function activitiesMapDataFetchSuccess(data) {
  return {
    type: ACTIVITIES_MAP_DATA.success,
    data: data
  };
};

var activitiesMapDataFetchFailed = function activitiesMapDataFetchFailed(error) {
  return {
    type: ACTIVITIES_MAP_DATA.failed,
    error: error
  };
};

var activitiesMapDataReset = function activitiesMapDataReset(data) {
  return {
    type: ACTIVITIES_MAP_DATA.success
  };
};

var getActivitiesMapData = function getActivitiesMapData(year, portal, field_of_operation, donor, oecd, sdg) {
  return function (dispatch) {
    dispatch(activitiesMapDataFetchStart());
    var filterYear = year || "";
    var filterPortal = portal || "";
    var filterField_of_operation = field_of_operation || "";
    var filterDonor = donor || "";
    var filterOecd = oecd || "";
    var filterSdg = sdg || "";
    if (year !== "") return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_ACTIVITIES_MAP_DATA(filterYear, filterPortal, filterField_of_operation, filterDonor, filterOecd, filterSdg)).then(function (response) {
      dispatch(activitiesMapDataFetchEnd());
      dispatch(activitiesMapDataFetchSuccess(response.data));
    }).catch(function (exception) {
      dispatch(activitiesMapDataFetchEnd());
      dispatch(activitiesMapDataFetchFailed(exception));
    });else {
      dispatch(activitiesMapDataFetchEnd());
      dispatch(activitiesMapDataFetchFailed());
    }
  };
};

var resetActivitiesMapData = function resetActivitiesMapData() {
  return function (dispatch) {
    dispatch(activitiesMapDataReset());
  };
};

/***/ }),

/***/ "tokj":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function () {
  var d3 = {
    version: "3.5.17"
  };
  var d3_arraySlice = [].slice,
      d3_array = function d3_array(list) {
    return d3_arraySlice.call(list);
  };
  var d3_document = this.document;
  function d3_documentElement(node) {
    return node && (node.ownerDocument || node.document || node).documentElement;
  }
  function d3_window(node) {
    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
  }
  if (d3_document) {
    try {
      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
      d3_array = function d3_array(list) {
        var i = list.length,
            array = new Array(i);
        while (i--) {
          array[i] = list[i];
        }return array;
      };
    }
  }
  if (!Date.now) Date.now = function () {
    return +new Date();
  };
  if (d3_document) {
    try {
      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
    } catch (error) {
      var d3_element_prototype = this.Element.prototype,
          d3_element_setAttribute = d3_element_prototype.setAttribute,
          d3_element_setAttributeNS = d3_element_prototype.setAttributeNS,
          d3_style_prototype = this.CSSStyleDeclaration.prototype,
          d3_style_setProperty = d3_style_prototype.setProperty;
      d3_element_prototype.setAttribute = function (name, value) {
        d3_element_setAttribute.call(this, name, value + "");
      };
      d3_element_prototype.setAttributeNS = function (space, local, value) {
        d3_element_setAttributeNS.call(this, space, local, value + "");
      };
      d3_style_prototype.setProperty = function (name, value, priority) {
        d3_style_setProperty.call(this, name, value + "", priority);
      };
    }
  }
  d3.ascending = d3_ascending;
  function d3_ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  d3.descending = function (a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  };
  d3.min = function (array, f) {
    var i = -1,
        n = array.length,
        a,
        b;
    if (arguments.length === 1) {
      while (++i < n) {
        if ((b = array[i]) != null && b >= b) {
          a = b;
          break;
        }
      }while (++i < n) {
        if ((b = array[i]) != null && a > b) a = b;
      }
    } else {
      while (++i < n) {
        if ((b = f.call(array, array[i], i)) != null && b >= b) {
          a = b;
          break;
        }
      }while (++i < n) {
        if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
      }
    }
    return a;
  };
  d3.max = function (array, f) {
    var i = -1,
        n = array.length,
        a,
        b;
    if (arguments.length === 1) {
      while (++i < n) {
        if ((b = array[i]) != null && b >= b) {
          a = b;
          break;
        }
      }while (++i < n) {
        if ((b = array[i]) != null && b > a) a = b;
      }
    } else {
      while (++i < n) {
        if ((b = f.call(array, array[i], i)) != null && b >= b) {
          a = b;
          break;
        }
      }while (++i < n) {
        if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
      }
    }
    return a;
  };
  d3.extent = function (array, f) {
    var i = -1,
        n = array.length,
        a,
        b,
        c;
    if (arguments.length === 1) {
      while (++i < n) {
        if ((b = array[i]) != null && b >= b) {
          a = c = b;
          break;
        }
      }while (++i < n) {
        if ((b = array[i]) != null) {
          if (a > b) a = b;
          if (c < b) c = b;
        }
      }
    } else {
      while (++i < n) {
        if ((b = f.call(array, array[i], i)) != null && b >= b) {
          a = c = b;
          break;
        }
      }while (++i < n) {
        if ((b = f.call(array, array[i], i)) != null) {
          if (a > b) a = b;
          if (c < b) c = b;
        }
      }
    }
    return [a, c];
  };
  function d3_number(x) {
    return x === null ? NaN : +x;
  }
  function d3_numeric(x) {
    return !isNaN(x);
  }
  d3.sum = function (array, f) {
    var s = 0,
        n = array.length,
        a,
        i = -1;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = +array[i])) s += a;
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
      }
    }
    return s;
  };
  d3.mean = function (array, f) {
    var s = 0,
        n = array.length,
        a,
        i = -1,
        j = n;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) s += a;else --j;
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a;else --j;
      }
    }
    if (j) return s / j;
  };
  d3.quantile = function (values, p) {
    var H = (values.length - 1) * p + 1,
        h = Math.floor(H),
        v = +values[h - 1],
        e = H - h;
    return e ? v + e * (values[h] - v) : v;
  };
  d3.median = function (array, f) {
    var numbers = [],
        n = array.length,
        a,
        i = -1;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
      }
    }
    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
  };
  d3.variance = function (array, f) {
    var n = array.length,
        m = 0,
        a,
        d,
        s = 0,
        i = -1,
        j = 0;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }
    if (j > 1) return s / (j - 1);
  };
  d3.deviation = function () {
    var v = d3.variance.apply(this, arguments);
    return v ? Math.sqrt(v) : v;
  };
  function d3_bisector(compare) {
    return {
      left: function left(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
        }
        return lo;
      },
      right: function right(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  var d3_bisect = d3_bisector(d3_ascending);
  d3.bisectLeft = d3_bisect.left;
  d3.bisect = d3.bisectRight = d3_bisect.right;
  d3.bisector = function (f) {
    return d3_bisector(f.length === 1 ? function (d, x) {
      return d3_ascending(f(d), x);
    } : f);
  };
  d3.shuffle = function (array, i0, i1) {
    if ((m = arguments.length) < 3) {
      i1 = array.length;
      if (m < 2) i0 = 0;
    }
    var m = i1 - i0,
        t,
        i;
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
    }
    return array;
  };
  d3.permute = function (array, indexes) {
    var i = indexes.length,
        permutes = new Array(i);
    while (i--) {
      permutes[i] = array[indexes[i]];
    }return permutes;
  };
  d3.pairs = function (array) {
    var i = 0,
        n = array.length - 1,
        p0,
        p1 = array[0],
        pairs = new Array(n < 0 ? 0 : n);
    while (i < n) {
      pairs[i] = [p0 = p1, p1 = array[++i]];
    }return pairs;
  };
  d3.transpose = function (matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m;) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  };
  function d3_transposeLength(d) {
    return d.length;
  }
  d3.zip = function () {
    return d3.transpose(arguments);
  };
  d3.keys = function (map) {
    var keys = [];
    for (var key in map) {
      keys.push(key);
    }return keys;
  };
  d3.values = function (map) {
    var values = [];
    for (var key in map) {
      values.push(map[key]);
    }return values;
  };
  d3.entries = function (map) {
    var entries = [];
    for (var key in map) {
      entries.push({
        key: key,
        value: map[key]
      });
    }return entries;
  };
  d3.merge = function (arrays) {
    var n = arrays.length,
        m,
        i = -1,
        j = 0,
        merged,
        array;
    while (++i < n) {
      j += arrays[i].length;
    }merged = new Array(j);
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
    return merged;
  };
  var abs = Math.abs;
  d3.range = function (start, stop, step) {
    if (arguments.length < 3) {
      step = 1;
      if (arguments.length < 2) {
        stop = start;
        start = 0;
      }
    }
    if ((stop - start) / step === Infinity) throw new Error("infinite range");
    var range = [],
        k = d3_range_integerScale(abs(step)),
        i = -1,
        j;
    start *= k, stop *= k, step *= k;
    if (step < 0) while ((j = start + step * ++i) > stop) {
      range.push(j / k);
    } else while ((j = start + step * ++i) < stop) {
      range.push(j / k);
    }return range;
  };
  function d3_range_integerScale(x) {
    var k = 1;
    while (x * k % 1) {
      k *= 10;
    }return k;
  }
  function d3_class(ctor, properties) {
    for (var key in properties) {
      Object.defineProperty(ctor.prototype, key, {
        value: properties[key],
        enumerable: false
      });
    }
  }
  d3.map = function (object, f) {
    var map = new d3_Map();
    if (object instanceof d3_Map) {
      object.forEach(function (key, value) {
        map.set(key, value);
      });
    } else if (Array.isArray(object)) {
      var i = -1,
          n = object.length,
          o;
      if (arguments.length === 1) while (++i < n) {
        map.set(i, object[i]);
      } else while (++i < n) {
        map.set(f.call(object, o = object[i], i), o);
      }
    } else {
      for (var key in object) {
        map.set(key, object[key]);
      }
    }
    return map;
  };
  function d3_Map() {
    this._ = Object.create(null);
  }
  var d3_map_proto = "__proto__",
      d3_map_zero = "\x00";
  d3_class(d3_Map, {
    has: d3_map_has,
    get: function get(key) {
      return this._[d3_map_escape(key)];
    },
    set: function set(key, value) {
      return this._[d3_map_escape(key)] = value;
    },
    remove: d3_map_remove,
    keys: d3_map_keys,
    values: function values() {
      var values = [];
      for (var key in this._) {
        values.push(this._[key]);
      }return values;
    },
    entries: function entries() {
      var entries = [];
      for (var key in this._) {
        entries.push({
          key: d3_map_unescape(key),
          value: this._[key]
        });
      }return entries;
    },
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function forEach(f) {
      for (var key in this._) {
        f.call(this, d3_map_unescape(key), this._[key]);
      }
    }
  });
  function d3_map_escape(key) {
    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
  }
  function d3_map_unescape(key) {
    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
  }
  function d3_map_has(key) {
    return d3_map_escape(key) in this._;
  }
  function d3_map_remove(key) {
    return (key = d3_map_escape(key)) in this._ && delete this._[key];
  }
  function d3_map_keys() {
    var keys = [];
    for (var key in this._) {
      keys.push(d3_map_unescape(key));
    }return keys;
  }
  function d3_map_size() {
    var size = 0;
    for (var key in this._) {
      ++size;
    }return size;
  }
  function d3_map_empty() {
    for (var key in this._) {
      return false;
    }return true;
  }
  d3.nest = function () {
    var nest = {},
        keys = [],
        sortKeys = [],
        sortValues,
        rollup;
    function map(mapType, array, depth) {
      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
      var i = -1,
          n = array.length,
          key = keys[depth++],
          keyValue,
          object,
          setter,
          valuesByKey = new d3_Map(),
          values;
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
          values.push(object);
        } else {
          valuesByKey.set(keyValue, [object]);
        }
      }
      if (mapType) {
        object = mapType();
        setter = function setter(keyValue, values) {
          object.set(keyValue, map(mapType, values, depth));
        };
      } else {
        object = {};
        setter = function setter(keyValue, values) {
          object[keyValue] = map(mapType, values, depth);
        };
      }
      valuesByKey.forEach(setter);
      return object;
    }
    function entries(map, depth) {
      if (depth >= keys.length) return map;
      var array = [],
          sortKey = sortKeys[depth++];
      map.forEach(function (key, keyMap) {
        array.push({
          key: key,
          values: entries(keyMap, depth)
        });
      });
      return sortKey ? array.sort(function (a, b) {
        return sortKey(a.key, b.key);
      }) : array;
    }
    nest.map = function (array, mapType) {
      return map(mapType, array, 0);
    };
    nest.entries = function (array) {
      return entries(map(d3.map, array, 0), 0);
    };
    nest.key = function (d) {
      keys.push(d);
      return nest;
    };
    nest.sortKeys = function (order) {
      sortKeys[keys.length - 1] = order;
      return nest;
    };
    nest.sortValues = function (order) {
      sortValues = order;
      return nest;
    };
    nest.rollup = function (f) {
      rollup = f;
      return nest;
    };
    return nest;
  };
  d3.set = function (array) {
    var set = new d3_Set();
    if (array) for (var i = 0, n = array.length; i < n; ++i) {
      set.add(array[i]);
    }return set;
  };
  function d3_Set() {
    this._ = Object.create(null);
  }
  d3_class(d3_Set, {
    has: d3_map_has,
    add: function add(key) {
      this._[d3_map_escape(key += "")] = true;
      return key;
    },
    remove: d3_map_remove,
    values: d3_map_keys,
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function forEach(f) {
      for (var key in this._) {
        f.call(this, d3_map_unescape(key));
      }
    }
  });
  d3.behavior = {};
  function d3_identity(d) {
    return d;
  }
  d3.rebind = function (target, source) {
    var i = 1,
        n = arguments.length,
        method;
    while (++i < n) {
      target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    }return target;
  };
  function d3_rebind(target, source, method) {
    return function () {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  function d3_vendorSymbol(object, name) {
    if (name in object) return name;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
      var prefixName = d3_vendorPrefixes[i] + name;
      if (prefixName in object) return prefixName;
    }
  }
  var d3_vendorPrefixes = ["webkit", "ms", "moz", "Moz", "o", "O"];
  function d3_noop() {}
  d3.dispatch = function () {
    var dispatch = new d3_dispatch(),
        i = -1,
        n = arguments.length;
    while (++i < n) {
      dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    }return dispatch;
  };
  function d3_dispatch() {}
  d3_dispatch.prototype.on = function (type, listener) {
    var i = type.indexOf("."),
        name = "";
    if (i >= 0) {
      name = type.slice(i + 1);
      type = type.slice(0, i);
    }
    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
    if (arguments.length === 2) {
      if (listener == null) for (type in this) {
        if (this.hasOwnProperty(type)) this[type].on(name, null);
      }
      return this;
    }
  };
  function d3_dispatch_event(dispatch) {
    var listeners = [],
        listenerByName = new d3_Map();
    function event() {
      var z = listeners,
          i = -1,
          n = z.length,
          l;
      while (++i < n) {
        if (l = z[i].on) l.apply(this, arguments);
      }return dispatch;
    }
    event.on = function (name, listener) {
      var l = listenerByName.get(name),
          i;
      if (arguments.length < 2) return l && l.on;
      if (l) {
        l.on = null;
        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
        listenerByName.remove(name);
      }
      if (listener) listeners.push(listenerByName.set(name, {
        on: listener
      }));
      return dispatch;
    };
    return event;
  }
  d3.event = null;
  function d3_eventPreventDefault() {
    d3.event.preventDefault();
  }
  function d3_eventSource() {
    var e = d3.event,
        s;
    while (s = e.sourceEvent) {
      e = s;
    }return e;
  }
  function d3_eventDispatch(target) {
    var dispatch = new d3_dispatch(),
        i = 0,
        n = arguments.length;
    while (++i < n) {
      dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    }dispatch.of = function (thiz, argumentz) {
      return function (e1) {
        try {
          var e0 = e1.sourceEvent = d3.event;
          e1.target = target;
          d3.event = e1;
          dispatch[e1.type].apply(thiz, argumentz);
        } finally {
          d3.event = e0;
        }
      };
    };
    return dispatch;
  }
  d3.requote = function (s) {
    return s.replace(d3_requote_re, "\\$&");
  };
  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var d3_subclass = {}.__proto__ ? function (object, prototype) {
    object.__proto__ = prototype;
  } : function (object, prototype) {
    for (var property in prototype) {
      object[property] = prototype[property];
    }
  };
  function d3_selection(groups) {
    d3_subclass(groups, d3_selectionPrototype);
    return groups;
  }
  var d3_select = function d3_select(s, n) {
    return n.querySelector(s);
  },
      d3_selectAll = function d3_selectAll(s, n) {
    return n.querySelectorAll(s);
  },
      _d3_selectMatches = function d3_selectMatches(n, s) {
    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
    _d3_selectMatches = function d3_selectMatches(n, s) {
      return d3_selectMatcher.call(n, s);
    };
    return _d3_selectMatches(n, s);
  };
  if (typeof Sizzle === "function") {
    d3_select = function d3_select(s, n) {
      return Sizzle(s, n)[0] || null;
    };
    d3_selectAll = Sizzle;
    _d3_selectMatches = Sizzle.matchesSelector;
  }
  d3.selection = function () {
    return d3.select(d3_document.documentElement);
  };
  var d3_selectionPrototype = d3.selection.prototype = [];
  d3_selectionPrototype.select = function (selector) {
    var subgroups = [],
        subgroup,
        subnode,
        group,
        node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m;) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = -1, n = group.length; ++i < n;) {
        if (node = group[i]) {
          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selector(selector) {
    return typeof selector === "function" ? selector : function () {
      return d3_select(selector, this);
    };
  }
  d3_selectionPrototype.selectAll = function (selector) {
    var subgroups = [],
        subgroup,
        node;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m;) {
      for (var group = this[j], i = -1, n = group.length; ++i < n;) {
        if (node = group[i]) {
          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
          subgroup.parentNode = node;
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selectorAll(selector) {
    return typeof selector === "function" ? selector : function () {
      return d3_selectAll(selector, this);
    };
  }
  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
  var d3_nsPrefix = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: d3_nsXhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  d3.ns = {
    prefix: d3_nsPrefix,
    qualify: function qualify(name) {
      var i = name.indexOf(":"),
          prefix = name;
      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
      return d3_nsPrefix.hasOwnProperty(prefix) ? {
        space: d3_nsPrefix[prefix],
        local: name
      } : name;
    }
  };
  d3_selectionPrototype.attr = function (name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node();
        name = d3.ns.qualify(name);
        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
      }
      for (value in name) {
        this.each(d3_selection_attr(value, name[value]));
      }return this;
    }
    return this.each(d3_selection_attr(name, value));
  };
  function d3_selection_attr(name, value) {
    name = d3.ns.qualify(name);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrConstant() {
      this.setAttribute(name, value);
    }
    function attrConstantNS() {
      this.setAttributeNS(name.space, name.local, value);
    }
    function attrFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttribute(name);else this.setAttribute(name, x);
    }
    function attrFunctionNS() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttributeNS(name.space, name.local);else this.setAttributeNS(name.space, name.local, x);
    }
    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
  }
  function d3_collapse(s) {
    return s.trim().replace(/\s+/g, " ");
  }
  d3_selectionPrototype.classed = function (name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node(),
            n = (name = d3_selection_classes(name)).length,
            i = -1;
        if (value = node.classList) {
          while (++i < n) {
            if (!value.contains(name[i])) return false;
          }
        } else {
          value = node.getAttribute("class");
          while (++i < n) {
            if (!d3_selection_classedRe(name[i]).test(value)) return false;
          }
        }
        return true;
      }
      for (value in name) {
        this.each(d3_selection_classed(value, name[value]));
      }return this;
    }
    return this.each(d3_selection_classed(name, value));
  };
  function d3_selection_classedRe(name) {
    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
  }
  function d3_selection_classes(name) {
    return (name + "").trim().split(/^|\s+/);
  }
  function d3_selection_classed(name, value) {
    name = d3_selection_classes(name).map(d3_selection_classedName);
    var n = name.length;
    function classedConstant() {
      var i = -1;
      while (++i < n) {
        name[i](this, value);
      }
    }
    function classedFunction() {
      var i = -1,
          x = value.apply(this, arguments);
      while (++i < n) {
        name[i](this, x);
      }
    }
    return typeof value === "function" ? classedFunction : classedConstant;
  }
  function d3_selection_classedName(name) {
    var re = d3_selection_classedRe(name);
    return function (node, value) {
      if (c = node.classList) return value ? c.add(name) : c.remove(name);
      var c = node.getAttribute("class") || "";
      if (value) {
        re.lastIndex = 0;
        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
      } else {
        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
      }
    };
  }
  d3_selectionPrototype.style = function (name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) {
          this.each(d3_selection_style(priority, name[priority], value));
        }return this;
      }
      if (n < 2) {
        var node = this.node();
        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }
      priority = "";
    }
    return this.each(d3_selection_style(name, value, priority));
  };
  function d3_selection_style(name, value, priority) {
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleConstant() {
      this.style.setProperty(name, value, priority);
    }
    function styleFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.style.removeProperty(name);else this.style.setProperty(name, x, priority);
    }
    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
  }
  d3_selectionPrototype.property = function (name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") return this.node()[name];
      for (value in name) {
        this.each(d3_selection_property(value, name[value]));
      }return this;
    }
    return this.each(d3_selection_property(name, value));
  };
  function d3_selection_property(name, value) {
    function propertyNull() {
      delete this[name];
    }
    function propertyConstant() {
      this[name] = value;
    }
    function propertyFunction() {
      var x = value.apply(this, arguments);
      if (x == null) delete this[name];else this[name] = x;
    }
    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
  }
  d3_selectionPrototype.text = function (value) {
    return arguments.length ? this.each(typeof value === "function" ? function () {
      var v = value.apply(this, arguments);
      this.textContent = v == null ? "" : v;
    } : value == null ? function () {
      this.textContent = "";
    } : function () {
      this.textContent = value;
    }) : this.node().textContent;
  };
  d3_selectionPrototype.html = function (value) {
    return arguments.length ? this.each(typeof value === "function" ? function () {
      var v = value.apply(this, arguments);
      this.innerHTML = v == null ? "" : v;
    } : value == null ? function () {
      this.innerHTML = "";
    } : function () {
      this.innerHTML = value;
    }) : this.node().innerHTML;
  };
  d3_selectionPrototype.append = function (name) {
    name = d3_selection_creator(name);
    return this.select(function () {
      return this.appendChild(name.apply(this, arguments));
    });
  };
  function d3_selection_creator(name) {
    function create() {
      var document = this.ownerDocument,
          namespace = this.namespaceURI;
      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
    }
    function createNS() {
      return this.ownerDocument.createElementNS(name.space, name.local);
    }
    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
  }
  d3_selectionPrototype.insert = function (name, before) {
    name = d3_selection_creator(name);
    before = d3_selection_selector(before);
    return this.select(function () {
      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
    });
  };
  d3_selectionPrototype.remove = function () {
    return this.each(d3_selectionRemove);
  };
  function d3_selectionRemove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
  }
  d3_selectionPrototype.data = function (value, key) {
    var i = -1,
        n = this.length,
        group,
        node;
    if (!arguments.length) {
      value = new Array(n = (group = this[0]).length);
      while (++i < n) {
        if (node = group[i]) {
          value[i] = node.__data__;
        }
      }
      return value;
    }
    function bind(group, groupData) {
      var i,
          n = group.length,
          m = groupData.length,
          n0 = Math.min(n, m),
          updateNodes = new Array(m),
          enterNodes = new Array(m),
          exitNodes = new Array(n),
          node,
          nodeData;
      if (key) {
        var nodeByKeyValue = new d3_Map(),
            keyValues = new Array(n),
            keyValue;
        for (i = -1; ++i < n;) {
          if (node = group[i]) {
            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
              exitNodes[i] = node;
            } else {
              nodeByKeyValue.set(keyValue, node);
            }
            keyValues[i] = keyValue;
          }
        }
        for (i = -1; ++i < m;) {
          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          } else if (node !== true) {
            updateNodes[i] = node;
            node.__data__ = nodeData;
          }
          nodeByKeyValue.set(keyValue, true);
        }
        for (i = -1; ++i < n;) {
          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
            exitNodes[i] = group[i];
          }
        }
      } else {
        for (i = -1; ++i < n0;) {
          node = group[i];
          nodeData = groupData[i];
          if (node) {
            node.__data__ = nodeData;
            updateNodes[i] = node;
          } else {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          }
        }
        for (; i < m; ++i) {
          enterNodes[i] = d3_selection_dataNode(groupData[i]);
        }
        for (; i < n; ++i) {
          exitNodes[i] = group[i];
        }
      }
      enterNodes.update = updateNodes;
      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
      enter.push(enterNodes);
      update.push(updateNodes);
      exit.push(exitNodes);
    }
    var enter = d3_selection_enter([]),
        update = d3_selection([]),
        exit = d3_selection([]);
    if (typeof value === "function") {
      while (++i < n) {
        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
      }
    } else {
      while (++i < n) {
        bind(group = this[i], value);
      }
    }
    update.enter = function () {
      return enter;
    };
    update.exit = function () {
      return exit;
    };
    return update;
  };
  function d3_selection_dataNode(data) {
    return {
      __data__: data
    };
  }
  d3_selectionPrototype.datum = function (value) {
    return arguments.length ? this.property("__data__", value) : this.property("__data__");
  };
  d3_selectionPrototype.filter = function (filter) {
    var subgroups = [],
        subgroup,
        group,
        node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_filter(selector) {
    return function () {
      return _d3_selectMatches(this, selector);
    };
  }
  d3_selectionPrototype.order = function () {
    for (var j = -1, m = this.length; ++j < m;) {
      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
        if (node = group[i]) {
          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
          next = node;
        }
      }
    }
    return this;
  };
  d3_selectionPrototype.sort = function (comparator) {
    comparator = d3_selection_sortComparator.apply(this, arguments);
    for (var j = -1, m = this.length; ++j < m;) {
      this[j].sort(comparator);
    }return this.order();
  };
  function d3_selection_sortComparator(comparator) {
    if (!arguments.length) comparator = d3_ascending;
    return function (a, b) {
      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
    };
  }
  d3_selectionPrototype.each = function (callback) {
    return d3_selection_each(this, function (node, i, j) {
      callback.call(node, node.__data__, i, j);
    });
  };
  function d3_selection_each(groups, callback) {
    for (var j = 0, m = groups.length; j < m; j++) {
      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
        if (node = group[i]) callback(node, i, j);
      }
    }
    return groups;
  }
  d3_selectionPrototype.call = function (callback) {
    var args = d3_array(arguments);
    callback.apply(args[0] = this, args);
    return this;
  };
  d3_selectionPrototype.empty = function () {
    return !this.node();
  };
  d3_selectionPrototype.node = function () {
    for (var j = 0, m = this.length; j < m; j++) {
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        var node = group[i];
        if (node) return node;
      }
    }
    return null;
  };
  d3_selectionPrototype.size = function () {
    var n = 0;
    d3_selection_each(this, function () {
      ++n;
    });
    return n;
  };
  function d3_selection_enter(selection) {
    d3_subclass(selection, d3_selection_enterPrototype);
    return selection;
  }
  var d3_selection_enterPrototype = [];
  d3.selection.enter = d3_selection_enter;
  d3.selection.enter.prototype = d3_selection_enterPrototype;
  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
  d3_selection_enterPrototype.select = function (selector) {
    var subgroups = [],
        subgroup,
        subnode,
        upgroup,
        group,
        node;
    for (var j = -1, m = this.length; ++j < m;) {
      upgroup = (group = this[j]).update;
      subgroups.push(subgroup = []);
      subgroup.parentNode = group.parentNode;
      for (var i = -1, n = group.length; ++i < n;) {
        if (node = group[i]) {
          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
          subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  d3_selection_enterPrototype.insert = function (name, before) {
    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
    return d3_selectionPrototype.insert.call(this, name, before);
  };
  function d3_selection_enterInsertBefore(enter) {
    var i0, j0;
    return function (d, i, j) {
      var group = enter[j].update,
          n = group.length,
          node;
      if (j != j0) j0 = j, i0 = 0;
      if (i >= i0) i0 = i + 1;
      while (!(node = group[i0]) && ++i0 < n) {}
      return node;
    };
  }
  d3.select = function (node) {
    var group;
    if (typeof node === "string") {
      group = [d3_select(node, d3_document)];
      group.parentNode = d3_document.documentElement;
    } else {
      group = [node];
      group.parentNode = d3_documentElement(node);
    }
    return d3_selection([group]);
  };
  d3.selectAll = function (nodes) {
    var group;
    if (typeof nodes === "string") {
      group = d3_array(d3_selectAll(nodes, d3_document));
      group.parentNode = d3_document.documentElement;
    } else {
      group = d3_array(nodes);
      group.parentNode = null;
    }
    return d3_selection([group]);
  };
  d3_selectionPrototype.on = function (type, listener, capture) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof type !== "string") {
        if (n < 2) listener = false;
        for (capture in type) {
          this.each(d3_selection_on(capture, type[capture], listener));
        }return this;
      }
      if (n < 2) return (n = this.node()["__on" + type]) && n._;
      capture = false;
    }
    return this.each(d3_selection_on(type, listener, capture));
  };
  function d3_selection_on(type, listener, capture) {
    var name = "__on" + type,
        i = type.indexOf("."),
        wrap = d3_selection_onListener;
    if (i > 0) type = type.slice(0, i);
    var filter = d3_selection_onFilters.get(type);
    if (filter) type = filter, wrap = d3_selection_onFilter;
    function onRemove() {
      var l = this[name];
      if (l) {
        this.removeEventListener(type, l, l.$);
        delete this[name];
      }
    }
    function onAdd() {
      var l = wrap(listener, d3_array(arguments));
      onRemove.call(this);
      this.addEventListener(type, this[name] = l, l.$ = capture);
      l._ = listener;
    }
    function removeAll() {
      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"),
          match;
      for (var name in this) {
        if (match = name.match(re)) {
          var l = this[name];
          this.removeEventListener(match[1], l, l.$);
          delete this[name];
        }
      }
    }
    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
  }
  var d3_selection_onFilters = d3.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  if (d3_document) {
    d3_selection_onFilters.forEach(function (k) {
      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
  }
  function d3_selection_onListener(listener, argumentz) {
    return function (e) {
      var o = d3.event;
      d3.event = e;
      argumentz[0] = this.__data__;
      try {
        listener.apply(this, argumentz);
      } finally {
        d3.event = o;
      }
    };
  }
  function d3_selection_onFilter(listener, argumentz) {
    var l = d3_selection_onListener(listener, argumentz);
    return function (e) {
      var target = this,
          related = e.relatedTarget;
      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
        l.call(target, e);
      }
    };
  }
  var d3_event_dragSelect,
      d3_event_dragId = 0;
  function d3_event_dragSuppress(node) {
    var name = ".dragsuppress-" + ++d3_event_dragId,
        click = "click" + name,
        w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
    if (d3_event_dragSelect == null) {
      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
    }
    if (d3_event_dragSelect) {
      var style = d3_documentElement(node).style,
          select = style[d3_event_dragSelect];
      style[d3_event_dragSelect] = "none";
    }
    return function (suppressClick) {
      w.on(name, null);
      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
      if (suppressClick) {
        var off = function off() {
          w.on(click, null);
        };
        w.on(click, function () {
          d3_eventPreventDefault();
          off();
        }, true);
        setTimeout(off, 0);
      }
    };
  }
  d3.mouse = function (container) {
    return d3_mousePoint(container, d3_eventSource());
  };
  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
  function d3_mousePoint(container, e) {
    if (e.changedTouches) e = e.changedTouches[0];
    var svg = container.ownerSVGElement || container;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      if (d3_mouse_bug44083 < 0) {
        var window = d3_window(container);
        if (window.scrollX || window.scrollY) {
          svg = d3.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var ctm = svg[0][0].getScreenCTM();
          d3_mouse_bug44083 = !(ctm.f || ctm.e);
          svg.remove();
        }
      }
      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY;else point.x = e.clientX, point.y = e.clientY;
      point = point.matrixTransform(container.getScreenCTM().inverse());
      return [point.x, point.y];
    }
    var rect = container.getBoundingClientRect();
    return [e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop];
  }
  d3.touch = function (container, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
      if ((touch = touches[i]).identifier === identifier) {
        return d3_mousePoint(container, touch);
      }
    }
  };
  d3.behavior.drag = function () {
    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"),
        origin = null,
        mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"),
        touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
    function drag() {
      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
    }
    function dragstart(id, position, subject, move, end) {
      return function () {
        var that = this,
            target = d3.event.target.correspondingElement || d3.event.target,
            parent = that.parentNode,
            dispatch = event.of(that, arguments),
            dragged = 0,
            dragId = id(),
            dragName = ".drag" + (dragId == null ? "" : "-" + dragId),
            dragOffset,
            dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended),
            dragRestore = d3_event_dragSuppress(target),
            position0 = position(parent, dragId);
        if (origin) {
          dragOffset = origin.apply(that, arguments);
          dragOffset = [dragOffset.x - position0[0], dragOffset.y - position0[1]];
        } else {
          dragOffset = [0, 0];
        }
        dispatch({
          type: "dragstart"
        });
        function moved() {
          var position1 = position(parent, dragId),
              dx,
              dy;
          if (!position1) return;
          dx = position1[0] - position0[0];
          dy = position1[1] - position0[1];
          dragged |= dx | dy;
          position0 = position1;
          dispatch({
            type: "drag",
            x: position1[0] + dragOffset[0],
            y: position1[1] + dragOffset[1],
            dx: dx,
            dy: dy
          });
        }
        function ended() {
          if (!position(parent, dragId)) return;
          dragSubject.on(move + dragName, null).on(end + dragName, null);
          dragRestore(dragged);
          dispatch({
            type: "dragend"
          });
        }
      };
    }
    drag.origin = function (x) {
      if (!arguments.length) return origin;
      origin = x;
      return drag;
    };
    return d3.rebind(drag, event, "on");
  };
  function d3_behavior_dragTouchId() {
    return d3.event.changedTouches[0].identifier;
  }
  d3.touches = function (container, touches) {
    if (arguments.length < 2) touches = d3_eventSource().touches;
    return touches ? d3_array(touches).map(function (touch) {
      var point = d3_mousePoint(container, touch);
      point.identifier = touch.identifier;
      return point;
    }) : [];
  };
  var ε = 1e-6,
      ε2 = ε * ε,
      π = Math.PI,
      τ = 2 * π,
      τε = τ - ε,
      halfπ = π / 2,
      d3_radians = π / 180,
      d3_degrees = 180 / π;
  function d3_sgn(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }
  function d3_cross2d(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function d3_acos(x) {
    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
  }
  function d3_asin(x) {
    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
  }
  function d3_sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  function d3_cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  function d3_tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  function d3_haversin(x) {
    return (x = Math.sin(x / 2)) * x;
  }
  var ρ = Math.SQRT2,
      ρ2 = 2,
      ρ4 = 4;
  d3.interpolateZoom = function (p0, p1) {
    var ux0 = p0[0],
        uy0 = p0[1],
        w0 = p0[2],
        ux1 = p1[0],
        uy1 = p1[1],
        w1 = p1[2],
        dx = ux1 - ux0,
        dy = uy1 - uy0,
        d2 = dx * dx + dy * dy,
        i,
        S;
    if (d2 < ε2) {
      S = Math.log(w1 / w0) / ρ;
      i = function i(t) {
        return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S)];
      };
    } else {
      var d1 = Math.sqrt(d2),
          b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1),
          b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1),
          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / ρ;
      i = function i(t) {
        var s = t * S,
            coshr0 = d3_cosh(r0),
            u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
        return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0)];
      };
    }
    i.duration = S * 1e3;
    return i;
  };
  d3.behavior.zoom = function () {
    var view = {
      x: 0,
      y: 0,
      k: 1
    },
        translate0,
        center0,
        center,
        size = [960, 500],
        scaleExtent = d3_behavior_zoomInfinity,
        duration = 250,
        zooming = 0,
        mousedown = "mousedown.zoom",
        mousemove = "mousemove.zoom",
        mouseup = "mouseup.zoom",
        mousewheelTimer,
        touchstart = "touchstart.zoom",
        touchtime,
        event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"),
        x0,
        x1,
        y0,
        y1;
    if (!d3_behavior_zoomWheel) {
      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function d3_behavior_zoomDelta() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function d3_behavior_zoomDelta() {
        return d3.event.wheelDelta;
      }, "mousewheel") : (d3_behavior_zoomDelta = function d3_behavior_zoomDelta() {
        return -d3.event.detail;
      }, "MozMousePixelScroll");
    }
    function zoom(g) {
      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
    }
    zoom.event = function (g) {
      g.each(function () {
        var dispatch = event.of(this, arguments),
            view1 = view;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.zoom", function () {
            view = this.__chart__ || {
              x: 0,
              y: 0,
              k: 1
            };
            zoomstarted(dispatch);
          }).tween("zoom:zoom", function () {
            var dx = size[0],
                dy = size[1],
                cx = center0 ? center0[0] : dx / 2,
                cy = center0 ? center0[1] : dy / 2,
                i = d3.interpolateZoom([(cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k], [(cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k]);
            return function (t) {
              var l = i(t),
                  k = dx / l[2];
              this.__chart__ = view = {
                x: cx - l[0] * k,
                y: cy - l[1] * k,
                k: k
              };
              zoomed(dispatch);
            };
          }).each("interrupt.zoom", function () {
            zoomended(dispatch);
          }).each("end.zoom", function () {
            zoomended(dispatch);
          });
        } else {
          this.__chart__ = view;
          zoomstarted(dispatch);
          zoomed(dispatch);
          zoomended(dispatch);
        }
      });
    };
    zoom.translate = function (_) {
      if (!arguments.length) return [view.x, view.y];
      view = {
        x: +_[0],
        y: +_[1],
        k: view.k
      };
      rescale();
      return zoom;
    };
    zoom.scale = function (_) {
      if (!arguments.length) return view.k;
      view = {
        x: view.x,
        y: view.y,
        k: null
      };
      scaleTo(+_);
      rescale();
      return zoom;
    };
    zoom.scaleExtent = function (_) {
      if (!arguments.length) return scaleExtent;
      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [+_[0], +_[1]];
      return zoom;
    };
    zoom.center = function (_) {
      if (!arguments.length) return center;
      center = _ && [+_[0], +_[1]];
      return zoom;
    };
    zoom.size = function (_) {
      if (!arguments.length) return size;
      size = _ && [+_[0], +_[1]];
      return zoom;
    };
    zoom.duration = function (_) {
      if (!arguments.length) return duration;
      duration = +_;
      return zoom;
    };
    zoom.x = function (z) {
      if (!arguments.length) return x1;
      x1 = z;
      x0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    zoom.y = function (z) {
      if (!arguments.length) return y1;
      y1 = z;
      y0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    function location(p) {
      return [(p[0] - view.x) / view.k, (p[1] - view.y) / view.k];
    }
    function point(l) {
      return [l[0] * view.k + view.x, l[1] * view.k + view.y];
    }
    function scaleTo(s) {
      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
    }
    function translateTo(p, l) {
      l = point(l);
      view.x += p[0] - l[0];
      view.y += p[1] - l[1];
    }
    function zoomTo(that, p, l, k) {
      that.__chart__ = {
        x: view.x,
        y: view.y,
        k: view.k
      };
      scaleTo(Math.pow(2, k));
      translateTo(center0 = p, l);
      that = d3.select(that);
      if (duration > 0) that = that.transition().duration(duration);
      that.call(zoom.event);
    }
    function rescale() {
      if (x1) x1.domain(x0.range().map(function (x) {
        return (x - view.x) / view.k;
      }).map(x0.invert));
      if (y1) y1.domain(y0.range().map(function (y) {
        return (y - view.y) / view.k;
      }).map(y0.invert));
    }
    function zoomstarted(dispatch) {
      if (!zooming++) dispatch({
        type: "zoomstart"
      });
    }
    function zoomed(dispatch) {
      rescale();
      dispatch({
        type: "zoom",
        scale: view.k,
        translate: [view.x, view.y]
      });
    }
    function zoomended(dispatch) {
      if (! --zooming) dispatch({
        type: "zoomend"
      }), center0 = null;
    }
    function mousedowned() {
      var that = this,
          dispatch = event.of(that, arguments),
          dragged = 0,
          subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended),
          location0 = location(d3.mouse(that)),
          dragRestore = d3_event_dragSuppress(that);
      d3_selection_interrupt.call(that);
      zoomstarted(dispatch);
      function moved() {
        dragged = 1;
        translateTo(d3.mouse(that), location0);
        zoomed(dispatch);
      }
      function ended() {
        subject.on(mousemove, null).on(mouseup, null);
        dragRestore(dragged);
        zoomended(dispatch);
      }
    }
    function touchstarted() {
      var that = this,
          dispatch = event.of(that, arguments),
          locations0 = {},
          distance0 = 0,
          scale0,
          zoomName = ".zoom-" + d3.event.changedTouches[0].identifier,
          touchmove = "touchmove" + zoomName,
          touchend = "touchend" + zoomName,
          targets = [],
          subject = d3.select(that),
          dragRestore = d3_event_dragSuppress(that);
      started();
      zoomstarted(dispatch);
      subject.on(mousedown, null).on(touchstart, started);
      function relocate() {
        var touches = d3.touches(that);
        scale0 = view.k;
        touches.forEach(function (t) {
          if (t.identifier in locations0) locations0[t.identifier] = location(t);
        });
        return touches;
      }
      function started() {
        var target = d3.event.target;
        d3.select(target).on(touchmove, moved).on(touchend, ended);
        targets.push(target);
        var changed = d3.event.changedTouches;
        for (var i = 0, n = changed.length; i < n; ++i) {
          locations0[changed[i].identifier] = null;
        }
        var touches = relocate(),
            now = Date.now();
        if (touches.length === 1) {
          if (now - touchtime < 500) {
            var p = touches[0];
            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
            d3_eventPreventDefault();
          }
          touchtime = now;
        } else if (touches.length > 1) {
          var p = touches[0],
              q = touches[1],
              dx = p[0] - q[0],
              dy = p[1] - q[1];
          distance0 = dx * dx + dy * dy;
        }
      }
      function moved() {
        var touches = d3.touches(that),
            p0,
            l0,
            p1,
            l1;
        d3_selection_interrupt.call(that);
        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
          p1 = touches[i];
          if (l1 = locations0[p1.identifier]) {
            if (l0) break;
            p0 = p1, l0 = l1;
          }
        }
        if (l1) {
          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1,
              scale1 = distance0 && Math.sqrt(distance1 / distance0);
          p0 = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
          l0 = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
          scaleTo(scale1 * scale0);
        }
        touchtime = null;
        translateTo(p0, l0);
        zoomed(dispatch);
      }
      function ended() {
        if (d3.event.touches.length) {
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            delete locations0[changed[i].identifier];
          }
          for (var identifier in locations0) {
            return void relocate();
          }
        }
        d3.selectAll(targets).on(zoomName, null);
        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
        dragRestore();
        zoomended(dispatch);
      }
    }
    function mousewheeled() {
      var dispatch = event.of(this, arguments);
      if (mousewheelTimer) clearTimeout(mousewheelTimer);else d3_selection_interrupt.call(this), translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
      mousewheelTimer = setTimeout(function () {
        mousewheelTimer = null;
        zoomended(dispatch);
      }, 50);
      d3_eventPreventDefault();
      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
      translateTo(center0, translate0);
      zoomed(dispatch);
    }
    function dblclicked() {
      var p = d3.mouse(this),
          k = Math.log(view.k) / Math.LN2;
      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
    }
    return d3.rebind(zoom, event, "on");
  };
  var d3_behavior_zoomInfinity = [0, Infinity],
      d3_behavior_zoomDelta,
      d3_behavior_zoomWheel;
  d3.color = d3_color;
  function d3_color() {}
  d3_color.prototype.toString = function () {
    return this.rgb() + "";
  };
  d3.hsl = d3_hsl;
  function d3_hsl(h, s, l) {
    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
  }
  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
  d3_hslPrototype.brighter = function (k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, this.l / k);
  };
  d3_hslPrototype.darker = function (k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, k * this.l);
  };
  d3_hslPrototype.rgb = function () {
    return d3_hsl_rgb(this.h, this.s, this.l);
  };
  function d3_hsl_rgb(h, s, l) {
    var m1, m2;
    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
    l = l < 0 ? 0 : l > 1 ? 1 : l;
    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
    m1 = 2 * l - m2;
    function v(h) {
      if (h > 360) h -= 360;else if (h < 0) h += 360;
      if (h < 60) return m1 + (m2 - m1) * h / 60;
      if (h < 180) return m2;
      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
      return m1;
    }
    function vv(h) {
      return Math.round(v(h) * 255);
    }
    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
  }
  d3.hcl = d3_hcl;
  function d3_hcl(h, c, l) {
    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
  }
  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
  d3_hclPrototype.brighter = function (k) {
    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.darker = function (k) {
    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.rgb = function () {
    return d3_hcl_lab(this.h, this.c, this.l).rgb();
  };
  function d3_hcl_lab(h, c, l) {
    if (isNaN(h)) h = 0;
    if (isNaN(c)) c = 0;
    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
  }
  d3.lab = d3_lab;
  function d3_lab(l, a, b) {
    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
  }
  var d3_lab_K = 18;
  var d3_lab_X = .95047,
      d3_lab_Y = 1,
      d3_lab_Z = 1.08883;
  var d3_labPrototype = d3_lab.prototype = new d3_color();
  d3_labPrototype.brighter = function (k) {
    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.darker = function (k) {
    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.rgb = function () {
    return d3_lab_rgb(this.l, this.a, this.b);
  };
  function d3_lab_rgb(l, a, b) {
    var y = (l + 16) / 116,
        x = y + a / 500,
        z = y - b / 200;
    x = d3_lab_xyz(x) * d3_lab_X;
    y = d3_lab_xyz(y) * d3_lab_Y;
    z = d3_lab_xyz(z) * d3_lab_Z;
    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
  }
  function d3_lab_hcl(l, a, b) {
    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
  }
  function d3_lab_xyz(x) {
    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
  }
  function d3_xyz_lab(x) {
    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
  }
  function d3_xyz_rgb(r) {
    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
  }
  d3.rgb = d3_rgb;
  function d3_rgb(r, g, b) {
    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
  }
  function d3_rgbNumber(value) {
    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
  }
  function d3_rgbString(value) {
    return d3_rgbNumber(value) + "";
  }
  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
  d3_rgbPrototype.brighter = function (k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    var r = this.r,
        g = this.g,
        b = this.b,
        i = 30;
    if (!r && !g && !b) return new d3_rgb(i, i, i);
    if (r && r < i) r = i;
    if (g && g < i) g = i;
    if (b && b < i) b = i;
    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
  };
  d3_rgbPrototype.darker = function (k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_rgb(k * this.r, k * this.g, k * this.b);
  };
  d3_rgbPrototype.hsl = function () {
    return d3_rgb_hsl(this.r, this.g, this.b);
  };
  d3_rgbPrototype.toString = function () {
    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
  };
  function d3_rgb_hex(v) {
    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
  }
  function d3_rgb_parse(format, rgb, hsl) {
    var r = 0,
        g = 0,
        b = 0,
        m1,
        m2,
        color;
    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
    if (m1) {
      m2 = m1[2].split(",");
      switch (m1[1]) {
        case "hsl":
          {
            return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
          }

        case "rgb":
          {
            return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
          }
      }
    }
    if (color = d3_rgb_names.get(format)) {
      return rgb(color.r, color.g, color.b);
    }
    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
      if (format.length === 4) {
        r = (color & 3840) >> 4;
        r = r >> 4 | r;
        g = color & 240;
        g = g >> 4 | g;
        b = color & 15;
        b = b << 4 | b;
      } else if (format.length === 7) {
        r = (color & 16711680) >> 16;
        g = (color & 65280) >> 8;
        b = color & 255;
      }
    }
    return rgb(r, g, b);
  }
  function d3_rgb_hsl(r, g, b) {
    var min = Math.min(r /= 255, g /= 255, b /= 255),
        max = Math.max(r, g, b),
        d = max - min,
        h,
        s,
        l = (max + min) / 2;
    if (d) {
      s = l < .5 ? d / (max + min) : d / (2 - max - min);
      if (r == max) h = (g - b) / d + (g < b ? 6 : 0);else if (g == max) h = (b - r) / d + 2;else h = (r - g) / d + 4;
      h *= 60;
    } else {
      h = NaN;
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new d3_hsl(h, s, l);
  }
  function d3_rgb_lab(r, g, b) {
    r = d3_rgb_xyz(r);
    g = d3_rgb_xyz(g);
    b = d3_rgb_xyz(b);
    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X),
        y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y),
        z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
  }
  function d3_rgb_xyz(r) {
    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
  }
  function d3_rgb_parseNumber(c) {
    var f = parseFloat(c);
    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
  }
  var d3_rgb_names = d3.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  d3_rgb_names.forEach(function (key, value) {
    d3_rgb_names.set(key, d3_rgbNumber(value));
  });
  function d3_functor(v) {
    return typeof v === "function" ? v : function () {
      return v;
    };
  }
  d3.functor = d3_functor;
  d3.xhr = d3_xhrType(d3_identity);
  function d3_xhrType(response) {
    return function (url, mimeType, callback) {
      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, mimeType = null;
      return d3_xhr(url, mimeType, response, callback);
    };
  }
  function d3_xhr(url, mimeType, response, callback) {
    var xhr = {},
        dispatch = d3.dispatch("beforesend", "progress", "load", "error"),
        headers = {},
        request = new XMLHttpRequest(),
        responseType = null;
    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function () {
      request.readyState > 3 && respond();
    };
    function respond() {
      var status = request.status,
          result;
      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
        try {
          result = response.call(xhr, request);
        } catch (e) {
          dispatch.error.call(xhr, e);
          return;
        }
        dispatch.load.call(xhr, result);
      } else {
        dispatch.error.call(xhr, request);
      }
    }
    request.onprogress = function (event) {
      var o = d3.event;
      d3.event = event;
      try {
        dispatch.progress.call(xhr, request);
      } finally {
        d3.event = o;
      }
    };
    xhr.header = function (name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers[name];
      if (value == null) delete headers[name];else headers[name] = value + "";
      return xhr;
    };
    xhr.mimeType = function (value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return xhr;
    };
    xhr.responseType = function (value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return xhr;
    };
    xhr.response = function (value) {
      response = value;
      return xhr;
    };
    ["get", "post"].forEach(function (method) {
      xhr[method] = function () {
        return xhr.send.apply(xhr, [method].concat(d3_array(arguments)));
      };
    });
    xhr.send = function (method, data, callback) {
      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
      request.open(method, url, true);
      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
      if (request.setRequestHeader) for (var name in headers) {
        request.setRequestHeader(name, headers[name]);
      }if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
      if (responseType != null) request.responseType = responseType;
      if (callback != null) xhr.on("error", callback).on("load", function (request) {
        callback(null, request);
      });
      dispatch.beforesend.call(xhr, request);
      request.send(data == null ? null : data);
      return xhr;
    };
    xhr.abort = function () {
      request.abort();
      return xhr;
    };
    d3.rebind(xhr, dispatch, "on");
    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
  }
  function d3_xhr_fixCallback(callback) {
    return callback.length === 1 ? function (error, request) {
      callback(error == null ? request : null);
    } : callback;
  }
  function d3_xhrHasResponse(request) {
    var type = request.responseType;
    return type && type !== "text" ? request.response : request.responseText;
  }
  d3.dsv = function (delimiter, mimeType) {
    var reFormat = new RegExp('["' + delimiter + "\n]"),
        delimiterCode = delimiter.charCodeAt(0);
    function dsv(url, row, callback) {
      if (arguments.length < 3) callback = row, row = null;
      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
      xhr.row = function (_) {
        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
      };
      return xhr;
    }
    function response(request) {
      return dsv.parse(request.responseText);
    }
    function typedResponse(f) {
      return function (request) {
        return dsv.parse(request.responseText, f);
      };
    }
    dsv.parse = function (text, f) {
      var o;
      return dsv.parseRows(text, function (row, i) {
        if (o) return o(row, i - 1);
        var a = new Function("d", "return {" + row.map(function (name, i) {
          return JSON.stringify(name) + ": d[" + i + "]";
        }).join(",") + "}");
        o = f ? function (row, i) {
          return f(a(row), i);
        } : a;
      });
    };
    dsv.parseRows = function (text, f) {
      var EOL = {},
          EOF = {},
          rows = [],
          N = text.length,
          I = 0,
          n = 0,
          t,
          eol;
      function token() {
        if (I >= N) return EOF;
        if (eol) return eol = false, EOL;
        var j = I;
        if (text.charCodeAt(j) === 34) {
          var i = j;
          while (i++ < N) {
            if (text.charCodeAt(i) === 34) {
              if (text.charCodeAt(i + 1) !== 34) break;
              ++i;
            }
          }
          I = i + 2;
          var c = text.charCodeAt(i + 1);
          if (c === 13) {
            eol = true;
            if (text.charCodeAt(i + 2) === 10) ++I;
          } else if (c === 10) {
            eol = true;
          }
          return text.slice(j + 1, i).replace(/""/g, '"');
        }
        while (I < N) {
          var c = text.charCodeAt(I++),
              k = 1;
          if (c === 10) eol = true;else if (c === 13) {
            eol = true;
            if (text.charCodeAt(I) === 10) ++I, ++k;
          } else if (c !== delimiterCode) continue;
          return text.slice(j, I - k);
        }
        return text.slice(j);
      }
      while ((t = token()) !== EOF) {
        var a = [];
        while (t !== EOL && t !== EOF) {
          a.push(t);
          t = token();
        }
        if (f && (a = f(a, n++)) == null) continue;
        rows.push(a);
      }
      return rows;
    };
    dsv.format = function (rows) {
      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
      var fieldSet = new d3_Set(),
          fields = [];
      rows.forEach(function (row) {
        for (var field in row) {
          if (!fieldSet.has(field)) {
            fields.push(fieldSet.add(field));
          }
        }
      });
      return [fields.map(formatValue).join(delimiter)].concat(rows.map(function (row) {
        return fields.map(function (field) {
          return formatValue(row[field]);
        }).join(delimiter);
      })).join("\n");
    };
    dsv.formatRows = function (rows) {
      return rows.map(formatRow).join("\n");
    };
    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
    }
    return dsv;
  };
  d3.csv = d3.dsv(",", "text/csv");
  d3.tsv = d3.dsv("	", "text/tab-separated-values");
  var d3_timer_queueHead,
      d3_timer_queueTail,
      d3_timer_interval,
      d3_timer_timeout,
      d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function (callback) {
    setTimeout(callback, 17);
  };
  d3.timer = function () {
    d3_timer.apply(this, arguments);
  };
  function d3_timer(callback, delay, then) {
    var n = arguments.length;
    if (n < 2) delay = 0;
    if (n < 3) then = Date.now();
    var time = then + delay,
        timer = {
      c: callback,
      t: time,
      n: null
    };
    if (d3_timer_queueTail) d3_timer_queueTail.n = timer;else d3_timer_queueHead = timer;
    d3_timer_queueTail = timer;
    if (!d3_timer_interval) {
      d3_timer_timeout = clearTimeout(d3_timer_timeout);
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
    return timer;
  }
  function d3_timer_step() {
    var now = d3_timer_mark(),
        delay = d3_timer_sweep() - now;
    if (delay > 24) {
      if (isFinite(delay)) {
        clearTimeout(d3_timer_timeout);
        d3_timer_timeout = setTimeout(d3_timer_step, delay);
      }
      d3_timer_interval = 0;
    } else {
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
  }
  d3.timer.flush = function () {
    d3_timer_mark();
    d3_timer_sweep();
  };
  function d3_timer_mark() {
    var now = Date.now(),
        timer = d3_timer_queueHead;
    while (timer) {
      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
      timer = timer.n;
    }
    return now;
  }
  function d3_timer_sweep() {
    var t0,
        t1 = d3_timer_queueHead,
        time = Infinity;
    while (t1) {
      if (t1.c) {
        if (t1.t < time) time = t1.t;
        t1 = (t0 = t1).n;
      } else {
        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
      }
    }
    d3_timer_queueTail = t0;
    return time;
  }
  function d3_format_precision(x, p) {
    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
  }
  d3.round = function (x, n) {
    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
  };
  var d3_formatPrefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"].map(d3_formatPrefix);
  d3.formatPrefix = function (value, precision) {
    var i = 0;
    if (value = +value) {
      if (value < 0) value *= -1;
      if (precision) value = d3.round(value, d3_format_precision(value, precision));
      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
    }
    return d3_formatPrefixes[8 + i / 3];
  };
  function d3_formatPrefix(d, i) {
    var k = Math.pow(10, abs(8 - i) * 3);
    return {
      scale: i > 8 ? function (d) {
        return d / k;
      } : function (d) {
        return d * k;
      },
      symbol: d
    };
  }
  function d3_locale_numberFormat(locale) {
    var locale_decimal = locale.decimal,
        locale_thousands = locale.thousands,
        locale_grouping = locale.grouping,
        locale_currency = locale.currency,
        formatGroup = locale_grouping && locale_thousands ? function (value, width) {
      var i = value.length,
          t = [],
          j = 0,
          g = locale_grouping[0],
          length = 0;
      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = locale_grouping[j = (j + 1) % locale_grouping.length];
      }
      return t.reverse().join(locale_thousands);
    } : d3_identity;
    return function (specifier) {
      var match = d3_format_re.exec(specifier),
          fill = match[1] || " ",
          align = match[2] || ">",
          sign = match[3] || "-",
          symbol = match[4] || "",
          zfill = match[5],
          width = +match[6],
          comma = match[7],
          precision = match[8],
          type = match[9],
          scale = 1,
          prefix = "",
          suffix = "",
          integer = false,
          exponent = true;
      if (precision) precision = +precision.substring(1);
      if (zfill || fill === "0" && align === "=") {
        zfill = fill = "0";
        align = "=";
      }
      switch (type) {
        case "n":
          comma = true;
          type = "g";
          break;

        case "%":
          scale = 100;
          suffix = "%";
          type = "f";
          break;

        case "p":
          scale = 100;
          suffix = "%";
          type = "r";
          break;

        case "b":
        case "o":
        case "x":
        case "X":
          if (symbol === "#") prefix = "0" + type.toLowerCase();

        case "c":
          exponent = false;

        case "d":
          integer = true;
          precision = 0;
          break;

        case "s":
          scale = -1;
          type = "r";
          break;
      }
      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
      if (type == "r" && !precision) type = "g";
      if (precision != null) {
        if (type == "g") precision = Math.max(1, Math.min(21, precision));else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
      }
      type = d3_format_types.get(type) || d3_format_typeDefault;
      var zcomma = zfill && comma;
      return function (value) {
        var fullSuffix = suffix;
        if (integer && value % 1) return "";
        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
        if (scale < 0) {
          var unit = d3.formatPrefix(value, precision);
          value = unit.scale(value);
          fullSuffix = unit.symbol + suffix;
        } else {
          value *= scale;
        }
        value = type(value, precision);
        var i = value.lastIndexOf("."),
            before,
            after;
        if (i < 0) {
          var j = exponent ? value.lastIndexOf("e") : -1;
          if (j < 0) before = value, after = "";else before = value.substring(0, j), after = value.substring(j);
        } else {
          before = value.substring(0, i);
          after = locale_decimal + value.substring(i + 1);
        }
        if (!zfill && comma) before = formatGroup(before, Infinity);
        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length),
            padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
        negative += prefix;
        value = before + after;
        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
      };
    };
  }
  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
  var d3_format_types = d3.map({
    b: function b(x) {
      return x.toString(2);
    },
    c: function c(x) {
      return String.fromCharCode(x);
    },
    o: function o(x) {
      return x.toString(8);
    },
    x: function x(_x) {
      return _x.toString(16);
    },
    X: function X(x) {
      return x.toString(16).toUpperCase();
    },
    g: function g(x, p) {
      return x.toPrecision(p);
    },
    e: function e(x, p) {
      return x.toExponential(p);
    },
    f: function f(x, p) {
      return x.toFixed(p);
    },
    r: function r(x, p) {
      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
    }
  });
  function d3_format_typeDefault(x) {
    return x + "";
  }
  var d3_time = d3.time = {},
      d3_date = Date;
  function d3_date_utc() {
    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
  }
  d3_date_utc.prototype = {
    getDate: function getDate() {
      return this._.getUTCDate();
    },
    getDay: function getDay() {
      return this._.getUTCDay();
    },
    getFullYear: function getFullYear() {
      return this._.getUTCFullYear();
    },
    getHours: function getHours() {
      return this._.getUTCHours();
    },
    getMilliseconds: function getMilliseconds() {
      return this._.getUTCMilliseconds();
    },
    getMinutes: function getMinutes() {
      return this._.getUTCMinutes();
    },
    getMonth: function getMonth() {
      return this._.getUTCMonth();
    },
    getSeconds: function getSeconds() {
      return this._.getUTCSeconds();
    },
    getTime: function getTime() {
      return this._.getTime();
    },
    getTimezoneOffset: function getTimezoneOffset() {
      return 0;
    },
    valueOf: function valueOf() {
      return this._.valueOf();
    },
    setDate: function setDate() {
      d3_time_prototype.setUTCDate.apply(this._, arguments);
    },
    setDay: function setDay() {
      d3_time_prototype.setUTCDay.apply(this._, arguments);
    },
    setFullYear: function setFullYear() {
      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
    },
    setHours: function setHours() {
      d3_time_prototype.setUTCHours.apply(this._, arguments);
    },
    setMilliseconds: function setMilliseconds() {
      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
    },
    setMinutes: function setMinutes() {
      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
    },
    setMonth: function setMonth() {
      d3_time_prototype.setUTCMonth.apply(this._, arguments);
    },
    setSeconds: function setSeconds() {
      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
    },
    setTime: function setTime() {
      d3_time_prototype.setTime.apply(this._, arguments);
    }
  };
  var d3_time_prototype = Date.prototype;
  function d3_time_interval(local, step, number) {
    function round(date) {
      var d0 = local(date),
          d1 = offset(d0, 1);
      return date - d0 < d1 - date ? d0 : d1;
    }
    function ceil(date) {
      step(date = local(new d3_date(date - 1)), 1);
      return date;
    }
    function offset(date, k) {
      step(date = new d3_date(+date), k);
      return date;
    }
    function range(t0, t1, dt) {
      var time = ceil(t0),
          times = [];
      if (dt > 1) {
        while (time < t1) {
          if (!(number(time) % dt)) times.push(new Date(+time));
          step(time, 1);
        }
      } else {
        while (time < t1) {
          times.push(new Date(+time)), step(time, 1);
        }
      }
      return times;
    }
    function range_utc(t0, t1, dt) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = t0;
        return range(utc, t1, dt);
      } finally {
        d3_date = Date;
      }
    }
    local.floor = local;
    local.round = round;
    local.ceil = ceil;
    local.offset = offset;
    local.range = range;
    var utc = local.utc = d3_time_interval_utc(local);
    utc.floor = utc;
    utc.round = d3_time_interval_utc(round);
    utc.ceil = d3_time_interval_utc(ceil);
    utc.offset = d3_time_interval_utc(offset);
    utc.range = range_utc;
    return local;
  }
  function d3_time_interval_utc(method) {
    return function (date, k) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = date;
        return method(utc, k)._;
      } finally {
        d3_date = Date;
      }
    };
  }
  d3_time.year = d3_time_interval(function (date) {
    date = d3_time.day(date);
    date.setMonth(0, 1);
    return date;
  }, function (date, offset) {
    date.setFullYear(date.getFullYear() + offset);
  }, function (date) {
    return date.getFullYear();
  });
  d3_time.years = d3_time.year.range;
  d3_time.years.utc = d3_time.year.utc.range;
  d3_time.day = d3_time_interval(function (date) {
    var day = new d3_date(2e3, 0);
    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    return day;
  }, function (date, offset) {
    date.setDate(date.getDate() + offset);
  }, function (date) {
    return date.getDate() - 1;
  });
  d3_time.days = d3_time.day.range;
  d3_time.days.utc = d3_time.day.utc.range;
  d3_time.dayOfYear = function (date) {
    var year = d3_time.year(date);
    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
  };
  ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].forEach(function (day, i) {
    i = 7 - i;
    var interval = d3_time[day] = d3_time_interval(function (date) {
      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
      return date;
    }, function (date, offset) {
      date.setDate(date.getDate() + Math.floor(offset) * 7);
    }, function (date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
    });
    d3_time[day + "s"] = interval.range;
    d3_time[day + "s"].utc = interval.utc.range;
    d3_time[day + "OfYear"] = function (date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
    };
  });
  d3_time.week = d3_time.sunday;
  d3_time.weeks = d3_time.sunday.range;
  d3_time.weeks.utc = d3_time.sunday.utc.range;
  d3_time.weekOfYear = d3_time.sundayOfYear;
  function d3_locale_timeFormat(locale) {
    var locale_dateTime = locale.dateTime,
        locale_date = locale.date,
        locale_time = locale.time,
        locale_periods = locale.periods,
        locale_days = locale.days,
        locale_shortDays = locale.shortDays,
        locale_months = locale.months,
        locale_shortMonths = locale.shortMonths;
    function d3_time_format(template) {
      var n = template.length;
      function format(date) {
        var string = [],
            i = -1,
            j = 0,
            c,
            p,
            f;
        while (++i < n) {
          if (template.charCodeAt(i) === 37) {
            string.push(template.slice(j, i));
            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
            string.push(c);
            j = i + 1;
          }
        }
        string.push(template.slice(j, i));
        return string.join("");
      }
      format.parse = function (string) {
        var d = {
          y: 1900,
          m: 0,
          d: 1,
          H: 0,
          M: 0,
          S: 0,
          L: 0,
          Z: null
        },
            i = d3_time_parse(d, template, string, 0);
        if (i != string.length) return null;
        if ("p" in d) d.H = d.H % 12 + d.p * 12;
        var localZ = d.Z != null && d3_date !== d3_date_utc,
            date = new (localZ ? d3_date_utc : d3_date)();
        if ("j" in d) date.setFullYear(d.y, 0, d.j);else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
          date.setFullYear(d.y, 0, 1);
          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
        } else date.setFullYear(d.y, d.m, d.d);
        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
        return localZ ? date._ : date;
      };
      format.toString = function () {
        return template;
      };
      return format;
    }
    function d3_time_parse(date, template, string, j) {
      var c,
          p,
          t,
          i = 0,
          n = template.length,
          m = string.length;
      while (i < n) {
        if (j >= m) return -1;
        c = template.charCodeAt(i++);
        if (c === 37) {
          t = template.charAt(i++);
          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
          if (!p || (j = p(date, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }
      return j;
    }
    d3_time_format.utc = function (template) {
      var local = d3_time_format(template);
      function format(date) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date();
          utc._ = date;
          return local(utc);
        } finally {
          d3_date = Date;
        }
      }
      format.parse = function (string) {
        try {
          d3_date = d3_date_utc;
          var date = local.parse(string);
          return date && date._;
        } finally {
          d3_date = Date;
        }
      };
      format.toString = local.toString;
      return format;
    };
    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
    var d3_time_periodLookup = d3.map(),
        d3_time_dayRe = d3_time_formatRe(locale_days),
        d3_time_dayLookup = d3_time_formatLookup(locale_days),
        d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays),
        d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays),
        d3_time_monthRe = d3_time_formatRe(locale_months),
        d3_time_monthLookup = d3_time_formatLookup(locale_months),
        d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths),
        d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
    locale_periods.forEach(function (p, i) {
      d3_time_periodLookup.set(p.toLowerCase(), i);
    });
    var d3_time_formats = {
      a: function a(d) {
        return locale_shortDays[d.getDay()];
      },
      A: function A(d) {
        return locale_days[d.getDay()];
      },
      b: function b(d) {
        return locale_shortMonths[d.getMonth()];
      },
      B: function B(d) {
        return locale_months[d.getMonth()];
      },
      c: d3_time_format(locale_dateTime),
      d: function d(_d, p) {
        return d3_time_formatPad(_d.getDate(), p, 2);
      },
      e: function e(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      H: function H(d, p) {
        return d3_time_formatPad(d.getHours(), p, 2);
      },
      I: function I(d, p) {
        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
      },
      j: function j(d, p) {
        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
      },
      L: function L(d, p) {
        return d3_time_formatPad(d.getMilliseconds(), p, 3);
      },
      m: function m(d, p) {
        return d3_time_formatPad(d.getMonth() + 1, p, 2);
      },
      M: function M(d, p) {
        return d3_time_formatPad(d.getMinutes(), p, 2);
      },
      p: function p(d) {
        return locale_periods[+(d.getHours() >= 12)];
      },
      S: function S(d, p) {
        return d3_time_formatPad(d.getSeconds(), p, 2);
      },
      U: function U(d, p) {
        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
      },
      w: function w(d) {
        return d.getDay();
      },
      W: function W(d, p) {
        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
      },
      x: d3_time_format(locale_date),
      X: d3_time_format(locale_time),
      y: function y(d, p) {
        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
      },
      Y: function Y(d, p) {
        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
      },
      Z: d3_time_zone,
      "%": function _() {
        return "%";
      }
    };
    var d3_time_parsers = {
      a: d3_time_parseWeekdayAbbrev,
      A: d3_time_parseWeekday,
      b: d3_time_parseMonthAbbrev,
      B: d3_time_parseMonth,
      c: d3_time_parseLocaleFull,
      d: d3_time_parseDay,
      e: d3_time_parseDay,
      H: d3_time_parseHour24,
      I: d3_time_parseHour24,
      j: d3_time_parseDayOfYear,
      L: d3_time_parseMilliseconds,
      m: d3_time_parseMonthNumber,
      M: d3_time_parseMinutes,
      p: d3_time_parseAmPm,
      S: d3_time_parseSeconds,
      U: d3_time_parseWeekNumberSunday,
      w: d3_time_parseWeekdayNumber,
      W: d3_time_parseWeekNumberMonday,
      x: d3_time_parseLocaleDate,
      X: d3_time_parseLocaleTime,
      y: d3_time_parseYear,
      Y: d3_time_parseFullYear,
      Z: d3_time_parseZone,
      "%": d3_time_parseLiteralPercent
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
      d3_time_dayAbbrevRe.lastIndex = 0;
      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
      d3_time_dayRe.lastIndex = 0;
      var n = d3_time_dayRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
      d3_time_monthAbbrevRe.lastIndex = 0;
      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
      d3_time_monthRe.lastIndex = 0;
      var n = d3_time_monthRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseAmPm(date, string, i) {
      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
      return n == null ? -1 : (date.p = n, i);
    }
    return d3_time_format;
  }
  var d3_time_formatPads = {
    "-": "",
    _: " ",
    "0": "0"
  },
      d3_time_numberRe = /^\s*\d+/,
      d3_time_percentRe = /^%/;
  function d3_time_formatPad(value, fill, width) {
    var sign = value < 0 ? "-" : "",
        string = (sign ? -value : value) + "",
        length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }
  function d3_time_formatRe(names) {
    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
  }
  function d3_time_formatLookup(names) {
    var map = new d3_Map(),
        i = -1,
        n = names.length;
    while (++i < n) {
      map.set(names[i].toLowerCase(), i);
    }return map;
  }
  function d3_time_parseWeekdayNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
    return n ? (date.w = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberSunday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.U = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberMonday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.W = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseFullYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
    return n ? (date.y = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
  }
  function d3_time_parseZone(date, string, i) {
    return (/^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, i + 5) : -1
    );
  }
  function d3_time_expandYear(d) {
    return d + (d > 68 ? 1900 : 2e3);
  }
  function d3_time_parseMonthNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
  }
  function d3_time_parseDay(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.d = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseDayOfYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.j = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseHour24(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.H = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMinutes(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.M = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseSeconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.S = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMilliseconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.L = +n[0], i + n[0].length) : -1;
  }
  function d3_time_zone(d) {
    var z = d.getTimezoneOffset(),
        zs = z > 0 ? "-" : "+",
        zh = abs(z) / 60 | 0,
        zm = abs(z) % 60;
    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
  }
  function d3_time_parseLiteralPercent(date, string, i) {
    d3_time_percentRe.lastIndex = 0;
    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  function d3_time_formatMulti(formats) {
    var n = formats.length,
        i = -1;
    while (++i < n) {
      formats[i][0] = this(formats[i][0]);
    }return function (date) {
      var i = 0,
          f = formats[i];
      while (!f[1](date)) {
        f = formats[++i];
      }return f[0](date);
    };
  }
  d3.locale = function (locale) {
    return {
      numberFormat: d3_locale_numberFormat(locale),
      timeFormat: d3_locale_timeFormat(locale)
    };
  };
  var d3_locale_enUS = d3.locale({
    decimal: ".",
    thousands: ",",
    grouping: [3],
    currency: ["$", ""],
    dateTime: "%a %b %e %X %Y",
    date: "%m/%d/%Y",
    time: "%H:%M:%S",
    periods: ["AM", "PM"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  });
  d3.format = d3_locale_enUS.numberFormat;
  d3.geo = {};
  function d3_adder() {}
  d3_adder.prototype = {
    s: 0,
    t: 0,
    add: function add(y) {
      d3_adderSum(y, this.t, d3_adderTemp);
      d3_adderSum(d3_adderTemp.s, this.s, this);
      if (this.s) this.t += d3_adderTemp.t;else this.s = d3_adderTemp.t;
    },
    reset: function reset() {
      this.s = this.t = 0;
    },
    valueOf: function valueOf() {
      return this.s;
    }
  };
  var d3_adderTemp = new d3_adder();
  function d3_adderSum(a, b, o) {
    var x = o.s = a + b,
        bv = x - a,
        av = x - bv;
    o.t = a - av + (b - bv);
  }
  d3.geo.stream = function (object, listener) {
    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
      d3_geo_streamObjectType[object.type](object, listener);
    } else {
      d3_geo_streamGeometry(object, listener);
    }
  };
  function d3_geo_streamGeometry(geometry, listener) {
    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
      d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
  }
  var d3_geo_streamObjectType = {
    Feature: function Feature(feature, listener) {
      d3_geo_streamGeometry(feature.geometry, listener);
    },
    FeatureCollection: function FeatureCollection(object, listener) {
      var features = object.features,
          i = -1,
          n = features.length;
      while (++i < n) {
        d3_geo_streamGeometry(features[i].geometry, listener);
      }
    }
  };
  var d3_geo_streamGeometryType = {
    Sphere: function Sphere(object, listener) {
      listener.sphere();
    },
    Point: function Point(object, listener) {
      object = object.coordinates;
      listener.point(object[0], object[1], object[2]);
    },
    MultiPoint: function MultiPoint(object, listener) {
      var coordinates = object.coordinates,
          i = -1,
          n = coordinates.length;
      while (++i < n) {
        object = coordinates[i], listener.point(object[0], object[1], object[2]);
      }
    },
    LineString: function LineString(object, listener) {
      d3_geo_streamLine(object.coordinates, listener, 0);
    },
    MultiLineString: function MultiLineString(object, listener) {
      var coordinates = object.coordinates,
          i = -1,
          n = coordinates.length;
      while (++i < n) {
        d3_geo_streamLine(coordinates[i], listener, 0);
      }
    },
    Polygon: function Polygon(object, listener) {
      d3_geo_streamPolygon(object.coordinates, listener);
    },
    MultiPolygon: function MultiPolygon(object, listener) {
      var coordinates = object.coordinates,
          i = -1,
          n = coordinates.length;
      while (++i < n) {
        d3_geo_streamPolygon(coordinates[i], listener);
      }
    },
    GeometryCollection: function GeometryCollection(object, listener) {
      var geometries = object.geometries,
          i = -1,
          n = geometries.length;
      while (++i < n) {
        d3_geo_streamGeometry(geometries[i], listener);
      }
    }
  };
  function d3_geo_streamLine(coordinates, listener, closed) {
    var i = -1,
        n = coordinates.length - closed,
        coordinate;
    listener.lineStart();
    while (++i < n) {
      coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
    }listener.lineEnd();
  }
  function d3_geo_streamPolygon(coordinates, listener) {
    var i = -1,
        n = coordinates.length;
    listener.polygonStart();
    while (++i < n) {
      d3_geo_streamLine(coordinates[i], listener, 1);
    }listener.polygonEnd();
  }
  d3.geo.area = function (object) {
    d3_geo_areaSum = 0;
    d3.geo.stream(object, d3_geo_area);
    return d3_geo_areaSum;
  };
  var d3_geo_areaSum,
      d3_geo_areaRingSum = new d3_adder();
  var d3_geo_area = {
    sphere: function sphere() {
      d3_geo_areaSum += 4 * π;
    },
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function polygonStart() {
      d3_geo_areaRingSum.reset();
      d3_geo_area.lineStart = d3_geo_areaRingStart;
    },
    polygonEnd: function polygonEnd() {
      var area = 2 * d3_geo_areaRingSum;
      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
    }
  };
  function d3_geo_areaRingStart() {
    var λ00, φ00, λ0, cosφ0, sinφ0;
    d3_geo_area.point = function (λ, φ) {
      d3_geo_area.point = nextPoint;
      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), sinφ0 = Math.sin(φ);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      φ = φ * d3_radians / 2 + π / 4;
      var dλ = λ - λ0,
          sdλ = dλ >= 0 ? 1 : -1,
          adλ = sdλ * dλ,
          cosφ = Math.cos(φ),
          sinφ = Math.sin(φ),
          k = sinφ0 * sinφ,
          u = cosφ0 * cosφ + k * Math.cos(adλ),
          v = k * sdλ * Math.sin(adλ);
      d3_geo_areaRingSum.add(Math.atan2(v, u));
      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
    }
    d3_geo_area.lineEnd = function () {
      nextPoint(λ00, φ00);
    };
  }
  function d3_geo_cartesian(spherical) {
    var λ = spherical[0],
        φ = spherical[1],
        cosφ = Math.cos(φ);
    return [cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ)];
  }
  function d3_geo_cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  }
  function d3_geo_cartesianCross(a, b) {
    return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
  }
  function d3_geo_cartesianAdd(a, b) {
    a[0] += b[0];
    a[1] += b[1];
    a[2] += b[2];
  }
  function d3_geo_cartesianScale(vector, k) {
    return [vector[0] * k, vector[1] * k, vector[2] * k];
  }
  function d3_geo_cartesianNormalize(d) {
    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l;
    d[1] /= l;
    d[2] /= l;
  }
  function d3_geo_spherical(cartesian) {
    return [Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2])];
  }
  function d3_geo_sphericalEqual(a, b) {
    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
  }
  d3.geo.bounds = function () {
    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
    var bound = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function polygonStart() {
        bound.point = ringPoint;
        bound.lineStart = ringStart;
        bound.lineEnd = ringEnd;
        dλSum = 0;
        d3_geo_area.polygonStart();
      },
      polygonEnd: function polygonEnd() {
        d3_geo_area.polygonEnd();
        bound.point = point;
        bound.lineStart = lineStart;
        bound.lineEnd = lineEnd;
        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90);else if (dλSum > ε) φ1 = 90;else if (dλSum < -ε) φ0 = -90;
        range[0] = λ0, range[1] = λ1;
      }
    };
    function point(λ, φ) {
      ranges.push(range = [λ0 = λ, λ1 = λ]);
      if (φ < φ0) φ0 = φ;
      if (φ > φ1) φ1 = φ;
    }
    function linePoint(λ, φ) {
      var p = d3_geo_cartesian([λ * d3_radians, φ * d3_radians]);
      if (p0) {
        var normal = d3_geo_cartesianCross(p0, p),
            equatorial = [normal[1], -normal[0], 0],
            inflection = d3_geo_cartesianCross(equatorial, normal);
        d3_geo_cartesianNormalize(inflection);
        inflection = d3_geo_spherical(inflection);
        var dλ = λ - λ_,
            s = dλ > 0 ? 1 : -1,
            λi = inflection[0] * d3_degrees * s,
            antimeridian = abs(dλ) > 180;
        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = inflection[1] * d3_degrees;
          if (φi > φ1) φ1 = φi;
        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = -inflection[1] * d3_degrees;
          if (φi < φ0) φ0 = φi;
        } else {
          if (φ < φ0) φ0 = φ;
          if (φ > φ1) φ1 = φ;
        }
        if (antimeridian) {
          if (λ < λ_) {
            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
          } else {
            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
          }
        } else {
          if (λ1 >= λ0) {
            if (λ < λ0) λ0 = λ;
            if (λ > λ1) λ1 = λ;
          } else {
            if (λ > λ_) {
              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
            } else {
              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
            }
          }
        }
      } else {
        point(λ, φ);
      }
      p0 = p, λ_ = λ;
    }
    function lineStart() {
      bound.point = linePoint;
    }
    function lineEnd() {
      range[0] = λ0, range[1] = λ1;
      bound.point = point;
      p0 = null;
    }
    function ringPoint(λ, φ) {
      if (p0) {
        var dλ = λ - λ_;
        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
      } else λ__ = λ, φ__ = φ;
      d3_geo_area.point(λ, φ);
      linePoint(λ, φ);
    }
    function ringStart() {
      d3_geo_area.lineStart();
    }
    function ringEnd() {
      ringPoint(λ__, φ__);
      d3_geo_area.lineEnd();
      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
      range[0] = λ0, range[1] = λ1;
      p0 = null;
    }
    function angle(λ0, λ1) {
      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
    }
    function compareRanges(a, b) {
      return a[0] - b[0];
    }
    function withinRange(x, range) {
      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    return function (feature) {
      φ1 = λ1 = -(λ0 = φ0 = Infinity);
      ranges = [];
      d3.geo.stream(feature, bound);
      var n = ranges.length;
      if (n) {
        ranges.sort(compareRanges);
        for (var i = 1, a = ranges[0], b, merged = [a]; i < n; ++i) {
          b = ranges[i];
          if (withinRange(b[0], a) || withinRange(b[1], a)) {
            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
          } else {
            merged.push(a = b);
          }
        }
        var best = -Infinity,
            dλ;
        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
          b = merged[i];
          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
        }
      }
      ranges = range = null;
      return λ0 === Infinity || φ0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[λ0, φ0], [λ1, φ1]];
    };
  }();
  d3.geo.centroid = function (object) {
    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
    d3.geo.stream(object, d3_geo_centroid);
    var x = d3_geo_centroidX2,
        y = d3_geo_centroidY2,
        z = d3_geo_centroidZ2,
        m = x * x + y * y + z * z;
    if (m < ε2) {
      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
      m = x * x + y * y + z * z;
      if (m < ε2) return [NaN, NaN];
    }
    return [Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees];
  };
  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
  var d3_geo_centroid = {
    sphere: d3_noop,
    point: d3_geo_centroidPoint,
    lineStart: d3_geo_centroidLineStart,
    lineEnd: d3_geo_centroidLineEnd,
    polygonStart: function polygonStart() {
      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
    },
    polygonEnd: function polygonEnd() {
      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
    }
  };
  function d3_geo_centroidPoint(λ, φ) {
    λ *= d3_radians;
    var cosφ = Math.cos(φ *= d3_radians);
    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
  }
  function d3_geo_centroidPointXYZ(x, y, z) {
    ++d3_geo_centroidW0;
    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
  }
  function d3_geo_centroidLineStart() {
    var x0, y0, z0;
    d3_geo_centroid.point = function (λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroid.point = nextPoint;
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians),
          x = cosφ * Math.cos(λ),
          y = cosφ * Math.sin(λ),
          z = Math.sin(φ),
          w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_centroidLineEnd() {
    d3_geo_centroid.point = d3_geo_centroidPoint;
  }
  function d3_geo_centroidRingStart() {
    var λ00, φ00, x0, y0, z0;
    d3_geo_centroid.point = function (λ, φ) {
      λ00 = λ, φ00 = φ;
      d3_geo_centroid.point = nextPoint;
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    d3_geo_centroid.lineEnd = function () {
      nextPoint(λ00, φ00);
      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
      d3_geo_centroid.point = d3_geo_centroidPoint;
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians),
          x = cosφ * Math.cos(λ),
          y = cosφ * Math.sin(λ),
          z = Math.sin(φ),
          cx = y0 * z - z0 * y,
          cy = z0 * x - x0 * z,
          cz = x0 * y - y0 * x,
          m = Math.sqrt(cx * cx + cy * cy + cz * cz),
          u = x0 * x + y0 * y + z0 * z,
          v = m && -d3_acos(u) / m,
          w = Math.atan2(m, u);
      d3_geo_centroidX2 += v * cx;
      d3_geo_centroidY2 += v * cy;
      d3_geo_centroidZ2 += v * cz;
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_compose(a, b) {
    function compose(x, y) {
      return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function (x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
  }
  function d3_true() {
    return true;
  }
  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
    var subject = [],
        clip = [];
    segments.forEach(function (segment) {
      if ((n = segment.length - 1) <= 0) return;
      var n,
          p0 = segment[0],
          p1 = segment[n];
      if (d3_geo_sphericalEqual(p0, p1)) {
        listener.lineStart();
        for (var i = 0; i < n; ++i) {
          listener.point((p0 = segment[i])[0], p0[1]);
        }listener.lineEnd();
        return;
      }
      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true),
          b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
      a.o = b;
      subject.push(a);
      clip.push(b);
      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
      a.o = b;
      subject.push(a);
      clip.push(b);
    });
    clip.sort(compare);
    d3_geo_clipPolygonLinkCircular(subject);
    d3_geo_clipPolygonLinkCircular(clip);
    if (!subject.length) return;
    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
      clip[i].e = entry = !entry;
    }
    var start = subject[0],
        points,
        point;
    while (1) {
      var current = start,
          isSubject = true;
      while (current.v) {
        if ((current = current.n) === start) return;
      }points = current.z;
      listener.lineStart();
      do {
        current.v = current.o.v = true;
        if (current.e) {
          if (isSubject) {
            for (var i = 0, n = points.length; i < n; ++i) {
              listener.point((point = points[i])[0], point[1]);
            }
          } else {
            interpolate(current.x, current.n.x, 1, listener);
          }
          current = current.n;
        } else {
          if (isSubject) {
            points = current.p.z;
            for (var i = points.length - 1; i >= 0; --i) {
              listener.point((point = points[i])[0], point[1]);
            }
          } else {
            interpolate(current.x, current.p.x, -1, listener);
          }
          current = current.p;
        }
        current = current.o;
        points = current.z;
        isSubject = !isSubject;
      } while (!current.v);
      listener.lineEnd();
    }
  }
  function d3_geo_clipPolygonLinkCircular(array) {
    if (!(n = array.length)) return;
    var n,
        i = 0,
        a = array[0],
        b;
    while (++i < n) {
      a.n = b = array[i];
      b.p = a;
      a = b;
    }
    a.n = b = array[0];
    b.p = a;
  }
  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other;
    this.e = entry;
    this.v = false;
    this.n = this.p = null;
  }
  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
    return function (rotate, listener) {
      var line = clipLine(listener),
          rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function polygonStart() {
          clip.point = pointRing;
          clip.lineStart = ringStart;
          clip.lineEnd = ringEnd;
          segments = [];
          polygon = [];
        },
        polygonEnd: function polygonEnd() {
          clip.point = point;
          clip.lineStart = lineStart;
          clip.lineEnd = lineEnd;
          segments = d3.merge(segments);
          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
          if (segments.length) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
          } else if (clipStartInside) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            interpolate(null, null, 1, listener);
            listener.lineEnd();
          }
          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
          segments = polygon = null;
        },
        sphere: function sphere() {
          listener.polygonStart();
          listener.lineStart();
          interpolate(null, null, 1, listener);
          listener.lineEnd();
          listener.polygonEnd();
        }
      };
      function point(λ, φ) {
        var point = rotate(λ, φ);
        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
      }
      function pointLine(λ, φ) {
        var point = rotate(λ, φ);
        line.point(point[0], point[1]);
      }
      function lineStart() {
        clip.point = pointLine;
        line.lineStart();
      }
      function lineEnd() {
        clip.point = point;
        line.lineEnd();
      }
      var segments;
      var buffer = d3_geo_clipBufferListener(),
          ringListener = clipLine(buffer),
          polygonStarted = false,
          polygon,
          ring;
      function pointRing(λ, φ) {
        ring.push([λ, φ]);
        var point = rotate(λ, φ);
        ringListener.point(point[0], point[1]);
      }
      function ringStart() {
        ringListener.lineStart();
        ring = [];
      }
      function ringEnd() {
        pointRing(ring[0][0], ring[0][1]);
        ringListener.lineEnd();
        var clean = ringListener.clean(),
            ringSegments = buffer.buffer(),
            segment,
            n = ringSegments.length;
        ring.pop();
        polygon.push(ring);
        ring = null;
        if (!n) return;
        if (clean & 1) {
          segment = ringSegments[0];
          var n = segment.length - 1,
              i = -1,
              point;
          if (n > 0) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            while (++i < n) {
              listener.point((point = segment[i])[0], point[1]);
            }listener.lineEnd();
          }
          return;
        }
        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
      }
      return clip;
    };
  }
  function d3_geo_clipSegmentLength1(segment) {
    return segment.length > 1;
  }
  function d3_geo_clipBufferListener() {
    var lines = [],
        line;
    return {
      lineStart: function lineStart() {
        lines.push(line = []);
      },
      point: function point(λ, φ) {
        line.push([λ, φ]);
      },
      lineEnd: d3_noop,
      buffer: function buffer() {
        var buffer = lines;
        lines = [];
        line = null;
        return buffer;
      },
      rejoin: function rejoin() {
        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
      }
    };
  }
  function d3_geo_clipSort(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
  }
  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [-π, -π / 2]);
  function d3_geo_clipAntimeridianLine(listener) {
    var λ0 = NaN,
        φ0 = NaN,
        sλ0 = NaN,
        _clean;
    return {
      lineStart: function lineStart() {
        listener.lineStart();
        _clean = 1;
      },
      point: function point(λ1, φ1) {
        var sλ1 = λ1 > 0 ? π : -π,
            dλ = abs(λ1 - λ0);
        if (abs(dλ - π) < ε) {
          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          listener.point(λ1, φ0);
          _clean = 0;
        } else if (sλ0 !== sλ1 && dλ >= π) {
          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          _clean = 0;
        }
        listener.point(λ0 = λ1, φ0 = φ1);
        sλ0 = sλ1;
      },
      lineEnd: function lineEnd() {
        listener.lineEnd();
        λ0 = φ0 = NaN;
      },
      clean: function clean() {
        return 2 - _clean;
      }
    };
  }
  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
    var cosφ0,
        cosφ1,
        sinλ0_λ1 = Math.sin(λ0 - λ1);
    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
  }
  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
    var φ;
    if (from == null) {
      φ = direction * halfπ;
      listener.point(-π, φ);
      listener.point(0, φ);
      listener.point(π, φ);
      listener.point(π, 0);
      listener.point(π, -φ);
      listener.point(0, -φ);
      listener.point(-π, -φ);
      listener.point(-π, 0);
      listener.point(-π, φ);
    } else if (abs(from[0] - to[0]) > ε) {
      var s = from[0] < to[0] ? π : -π;
      φ = direction * s / 2;
      listener.point(-s, φ);
      listener.point(0, φ);
      listener.point(s, φ);
    } else {
      listener.point(to[0], to[1]);
    }
  }
  function d3_geo_pointInPolygon(point, polygon) {
    var meridian = point[0],
        parallel = point[1],
        meridianNormal = [Math.sin(meridian), -Math.cos(meridian), 0],
        polarAngle = 0,
        winding = 0;
    d3_geo_areaRingSum.reset();
    for (var i = 0, n = polygon.length; i < n; ++i) {
      var ring = polygon[i],
          m = ring.length;
      if (!m) continue;
      var point0 = ring[0],
          λ0 = point0[0],
          φ0 = point0[1] / 2 + π / 4,
          sinφ0 = Math.sin(φ0),
          cosφ0 = Math.cos(φ0),
          j = 1;
      while (true) {
        if (j === m) j = 0;
        point = ring[j];
        var λ = point[0],
            φ = point[1] / 2 + π / 4,
            sinφ = Math.sin(φ),
            cosφ = Math.cos(φ),
            dλ = λ - λ0,
            sdλ = dλ >= 0 ? 1 : -1,
            adλ = sdλ * dλ,
            antimeridian = adλ > π,
            k = sinφ0 * sinφ;
        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
          d3_geo_cartesianNormalize(arc);
          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
          d3_geo_cartesianNormalize(intersection);
          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
          }
        }
        if (!j++) break;
        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
      }
    }
    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
  }
  function d3_geo_clipCircle(radius) {
    var cr = Math.cos(radius),
        smallRadius = cr > 0,
        notHemisphere = abs(cr) > ε,
        interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-π, radius - π]);
    function visible(λ, φ) {
      return Math.cos(λ) * Math.cos(φ) > cr;
    }
    function clipLine(listener) {
      var point0, c0, v0, v00, _clean2;
      return {
        lineStart: function lineStart() {
          v00 = v0 = false;
          _clean2 = 1;
        },
        point: function point(λ, φ) {
          var point1 = [λ, φ],
              point2,
              v = visible(λ, φ),
              c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
          if (!point0 && (v00 = v0 = v)) listener.lineStart();
          if (v !== v0) {
            point2 = intersect(point0, point1);
            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
              point1[0] += ε;
              point1[1] += ε;
              v = visible(point1[0], point1[1]);
            }
          }
          if (v !== v0) {
            _clean2 = 0;
            if (v) {
              listener.lineStart();
              point2 = intersect(point1, point0);
              listener.point(point2[0], point2[1]);
            } else {
              point2 = intersect(point0, point1);
              listener.point(point2[0], point2[1]);
              listener.lineEnd();
            }
            point0 = point2;
          } else if (notHemisphere && point0 && smallRadius ^ v) {
            var t;
            if (!(c & c0) && (t = intersect(point1, point0, true))) {
              _clean2 = 0;
              if (smallRadius) {
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
              } else {
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
              }
            }
          }
          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
            listener.point(point1[0], point1[1]);
          }
          point0 = point1, v0 = v, c0 = c;
        },
        lineEnd: function lineEnd() {
          if (v0) listener.lineEnd();
          point0 = null;
        },
        clean: function clean() {
          return _clean2 | (v00 && v0) << 1;
        }
      };
    }
    function intersect(a, b, two) {
      var pa = d3_geo_cartesian(a),
          pb = d3_geo_cartesian(b);
      var n1 = [1, 0, 0],
          n2 = d3_geo_cartesianCross(pa, pb),
          n2n2 = d3_geo_cartesianDot(n2, n2),
          n1n2 = n2[0],
          determinant = n2n2 - n1n2 * n1n2;
      if (!determinant) return !two && a;
      var c1 = cr * n2n2 / determinant,
          c2 = -cr * n1n2 / determinant,
          n1xn2 = d3_geo_cartesianCross(n1, n2),
          A = d3_geo_cartesianScale(n1, c1),
          B = d3_geo_cartesianScale(n2, c2);
      d3_geo_cartesianAdd(A, B);
      var u = n1xn2,
          w = d3_geo_cartesianDot(A, u),
          uu = d3_geo_cartesianDot(u, u),
          t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
      if (t2 < 0) return;
      var t = Math.sqrt(t2),
          q = d3_geo_cartesianScale(u, (-w - t) / uu);
      d3_geo_cartesianAdd(q, A);
      q = d3_geo_spherical(q);
      if (!two) return q;
      var λ0 = a[0],
          λ1 = b[0],
          φ0 = a[1],
          φ1 = b[1],
          z;
      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
      var δλ = λ1 - λ0,
          polar = abs(δλ - π) < ε,
          meridian = polar || δλ < ε;
      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
        d3_geo_cartesianAdd(q1, A);
        return [q, d3_geo_spherical(q1)];
      }
    }
    function code(λ, φ) {
      var r = smallRadius ? radius : π - radius,
          code = 0;
      if (λ < -r) code |= 1;else if (λ > r) code |= 2;
      if (φ < -r) code |= 4;else if (φ > r) code |= 8;
      return code;
    }
  }
  function d3_geom_clipLine(x0, y0, x1, y1) {
    return function (line) {
      var a = line.a,
          b = line.b,
          ax = a.x,
          ay = a.y,
          bx = b.x,
          by = b.y,
          t0 = 0,
          t1 = 1,
          dx = bx - ax,
          dy = by - ay,
          r;
      r = x0 - ax;
      if (!dx && r > 0) return;
      r /= dx;
      if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = x1 - ax;
      if (!dx && r < 0) return;
      r /= dx;
      if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      r = y0 - ay;
      if (!dy && r > 0) return;
      r /= dy;
      if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = y1 - ay;
      if (!dy && r < 0) return;
      r /= dy;
      if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      if (t0 > 0) line.a = {
        x: ax + t0 * dx,
        y: ay + t0 * dy
      };
      if (t1 < 1) line.b = {
        x: ax + t1 * dx,
        y: ay + t1 * dy
      };
      return line;
    };
  }
  var d3_geo_clipExtentMAX = 1e9;
  d3.geo.clipExtent = function () {
    var x0,
        y0,
        x1,
        y1,
        _stream,
        clip,
        clipExtent = {
      stream: function stream(output) {
        if (_stream) _stream.valid = false;
        _stream = clip(output);
        _stream.valid = true;
        return _stream;
      },
      extent: function extent(_) {
        if (!arguments.length) return [[x0, y0], [x1, y1]];
        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
        if (_stream) _stream.valid = false, _stream = null;
        return clipExtent;
      }
    };
    return clipExtent.extent([[0, 0], [960, 500]]);
  };
  function d3_geo_clipExtent(x0, y0, x1, y1) {
    return function (listener) {
      var listener_ = listener,
          bufferListener = d3_geo_clipBufferListener(),
          clipLine = d3_geom_clipLine(x0, y0, x1, y1),
          segments,
          polygon,
          ring;
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function polygonStart() {
          listener = bufferListener;
          segments = [];
          polygon = [];
          clean = true;
        },
        polygonEnd: function polygonEnd() {
          listener = listener_;
          segments = d3.merge(segments);
          var clipStartInside = insidePolygon([x0, y1]),
              inside = clean && clipStartInside,
              visible = segments.length;
          if (inside || visible) {
            listener.polygonStart();
            if (inside) {
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
            }
            if (visible) {
              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
            }
            listener.polygonEnd();
          }
          segments = polygon = ring = null;
        }
      };
      function insidePolygon(p) {
        var wn = 0,
            n = polygon.length,
            y = p[1];
        for (var i = 0; i < n; ++i) {
          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
            b = v[j];
            if (a[1] <= y) {
              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
            } else {
              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
            }
            a = b;
          }
        }
        return wn !== 0;
      }
      function interpolate(from, to, direction, listener) {
        var a = 0,
            a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
          do {
            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
          } while ((a = (a + direction + 4) % 4) !== a1);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function pointVisible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
      }
      function point(x, y) {
        if (pointVisible(x, y)) listener.point(x, y);
      }
      var x__, y__, v__, x_, y_, v_, first, clean;
      function lineStart() {
        clip.point = linePoint;
        if (polygon) polygon.push(ring = []);
        first = true;
        v_ = false;
        x_ = y_ = NaN;
      }
      function lineEnd() {
        if (segments) {
          linePoint(x__, y__);
          if (v__ && v_) bufferListener.rejoin();
          segments.push(bufferListener.buffer());
        }
        clip.point = point;
        if (v_) listener.lineEnd();
      }
      function linePoint(x, y) {
        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
        var v = pointVisible(x, y);
        if (polygon) ring.push([x, y]);
        if (first) {
          x__ = x, y__ = y, v__ = v;
          first = false;
          if (v) {
            listener.lineStart();
            listener.point(x, y);
          }
        } else {
          if (v && v_) listener.point(x, y);else {
            var l = {
              a: {
                x: x_,
                y: y_
              },
              b: {
                x: x,
                y: y
              }
            };
            if (clipLine(l)) {
              if (!v_) {
                listener.lineStart();
                listener.point(l.a.x, l.a.y);
              }
              listener.point(l.b.x, l.b.y);
              if (!v) listener.lineEnd();
              clean = false;
            } else if (v) {
              listener.lineStart();
              listener.point(x, y);
              clean = false;
            }
          }
        }
        x_ = x, y_ = y, v_ = v;
      }
      return clip;
    };
    function corner(p, direction) {
      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
    }
    function compare(a, b) {
      return comparePoints(a.x, b.x);
    }
    function comparePoints(a, b) {
      var ca = corner(a, 1),
          cb = corner(b, 1);
      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
  }
  function d3_geo_conic(projectAt) {
    var φ0 = 0,
        φ1 = π / 3,
        m = d3_geo_projectionMutator(projectAt),
        p = m(φ0, φ1);
    p.parallels = function (_) {
      if (!arguments.length) return [φ0 / π * 180, φ1 / π * 180];
      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
    };
    return p;
  }
  function d3_geo_conicEqualArea(φ0, φ1) {
    var sinφ0 = Math.sin(φ0),
        n = (sinφ0 + Math.sin(φ1)) / 2,
        C = 1 + sinφ0 * (2 * n - sinφ0),
        ρ0 = Math.sqrt(C) / n;
    function forward(λ, φ) {
      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
      return [ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ)];
    }
    forward.invert = function (x, y) {
      var ρ0_y = ρ0 - y;
      return [Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n))];
    };
    return forward;
  }
  (d3.geo.conicEqualArea = function () {
    return d3_geo_conic(d3_geo_conicEqualArea);
  }).raw = d3_geo_conicEqualArea;
  d3.geo.albers = function () {
    return d3.geo.conicEqualArea().rotate([96, 0]).center([-.6, 38.7]).parallels([29.5, 45.5]).scale(1070);
  };
  d3.geo.albersUsa = function () {
    var lower48 = d3.geo.albers();
    var alaska = d3.geo.conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]);
    var hawaii = d3.geo.conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]);
    var _point,
        pointStream = {
      point: function point(x, y) {
        _point = [x, y];
      }
    },
        lower48Point,
        alaskaPoint,
        hawaiiPoint;
    function albersUsa(coordinates) {
      var x = coordinates[0],
          y = coordinates[1];
      _point = null;
      (lower48Point(x, y), _point) || (alaskaPoint(x, y), _point) || hawaiiPoint(x, y);
      return _point;
    }
    albersUsa.invert = function (coordinates) {
      var k = lower48.scale(),
          t = lower48.translate(),
          x = (coordinates[0] - t[0]) / k,
          y = (coordinates[1] - t[1]) / k;
      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function (stream) {
      var lower48Stream = lower48.stream(stream),
          alaskaStream = alaska.stream(stream),
          hawaiiStream = hawaii.stream(stream);
      return {
        point: function point(x, y) {
          lower48Stream.point(x, y);
          alaskaStream.point(x, y);
          hawaiiStream.point(x, y);
        },
        sphere: function sphere() {
          lower48Stream.sphere();
          alaskaStream.sphere();
          hawaiiStream.sphere();
        },
        lineStart: function lineStart() {
          lower48Stream.lineStart();
          alaskaStream.lineStart();
          hawaiiStream.lineStart();
        },
        lineEnd: function lineEnd() {
          lower48Stream.lineEnd();
          alaskaStream.lineEnd();
          hawaiiStream.lineEnd();
        },
        polygonStart: function polygonStart() {
          lower48Stream.polygonStart();
          alaskaStream.polygonStart();
          hawaiiStream.polygonStart();
        },
        polygonEnd: function polygonEnd() {
          lower48Stream.polygonEnd();
          alaskaStream.polygonEnd();
          hawaiiStream.polygonEnd();
        }
      };
    };
    albersUsa.precision = function (_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_);
      alaska.precision(_);
      hawaii.precision(_);
      return albersUsa;
    };
    albersUsa.scale = function (_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_);
      alaska.scale(_ * .35);
      hawaii.scale(_);
      return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function (_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(),
          x = +_[0],
          y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([[x - .455 * k, y - .238 * k], [x + .455 * k, y + .238 * k]]).stream(pointStream).point;
      alaskaPoint = alaska.translate([x - .307 * k, y + .201 * k]).clipExtent([[x - .425 * k + ε, y + .12 * k + ε], [x - .214 * k - ε, y + .234 * k - ε]]).stream(pointStream).point;
      hawaiiPoint = hawaii.translate([x - .205 * k, y + .212 * k]).clipExtent([[x - .214 * k + ε, y + .166 * k + ε], [x - .115 * k - ε, y + .234 * k - ε]]).stream(pointStream).point;
      return albersUsa;
    };
    return albersUsa.scale(1070);
  };
  var d3_geo_pathAreaSum,
      d3_geo_pathAreaPolygon,
      d3_geo_pathArea = {
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function polygonStart() {
      d3_geo_pathAreaPolygon = 0;
      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
    },
    polygonEnd: function polygonEnd() {
      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
    }
  };
  function d3_geo_pathAreaRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathArea.point = function (x, y) {
      d3_geo_pathArea.point = nextPoint;
      x00 = x0 = x, y00 = y0 = y;
    };
    function nextPoint(x, y) {
      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
      x0 = x, y0 = y;
    }
    d3_geo_pathArea.lineEnd = function () {
      nextPoint(x00, y00);
    };
  }
  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
  var d3_geo_pathBounds = {
    point: d3_geo_pathBoundsPoint,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_pathBoundsPoint(x, y) {
    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
  }
  function d3_geo_pathBuffer() {
    var pointCircle = d3_geo_pathBufferCircle(4.5),
        buffer = [];
    var stream = {
      point: point,
      lineStart: function lineStart() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function polygonStart() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function polygonEnd() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function pointRadius(_) {
        pointCircle = d3_geo_pathBufferCircle(_);
        return stream;
      },
      result: function result() {
        if (buffer.length) {
          var result = buffer.join("");
          buffer = [];
          return result;
        }
      }
    };
    function point(x, y) {
      buffer.push("M", x, ",", y, pointCircle);
    }
    function pointLineStart(x, y) {
      buffer.push("M", x, ",", y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      buffer.push("L", x, ",", y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      buffer.push("Z");
    }
    return stream;
  }
  function d3_geo_pathBufferCircle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
  }
  var d3_geo_pathCentroid = {
    point: d3_geo_pathCentroidPoint,
    lineStart: d3_geo_pathCentroidLineStart,
    lineEnd: d3_geo_pathCentroidLineEnd,
    polygonStart: function polygonStart() {
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
    },
    polygonEnd: function polygonEnd() {
      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
    }
  };
  function d3_geo_pathCentroidPoint(x, y) {
    d3_geo_centroidX0 += x;
    d3_geo_centroidY0 += y;
    ++d3_geo_centroidZ0;
  }
  function d3_geo_pathCentroidLineStart() {
    var x0, y0;
    d3_geo_pathCentroid.point = function (x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0,
          dy = y - y0,
          z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
  }
  function d3_geo_pathCentroidLineEnd() {
    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
  }
  function d3_geo_pathCentroidRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathCentroid.point = function (x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0,
          dy = y - y0,
          z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      z = y0 * x - x0 * y;
      d3_geo_centroidX2 += z * (x0 + x);
      d3_geo_centroidY2 += z * (y0 + y);
      d3_geo_centroidZ2 += z * 3;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
    d3_geo_pathCentroid.lineEnd = function () {
      nextPoint(x00, y00);
    };
  }
  function d3_geo_pathContext(context) {
    var _pointRadius = 4.5;
    var stream = {
      point: point,
      lineStart: function lineStart() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function polygonStart() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function polygonEnd() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function pointRadius(_) {
        _pointRadius = _;
        return stream;
      },
      result: d3_noop
    };
    function point(x, y) {
      context.moveTo(x + _pointRadius, y);
      context.arc(x, y, _pointRadius, 0, τ);
    }
    function pointLineStart(x, y) {
      context.moveTo(x, y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      context.lineTo(x, y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      context.closePath();
    }
    return stream;
  }
  function d3_geo_resample(project) {
    var δ2 = .5,
        cosMinDistance = Math.cos(30 * d3_radians),
        maxDepth = 16;
    function resample(stream) {
      return (maxDepth ? resampleRecursive : resampleNone)(stream);
    }
    function resampleNone(stream) {
      return d3_geo_transformPoint(stream, function (x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      });
    }
    function resampleRecursive(stream) {
      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
      var resample = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function polygonStart() {
          stream.polygonStart();
          resample.lineStart = ringStart;
        },
        polygonEnd: function polygonEnd() {
          stream.polygonEnd();
          resample.lineStart = lineStart;
        }
      };
      function point(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      }
      function lineStart() {
        x0 = NaN;
        resample.point = linePoint;
        stream.lineStart();
      }
      function linePoint(λ, φ) {
        var c = d3_geo_cartesian([λ, φ]),
            p = project(λ, φ);
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
        stream.point(x0, y0);
      }
      function lineEnd() {
        resample.point = point;
        stream.lineEnd();
      }
      function ringStart() {
        lineStart();
        resample.point = ringPoint;
        resample.lineEnd = ringEnd;
      }
      function ringPoint(λ, φ) {
        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
        resample.point = linePoint;
      }
      function ringEnd() {
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
        resample.lineEnd = lineEnd;
        lineEnd();
      }
      return resample;
    }
    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
      var dx = x1 - x0,
          dy = y1 - y0,
          d2 = dx * dx + dy * dy;
      if (d2 > 4 * δ2 && depth--) {
        var a = a0 + a1,
            b = b0 + b1,
            c = c0 + c1,
            m = Math.sqrt(a * a + b * b + c * c),
            φ2 = Math.asin(c /= m),
            λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a),
            p = project(λ2, φ2),
            x2 = p[0],
            y2 = p[1],
            dx2 = x2 - x0,
            dy2 = y2 - y0,
            dz = dy * dx2 - dx * dy2;
        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
          stream.point(x2, y2);
          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
        }
      }
    }
    resample.precision = function (_) {
      if (!arguments.length) return Math.sqrt(δ2);
      maxDepth = (δ2 = _ * _) > 0 && 16;
      return resample;
    };
    return resample;
  }
  d3.geo.path = function () {
    var pointRadius = 4.5,
        projection,
        context,
        projectStream,
        contextStream,
        cacheStream;
    function path(object) {
      if (object) {
        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
        d3.geo.stream(object, cacheStream);
      }
      return contextStream.result();
    }
    path.area = function (object) {
      d3_geo_pathAreaSum = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathArea));
      return d3_geo_pathAreaSum;
    };
    path.centroid = function (object) {
      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
      return d3_geo_centroidZ2 ? [d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2] : d3_geo_centroidZ1 ? [d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1] : d3_geo_centroidZ0 ? [d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0] : [NaN, NaN];
    };
    path.bounds = function (object) {
      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
      return [[d3_geo_pathBoundsX0, d3_geo_pathBoundsY0], [d3_geo_pathBoundsX1, d3_geo_pathBoundsY1]];
    };
    path.projection = function (_) {
      if (!arguments.length) return projection;
      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
      return reset();
    };
    path.context = function (_) {
      if (!arguments.length) return context;
      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
      return reset();
    };
    path.pointRadius = function (_) {
      if (!arguments.length) return pointRadius;
      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
      return path;
    };
    function reset() {
      cacheStream = null;
      return path;
    }
    return path.projection(d3.geo.albersUsa()).context(null);
  };
  function d3_geo_pathProjectStream(project) {
    var resample = d3_geo_resample(function (x, y) {
      return project([x * d3_degrees, y * d3_degrees]);
    });
    return function (stream) {
      return d3_geo_projectionRadians(resample(stream));
    };
  }
  d3.geo.transform = function (methods) {
    return {
      stream: function stream(_stream2) {
        var transform = new d3_geo_transform(_stream2);
        for (var k in methods) {
          transform[k] = methods[k];
        }return transform;
      }
    };
  };
  function d3_geo_transform(stream) {
    this.stream = stream;
  }
  d3_geo_transform.prototype = {
    point: function point(x, y) {
      this.stream.point(x, y);
    },
    sphere: function sphere() {
      this.stream.sphere();
    },
    lineStart: function lineStart() {
      this.stream.lineStart();
    },
    lineEnd: function lineEnd() {
      this.stream.lineEnd();
    },
    polygonStart: function polygonStart() {
      this.stream.polygonStart();
    },
    polygonEnd: function polygonEnd() {
      this.stream.polygonEnd();
    }
  };
  function d3_geo_transformPoint(stream, point) {
    return {
      point: point,
      sphere: function sphere() {
        stream.sphere();
      },
      lineStart: function lineStart() {
        stream.lineStart();
      },
      lineEnd: function lineEnd() {
        stream.lineEnd();
      },
      polygonStart: function polygonStart() {
        stream.polygonStart();
      },
      polygonEnd: function polygonEnd() {
        stream.polygonEnd();
      }
    };
  }
  d3.geo.projection = d3_geo_projection;
  d3.geo.projectionMutator = d3_geo_projectionMutator;
  function d3_geo_projection(project) {
    return d3_geo_projectionMutator(function () {
      return project;
    })();
  }
  function d3_geo_projectionMutator(projectAt) {
    var project,
        rotate,
        projectRotate,
        projectResample = d3_geo_resample(function (x, y) {
      x = project(x, y);
      return [x[0] * k + δx, δy - x[1] * k];
    }),
        k = 150,
        x = 480,
        y = 250,
        λ = 0,
        φ = 0,
        δλ = 0,
        δφ = 0,
        δγ = 0,
        δx,
        δy,
        preclip = d3_geo_clipAntimeridian,
        postclip = d3_identity,
        clipAngle = null,
        clipExtent = null,
        stream;
    function projection(point) {
      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
      return [point[0] * k + δx, δy - point[1] * k];
    }
    function invert(point) {
      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
      return point && [point[0] * d3_degrees, point[1] * d3_degrees];
    }
    projection.stream = function (output) {
      if (stream) stream.valid = false;
      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
      stream.valid = true;
      return stream;
    };
    projection.clipAngle = function (_) {
      if (!arguments.length) return clipAngle;
      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
      return invalidate();
    };
    projection.clipExtent = function (_) {
      if (!arguments.length) return clipExtent;
      clipExtent = _;
      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
      return invalidate();
    };
    projection.scale = function (_) {
      if (!arguments.length) return k;
      k = +_;
      return reset();
    };
    projection.translate = function (_) {
      if (!arguments.length) return [x, y];
      x = +_[0];
      y = +_[1];
      return reset();
    };
    projection.center = function (_) {
      if (!arguments.length) return [λ * d3_degrees, φ * d3_degrees];
      λ = _[0] % 360 * d3_radians;
      φ = _[1] % 360 * d3_radians;
      return reset();
    };
    projection.rotate = function (_) {
      if (!arguments.length) return [δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees];
      δλ = _[0] % 360 * d3_radians;
      δφ = _[1] % 360 * d3_radians;
      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
      return reset();
    };
    d3.rebind(projection, projectResample, "precision");
    function reset() {
      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
      var center = project(λ, φ);
      δx = x - center[0] * k;
      δy = y + center[1] * k;
      return invalidate();
    }
    function invalidate() {
      if (stream) stream.valid = false, stream = null;
      return projection;
    }
    return function () {
      project = projectAt.apply(this, arguments);
      projection.invert = project.invert && invert;
      return reset();
    };
  }
  function d3_geo_projectionRadians(stream) {
    return d3_geo_transformPoint(stream, function (x, y) {
      stream.point(x * d3_radians, y * d3_radians);
    });
  }
  function d3_geo_equirectangular(λ, φ) {
    return [λ, φ];
  }
  (d3.geo.equirectangular = function () {
    return d3_geo_projection(d3_geo_equirectangular);
  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
  d3.geo.rotation = function (rotate) {
    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
    function forward(coordinates) {
      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    }
    forward.invert = function (coordinates) {
      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    };
    return forward;
  };
  function d3_geo_identityRotation(λ, φ) {
    return [λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ];
  }
  d3_geo_identityRotation.invert = d3_geo_equirectangular;
  function d3_geo_rotation(δλ, δφ, δγ) {
    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
  }
  function d3_geo_forwardRotationλ(δλ) {
    return function (λ, φ) {
      return λ += δλ, [λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ];
    };
  }
  function d3_geo_rotationλ(δλ) {
    var rotation = d3_geo_forwardRotationλ(δλ);
    rotation.invert = d3_geo_forwardRotationλ(-δλ);
    return rotation;
  }
  function d3_geo_rotationφγ(δφ, δγ) {
    var cosδφ = Math.cos(δφ),
        sinδφ = Math.sin(δφ),
        cosδγ = Math.cos(δγ),
        sinδγ = Math.sin(δγ);
    function rotation(λ, φ) {
      var cosφ = Math.cos(φ),
          x = Math.cos(λ) * cosφ,
          y = Math.sin(λ) * cosφ,
          z = Math.sin(φ),
          k = z * cosδφ + x * sinδφ;
      return [Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ)];
    }
    rotation.invert = function (λ, φ) {
      var cosφ = Math.cos(φ),
          x = Math.cos(λ) * cosφ,
          y = Math.sin(λ) * cosφ,
          z = Math.sin(φ),
          k = z * cosδγ - y * sinδγ;
      return [Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ)];
    };
    return rotation;
  }
  d3.geo.circle = function () {
    var origin = [0, 0],
        angle,
        precision = 6,
        interpolate;
    function circle() {
      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin,
          rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert,
          ring = [];
      interpolate(null, null, 1, {
        point: function point(x, y) {
          ring.push(x = rotate(x, y));
          x[0] *= d3_degrees, x[1] *= d3_degrees;
        }
      });
      return {
        type: "Polygon",
        coordinates: [ring]
      };
    }
    circle.origin = function (x) {
      if (!arguments.length) return origin;
      origin = x;
      return circle;
    };
    circle.angle = function (x) {
      if (!arguments.length) return angle;
      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
      return circle;
    };
    circle.precision = function (_) {
      if (!arguments.length) return precision;
      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
      return circle;
    };
    return circle.angle(90);
  };
  function d3_geo_circleInterpolate(radius, precision) {
    var cr = Math.cos(radius),
        sr = Math.sin(radius);
    return function (from, to, direction, listener) {
      var step = direction * precision;
      if (from != null) {
        from = d3_geo_circleAngle(cr, from);
        to = d3_geo_circleAngle(cr, to);
        if (direction > 0 ? from < to : from > to) from += direction * τ;
      } else {
        from = radius + direction * τ;
        to = radius - .5 * step;
      }
      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
        listener.point((point = d3_geo_spherical([cr, -sr * Math.cos(t), -sr * Math.sin(t)]))[0], point[1]);
      }
    };
  }
  function d3_geo_circleAngle(cr, point) {
    var a = d3_geo_cartesian(point);
    a[0] -= cr;
    d3_geo_cartesianNormalize(a);
    var angle = d3_acos(-a[1]);
    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
  }
  d3.geo.distance = function (a, b) {
    var Δλ = (b[0] - a[0]) * d3_radians,
        φ0 = a[1] * d3_radians,
        φ1 = b[1] * d3_radians,
        sinΔλ = Math.sin(Δλ),
        cosΔλ = Math.cos(Δλ),
        sinφ0 = Math.sin(φ0),
        cosφ0 = Math.cos(φ0),
        sinφ1 = Math.sin(φ1),
        cosφ1 = Math.cos(φ1),
        t;
    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
  };
  d3.geo.graticule = function () {
    var x1,
        x0,
        X1,
        X0,
        y1,
        y0,
        Y1,
        Y0,
        dx = 10,
        dy = dx,
        DX = 90,
        DY = 360,
        x,
        y,
        X,
        Y,
        precision = 2.5;
    function graticule() {
      return {
        type: "MultiLineString",
        coordinates: lines()
      };
    }
    function lines() {
      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function (x) {
        return abs(x % DX) > ε;
      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function (y) {
        return abs(y % DY) > ε;
      }).map(y));
    }
    graticule.lines = function () {
      return lines().map(function (coordinates) {
        return {
          type: "LineString",
          coordinates: coordinates
        };
      });
    };
    graticule.outline = function () {
      return {
        type: "Polygon",
        coordinates: [X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))]
      };
    };
    graticule.extent = function (_) {
      if (!arguments.length) return graticule.minorExtent();
      return graticule.majorExtent(_).minorExtent(_);
    };
    graticule.majorExtent = function (_) {
      if (!arguments.length) return [[X0, Y0], [X1, Y1]];
      X0 = +_[0][0], X1 = +_[1][0];
      Y0 = +_[0][1], Y1 = +_[1][1];
      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
      return graticule.precision(precision);
    };
    graticule.minorExtent = function (_) {
      if (!arguments.length) return [[x0, y0], [x1, y1]];
      x0 = +_[0][0], x1 = +_[1][0];
      y0 = +_[0][1], y1 = +_[1][1];
      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
      return graticule.precision(precision);
    };
    graticule.step = function (_) {
      if (!arguments.length) return graticule.minorStep();
      return graticule.majorStep(_).minorStep(_);
    };
    graticule.majorStep = function (_) {
      if (!arguments.length) return [DX, DY];
      DX = +_[0], DY = +_[1];
      return graticule;
    };
    graticule.minorStep = function (_) {
      if (!arguments.length) return [dx, dy];
      dx = +_[0], dy = +_[1];
      return graticule;
    };
    graticule.precision = function (_) {
      if (!arguments.length) return precision;
      precision = +_;
      x = d3_geo_graticuleX(y0, y1, 90);
      y = d3_geo_graticuleY(x0, x1, precision);
      X = d3_geo_graticuleX(Y0, Y1, 90);
      Y = d3_geo_graticuleY(X0, X1, precision);
      return graticule;
    };
    return graticule.majorExtent([[-180, -90 + ε], [180, 90 - ε]]).minorExtent([[-180, -80 - ε], [180, 80 + ε]]);
  };
  function d3_geo_graticuleX(y0, y1, dy) {
    var y = d3.range(y0, y1 - ε, dy).concat(y1);
    return function (x) {
      return y.map(function (y) {
        return [x, y];
      });
    };
  }
  function d3_geo_graticuleY(x0, x1, dx) {
    var x = d3.range(x0, x1 - ε, dx).concat(x1);
    return function (y) {
      return x.map(function (x) {
        return [x, y];
      });
    };
  }
  function d3_source(d) {
    return d.source;
  }
  function d3_target(d) {
    return d.target;
  }
  d3.geo.greatArc = function () {
    var source = d3_source,
        source_,
        target = d3_target,
        target_;
    function greatArc() {
      return {
        type: "LineString",
        coordinates: [source_ || source.apply(this, arguments), target_ || target.apply(this, arguments)]
      };
    }
    greatArc.distance = function () {
      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
    };
    greatArc.source = function (_) {
      if (!arguments.length) return source;
      source = _, source_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.target = function (_) {
      if (!arguments.length) return target;
      target = _, target_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.precision = function () {
      return arguments.length ? greatArc : 0;
    };
    return greatArc;
  };
  d3.geo.interpolate = function (source, target) {
    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
  };
  function d3_geo_interpolate(x0, y0, x1, y1) {
    var cy0 = Math.cos(y0),
        sy0 = Math.sin(y0),
        cy1 = Math.cos(y1),
        sy1 = Math.sin(y1),
        kx0 = cy0 * Math.cos(x0),
        ky0 = cy0 * Math.sin(x0),
        kx1 = cy1 * Math.cos(x1),
        ky1 = cy1 * Math.sin(x1),
        d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))),
        k = 1 / Math.sin(d);
    var interpolate = d ? function (t) {
      var B = Math.sin(t *= d) * k,
          A = Math.sin(d - t) * k,
          x = A * kx0 + B * kx1,
          y = A * ky0 + B * ky1,
          z = A * sy0 + B * sy1;
      return [Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees];
    } : function () {
      return [x0 * d3_degrees, y0 * d3_degrees];
    };
    interpolate.distance = d;
    return interpolate;
  }
  d3.geo.length = function (object) {
    d3_geo_lengthSum = 0;
    d3.geo.stream(object, d3_geo_length);
    return d3_geo_lengthSum;
  };
  var d3_geo_lengthSum;
  var d3_geo_length = {
    sphere: d3_noop,
    point: d3_noop,
    lineStart: d3_geo_lengthLineStart,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_lengthLineStart() {
    var λ0, sinφ0, cosφ0;
    d3_geo_length.point = function (λ, φ) {
      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
      d3_geo_length.point = nextPoint;
    };
    d3_geo_length.lineEnd = function () {
      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
    };
    function nextPoint(λ, φ) {
      var sinφ = Math.sin(φ *= d3_radians),
          cosφ = Math.cos(φ),
          t = abs((λ *= d3_radians) - λ0),
          cosΔλ = Math.cos(t);
      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
    }
  }
  function d3_geo_azimuthal(scale, angle) {
    function azimuthal(λ, φ) {
      var cosλ = Math.cos(λ),
          cosφ = Math.cos(φ),
          k = scale(cosλ * cosφ);
      return [k * cosφ * Math.sin(λ), k * Math.sin(φ)];
    }
    azimuthal.invert = function (x, y) {
      var ρ = Math.sqrt(x * x + y * y),
          c = angle(ρ),
          sinc = Math.sin(c),
          cosc = Math.cos(c);
      return [Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ)];
    };
    return azimuthal;
  }
  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function (cosλcosφ) {
    return Math.sqrt(2 / (1 + cosλcosφ));
  }, function (ρ) {
    return 2 * Math.asin(ρ / 2);
  });
  (d3.geo.azimuthalEqualArea = function () {
    return d3_geo_projection(d3_geo_azimuthalEqualArea);
  }).raw = d3_geo_azimuthalEqualArea;
  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function (cosλcosφ) {
    var c = Math.acos(cosλcosφ);
    return c && c / Math.sin(c);
  }, d3_identity);
  (d3.geo.azimuthalEquidistant = function () {
    return d3_geo_projection(d3_geo_azimuthalEquidistant);
  }).raw = d3_geo_azimuthalEquidistant;
  function d3_geo_conicConformal(φ0, φ1) {
    var cosφ0 = Math.cos(φ0),
        t = function t(φ) {
      return Math.tan(π / 4 + φ / 2);
    },
        n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)),
        F = cosφ0 * Math.pow(t(φ0), n) / n;
    if (!n) return d3_geo_mercator;
    function forward(λ, φ) {
      if (F > 0) {
        if (φ < -halfπ + ε) φ = -halfπ + ε;
      } else {
        if (φ > halfπ - ε) φ = halfπ - ε;
      }
      var ρ = F / Math.pow(t(φ), n);
      return [ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ)];
    }
    forward.invert = function (x, y) {
      var ρ0_y = F - y,
          ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
      return [Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ];
    };
    return forward;
  }
  (d3.geo.conicConformal = function () {
    return d3_geo_conic(d3_geo_conicConformal);
  }).raw = d3_geo_conicConformal;
  function d3_geo_conicEquidistant(φ0, φ1) {
    var cosφ0 = Math.cos(φ0),
        n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0),
        G = cosφ0 / n + φ0;
    if (abs(n) < ε) return d3_geo_equirectangular;
    function forward(λ, φ) {
      var ρ = G - φ;
      return [ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ)];
    }
    forward.invert = function (x, y) {
      var ρ0_y = G - y;
      return [Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y)];
    };
    return forward;
  }
  (d3.geo.conicEquidistant = function () {
    return d3_geo_conic(d3_geo_conicEquidistant);
  }).raw = d3_geo_conicEquidistant;
  var d3_geo_gnomonic = d3_geo_azimuthal(function (cosλcosφ) {
    return 1 / cosλcosφ;
  }, Math.atan);
  (d3.geo.gnomonic = function () {
    return d3_geo_projection(d3_geo_gnomonic);
  }).raw = d3_geo_gnomonic;
  function d3_geo_mercator(λ, φ) {
    return [λ, Math.log(Math.tan(π / 4 + φ / 2))];
  }
  d3_geo_mercator.invert = function (x, y) {
    return [x, 2 * Math.atan(Math.exp(y)) - halfπ];
  };
  function d3_geo_mercatorProjection(project) {
    var m = d3_geo_projection(project),
        scale = m.scale,
        translate = m.translate,
        clipExtent = m.clipExtent,
        clipAuto;
    m.scale = function () {
      var v = scale.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.translate = function () {
      var v = translate.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.clipExtent = function (_) {
      var v = clipExtent.apply(m, arguments);
      if (v === m) {
        if (clipAuto = _ == null) {
          var k = π * scale(),
              t = translate();
          clipExtent([[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]]);
        }
      } else if (clipAuto) {
        v = null;
      }
      return v;
    };
    return m.clipExtent(null);
  }
  (d3.geo.mercator = function () {
    return d3_geo_mercatorProjection(d3_geo_mercator);
  }).raw = d3_geo_mercator;
  var d3_geo_orthographic = d3_geo_azimuthal(function () {
    return 1;
  }, Math.asin);
  (d3.geo.orthographic = function () {
    return d3_geo_projection(d3_geo_orthographic);
  }).raw = d3_geo_orthographic;
  var d3_geo_stereographic = d3_geo_azimuthal(function (cosλcosφ) {
    return 1 / (1 + cosλcosφ);
  }, function (ρ) {
    return 2 * Math.atan(ρ);
  });
  (d3.geo.stereographic = function () {
    return d3_geo_projection(d3_geo_stereographic);
  }).raw = d3_geo_stereographic;
  function d3_geo_transverseMercator(λ, φ) {
    return [Math.log(Math.tan(π / 4 + φ / 2)), -λ];
  }
  d3_geo_transverseMercator.invert = function (x, y) {
    return [-y, 2 * Math.atan(Math.exp(x)) - halfπ];
  };
  (d3.geo.transverseMercator = function () {
    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator),
        center = projection.center,
        rotate = projection.rotate;
    projection.center = function (_) {
      return _ ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
    };
    projection.rotate = function (_) {
      return _ ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
    };
    return rotate([0, 0, 90]);
  }).raw = d3_geo_transverseMercator;
  d3.geom = {};
  function d3_geom_pointX(d) {
    return d[0];
  }
  function d3_geom_pointY(d) {
    return d[1];
  }
  d3.geom.hull = function (vertices) {
    var x = d3_geom_pointX,
        y = d3_geom_pointY;
    if (arguments.length) return hull(vertices);
    function hull(data) {
      if (data.length < 3) return [];
      var fx = d3_functor(x),
          fy = d3_functor(y),
          i,
          n = data.length,
          points = [],
          flippedPoints = [];
      for (i = 0; i < n; i++) {
        points.push([+fx.call(this, data[i], i), +fy.call(this, data[i], i), i]);
      }
      points.sort(d3_geom_hullOrder);
      for (i = 0; i < n; i++) {
        flippedPoints.push([points[i][0], -points[i][1]]);
      }var upper = d3_geom_hullUpper(points),
          lower = d3_geom_hullUpper(flippedPoints);
      var skipLeft = lower[0] === upper[0],
          skipRight = lower[lower.length - 1] === upper[upper.length - 1],
          polygon = [];
      for (i = upper.length - 1; i >= 0; --i) {
        polygon.push(data[points[upper[i]][2]]);
      }for (i = +skipLeft; i < lower.length - skipRight; ++i) {
        polygon.push(data[points[lower[i]][2]]);
      }return polygon;
    }
    hull.x = function (_) {
      return arguments.length ? (x = _, hull) : x;
    };
    hull.y = function (_) {
      return arguments.length ? (y = _, hull) : y;
    };
    return hull;
  };
  function d3_geom_hullUpper(points) {
    var n = points.length,
        hull = [0, 1],
        hs = 2;
    for (var i = 2; i < n; i++) {
      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) {
        --hs;
      }hull[hs++] = i;
    }
    return hull.slice(0, hs);
  }
  function d3_geom_hullOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
  }
  d3.geom.polygon = function (coordinates) {
    d3_subclass(coordinates, d3_geom_polygonPrototype);
    return coordinates;
  };
  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
  d3_geom_polygonPrototype.area = function () {
    var i = -1,
        n = this.length,
        a,
        b = this[n - 1],
        area = 0;
    while (++i < n) {
      a = b;
      b = this[i];
      area += a[1] * b[0] - a[0] * b[1];
    }
    return area * .5;
  };
  d3_geom_polygonPrototype.centroid = function (k) {
    var i = -1,
        n = this.length,
        x = 0,
        y = 0,
        a,
        b = this[n - 1],
        c;
    if (!arguments.length) k = -1 / (6 * this.area());
    while (++i < n) {
      a = b;
      b = this[i];
      c = a[0] * b[1] - b[0] * a[1];
      x += (a[0] + b[0]) * c;
      y += (a[1] + b[1]) * c;
    }
    return [x * k, y * k];
  };
  d3_geom_polygonPrototype.clip = function (subject) {
    var input,
        closed = d3_geom_polygonClosed(subject),
        i = -1,
        n = this.length - d3_geom_polygonClosed(this),
        j,
        m,
        a = this[n - 1],
        b,
        c,
        d;
    while (++i < n) {
      input = subject.slice();
      subject.length = 0;
      b = this[i];
      c = input[(m = input.length - closed) - 1];
      j = -1;
      while (++j < m) {
        d = input[j];
        if (d3_geom_polygonInside(d, a, b)) {
          if (!d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          subject.push(d);
        } else if (d3_geom_polygonInside(c, a, b)) {
          subject.push(d3_geom_polygonIntersect(c, d, a, b));
        }
        c = d;
      }
      if (closed) subject.push(subject[0]);
      a = b;
    }
    return subject;
  };
  function d3_geom_polygonInside(p, a, b) {
    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
  }
  function d3_geom_polygonIntersect(c, d, a, b) {
    var x1 = c[0],
        x3 = a[0],
        x21 = d[0] - x1,
        x43 = b[0] - x3,
        y1 = c[1],
        y3 = a[1],
        y21 = d[1] - y1,
        y43 = b[1] - y3,
        ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
    return [x1 + ua * x21, y1 + ua * y21];
  }
  function d3_geom_polygonClosed(coordinates) {
    var a = coordinates[0],
        b = coordinates[coordinates.length - 1];
    return !(a[0] - b[0] || a[1] - b[1]);
  }
  var d3_geom_voronoiEdges,
      d3_geom_voronoiCells,
      d3_geom_voronoiBeaches,
      d3_geom_voronoiBeachPool = [],
      d3_geom_voronoiFirstCircle,
      d3_geom_voronoiCircles,
      d3_geom_voronoiCirclePool = [];
  function d3_geom_voronoiBeach() {
    d3_geom_voronoiRedBlackNode(this);
    this.edge = this.site = this.circle = null;
  }
  function d3_geom_voronoiCreateBeach(site) {
    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
    beach.site = site;
    return beach;
  }
  function d3_geom_voronoiDetachBeach(beach) {
    d3_geom_voronoiDetachCircle(beach);
    d3_geom_voronoiBeaches.remove(beach);
    d3_geom_voronoiBeachPool.push(beach);
    d3_geom_voronoiRedBlackNode(beach);
  }
  function d3_geom_voronoiRemoveBeach(beach) {
    var circle = beach.circle,
        x = circle.x,
        y = circle.cy,
        vertex = {
      x: x,
      y: y
    },
        previous = beach.P,
        next = beach.N,
        disappearing = [beach];
    d3_geom_voronoiDetachBeach(beach);
    var lArc = previous;
    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
      previous = lArc.P;
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachBeach(lArc);
      lArc = previous;
    }
    disappearing.unshift(lArc);
    d3_geom_voronoiDetachCircle(lArc);
    var rArc = next;
    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
      next = rArc.N;
      disappearing.push(rArc);
      d3_geom_voronoiDetachBeach(rArc);
      rArc = next;
    }
    disappearing.push(rArc);
    d3_geom_voronoiDetachCircle(rArc);
    var nArcs = disappearing.length,
        iArc;
    for (iArc = 1; iArc < nArcs; ++iArc) {
      rArc = disappearing[iArc];
      lArc = disappearing[iArc - 1];
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiAddBeach(site) {
    var x = site.x,
        directrix = site.y,
        lArc,
        rArc,
        dxl,
        dxr,
        node = d3_geom_voronoiBeaches._;
    while (node) {
      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
      if (dxl > ε) node = node.L;else {
        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
        if (dxr > ε) {
          if (!node.R) {
            lArc = node;
            break;
          }
          node = node.R;
        } else {
          if (dxl > -ε) {
            lArc = node.P;
            rArc = node;
          } else if (dxr > -ε) {
            lArc = node;
            rArc = node.N;
          } else {
            lArc = rArc = node;
          }
          break;
        }
      }
    }
    var newArc = d3_geom_voronoiCreateBeach(site);
    d3_geom_voronoiBeaches.insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
      d3_geom_voronoiDetachCircle(lArc);
      rArc = d3_geom_voronoiCreateBeach(lArc.site);
      d3_geom_voronoiBeaches.insert(newArc, rArc);
      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
      return;
    }
    if (!rArc) {
      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      return;
    }
    d3_geom_voronoiDetachCircle(lArc);
    d3_geom_voronoiDetachCircle(rArc);
    var lSite = lArc.site,
        ax = lSite.x,
        ay = lSite.y,
        bx = site.x - ax,
        by = site.y - ay,
        rSite = rArc.site,
        cx = rSite.x - ax,
        cy = rSite.y - ay,
        d = 2 * (bx * cy - by * cx),
        hb = bx * bx + by * by,
        hc = cx * cx + cy * cy,
        vertex = {
      x: (cy * hb - by * hc) / d + ax,
      y: (bx * hc - cx * hb) / d + ay
    };
    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
    var site = arc.site,
        rfocx = site.x,
        rfocy = site.y,
        pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site.x,
        lfocy = site.y,
        plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx,
        aby2 = 1 / pby2 - 1 / plby2,
        b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
  }
  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site.y === directrix ? site.x : Infinity;
  }
  function d3_geom_voronoiCell(site) {
    this.site = site;
    this.edges = [];
  }
  d3_geom_voronoiCell.prototype.prepare = function () {
    var halfEdges = this.edges,
        iHalfEdge = halfEdges.length,
        edge;
    while (iHalfEdge--) {
      edge = halfEdges[iHalfEdge].edge;
      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
    }
    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
    return halfEdges.length;
  };
  function d3_geom_voronoiCloseCells(extent) {
    var x0 = extent[0][0],
        x1 = extent[1][0],
        y0 = extent[0][1],
        y1 = extent[1][1],
        x2,
        y2,
        x3,
        y3,
        cells = d3_geom_voronoiCells,
        iCell = cells.length,
        cell,
        iHalfEdge,
        halfEdges,
        nHalfEdges,
        start,
        end;
    while (iCell--) {
      cell = cells[iCell];
      if (!cell || !cell.prepare()) continue;
      halfEdges = cell.edges;
      nHalfEdges = halfEdges.length;
      iHalfEdge = 0;
      while (iHalfEdge < nHalfEdges) {
        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
            x: x0,
            y: abs(x2 - x0) < ε ? y2 : y1
          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
            x: abs(y2 - y1) < ε ? x2 : x1,
            y: y1
          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
            x: x1,
            y: abs(x2 - x1) < ε ? y2 : y0
          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
            x: abs(y2 - y0) < ε ? x2 : x0,
            y: y0
          } : null), cell.site, null));
          ++nHalfEdges;
        }
      }
    }
  }
  function d3_geom_voronoiHalfEdgeOrder(a, b) {
    return b.angle - a.angle;
  }
  function d3_geom_voronoiCircle() {
    d3_geom_voronoiRedBlackNode(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function d3_geom_voronoiAttachCircle(arc) {
    var lArc = arc.P,
        rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site,
        cSite = arc.site,
        rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite.x,
        by = cSite.y,
        ax = lSite.x - bx,
        ay = lSite.y - by,
        cx = rSite.x - bx,
        cy = rSite.y - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -ε2) return;
    var ha = ax * ax + ay * ay,
        hc = cx * cx + cy * cy,
        x = (cy * ha - ay * hc) / d,
        y = (ax * hc - cx * ha) / d,
        cy = y + by;
    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = cy + Math.sqrt(x * x + y * y);
    circle.cy = cy;
    arc.circle = circle;
    var before = null,
        node = d3_geom_voronoiCircles._;
    while (node) {
      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
        if (node.L) node = node.L;else {
          before = node.P;
          break;
        }
      } else {
        if (node.R) node = node.R;else {
          before = node;
          break;
        }
      }
    }
    d3_geom_voronoiCircles.insert(before, circle);
    if (!before) d3_geom_voronoiFirstCircle = circle;
  }
  function d3_geom_voronoiDetachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
      d3_geom_voronoiCircles.remove(circle);
      d3_geom_voronoiCirclePool.push(circle);
      d3_geom_voronoiRedBlackNode(circle);
      arc.circle = null;
    }
  }
  function d3_geom_voronoiClipEdges(extent) {
    var edges = d3_geom_voronoiEdges,
        clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]),
        i = edges.length,
        e;
    while (i--) {
      e = edges[i];
      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
        e.a = e.b = null;
        edges.splice(i, 1);
      }
    }
  }
  function d3_geom_voronoiConnectEdge(edge, extent) {
    var vb = edge.b;
    if (vb) return true;
    var va = edge.a,
        x0 = extent[0][0],
        x1 = extent[1][0],
        y0 = extent[0][1],
        y1 = extent[1][1],
        lSite = edge.l,
        rSite = edge.r,
        lx = lSite.x,
        ly = lSite.y,
        rx = rSite.x,
        ry = rSite.y,
        fx = (lx + rx) / 2,
        fy = (ly + ry) / 2,
        fm,
        fb;
    if (ry === ly) {
      if (fx < x0 || fx >= x1) return;
      if (lx > rx) {
        if (!va) va = {
          x: fx,
          y: y0
        };else if (va.y >= y1) return;
        vb = {
          x: fx,
          y: y1
        };
      } else {
        if (!va) va = {
          x: fx,
          y: y1
        };else if (va.y < y0) return;
        vb = {
          x: fx,
          y: y0
        };
      }
    } else {
      fm = (lx - rx) / (ry - ly);
      fb = fy - fm * fx;
      if (fm < -1 || fm > 1) {
        if (lx > rx) {
          if (!va) va = {
            x: (y0 - fb) / fm,
            y: y0
          };else if (va.y >= y1) return;
          vb = {
            x: (y1 - fb) / fm,
            y: y1
          };
        } else {
          if (!va) va = {
            x: (y1 - fb) / fm,
            y: y1
          };else if (va.y < y0) return;
          vb = {
            x: (y0 - fb) / fm,
            y: y0
          };
        }
      } else {
        if (ly < ry) {
          if (!va) va = {
            x: x0,
            y: fm * x0 + fb
          };else if (va.x >= x1) return;
          vb = {
            x: x1,
            y: fm * x1 + fb
          };
        } else {
          if (!va) va = {
            x: x1,
            y: fm * x1 + fb
          };else if (va.x < x0) return;
          vb = {
            x: x0,
            y: fm * x0 + fb
          };
        }
      }
    }
    edge.a = va;
    edge.b = vb;
    return true;
  }
  function d3_geom_voronoiEdge(lSite, rSite) {
    this.l = lSite;
    this.r = rSite;
    this.a = this.b = null;
  }
  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, rSite);
    d3_geom_voronoiEdges.push(edge);
    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
    return edge;
  }
  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, null);
    edge.a = va;
    edge.b = vb;
    d3_geom_voronoiEdges.push(edge);
    return edge;
  }
  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
    if (!edge.a && !edge.b) {
      edge.a = vertex;
      edge.l = lSite;
      edge.r = rSite;
    } else if (edge.l === rSite) {
      edge.b = vertex;
    } else {
      edge.a = vertex;
    }
  }
  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
    var va = edge.a,
        vb = edge.b;
    this.edge = edge;
    this.site = lSite;
    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
  }
  d3_geom_voronoiHalfEdge.prototype = {
    start: function start() {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function end() {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  };
  function d3_geom_voronoiRedBlackTree() {
    this._ = null;
  }
  function d3_geom_voronoiRedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null;
  }
  d3_geom_voronoiRedBlackTree.prototype = {
    insert: function insert(after, node) {
      var parent, grandpa, uncle;
      if (after) {
        node.P = after;
        node.N = after.N;
        if (after.N) after.N.P = node;
        after.N = node;
        if (after.R) {
          after = after.R;
          while (after.L) {
            after = after.L;
          }after.L = node;
        } else {
          after.R = node;
        }
        parent = after;
      } else if (this._) {
        after = d3_geom_voronoiRedBlackFirst(this._);
        node.P = null;
        node.N = after;
        after.P = after.L = node;
        parent = after;
      } else {
        node.P = node.N = null;
        this._ = node;
        parent = null;
      }
      node.L = node.R = null;
      node.U = parent;
      node.C = true;
      after = node;
      while (parent && parent.C) {
        grandpa = parent.U;
        if (parent === grandpa.L) {
          uncle = grandpa.R;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.R) {
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
          }
        } else {
          uncle = grandpa.L;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.L) {
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
          }
        }
        parent = after.U;
      }
      this._.C = false;
    },
    remove: function remove(node) {
      if (node.N) node.N.P = node.P;
      if (node.P) node.P.N = node.N;
      node.N = node.P = null;
      var parent = node.U,
          sibling,
          left = node.L,
          right = node.R,
          next,
          red;
      if (!left) next = right;else if (!right) next = left;else next = d3_geom_voronoiRedBlackFirst(right);
      if (parent) {
        if (parent.L === node) parent.L = next;else parent.R = next;
      } else {
        this._ = next;
      }
      if (left && right) {
        red = next.C;
        next.C = node.C;
        next.L = left;
        left.U = next;
        if (next !== right) {
          parent = next.U;
          next.U = node.U;
          node = next.R;
          parent.L = node;
          next.R = right;
          right.U = next;
        } else {
          next.U = parent;
          parent = next;
          node = next.R;
        }
      } else {
        red = node.C;
        node = next;
      }
      if (node) node.U = parent;
      if (red) return;
      if (node && node.C) {
        node.C = false;
        return;
      }
      do {
        if (node === this._) break;
        if (node === parent.L) {
          sibling = parent.R;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            sibling = parent.R;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.R || !sibling.R.C) {
              sibling.L.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, sibling);
              sibling = parent.R;
            }
            sibling.C = parent.C;
            parent.C = sibling.R.C = false;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            node = this._;
            break;
          }
        } else {
          sibling = parent.L;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            sibling = parent.L;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.L || !sibling.L.C) {
              sibling.R.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
              sibling = parent.L;
            }
            sibling.C = parent.C;
            parent.C = sibling.L.C = false;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            node = this._;
            break;
          }
        }
        sibling.C = true;
        node = parent;
        parent = parent.U;
      } while (!node.C);
      if (node) node.C = false;
    }
  };
  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
    var p = node,
        q = node.R,
        parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q;else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
  }
  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
    var p = node,
        q = node.L,
        parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q;else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
  }
  function d3_geom_voronoiRedBlackFirst(node) {
    while (node.L) {
      node = node.L;
    }return node;
  }
  function d3_geom_voronoi(sites, bbox) {
    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(),
        x0,
        y0,
        circle;
    d3_geom_voronoiEdges = [];
    d3_geom_voronoiCells = new Array(sites.length);
    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
    while (true) {
      circle = d3_geom_voronoiFirstCircle;
      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
        if (site.x !== x0 || site.y !== y0) {
          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
          d3_geom_voronoiAddBeach(site);
          x0 = site.x, y0 = site.y;
        }
        site = sites.pop();
      } else if (circle) {
        d3_geom_voronoiRemoveBeach(circle.arc);
      } else {
        break;
      }
    }
    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
    var diagram = {
      cells: d3_geom_voronoiCells,
      edges: d3_geom_voronoiEdges
    };
    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
    return diagram;
  }
  function d3_geom_voronoiVertexOrder(a, b) {
    return b.y - a.y || b.x - a.x;
  }
  d3.geom.voronoi = function (points) {
    var x = d3_geom_pointX,
        y = d3_geom_pointY,
        fx = x,
        fy = y,
        clipExtent = d3_geom_voronoiClipExtent;
    if (points) return voronoi(points);
    function voronoi(data) {
      var polygons = new Array(data.length),
          x0 = clipExtent[0][0],
          y0 = clipExtent[0][1],
          x1 = clipExtent[1][0],
          y1 = clipExtent[1][1];
      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function (cell, i) {
        var edges = cell.edges,
            site = cell.site,
            polygon = polygons[i] = edges.length ? edges.map(function (e) {
          var s = e.start();
          return [s.x, s.y];
        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [[x0, y1], [x1, y1], [x1, y0], [x0, y0]] : [];
        polygon.point = data[i];
      });
      return polygons;
    }
    function sites(data) {
      return data.map(function (d, i) {
        return {
          x: Math.round(fx(d, i) / ε) * ε,
          y: Math.round(fy(d, i) / ε) * ε,
          i: i
        };
      });
    }
    voronoi.links = function (data) {
      return d3_geom_voronoi(sites(data)).edges.filter(function (edge) {
        return edge.l && edge.r;
      }).map(function (edge) {
        return {
          source: data[edge.l.i],
          target: data[edge.r.i]
        };
      });
    };
    voronoi.triangles = function (data) {
      var triangles = [];
      d3_geom_voronoi(sites(data)).cells.forEach(function (cell, i) {
        var site = cell.site,
            edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder),
            j = -1,
            m = edges.length,
            e0,
            s0,
            e1 = edges[m - 1].edge,
            s1 = e1.l === site ? e1.r : e1.l;
        while (++j < m) {
          e0 = e1;
          s0 = s1;
          e1 = edges[j].edge;
          s1 = e1.l === site ? e1.r : e1.l;
          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
            triangles.push([data[i], data[s0.i], data[s1.i]]);
          }
        }
      });
      return triangles;
    };
    voronoi.x = function (_) {
      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
    };
    voronoi.y = function (_) {
      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
    };
    voronoi.clipExtent = function (_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
      return voronoi;
    };
    voronoi.size = function (_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
      return voronoi.clipExtent(_ && [[0, 0], _]);
    };
    return voronoi;
  };
  var d3_geom_voronoiClipExtent = [[-1e6, -1e6], [1e6, 1e6]];
  function d3_geom_voronoiTriangleArea(a, b, c) {
    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
  }
  d3.geom.delaunay = function (vertices) {
    return d3.geom.voronoi().triangles(vertices);
  };
  d3.geom.quadtree = function (points, x1, y1, x2, y2) {
    var x = d3_geom_pointX,
        y = d3_geom_pointY,
        compat;
    if (compat = arguments.length) {
      x = d3_geom_quadtreeCompatX;
      y = d3_geom_quadtreeCompatY;
      if (compat === 3) {
        y2 = y1;
        x2 = x1;
        y1 = x1 = 0;
      }
      return quadtree(points);
    }
    function quadtree(data) {
      var d,
          fx = d3_functor(x),
          fy = d3_functor(y),
          xs,
          ys,
          i,
          n,
          x1_,
          y1_,
          x2_,
          y2_;
      if (x1 != null) {
        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
      } else {
        x2_ = y2_ = -(x1_ = y1_ = Infinity);
        xs = [], ys = [];
        n = data.length;
        if (compat) for (i = 0; i < n; ++i) {
          d = data[i];
          if (d.x < x1_) x1_ = d.x;
          if (d.y < y1_) y1_ = d.y;
          if (d.x > x2_) x2_ = d.x;
          if (d.y > y2_) y2_ = d.y;
          xs.push(d.x);
          ys.push(d.y);
        } else for (i = 0; i < n; ++i) {
          var x_ = +fx(d = data[i], i),
              y_ = +fy(d, i);
          if (x_ < x1_) x1_ = x_;
          if (y_ < y1_) y1_ = y_;
          if (x_ > x2_) x2_ = x_;
          if (y_ > y2_) y2_ = y_;
          xs.push(x_);
          ys.push(y_);
        }
      }
      var dx = x2_ - x1_,
          dy = y2_ - y1_;
      if (dx > dy) y2_ = y1_ + dx;else x2_ = x1_ + dy;
      function insert(n, d, x, y, x1, y1, x2, y2) {
        if (isNaN(x) || isNaN(y)) return;
        if (n.leaf) {
          var nx = n.x,
              ny = n.y;
          if (nx != null) {
            if (abs(nx - x) + abs(ny - y) < .01) {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            } else {
              var nPoint = n.point;
              n.x = n.y = n.point = null;
              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          } else {
            n.x = x, n.y = y, n.point = d;
          }
        } else {
          insertChild(n, d, x, y, x1, y1, x2, y2);
        }
      }
      function insertChild(n, d, x, y, x1, y1, x2, y2) {
        var xm = (x1 + x2) * .5,
            ym = (y1 + y2) * .5,
            right = x >= xm,
            below = y >= ym,
            i = below << 1 | right;
        n.leaf = false;
        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
        if (right) x1 = xm;else x2 = xm;
        if (below) y1 = ym;else y2 = ym;
        insert(n, d, x, y, x1, y1, x2, y2);
      }
      var root = d3_geom_quadtreeNode();
      root.add = function (d) {
        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
      };
      root.visit = function (f) {
        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
      };
      root.find = function (point) {
        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
      };
      i = -1;
      if (x1 == null) {
        while (++i < n) {
          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
        }
        --i;
      } else data.forEach(root.add);
      xs = ys = data = d = null;
      return root;
    }
    quadtree.x = function (_) {
      return arguments.length ? (x = _, quadtree) : x;
    };
    quadtree.y = function (_) {
      return arguments.length ? (y = _, quadtree) : y;
    };
    quadtree.extent = function (_) {
      if (!arguments.length) return x1 == null ? null : [[x1, y1], [x2, y2]];
      if (_ == null) x1 = y1 = x2 = y2 = null;else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], y2 = +_[1][1];
      return quadtree;
    };
    quadtree.size = function (_) {
      if (!arguments.length) return x1 == null ? null : [x2 - x1, y2 - y1];
      if (_ == null) x1 = y1 = x2 = y2 = null;else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
      return quadtree;
    };
    return quadtree;
  };
  function d3_geom_quadtreeCompatX(d) {
    return d.x;
  }
  function d3_geom_quadtreeCompatY(d) {
    return d.y;
  }
  function d3_geom_quadtreeNode() {
    return {
      leaf: true,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
    if (!f(node, x1, y1, x2, y2)) {
      var sx = (x1 + x2) * .5,
          sy = (y1 + y2) * .5,
          children = node.nodes;
      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
    }
  }
  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
    var minDistance2 = Infinity,
        closestPoint;
    (function find(node, x1, y1, x2, y2) {
      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
      if (point = node.point) {
        var point,
            dx = x - node.x,
            dy = y - node.y,
            distance2 = dx * dx + dy * dy;
        if (distance2 < minDistance2) {
          var distance = Math.sqrt(minDistance2 = distance2);
          x0 = x - distance, y0 = y - distance;
          x3 = x + distance, y3 = y + distance;
          closestPoint = point;
        }
      }
      var children = node.nodes,
          xm = (x1 + x2) * .5,
          ym = (y1 + y2) * .5,
          right = x >= xm,
          below = y >= ym;
      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
        if (node = children[i & 3]) switch (i & 3) {
          case 0:
            find(node, x1, y1, xm, ym);
            break;

          case 1:
            find(node, xm, y1, x2, ym);
            break;

          case 2:
            find(node, x1, ym, xm, y2);
            break;

          case 3:
            find(node, xm, ym, x2, y2);
            break;
        }
      }
    })(root, x0, y0, x3, y3);
    return closestPoint;
  }
  d3.interpolateRgb = d3_interpolateRgb;
  function d3_interpolateRgb(a, b) {
    a = d3.rgb(a);
    b = d3.rgb(b);
    var ar = a.r,
        ag = a.g,
        ab = a.b,
        br = b.r - ar,
        bg = b.g - ag,
        bb = b.b - ab;
    return function (t) {
      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
    };
  }
  d3.interpolateObject = d3_interpolateObject;
  function d3_interpolateObject(a, b) {
    var i = {},
        c = {},
        k;
    for (k in a) {
      if (k in b) {
        i[k] = d3_interpolate(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }
    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }
    return function (t) {
      for (k in i) {
        c[k] = i[k](t);
      }return c;
    };
  }
  d3.interpolateNumber = d3_interpolateNumber;
  function d3_interpolateNumber(a, b) {
    a = +a, b = +b;
    return function (t) {
      return a * (1 - t) + b * t;
    };
  }
  d3.interpolateString = d3_interpolateString;
  function d3_interpolateString(a, b) {
    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0,
        am,
        bm,
        bs,
        i = -1,
        s = [],
        q = [];
    a = a + "", b = b + "";
    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
      if ((bs = bm.index) > bi) {
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs;else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        if (s[i]) s[i] += bm;else s[++i] = bm;
      } else {
        s[++i] = null;
        q.push({
          i: i,
          x: d3_interpolateNumber(am, bm)
        });
      }
      bi = d3_interpolate_numberB.lastIndex;
    }
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs;else s[++i] = bs;
    }
    return s.length < 2 ? q[0] ? (b = q[0].x, function (t) {
      return b(t) + "";
    }) : function () {
      return b;
    } : (b = q.length, function (t) {
      for (var i = 0, o; i < b; ++i) {
        s[(o = q[i]).i] = o.x(t);
      }return s.join("");
    });
  }
  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
      d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
  d3.interpolate = d3_interpolate;
  function d3_interpolate(a, b) {
    var i = d3.interpolators.length,
        f;
    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) {}
    return f;
  }
  d3.interpolators = [function (a, b) {
    var t = typeof b;
    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
  }];
  d3.interpolateArray = d3_interpolateArray;
  function d3_interpolateArray(a, b) {
    var x = [],
        c = [],
        na = a.length,
        nb = b.length,
        n0 = Math.min(a.length, b.length),
        i;
    for (i = 0; i < n0; ++i) {
      x.push(d3_interpolate(a[i], b[i]));
    }for (; i < na; ++i) {
      c[i] = a[i];
    }for (; i < nb; ++i) {
      c[i] = b[i];
    }return function (t) {
      for (i = 0; i < n0; ++i) {
        c[i] = x[i](t);
      }return c;
    };
  }
  var d3_ease_default = function d3_ease_default() {
    return d3_identity;
  };
  var d3_ease = d3.map({
    linear: d3_ease_default,
    poly: d3_ease_poly,
    quad: function quad() {
      return d3_ease_quad;
    },
    cubic: function cubic() {
      return d3_ease_cubic;
    },
    sin: function sin() {
      return d3_ease_sin;
    },
    exp: function exp() {
      return d3_ease_exp;
    },
    circle: function circle() {
      return d3_ease_circle;
    },
    elastic: d3_ease_elastic,
    back: d3_ease_back,
    bounce: function bounce() {
      return d3_ease_bounce;
    }
  });
  var d3_ease_mode = d3.map({
    "in": d3_identity,
    out: d3_ease_reverse,
    "in-out": d3_ease_reflect,
    "out-in": function outIn(f) {
      return d3_ease_reflect(d3_ease_reverse(f));
    }
  });
  d3.ease = function (name) {
    var i = name.indexOf("-"),
        t = i >= 0 ? name.slice(0, i) : name,
        m = i >= 0 ? name.slice(i + 1) : "in";
    t = d3_ease.get(t) || d3_ease_default;
    m = d3_ease_mode.get(m) || d3_identity;
    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
  };
  function d3_ease_clamp(f) {
    return function (t) {
      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
    };
  }
  function d3_ease_reverse(f) {
    return function (t) {
      return 1 - f(1 - t);
    };
  }
  function d3_ease_reflect(f) {
    return function (t) {
      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
    };
  }
  function d3_ease_quad(t) {
    return t * t;
  }
  function d3_ease_cubic(t) {
    return t * t * t;
  }
  function d3_ease_cubicInOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var t2 = t * t,
        t3 = t2 * t;
    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
  }
  function d3_ease_poly(e) {
    return function (t) {
      return Math.pow(t, e);
    };
  }
  function d3_ease_sin(t) {
    return 1 - Math.cos(t * halfπ);
  }
  function d3_ease_exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  function d3_ease_circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  function d3_ease_elastic(a, p) {
    var s;
    if (arguments.length < 2) p = .45;
    if (arguments.length) s = p / τ * Math.asin(1 / a);else a = 1, s = p / 4;
    return function (t) {
      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
    };
  }
  function d3_ease_back(s) {
    if (!s) s = 1.70158;
    return function (t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  function d3_ease_bounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
  }
  d3.interpolateHcl = d3_interpolateHcl;
  function d3_interpolateHcl(a, b) {
    a = d3.hcl(a);
    b = d3.hcl(b);
    var ah = a.h,
        ac = a.c,
        al = a.l,
        bh = b.h - ah,
        bc = b.c - ac,
        bl = b.l - al;
    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah;else if (bh > 180) bh -= 360;else if (bh < -180) bh += 360;
    return function (t) {
      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
    };
  }
  d3.interpolateHsl = d3_interpolateHsl;
  function d3_interpolateHsl(a, b) {
    a = d3.hsl(a);
    b = d3.hsl(b);
    var ah = a.h,
        as = a.s,
        al = a.l,
        bh = b.h - ah,
        bs = b.s - as,
        bl = b.l - al;
    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah;else if (bh > 180) bh -= 360;else if (bh < -180) bh += 360;
    return function (t) {
      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
    };
  }
  d3.interpolateLab = d3_interpolateLab;
  function d3_interpolateLab(a, b) {
    a = d3.lab(a);
    b = d3.lab(b);
    var al = a.l,
        aa = a.a,
        ab = a.b,
        bl = b.l - al,
        ba = b.a - aa,
        bb = b.b - ab;
    return function (t) {
      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
    };
  }
  d3.interpolateRound = d3_interpolateRound;
  function d3_interpolateRound(a, b) {
    b -= a;
    return function (t) {
      return Math.round(a + b * t);
    };
  }
  d3.transform = function (string) {
    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
    return (d3.transform = function (string) {
      if (string != null) {
        g.setAttribute("transform", string);
        var t = g.transform.baseVal.consolidate();
      }
      return new d3_transform(t ? t.matrix : d3_transformIdentity);
    })(string);
  };
  function d3_transform(m) {
    var r0 = [m.a, m.b],
        r1 = [m.c, m.d],
        kx = d3_transformNormalize(r0),
        kz = d3_transformDot(r0, r1),
        ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }
    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
    this.translate = [m.e, m.f];
    this.scale = [kx, ky];
    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
  }
  d3_transform.prototype.toString = function () {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  function d3_transformDot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }
  function d3_transformNormalize(a) {
    var k = Math.sqrt(d3_transformDot(a, a));
    if (k) {
      a[0] /= k;
      a[1] /= k;
    }
    return k;
  }
  function d3_transformCombine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }
  var d3_transformIdentity = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  d3.interpolateTransform = d3_interpolateTransform;
  function d3_interpolateTransformPop(s) {
    return s.length ? s.pop() + "," : "";
  }
  function d3_interpolateTranslate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ta[0], tb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ta[1], tb[1])
      });
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }
  function d3_interpolateRotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360;else if (rb - ra > 180) ra += 360;
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
        x: d3_interpolateNumber(ra, rb)
      });
    } else if (rb) {
      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
    }
  }
  function d3_interpolateSkew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
        x: d3_interpolateNumber(wa, wb)
      });
    } else if (wb) {
      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
    }
  }
  function d3_interpolateScale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ka[0], kb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ka[1], kb[1])
      });
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
    }
  }
  function d3_interpolateTransform(a, b) {
    var s = [],
        q = [];
    a = d3.transform(a), b = d3.transform(b);
    d3_interpolateTranslate(a.translate, b.translate, s, q);
    d3_interpolateRotate(a.rotate, b.rotate, s, q);
    d3_interpolateSkew(a.skew, b.skew, s, q);
    d3_interpolateScale(a.scale, b.scale, s, q);
    a = b = null;
    return function (t) {
      var i = -1,
          n = q.length,
          o;
      while (++i < n) {
        s[(o = q[i]).i] = o.x(t);
      }return s.join("");
    };
  }
  function d3_uninterpolateNumber(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function (x) {
      return (x - a) / b;
    };
  }
  function d3_uninterpolateClamp(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function (x) {
      return Math.max(0, Math.min(1, (x - a) / b));
    };
  }
  d3.layout = {};
  d3.layout.bundle = function () {
    return function (links) {
      var paths = [],
          i = -1,
          n = links.length;
      while (++i < n) {
        paths.push(d3_layout_bundlePath(links[i]));
      }return paths;
    };
  };
  function d3_layout_bundlePath(link) {
    var start = link.source,
        end = link.target,
        lca = d3_layout_bundleLeastCommonAncestor(start, end),
        points = [start];
    while (start !== lca) {
      start = start.parent;
      points.push(start);
    }
    var k = points.length;
    while (end !== lca) {
      points.splice(k, 0, end);
      end = end.parent;
    }
    return points;
  }
  function d3_layout_bundleAncestors(node) {
    var ancestors = [],
        parent = node.parent;
    while (parent != null) {
      ancestors.push(node);
      node = parent;
      parent = parent.parent;
    }
    ancestors.push(node);
    return ancestors;
  }
  function d3_layout_bundleLeastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = d3_layout_bundleAncestors(a),
        bNodes = d3_layout_bundleAncestors(b),
        aNode = aNodes.pop(),
        bNode = bNodes.pop(),
        sharedNode = null;
    while (aNode === bNode) {
      sharedNode = aNode;
      aNode = aNodes.pop();
      bNode = bNodes.pop();
    }
    return sharedNode;
  }
  d3.layout.chord = function () {
    var chord = {},
        chords,
        groups,
        matrix,
        n,
        padding = 0,
        sortGroups,
        sortSubgroups,
        sortChords;
    function relayout() {
      var subgroups = {},
          groupSums = [],
          groupIndex = d3.range(n),
          subgroupIndex = [],
          k,
          x,
          x0,
          i,
          j;
      chords = [];
      groups = [];
      k = 0, i = -1;
      while (++i < n) {
        x = 0, j = -1;
        while (++j < n) {
          x += matrix[i][j];
        }
        groupSums.push(x);
        subgroupIndex.push(d3.range(n));
        k += x;
      }
      if (sortGroups) {
        groupIndex.sort(function (a, b) {
          return sortGroups(groupSums[a], groupSums[b]);
        });
      }
      if (sortSubgroups) {
        subgroupIndex.forEach(function (d, i) {
          d.sort(function (a, b) {
            return sortSubgroups(matrix[i][a], matrix[i][b]);
          });
        });
      }
      k = (τ - padding * n) / k;
      x = 0, i = -1;
      while (++i < n) {
        x0 = x, j = -1;
        while (++j < n) {
          var di = groupIndex[i],
              dj = subgroupIndex[di][j],
              v = matrix[di][dj],
              a0 = x,
              a1 = x += v * k;
          subgroups[di + "-" + dj] = {
            index: di,
            subindex: dj,
            startAngle: a0,
            endAngle: a1,
            value: v
          };
        }
        groups[di] = {
          index: di,
          startAngle: x0,
          endAngle: x,
          value: groupSums[di]
        };
        x += padding;
      }
      i = -1;
      while (++i < n) {
        j = i - 1;
        while (++j < n) {
          var source = subgroups[i + "-" + j],
              target = subgroups[j + "-" + i];
          if (source.value || target.value) {
            chords.push(source.value < target.value ? {
              source: target,
              target: source
            } : {
              source: source,
              target: target
            });
          }
        }
      }
      if (sortChords) resort();
    }
    function resort() {
      chords.sort(function (a, b) {
        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
      });
    }
    chord.matrix = function (x) {
      if (!arguments.length) return matrix;
      n = (matrix = x) && matrix.length;
      chords = groups = null;
      return chord;
    };
    chord.padding = function (x) {
      if (!arguments.length) return padding;
      padding = x;
      chords = groups = null;
      return chord;
    };
    chord.sortGroups = function (x) {
      if (!arguments.length) return sortGroups;
      sortGroups = x;
      chords = groups = null;
      return chord;
    };
    chord.sortSubgroups = function (x) {
      if (!arguments.length) return sortSubgroups;
      sortSubgroups = x;
      chords = null;
      return chord;
    };
    chord.sortChords = function (x) {
      if (!arguments.length) return sortChords;
      sortChords = x;
      if (chords) resort();
      return chord;
    };
    chord.chords = function () {
      if (!chords) relayout();
      return chords;
    };
    chord.groups = function () {
      if (!groups) relayout();
      return groups;
    };
    return chord;
  };
  d3.layout.force = function () {
    var force = {},
        event = d3.dispatch("start", "tick", "end"),
        timer,
        size = [1, 1],
        drag,
        alpha,
        friction = .9,
        linkDistance = d3_layout_forceLinkDistance,
        linkStrength = d3_layout_forceLinkStrength,
        charge = -30,
        chargeDistance2 = d3_layout_forceChargeDistance2,
        gravity = .1,
        theta2 = .64,
        nodes = [],
        links = [],
        distances,
        strengths,
        charges;
    function repulse(node) {
      return function (quad, x1, _, x2) {
        if (quad.point !== node) {
          var dx = quad.cx - node.x,
              dy = quad.cy - node.y,
              dw = x2 - x1,
              dn = dx * dx + dy * dy;
          if (dw * dw / theta2 < dn) {
            if (dn < chargeDistance2) {
              var k = quad.charge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
            return true;
          }
          if (quad.point && dn && dn < chargeDistance2) {
            var k = quad.pointCharge / dn;
            node.px -= dx * k;
            node.py -= dy * k;
          }
        }
        return !quad.charge;
      };
    }
    force.tick = function () {
      if ((alpha *= .99) < .005) {
        timer = null;
        event.end({
          type: "end",
          alpha: alpha = 0
        });
        return true;
      }
      var n = nodes.length,
          m = links.length,
          q,
          i,
          o,
          s,
          t,
          l,
          k,
          x,
          y;
      for (i = 0; i < m; ++i) {
        o = links[i];
        s = o.source;
        t = o.target;
        x = t.x - s.x;
        y = t.y - s.y;
        if (l = x * x + y * y) {
          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
          x *= l;
          y *= l;
          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
          t.y -= y * k;
          s.x += x * (k = 1 - k);
          s.y += y * k;
        }
      }
      if (k = alpha * gravity) {
        x = size[0] / 2;
        y = size[1] / 2;
        i = -1;
        if (k) while (++i < n) {
          o = nodes[i];
          o.x += (x - o.x) * k;
          o.y += (y - o.y) * k;
        }
      }
      if (charge) {
        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
        i = -1;
        while (++i < n) {
          if (!(o = nodes[i]).fixed) {
            q.visit(repulse(o));
          }
        }
      }
      i = -1;
      while (++i < n) {
        o = nodes[i];
        if (o.fixed) {
          o.x = o.px;
          o.y = o.py;
        } else {
          o.x -= (o.px - (o.px = o.x)) * friction;
          o.y -= (o.py - (o.py = o.y)) * friction;
        }
      }
      event.tick({
        type: "tick",
        alpha: alpha
      });
    };
    force.nodes = function (x) {
      if (!arguments.length) return nodes;
      nodes = x;
      return force;
    };
    force.links = function (x) {
      if (!arguments.length) return links;
      links = x;
      return force;
    };
    force.size = function (x) {
      if (!arguments.length) return size;
      size = x;
      return force;
    };
    force.linkDistance = function (x) {
      if (!arguments.length) return linkDistance;
      linkDistance = typeof x === "function" ? x : +x;
      return force;
    };
    force.distance = force.linkDistance;
    force.linkStrength = function (x) {
      if (!arguments.length) return linkStrength;
      linkStrength = typeof x === "function" ? x : +x;
      return force;
    };
    force.friction = function (x) {
      if (!arguments.length) return friction;
      friction = +x;
      return force;
    };
    force.charge = function (x) {
      if (!arguments.length) return charge;
      charge = typeof x === "function" ? x : +x;
      return force;
    };
    force.chargeDistance = function (x) {
      if (!arguments.length) return Math.sqrt(chargeDistance2);
      chargeDistance2 = x * x;
      return force;
    };
    force.gravity = function (x) {
      if (!arguments.length) return gravity;
      gravity = +x;
      return force;
    };
    force.theta = function (x) {
      if (!arguments.length) return Math.sqrt(theta2);
      theta2 = x * x;
      return force;
    };
    force.alpha = function (x) {
      if (!arguments.length) return alpha;
      x = +x;
      if (alpha) {
        if (x > 0) {
          alpha = x;
        } else {
          timer.c = null, timer.t = NaN, timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
        }
      } else if (x > 0) {
        event.start({
          type: "start",
          alpha: alpha = x
        });
        timer = d3_timer(force.tick);
      }
      return force;
    };
    force.start = function () {
      var i,
          n = nodes.length,
          m = links.length,
          w = size[0],
          h = size[1],
          neighbors,
          o;
      for (i = 0; i < n; ++i) {
        (o = nodes[i]).index = i;
        o.weight = 0;
      }
      for (i = 0; i < m; ++i) {
        o = links[i];
        if (typeof o.source == "number") o.source = nodes[o.source];
        if (typeof o.target == "number") o.target = nodes[o.target];
        ++o.source.weight;
        ++o.target.weight;
      }
      for (i = 0; i < n; ++i) {
        o = nodes[i];
        if (isNaN(o.x)) o.x = position("x", w);
        if (isNaN(o.y)) o.y = position("y", h);
        if (isNaN(o.px)) o.px = o.x;
        if (isNaN(o.py)) o.py = o.y;
      }
      distances = [];
      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) {
        distances[i] = +linkDistance.call(this, links[i], i);
      } else for (i = 0; i < m; ++i) {
        distances[i] = linkDistance;
      }strengths = [];
      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) {
        strengths[i] = +linkStrength.call(this, links[i], i);
      } else for (i = 0; i < m; ++i) {
        strengths[i] = linkStrength;
      }charges = [];
      if (typeof charge === "function") for (i = 0; i < n; ++i) {
        charges[i] = +charge.call(this, nodes[i], i);
      } else for (i = 0; i < n; ++i) {
        charges[i] = charge;
      }function position(dimension, size) {
        if (!neighbors) {
          neighbors = new Array(n);
          for (j = 0; j < n; ++j) {
            neighbors[j] = [];
          }
          for (j = 0; j < m; ++j) {
            var o = links[j];
            neighbors[o.source.index].push(o.target);
            neighbors[o.target.index].push(o.source);
          }
        }
        var candidates = neighbors[i],
            j = -1,
            l = candidates.length,
            x;
        while (++j < l) {
          if (!isNaN(x = candidates[j][dimension])) return x;
        }return Math.random() * size;
      }
      return force.resume();
    };
    force.resume = function () {
      return force.alpha(.1);
    };
    force.stop = function () {
      return force.alpha(0);
    };
    force.drag = function () {
      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
      if (!arguments.length) return drag;
      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
    };
    function dragmove(d) {
      d.px = d3.event.x, d.py = d3.event.y;
      force.resume();
    }
    return d3.rebind(force, event, "on");
  };
  function d3_layout_forceDragstart(d) {
    d.fixed |= 2;
  }
  function d3_layout_forceDragend(d) {
    d.fixed &= ~6;
  }
  function d3_layout_forceMouseover(d) {
    d.fixed |= 4;
    d.px = d.x, d.py = d.y;
  }
  function d3_layout_forceMouseout(d) {
    d.fixed &= ~4;
  }
  function d3_layout_forceAccumulate(quad, alpha, charges) {
    var cx = 0,
        cy = 0;
    quad.charge = 0;
    if (!quad.leaf) {
      var nodes = quad.nodes,
          n = nodes.length,
          i = -1,
          c;
      while (++i < n) {
        c = nodes[i];
        if (c == null) continue;
        d3_layout_forceAccumulate(c, alpha, charges);
        quad.charge += c.charge;
        cx += c.charge * c.cx;
        cy += c.charge * c.cy;
      }
    }
    if (quad.point) {
      if (!quad.leaf) {
        quad.point.x += Math.random() - .5;
        quad.point.y += Math.random() - .5;
      }
      var k = alpha * charges[quad.point.index];
      quad.charge += quad.pointCharge = k;
      cx += k * quad.point.x;
      cy += k * quad.point.y;
    }
    quad.cx = cx / quad.charge;
    quad.cy = cy / quad.charge;
  }
  var d3_layout_forceLinkDistance = 20,
      d3_layout_forceLinkStrength = 1,
      d3_layout_forceChargeDistance2 = Infinity;
  d3.layout.hierarchy = function () {
    var sort = d3_layout_hierarchySort,
        children = d3_layout_hierarchyChildren,
        value = d3_layout_hierarchyValue;
    function hierarchy(root) {
      var stack = [root],
          nodes = [],
          node;
      root.depth = 0;
      while ((node = stack.pop()) != null) {
        nodes.push(node);
        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
          var n, childs, child;
          while (--n >= 0) {
            stack.push(child = childs[n]);
            child.parent = node;
            child.depth = node.depth + 1;
          }
          if (value) node.value = 0;
          node.children = childs;
        } else {
          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
          delete node.children;
        }
      }
      d3_layout_hierarchyVisitAfter(root, function (node) {
        var childs, parent;
        if (sort && (childs = node.children)) childs.sort(sort);
        if (value && (parent = node.parent)) parent.value += node.value;
      });
      return nodes;
    }
    hierarchy.sort = function (x) {
      if (!arguments.length) return sort;
      sort = x;
      return hierarchy;
    };
    hierarchy.children = function (x) {
      if (!arguments.length) return children;
      children = x;
      return hierarchy;
    };
    hierarchy.value = function (x) {
      if (!arguments.length) return value;
      value = x;
      return hierarchy;
    };
    hierarchy.revalue = function (root) {
      if (value) {
        d3_layout_hierarchyVisitBefore(root, function (node) {
          if (node.children) node.value = 0;
        });
        d3_layout_hierarchyVisitAfter(root, function (node) {
          var parent;
          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
          if (parent = node.parent) parent.value += node.value;
        });
      }
      return root;
    };
    return hierarchy;
  };
  function d3_layout_hierarchyRebind(object, hierarchy) {
    d3.rebind(object, hierarchy, "sort", "children", "value");
    object.nodes = object;
    object.links = d3_layout_hierarchyLinks;
    return object;
  }
  function d3_layout_hierarchyVisitBefore(node, callback) {
    var nodes = [node];
    while ((node = nodes.pop()) != null) {
      callback(node);
      if ((children = node.children) && (n = children.length)) {
        var n, children;
        while (--n >= 0) {
          nodes.push(children[n]);
        }
      }
    }
  }
  function d3_layout_hierarchyVisitAfter(node, callback) {
    var nodes = [node],
        nodes2 = [];
    while ((node = nodes.pop()) != null) {
      nodes2.push(node);
      if ((children = node.children) && (n = children.length)) {
        var i = -1,
            n,
            children;
        while (++i < n) {
          nodes.push(children[i]);
        }
      }
    }
    while ((node = nodes2.pop()) != null) {
      callback(node);
    }
  }
  function d3_layout_hierarchyChildren(d) {
    return d.children;
  }
  function d3_layout_hierarchyValue(d) {
    return d.value;
  }
  function d3_layout_hierarchySort(a, b) {
    return b.value - a.value;
  }
  function d3_layout_hierarchyLinks(nodes) {
    return d3.merge(nodes.map(function (parent) {
      return (parent.children || []).map(function (child) {
        return {
          source: parent,
          target: child
        };
      });
    }));
  }
  d3.layout.partition = function () {
    var hierarchy = d3.layout.hierarchy(),
        size = [1, 1];
    function position(node, x, dx, dy) {
      var children = node.children;
      node.x = x;
      node.y = node.depth * dy;
      node.dx = dx;
      node.dy = dy;
      if (children && (n = children.length)) {
        var i = -1,
            n,
            c,
            d;
        dx = node.value ? dx / node.value : 0;
        while (++i < n) {
          position(c = children[i], x, d = c.value * dx, dy);
          x += d;
        }
      }
    }
    function depth(node) {
      var children = node.children,
          d = 0;
      if (children && (n = children.length)) {
        var i = -1,
            n;
        while (++i < n) {
          d = Math.max(d, depth(children[i]));
        }
      }
      return 1 + d;
    }
    function partition(d, i) {
      var nodes = hierarchy.call(this, d, i);
      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
      return nodes;
    }
    partition.size = function (x) {
      if (!arguments.length) return size;
      size = x;
      return partition;
    };
    return d3_layout_hierarchyRebind(partition, hierarchy);
  };
  d3.layout.pie = function () {
    var value = Number,
        sort = d3_layout_pieSortByValue,
        startAngle = 0,
        endAngle = τ,
        padAngle = 0;
    function pie(data) {
      var n = data.length,
          values = data.map(function (d, i) {
        return +value.call(pie, d, i);
      }),
          a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle),
          da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a,
          p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)),
          pa = p * (da < 0 ? -1 : 1),
          sum = d3.sum(values),
          k = sum ? (da - n * pa) / sum : 0,
          index = d3.range(n),
          arcs = [],
          v;
      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function (i, j) {
        return values[j] - values[i];
      } : function (i, j) {
        return sort(data[i], data[j]);
      });
      index.forEach(function (i) {
        arcs[i] = {
          data: data[i],
          value: v = values[i],
          startAngle: a,
          endAngle: a += v * k + pa,
          padAngle: p
        };
      });
      return arcs;
    }
    pie.value = function (_) {
      if (!arguments.length) return value;
      value = _;
      return pie;
    };
    pie.sort = function (_) {
      if (!arguments.length) return sort;
      sort = _;
      return pie;
    };
    pie.startAngle = function (_) {
      if (!arguments.length) return startAngle;
      startAngle = _;
      return pie;
    };
    pie.endAngle = function (_) {
      if (!arguments.length) return endAngle;
      endAngle = _;
      return pie;
    };
    pie.padAngle = function (_) {
      if (!arguments.length) return padAngle;
      padAngle = _;
      return pie;
    };
    return pie;
  };
  var d3_layout_pieSortByValue = {};
  d3.layout.stack = function () {
    var values = d3_identity,
        order = d3_layout_stackOrderDefault,
        offset = d3_layout_stackOffsetZero,
        out = d3_layout_stackOut,
        x = d3_layout_stackX,
        y = d3_layout_stackY;
    function stack(data, index) {
      if (!(n = data.length)) return data;
      var series = data.map(function (d, i) {
        return values.call(stack, d, i);
      });
      var points = series.map(function (d) {
        return d.map(function (v, i) {
          return [x.call(stack, v, i), y.call(stack, v, i)];
        });
      });
      var orders = order.call(stack, points, index);
      series = d3.permute(series, orders);
      points = d3.permute(points, orders);
      var offsets = offset.call(stack, points, index);
      var m = series[0].length,
          n,
          i,
          j,
          o;
      for (j = 0; j < m; ++j) {
        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
        for (i = 1; i < n; ++i) {
          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
        }
      }
      return data;
    }
    stack.values = function (x) {
      if (!arguments.length) return values;
      values = x;
      return stack;
    };
    stack.order = function (x) {
      if (!arguments.length) return order;
      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
      return stack;
    };
    stack.offset = function (x) {
      if (!arguments.length) return offset;
      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
      return stack;
    };
    stack.x = function (z) {
      if (!arguments.length) return x;
      x = z;
      return stack;
    };
    stack.y = function (z) {
      if (!arguments.length) return y;
      y = z;
      return stack;
    };
    stack.out = function (z) {
      if (!arguments.length) return out;
      out = z;
      return stack;
    };
    return stack;
  };
  function d3_layout_stackX(d) {
    return d.x;
  }
  function d3_layout_stackY(d) {
    return d.y;
  }
  function d3_layout_stackOut(d, y0, y) {
    d.y0 = y0;
    d.y = y;
  }
  var d3_layout_stackOrders = d3.map({
    "inside-out": function insideOut(data) {
      var n = data.length,
          i,
          j,
          max = data.map(d3_layout_stackMaxIndex),
          sums = data.map(d3_layout_stackReduceSum),
          index = d3.range(n).sort(function (a, b) {
        return max[a] - max[b];
      }),
          top = 0,
          bottom = 0,
          tops = [],
          bottoms = [];
      for (i = 0; i < n; ++i) {
        j = index[i];
        if (top < bottom) {
          top += sums[j];
          tops.push(j);
        } else {
          bottom += sums[j];
          bottoms.push(j);
        }
      }
      return bottoms.reverse().concat(tops);
    },
    reverse: function reverse(data) {
      return d3.range(data.length).reverse();
    },
    "default": d3_layout_stackOrderDefault
  });
  var d3_layout_stackOffsets = d3.map({
    silhouette: function silhouette(data) {
      var n = data.length,
          m = data[0].length,
          sums = [],
          max = 0,
          i,
          j,
          o,
          y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) {
          o += data[i][j][1];
        }if (o > max) max = o;
        sums.push(o);
      }
      for (j = 0; j < m; ++j) {
        y0[j] = (max - sums[j]) / 2;
      }
      return y0;
    },
    wiggle: function wiggle(data) {
      var n = data.length,
          x = data[0],
          m = x.length,
          i,
          j,
          k,
          s1,
          s2,
          s3,
          dx,
          o,
          o0,
          y0 = [];
      y0[0] = o = o0 = 0;
      for (j = 1; j < m; ++j) {
        for (i = 0, s1 = 0; i < n; ++i) {
          s1 += data[i][j][1];
        }for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
          }
          s2 += s3 * data[i][j][1];
        }
        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
        if (o < o0) o0 = o;
      }
      for (j = 0; j < m; ++j) {
        y0[j] -= o0;
      }return y0;
    },
    expand: function expand(data) {
      var n = data.length,
          m = data[0].length,
          k = 1 / n,
          i,
          j,
          o,
          y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) {
          o += data[i][j][1];
        }if (o) for (i = 0; i < n; i++) {
          data[i][j][1] /= o;
        } else for (i = 0; i < n; i++) {
          data[i][j][1] = k;
        }
      }
      for (j = 0; j < m; ++j) {
        y0[j] = 0;
      }return y0;
    },
    zero: d3_layout_stackOffsetZero
  });
  function d3_layout_stackOrderDefault(data) {
    return d3.range(data.length);
  }
  function d3_layout_stackOffsetZero(data) {
    var j = -1,
        m = data[0].length,
        y0 = [];
    while (++j < m) {
      y0[j] = 0;
    }return y0;
  }
  function d3_layout_stackMaxIndex(array) {
    var i = 1,
        j = 0,
        v = array[0][1],
        k,
        n = array.length;
    for (; i < n; ++i) {
      if ((k = array[i][1]) > v) {
        j = i;
        v = k;
      }
    }
    return j;
  }
  function d3_layout_stackReduceSum(d) {
    return d.reduce(d3_layout_stackSum, 0);
  }
  function d3_layout_stackSum(p, d) {
    return p + d[1];
  }
  d3.layout.histogram = function () {
    var frequency = true,
        valuer = Number,
        ranger = d3_layout_histogramRange,
        binner = d3_layout_histogramBinSturges;
    function histogram(data, i) {
      var bins = [],
          values = data.map(valuer, this),
          range = ranger.call(this, values, i),
          thresholds = binner.call(this, range, values, i),
          bin,
          i = -1,
          n = values.length,
          m = thresholds.length - 1,
          k = frequency ? 1 : 1 / n,
          x;
      while (++i < m) {
        bin = bins[i] = [];
        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
        bin.y = 0;
      }
      if (m > 0) {
        i = -1;
        while (++i < n) {
          x = values[i];
          if (x >= range[0] && x <= range[1]) {
            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
            bin.y += k;
            bin.push(data[i]);
          }
        }
      }
      return bins;
    }
    histogram.value = function (x) {
      if (!arguments.length) return valuer;
      valuer = x;
      return histogram;
    };
    histogram.range = function (x) {
      if (!arguments.length) return ranger;
      ranger = d3_functor(x);
      return histogram;
    };
    histogram.bins = function (x) {
      if (!arguments.length) return binner;
      binner = typeof x === "number" ? function (range) {
        return d3_layout_histogramBinFixed(range, x);
      } : d3_functor(x);
      return histogram;
    };
    histogram.frequency = function (x) {
      if (!arguments.length) return frequency;
      frequency = !!x;
      return histogram;
    };
    return histogram;
  };
  function d3_layout_histogramBinSturges(range, values) {
    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
  }
  function d3_layout_histogramBinFixed(range, n) {
    var x = -1,
        b = +range[0],
        m = (range[1] - b) / n,
        f = [];
    while (++x <= n) {
      f[x] = m * x + b;
    }return f;
  }
  function d3_layout_histogramRange(values) {
    return [d3.min(values), d3.max(values)];
  }
  d3.layout.pack = function () {
    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort),
        padding = 0,
        size = [1, 1],
        radius;
    function pack(d, i) {
      var nodes = hierarchy.call(this, d, i),
          root = nodes[0],
          w = size[0],
          h = size[1],
          r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function () {
        return radius;
      };
      root.x = root.y = 0;
      d3_layout_hierarchyVisitAfter(root, function (d) {
        d.r = +r(d.value);
      });
      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
      if (padding) {
        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
        d3_layout_hierarchyVisitAfter(root, function (d) {
          d.r += dr;
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        d3_layout_hierarchyVisitAfter(root, function (d) {
          d.r -= dr;
        });
      }
      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
      return nodes;
    }
    pack.size = function (_) {
      if (!arguments.length) return size;
      size = _;
      return pack;
    };
    pack.radius = function (_) {
      if (!arguments.length) return radius;
      radius = _ == null || typeof _ === "function" ? _ : +_;
      return pack;
    };
    pack.padding = function (_) {
      if (!arguments.length) return padding;
      padding = +_;
      return pack;
    };
    return d3_layout_hierarchyRebind(pack, hierarchy);
  };
  function d3_layout_packSort(a, b) {
    return a.value - b.value;
  }
  function d3_layout_packInsert(a, b) {
    var c = a._pack_next;
    a._pack_next = b;
    b._pack_prev = a;
    b._pack_next = c;
    c._pack_prev = b;
  }
  function d3_layout_packSplice(a, b) {
    a._pack_next = b;
    b._pack_prev = a;
  }
  function d3_layout_packIntersects(a, b) {
    var dx = b.x - a.x,
        dy = b.y - a.y,
        dr = a.r + b.r;
    return .999 * dr * dr > dx * dx + dy * dy;
  }
  function d3_layout_packSiblings(node) {
    if (!(nodes = node.children) || !(n = nodes.length)) return;
    var nodes,
        xMin = Infinity,
        xMax = -Infinity,
        yMin = Infinity,
        yMax = -Infinity,
        a,
        b,
        c,
        i,
        j,
        k,
        n;
    function bound(node) {
      xMin = Math.min(node.x - node.r, xMin);
      xMax = Math.max(node.x + node.r, xMax);
      yMin = Math.min(node.y - node.r, yMin);
      yMax = Math.max(node.y + node.r, yMax);
    }
    nodes.forEach(d3_layout_packLink);
    a = nodes[0];
    a.x = -a.r;
    a.y = 0;
    bound(a);
    if (n > 1) {
      b = nodes[1];
      b.x = b.r;
      b.y = 0;
      bound(b);
      if (n > 2) {
        c = nodes[2];
        d3_layout_packPlace(a, b, c);
        bound(c);
        d3_layout_packInsert(a, c);
        a._pack_prev = c;
        d3_layout_packInsert(c, b);
        b = a._pack_next;
        for (i = 3; i < n; i++) {
          d3_layout_packPlace(a, b, c = nodes[i]);
          var isect = 0,
              s1 = 1,
              s2 = 1;
          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
            if (d3_layout_packIntersects(j, c)) {
              isect = 1;
              break;
            }
          }
          if (isect == 1) {
            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
              if (d3_layout_packIntersects(k, c)) {
                break;
              }
            }
          }
          if (isect) {
            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j);else d3_layout_packSplice(a = k, b);
            i--;
          } else {
            d3_layout_packInsert(a, c);
            b = c;
            bound(c);
          }
        }
      }
    }
    var cx = (xMin + xMax) / 2,
        cy = (yMin + yMax) / 2,
        cr = 0;
    for (i = 0; i < n; i++) {
      c = nodes[i];
      c.x -= cx;
      c.y -= cy;
      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
    }
    node.r = cr;
    nodes.forEach(d3_layout_packUnlink);
  }
  function d3_layout_packLink(node) {
    node._pack_next = node._pack_prev = node;
  }
  function d3_layout_packUnlink(node) {
    delete node._pack_next;
    delete node._pack_prev;
  }
  function d3_layout_packTransform(node, x, y, k) {
    var children = node.children;
    node.x = x += k * node.x;
    node.y = y += k * node.y;
    node.r *= k;
    if (children) {
      var i = -1,
          n = children.length;
      while (++i < n) {
        d3_layout_packTransform(children[i], x, y, k);
      }
    }
  }
  function d3_layout_packPlace(a, b, c) {
    var db = a.r + c.r,
        dx = b.x - a.x,
        dy = b.y - a.y;
    if (db && (dx || dy)) {
      var da = b.r + c.r,
          dc = dx * dx + dy * dy;
      da *= da;
      db *= db;
      var x = .5 + (db - da) / (2 * dc),
          y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
      c.x = a.x + x * dx + y * dy;
      c.y = a.y + x * dy - y * dx;
    } else {
      c.x = a.x + db;
      c.y = a.y;
    }
  }
  d3.layout.tree = function () {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null),
        separation = d3_layout_treeSeparation,
        size = [1, 1],
        nodeSize = null;
    function tree(d, i) {
      var nodes = hierarchy.call(this, d, i),
          root0 = nodes[0],
          root1 = wrapTree(root0);
      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
      d3_layout_hierarchyVisitBefore(root1, secondWalk);
      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode);else {
        var left = root0,
            right = root0,
            bottom = root0;
        d3_layout_hierarchyVisitBefore(root0, function (node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var tx = separation(left, right) / 2 - left.x,
            kx = size[0] / (right.x + separation(right, left) / 2 + tx),
            ky = size[1] / (bottom.depth || 1);
        d3_layout_hierarchyVisitBefore(root0, function (node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
      return nodes;
    }
    function wrapTree(root0) {
      var root1 = {
        A: null,
        children: [root0]
      },
          queue = [root1],
          node1;
      while ((node1 = queue.pop()) != null) {
        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
          queue.push((children[i] = child = {
            _: children[i],
            parent: node1,
            children: (child = children[i].children) && child.slice() || [],
            A: null,
            a: null,
            z: 0,
            m: 0,
            c: 0,
            s: 0,
            t: null,
            i: i
          }).a = child);
        }
      }
      return root1.children[0];
    }
    function firstWalk(v) {
      var children = v.children,
          siblings = v.parent.children,
          w = v.i ? siblings[v.i - 1] : null;
      if (children.length) {
        d3_layout_treeShift(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v,
            vop = v,
            vim = w,
            vom = vip.parent.children[0],
            sip = vip.m,
            sop = vop.m,
            sim = vim.m,
            som = vom.m,
            shift;
        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
          vom = d3_layout_treeLeft(vom);
          vop = d3_layout_treeRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !d3_layout_treeRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !d3_layout_treeLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
    function sizeNode(node) {
      node.x *= size[0];
      node.y = node.depth * size[1];
    }
    tree.separation = function (x) {
      if (!arguments.length) return separation;
      separation = x;
      return tree;
    };
    tree.size = function (x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null ? sizeNode : null;
      return tree;
    };
    tree.nodeSize = function (x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) == null ? null : sizeNode;
      return tree;
    };
    return d3_layout_hierarchyRebind(tree, hierarchy);
  };
  function d3_layout_treeSeparation(a, b) {
    return a.parent == b.parent ? 1 : 2;
  }
  function d3_layout_treeLeft(v) {
    var children = v.children;
    return children.length ? children[0] : v.t;
  }
  function d3_layout_treeRight(v) {
    var children = v.children,
        n;
    return (n = children.length) ? children[n - 1] : v.t;
  }
  function d3_layout_treeMove(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  function d3_layout_treeShift(v) {
    var shift = 0,
        change = 0,
        children = v.children,
        i = children.length,
        w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  function d3_layout_treeAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  d3.layout.cluster = function () {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null),
        separation = d3_layout_treeSeparation,
        size = [1, 1],
        nodeSize = false;
    function cluster(d, i) {
      var nodes = hierarchy.call(this, d, i),
          root = nodes[0],
          previousNode,
          x = 0;
      d3_layout_hierarchyVisitAfter(root, function (node) {
        var children = node.children;
        if (children && children.length) {
          node.x = d3_layout_clusterX(children);
          node.y = d3_layout_clusterY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = d3_layout_clusterLeft(root),
          right = d3_layout_clusterRight(root),
          x0 = left.x - separation(left, right) / 2,
          x1 = right.x + separation(right, left) / 2;
      d3_layout_hierarchyVisitAfter(root, nodeSize ? function (node) {
        node.x = (node.x - root.x) * size[0];
        node.y = (root.y - node.y) * size[1];
      } : function (node) {
        node.x = (node.x - x0) / (x1 - x0) * size[0];
        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
      });
      return nodes;
    }
    cluster.separation = function (x) {
      if (!arguments.length) return separation;
      separation = x;
      return cluster;
    };
    cluster.size = function (x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null;
      return cluster;
    };
    cluster.nodeSize = function (x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) != null;
      return cluster;
    };
    return d3_layout_hierarchyRebind(cluster, hierarchy);
  };
  function d3_layout_clusterY(children) {
    return 1 + d3.max(children, function (child) {
      return child.y;
    });
  }
  function d3_layout_clusterX(children) {
    return children.reduce(function (x, child) {
      return x + child.x;
    }, 0) / children.length;
  }
  function d3_layout_clusterLeft(node) {
    var children = node.children;
    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
  }
  function d3_layout_clusterRight(node) {
    var children = node.children,
        n;
    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
  }
  d3.layout.treemap = function () {
    var hierarchy = d3.layout.hierarchy(),
        round = Math.round,
        size = [1, 1],
        padding = null,
        pad = d3_layout_treemapPadNull,
        sticky = false,
        stickies,
        mode = "squarify",
        ratio = .5 * (1 + Math.sqrt(5));
    function scale(children, k) {
      var i = -1,
          n = children.length,
          child,
          area;
      while (++i < n) {
        area = (child = children[i]).value * (k < 0 ? 0 : k);
        child.area = isNaN(area) || area <= 0 ? 0 : area;
      }
    }
    function squarify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node),
            row = [],
            remaining = children.slice(),
            child,
            best = Infinity,
            score,
            u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy),
            n;
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while ((n = remaining.length) > 0) {
          row.push(child = remaining[n - 1]);
          row.area += child.area;
          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
            remaining.pop();
            best = score;
          } else {
            row.area -= row.pop().area;
            position(row, u, rect, false);
            u = Math.min(rect.dx, rect.dy);
            row.length = row.area = 0;
            best = Infinity;
          }
        }
        if (row.length) {
          position(row, u, rect, true);
          row.length = row.area = 0;
        }
        children.forEach(squarify);
      }
    }
    function stickify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node),
            remaining = children.slice(),
            child,
            row = [];
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while (child = remaining.pop()) {
          row.push(child);
          row.area += child.area;
          if (child.z != null) {
            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
            row.length = row.area = 0;
          }
        }
        children.forEach(stickify);
      }
    }
    function worst(row, u) {
      var s = row.area,
          r,
          rmax = 0,
          rmin = Infinity,
          i = -1,
          n = row.length;
      while (++i < n) {
        if (!(r = row[i].area)) continue;
        if (r < rmin) rmin = r;
        if (r > rmax) rmax = r;
      }
      s *= s;
      u *= u;
      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
    }
    function position(row, u, rect, flush) {
      var i = -1,
          n = row.length,
          x = rect.x,
          y = rect.y,
          v = u ? round(row.area / u) : 0,
          o;
      if (u == rect.dx) {
        if (flush || v > rect.dy) v = rect.dy;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dy = v;
          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
        }
        o.z = true;
        o.dx += rect.x + rect.dx - x;
        rect.y += v;
        rect.dy -= v;
      } else {
        if (flush || v > rect.dx) v = rect.dx;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dx = v;
          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
        }
        o.z = false;
        o.dy += rect.y + rect.dy - y;
        rect.x += v;
        rect.dx -= v;
      }
    }
    function treemap(d) {
      var nodes = stickies || hierarchy(d),
          root = nodes[0];
      root.x = root.y = 0;
      if (root.value) root.dx = size[0], root.dy = size[1];else root.dx = root.dy = 0;
      if (stickies) hierarchy.revalue(root);
      scale([root], root.dx * root.dy / root.value);
      (stickies ? stickify : squarify)(root);
      if (sticky) stickies = nodes;
      return nodes;
    }
    treemap.size = function (x) {
      if (!arguments.length) return size;
      size = x;
      return treemap;
    };
    treemap.padding = function (x) {
      if (!arguments.length) return padding;
      function padFunction(node) {
        var p = x.call(treemap, node, node.depth);
        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [p, p, p, p] : p);
      }
      function padConstant(node) {
        return d3_layout_treemapPad(node, x);
      }
      var type;
      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [x, x, x, x], padConstant) : padConstant;
      return treemap;
    };
    treemap.round = function (x) {
      if (!arguments.length) return round != Number;
      round = x ? Math.round : Number;
      return treemap;
    };
    treemap.sticky = function (x) {
      if (!arguments.length) return sticky;
      sticky = x;
      stickies = null;
      return treemap;
    };
    treemap.ratio = function (x) {
      if (!arguments.length) return ratio;
      ratio = x;
      return treemap;
    };
    treemap.mode = function (x) {
      if (!arguments.length) return mode;
      mode = x + "";
      return treemap;
    };
    return d3_layout_hierarchyRebind(treemap, hierarchy);
  };
  function d3_layout_treemapPadNull(node) {
    return {
      x: node.x,
      y: node.y,
      dx: node.dx,
      dy: node.dy
    };
  }
  function d3_layout_treemapPad(node, padding) {
    var x = node.x + padding[3],
        y = node.y + padding[0],
        dx = node.dx - padding[1] - padding[3],
        dy = node.dy - padding[0] - padding[2];
    if (dx < 0) {
      x += dx / 2;
      dx = 0;
    }
    if (dy < 0) {
      y += dy / 2;
      dy = 0;
    }
    return {
      x: x,
      y: y,
      dx: dx,
      dy: dy
    };
  }
  d3.random = {
    normal: function normal(µ, σ) {
      var n = arguments.length;
      if (n < 2) σ = 1;
      if (n < 1) µ = 0;
      return function () {
        var x, y, r;
        do {
          x = Math.random() * 2 - 1;
          y = Math.random() * 2 - 1;
          r = x * x + y * y;
        } while (!r || r > 1);
        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
      };
    },
    logNormal: function logNormal() {
      var random = d3.random.normal.apply(d3, arguments);
      return function () {
        return Math.exp(random());
      };
    },
    bates: function bates(m) {
      var random = d3.random.irwinHall(m);
      return function () {
        return random() / m;
      };
    },
    irwinHall: function irwinHall(m) {
      return function () {
        for (var s = 0, j = 0; j < m; j++) {
          s += Math.random();
        }return s;
      };
    }
  };
  d3.scale = {};
  function d3_scaleExtent(domain) {
    var start = domain[0],
        stop = domain[domain.length - 1];
    return start < stop ? [start, stop] : [stop, start];
  }
  function d3_scaleRange(scale) {
    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
  }
  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
    var u = uninterpolate(domain[0], domain[1]),
        i = interpolate(range[0], range[1]);
    return function (x) {
      return i(u(x));
    };
  }
  function d3_scale_nice(domain, nice) {
    var i0 = 0,
        i1 = domain.length - 1,
        x0 = domain[i0],
        x1 = domain[i1],
        dx;
    if (x1 < x0) {
      dx = i0, i0 = i1, i1 = dx;
      dx = x0, x0 = x1, x1 = dx;
    }
    domain[i0] = nice.floor(x0);
    domain[i1] = nice.ceil(x1);
    return domain;
  }
  function d3_scale_niceStep(step) {
    return step ? {
      floor: function floor(x) {
        return Math.floor(x / step) * step;
      },
      ceil: function ceil(x) {
        return Math.ceil(x / step) * step;
      }
    } : d3_scale_niceIdentity;
  }
  var d3_scale_niceIdentity = {
    floor: d3_identity,
    ceil: d3_identity
  };
  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
    var u = [],
        i = [],
        j = 0,
        k = Math.min(domain.length, range.length) - 1;
    if (domain[k] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    while (++j <= k) {
      u.push(uninterpolate(domain[j - 1], domain[j]));
      i.push(interpolate(range[j - 1], range[j]));
    }
    return function (x) {
      var j = d3.bisect(domain, x, 1, k) - 1;
      return i[j](u[j](x));
    };
  }
  d3.scale.linear = function () {
    return d3_scale_linear([0, 1], [0, 1], d3_interpolate, false);
  };
  function d3_scale_linear(domain, range, interpolate, clamp) {
    var output, input;
    function rescale() {
      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear,
          uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
      output = linear(domain, range, uninterpolate, interpolate);
      input = linear(range, domain, uninterpolate, d3_interpolate);
      return scale;
    }
    function scale(x) {
      return output(x);
    }
    scale.invert = function (y) {
      return input(y);
    };
    scale.domain = function (x) {
      if (!arguments.length) return domain;
      domain = x.map(Number);
      return rescale();
    };
    scale.range = function (x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.rangeRound = function (x) {
      return scale.range(x).interpolate(d3_interpolateRound);
    };
    scale.clamp = function (x) {
      if (!arguments.length) return clamp;
      clamp = x;
      return rescale();
    };
    scale.interpolate = function (x) {
      if (!arguments.length) return interpolate;
      interpolate = x;
      return rescale();
    };
    scale.ticks = function (m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function (m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function (m) {
      d3_scale_linearNice(domain, m);
      return rescale();
    };
    scale.copy = function () {
      return d3_scale_linear(domain, range, interpolate, clamp);
    };
    return rescale();
  }
  function d3_scale_linearRebind(scale, linear) {
    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
  }
  function d3_scale_linearNice(domain, m) {
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    return domain;
  }
  function d3_scale_linearTickRange(domain, m) {
    if (m == null) m = 10;
    var extent = d3_scaleExtent(domain),
        span = extent[1] - extent[0],
        step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)),
        err = m / span * step;
    if (err <= .15) step *= 10;else if (err <= .35) step *= 5;else if (err <= .75) step *= 2;
    extent[0] = Math.ceil(extent[0] / step) * step;
    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
    extent[2] = step;
    return extent;
  }
  function d3_scale_linearTicks(domain, m) {
    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
  }
  function d3_scale_linearTickFormat(domain, m, format) {
    var range = d3_scale_linearTickRange(domain, m);
    if (format) {
      var match = d3_format_re.exec(format);
      match.shift();
      if (match[8] === "s") {
        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
        match[8] = "f";
        format = d3.format(match.join(""));
        return function (d) {
          return format(prefix.scale(d)) + prefix.symbol;
        };
      }
      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
      format = match.join("");
    } else {
      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
    }
    return d3.format(format);
  }
  var d3_scale_linearFormatSignificant = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  function d3_scale_linearPrecision(value) {
    return -Math.floor(Math.log(value) / Math.LN10 + .01);
  }
  function d3_scale_linearFormatPrecision(type, range) {
    var p = d3_scale_linearPrecision(range[2]);
    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
  }
  d3.scale.log = function () {
    return d3_scale_log(d3.scale.linear().domain([0, 1]), 10, true, [1, 10]);
  };
  function d3_scale_log(linear, base, positive, domain) {
    function log(x) {
      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
    }
    function pow(x) {
      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
    }
    function scale(x) {
      return linear(log(x));
    }
    scale.invert = function (x) {
      return pow(linear.invert(x));
    };
    scale.domain = function (x) {
      if (!arguments.length) return domain;
      positive = x[0] >= 0;
      linear.domain((domain = x.map(Number)).map(log));
      return scale;
    };
    scale.base = function (_) {
      if (!arguments.length) return base;
      base = +_;
      linear.domain(domain.map(log));
      return scale;
    };
    scale.nice = function () {
      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
      linear.domain(niced);
      domain = niced.map(pow);
      return scale;
    };
    scale.ticks = function () {
      var extent = d3_scaleExtent(domain),
          ticks = [],
          u = extent[0],
          v = extent[1],
          i = Math.floor(log(u)),
          j = Math.ceil(log(v)),
          n = base % 1 ? 2 : base;
      if (isFinite(j - i)) {
        if (positive) {
          for (; i < j; i++) {
            for (var k = 1; k < n; k++) {
              ticks.push(pow(i) * k);
            }
          }ticks.push(pow(i));
        } else {
          ticks.push(pow(i));
          for (; i++ < j;) {
            for (var k = n - 1; k > 0; k--) {
              ticks.push(pow(i) * k);
            }
          }
        }
        for (i = 0; ticks[i] < u; i++) {}
        for (j = ticks.length; ticks[j - 1] > v; j--) {}
        ticks = ticks.slice(i, j);
      }
      return ticks;
    };
    scale.tickFormat = function (n, format) {
      if (!arguments.length) return d3_scale_logFormat;
      if (arguments.length < 2) format = d3_scale_logFormat;else if (typeof format !== "function") format = d3.format(format);
      var k = Math.max(1, base * n / scale.ticks().length);
      return function (d) {
        var i = d / pow(Math.round(log(d)));
        if (i * base < base - .5) i *= base;
        return i <= k ? format(d) : "";
      };
    };
    scale.copy = function () {
      return d3_scale_log(linear.copy(), base, positive, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  var d3_scale_logFormat = d3.format(".0e"),
      d3_scale_logNiceNegative = {
    floor: function floor(x) {
      return -Math.ceil(-x);
    },
    ceil: function ceil(x) {
      return -Math.floor(-x);
    }
  };
  d3.scale.pow = function () {
    return d3_scale_pow(d3.scale.linear(), 1, [0, 1]);
  };
  function d3_scale_pow(linear, exponent, domain) {
    var powp = d3_scale_powPow(exponent),
        powb = d3_scale_powPow(1 / exponent);
    function scale(x) {
      return linear(powp(x));
    }
    scale.invert = function (x) {
      return powb(linear.invert(x));
    };
    scale.domain = function (x) {
      if (!arguments.length) return domain;
      linear.domain((domain = x.map(Number)).map(powp));
      return scale;
    };
    scale.ticks = function (m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function (m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function (m) {
      return scale.domain(d3_scale_linearNice(domain, m));
    };
    scale.exponent = function (x) {
      if (!arguments.length) return exponent;
      powp = d3_scale_powPow(exponent = x);
      powb = d3_scale_powPow(1 / exponent);
      linear.domain(domain.map(powp));
      return scale;
    };
    scale.copy = function () {
      return d3_scale_pow(linear.copy(), exponent, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_scale_powPow(e) {
    return function (x) {
      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
    };
  }
  d3.scale.sqrt = function () {
    return d3.scale.pow().exponent(.5);
  };
  d3.scale.ordinal = function () {
    return d3_scale_ordinal([], {
      t: "range",
      a: [[]]
    });
  };
  function d3_scale_ordinal(domain, ranger) {
    var index, range, rangeBand;
    function scale(x) {
      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
    }
    function steps(start, step) {
      return d3.range(domain.length).map(function (i) {
        return start + step * i;
      });
    }
    scale.domain = function (x) {
      if (!arguments.length) return domain;
      domain = [];
      index = new d3_Map();
      var i = -1,
          n = x.length,
          xi;
      while (++i < n) {
        if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
      }return scale[ranger.t].apply(scale, ranger.a);
    };
    scale.range = function (x) {
      if (!arguments.length) return range;
      range = x;
      rangeBand = 0;
      ranger = {
        t: "range",
        a: arguments
      };
      return scale;
    };
    scale.rangePoints = function (x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0],
          stop = x[1],
          step = domain.length < 2 ? (start = (start + stop) / 2, 0) : (stop - start) / (domain.length - 1 + padding);
      range = steps(start + step * padding / 2, step);
      rangeBand = 0;
      ranger = {
        t: "rangePoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundPoints = function (x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0],
          stop = x[1],
          step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 0) : (stop - start) / (domain.length - 1 + padding) | 0;
      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
      rangeBand = 0;
      ranger = {
        t: "rangeRoundPoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeBands = function (x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0],
          start = x[reverse - 0],
          stop = x[1 - reverse],
          step = (stop - start) / (domain.length - padding + 2 * outerPadding);
      range = steps(start + step * outerPadding, step);
      if (reverse) range.reverse();
      rangeBand = step * (1 - padding);
      ranger = {
        t: "rangeBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundBands = function (x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0],
          start = x[reverse - 0],
          stop = x[1 - reverse],
          step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
      if (reverse) range.reverse();
      rangeBand = Math.round(step * (1 - padding));
      ranger = {
        t: "rangeRoundBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeBand = function () {
      return rangeBand;
    };
    scale.rangeExtent = function () {
      return d3_scaleExtent(ranger.a[0]);
    };
    scale.copy = function () {
      return d3_scale_ordinal(domain, ranger);
    };
    return scale.domain(domain);
  }
  d3.scale.category10 = function () {
    return d3.scale.ordinal().range(d3_category10);
  };
  d3.scale.category20 = function () {
    return d3.scale.ordinal().range(d3_category20);
  };
  d3.scale.category20b = function () {
    return d3.scale.ordinal().range(d3_category20b);
  };
  d3.scale.category20c = function () {
    return d3.scale.ordinal().range(d3_category20c);
  };
  var d3_category10 = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(d3_rgbString);
  var d3_category20 = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(d3_rgbString);
  var d3_category20b = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(d3_rgbString);
  var d3_category20c = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(d3_rgbString);
  d3.scale.quantile = function () {
    return d3_scale_quantile([], []);
  };
  function d3_scale_quantile(domain, range) {
    var thresholds;
    function rescale() {
      var k = 0,
          q = range.length;
      thresholds = [];
      while (++k < q) {
        thresholds[k - 1] = d3.quantile(domain, k / q);
      }return scale;
    }
    function scale(x) {
      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
    }
    scale.domain = function (x) {
      if (!arguments.length) return domain;
      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
      return rescale();
    };
    scale.range = function (x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.quantiles = function () {
      return thresholds;
    };
    scale.invertExtent = function (y) {
      y = range.indexOf(y);
      return y < 0 ? [NaN, NaN] : [y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1]];
    };
    scale.copy = function () {
      return d3_scale_quantile(domain, range);
    };
    return rescale();
  }
  d3.scale.quantize = function () {
    return d3_scale_quantize(0, 1, [0, 1]);
  };
  function d3_scale_quantize(x0, x1, range) {
    var kx, i;
    function scale(x) {
      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
    }
    function rescale() {
      kx = range.length / (x1 - x0);
      i = range.length - 1;
      return scale;
    }
    scale.domain = function (x) {
      if (!arguments.length) return [x0, x1];
      x0 = +x[0];
      x1 = +x[x.length - 1];
      return rescale();
    };
    scale.range = function (x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.invertExtent = function (y) {
      y = range.indexOf(y);
      y = y < 0 ? NaN : y / kx + x0;
      return [y, y + 1 / kx];
    };
    scale.copy = function () {
      return d3_scale_quantize(x0, x1, range);
    };
    return rescale();
  }
  d3.scale.threshold = function () {
    return d3_scale_threshold([.5], [0, 1]);
  };
  function d3_scale_threshold(domain, range) {
    function scale(x) {
      if (x <= x) return range[d3.bisect(domain, x)];
    }
    scale.domain = function (_) {
      if (!arguments.length) return domain;
      domain = _;
      return scale;
    };
    scale.range = function (_) {
      if (!arguments.length) return range;
      range = _;
      return scale;
    };
    scale.invertExtent = function (y) {
      y = range.indexOf(y);
      return [domain[y - 1], domain[y]];
    };
    scale.copy = function () {
      return d3_scale_threshold(domain, range);
    };
    return scale;
  }
  d3.scale.identity = function () {
    return d3_scale_identity([0, 1]);
  };
  function d3_scale_identity(domain) {
    function identity(x) {
      return +x;
    }
    identity.invert = identity;
    identity.domain = identity.range = function (x) {
      if (!arguments.length) return domain;
      domain = x.map(identity);
      return identity;
    };
    identity.ticks = function (m) {
      return d3_scale_linearTicks(domain, m);
    };
    identity.tickFormat = function (m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    identity.copy = function () {
      return d3_scale_identity(domain);
    };
    return identity;
  }
  d3.svg = {};
  function d3_zero() {
    return 0;
  }
  d3.svg.arc = function () {
    var innerRadius = d3_svg_arcInnerRadius,
        outerRadius = d3_svg_arcOuterRadius,
        cornerRadius = d3_zero,
        padRadius = d3_svg_arcAuto,
        startAngle = d3_svg_arcStartAngle,
        endAngle = d3_svg_arcEndAngle,
        padAngle = d3_svg_arcPadAngle;
    function arc() {
      var r0 = Math.max(0, +innerRadius.apply(this, arguments)),
          r1 = Math.max(0, +outerRadius.apply(this, arguments)),
          a0 = startAngle.apply(this, arguments) - halfπ,
          a1 = endAngle.apply(this, arguments) - halfπ,
          da = Math.abs(a1 - a0),
          cw = a0 > a1 ? 0 : 1;
      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
      var rc,
          cr,
          rp,
          ap,
          p0 = 0,
          p1 = 0,
          x0,
          y0,
          x1,
          y1,
          x2,
          y2,
          x3,
          y3,
          path = [];
      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
        if (!cw) p1 *= -1;
        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
      }
      if (r1) {
        x0 = r1 * Math.cos(a0 + p1);
        y0 = r1 * Math.sin(a0 + p1);
        x1 = r1 * Math.cos(a1 - p1);
        y1 = r1 * Math.sin(a1 - p1);
        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
          var h1 = (a0 + a1) / 2;
          x0 = r1 * Math.cos(h1);
          y0 = r1 * Math.sin(h1);
          x1 = y1 = null;
        }
      } else {
        x0 = y0 = 0;
      }
      if (r0) {
        x2 = r0 * Math.cos(a1 - p0);
        y2 = r0 * Math.sin(a1 - p0);
        x3 = r0 * Math.cos(a0 + p0);
        y3 = r0 * Math.sin(a0 + p0);
        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
          var h0 = (a0 + a1) / 2;
          x2 = r0 * Math.cos(h0);
          y2 = r0 * Math.sin(h0);
          x3 = y3 = null;
        }
      } else {
        x2 = y2 = 0;
      }
      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
        cr = r0 < r1 ^ cw ? 0 : 1;
        var rc1 = rc,
            rc0 = rc;
        if (da < π) {
          var oc = x3 == null ? [x2, y2] : x1 == null ? [x0, y0] : d3_geom_polygonIntersect([x0, y0], [x3, y3], [x1, y1], [x2, y2]),
              ax = x0 - oc[0],
              ay = y0 - oc[1],
              bx = x1 - oc[0],
              by = y1 - oc[1],
              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
        if (x1 != null) {
          var t30 = d3_svg_arcCornerTangents(x3 == null ? [x2, y2] : [x3, y3], [x0, y0], r1, rc1, cw),
              t12 = d3_svg_arcCornerTangents([x1, y1], [x2, y2], r1, rc1, cw);
          if (rc === rc1) {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
          } else {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
          }
        } else {
          path.push("M", x0, ",", y0);
        }
        if (x3 != null) {
          var t03 = d3_svg_arcCornerTangents([x0, y0], [x3, y3], r0, -rc0, cw),
              t21 = d3_svg_arcCornerTangents([x2, y2], x1 == null ? [x0, y0] : [x1, y1], r0, -rc0, cw);
          if (rc === rc0) {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          } else {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          }
        } else {
          path.push("L", x2, ",", y2);
        }
      } else {
        path.push("M", x0, ",", y0);
        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
        path.push("L", x2, ",", y2);
        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
      }
      path.push("Z");
      return path.join("");
    }
    function circleSegment(r1, cw) {
      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
    }
    arc.innerRadius = function (v) {
      if (!arguments.length) return innerRadius;
      innerRadius = d3_functor(v);
      return arc;
    };
    arc.outerRadius = function (v) {
      if (!arguments.length) return outerRadius;
      outerRadius = d3_functor(v);
      return arc;
    };
    arc.cornerRadius = function (v) {
      if (!arguments.length) return cornerRadius;
      cornerRadius = d3_functor(v);
      return arc;
    };
    arc.padRadius = function (v) {
      if (!arguments.length) return padRadius;
      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
      return arc;
    };
    arc.startAngle = function (v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return arc;
    };
    arc.endAngle = function (v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return arc;
    };
    arc.padAngle = function (v) {
      if (!arguments.length) return padAngle;
      padAngle = d3_functor(v);
      return arc;
    };
    arc.centroid = function () {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
          a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
      return [Math.cos(a) * r, Math.sin(a) * r];
    };
    return arc;
  };
  var d3_svg_arcAuto = "auto";
  function d3_svg_arcInnerRadius(d) {
    return d.innerRadius;
  }
  function d3_svg_arcOuterRadius(d) {
    return d.outerRadius;
  }
  function d3_svg_arcStartAngle(d) {
    return d.startAngle;
  }
  function d3_svg_arcEndAngle(d) {
    return d.endAngle;
  }
  function d3_svg_arcPadAngle(d) {
    return d && d.padAngle;
  }
  function d3_svg_arcSweep(x0, y0, x1, y1) {
    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
  }
  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
    var x01 = p0[0] - p1[0],
        y01 = p0[1] - p1[1],
        lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
        ox = lo * y01,
        oy = -lo * x01,
        x1 = p0[0] + ox,
        y1 = p0[1] + oy,
        x2 = p1[0] + ox,
        y2 = p1[1] + oy,
        x3 = (x1 + x2) / 2,
        y3 = (y1 + y2) / 2,
        dx = x2 - x1,
        dy = y2 - y1,
        d2 = dx * dx + dy * dy,
        r = r1 - rc,
        D = x1 * y2 - x2 * y1,
        d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
        cx0 = (D * dy - dx * d) / d2,
        cy0 = (-D * dx - dy * d) / d2,
        cx1 = (D * dy + dx * d) / d2,
        cy1 = (-D * dx + dy * d) / d2,
        dx0 = cx0 - x3,
        dy0 = cy0 - y3,
        dx1 = cx1 - x3,
        dy1 = cy1 - y3;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return [[cx0 - ox, cy0 - oy], [cx0 * r1 / r, cy0 * r1 / r]];
  }
  function d3_svg_line(projection) {
    var x = d3_geom_pointX,
        y = d3_geom_pointY,
        defined = d3_true,
        interpolate = d3_svg_lineLinear,
        interpolateKey = interpolate.key,
        tension = .7;
    function line(data) {
      var segments = [],
          points = [],
          i = -1,
          n = data.length,
          d,
          fx = d3_functor(x),
          fy = d3_functor(y);
      function segment() {
        segments.push("M", interpolate(projection(points), tension));
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points.push([+fx.call(this, d, i), +fy.call(this, d, i)]);
        } else if (points.length) {
          segment();
          points = [];
        }
      }
      if (points.length) segment();
      return segments.length ? segments.join("") : null;
    }
    line.x = function (_) {
      if (!arguments.length) return x;
      x = _;
      return line;
    };
    line.y = function (_) {
      if (!arguments.length) return y;
      y = _;
      return line;
    };
    line.defined = function (_) {
      if (!arguments.length) return defined;
      defined = _;
      return line;
    };
    line.interpolate = function (_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _;else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      return line;
    };
    line.tension = function (_) {
      if (!arguments.length) return tension;
      tension = _;
      return line;
    };
    return line;
  }
  d3.svg.line = function () {
    return d3_svg_line(d3_identity);
  };
  var d3_svg_lineInterpolators = d3.map({
    linear: d3_svg_lineLinear,
    "linear-closed": d3_svg_lineLinearClosed,
    step: d3_svg_lineStep,
    "step-before": d3_svg_lineStepBefore,
    "step-after": d3_svg_lineStepAfter,
    basis: d3_svg_lineBasis,
    "basis-open": d3_svg_lineBasisOpen,
    "basis-closed": d3_svg_lineBasisClosed,
    bundle: d3_svg_lineBundle,
    cardinal: d3_svg_lineCardinal,
    "cardinal-open": d3_svg_lineCardinalOpen,
    "cardinal-closed": d3_svg_lineCardinalClosed,
    monotone: d3_svg_lineMonotone
  });
  d3_svg_lineInterpolators.forEach(function (key, value) {
    value.key = key;
    value.closed = /-closed$/.test(key);
  });
  function d3_svg_lineLinear(points) {
    return points.length > 1 ? points.join("L") : points + "Z";
  }
  function d3_svg_lineLinearClosed(points) {
    return points.join("L") + "Z";
  }
  function d3_svg_lineStep(points) {
    var i = 0,
        n = points.length,
        p = points[0],
        path = [p[0], ",", p[1]];
    while (++i < n) {
      path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
    }if (n > 1) path.push("H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepBefore(points) {
    var i = 0,
        n = points.length,
        p = points[0],
        path = [p[0], ",", p[1]];
    while (++i < n) {
      path.push("V", (p = points[i])[1], "H", p[0]);
    }return path.join("");
  }
  function d3_svg_lineStepAfter(points) {
    var i = 0,
        n = points.length,
        p = points[0],
        path = [p[0], ",", p[1]];
    while (++i < n) {
      path.push("H", (p = points[i])[0], "V", p[1]);
    }return path.join("");
  }
  function d3_svg_lineCardinalOpen(points, tension) {
    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineCardinalClosed(points, tension) {
    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), points), d3_svg_lineCardinalTangents([points[points.length - 2]].concat(points, [points[1]]), tension));
  }
  function d3_svg_lineCardinal(points, tension) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineHermite(points, tangents) {
    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
      return d3_svg_lineLinear(points);
    }
    var quad = points.length != tangents.length,
        path = "",
        p0 = points[0],
        p = points[1],
        t0 = tangents[0],
        t = t0,
        pi = 1;
    if (quad) {
      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
      p0 = points[1];
      pi = 2;
    }
    if (tangents.length > 1) {
      t = tangents[1];
      p = points[pi];
      pi++;
      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      for (var i = 2; i < tangents.length; i++, pi++) {
        p = points[pi];
        t = tangents[i];
        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      }
    }
    if (quad) {
      var lp = points[pi];
      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
    }
    return path;
  }
  function d3_svg_lineCardinalTangents(points, tension) {
    var tangents = [],
        a = (1 - tension) / 2,
        p0,
        p1 = points[0],
        p2 = points[1],
        i = 1,
        n = points.length;
    while (++i < n) {
      p0 = p1;
      p1 = p2;
      p2 = points[i];
      tangents.push([a * (p2[0] - p0[0]), a * (p2[1] - p0[1])]);
    }
    return tangents;
  }
  function d3_svg_lineBasis(points) {
    if (points.length < 3) return d3_svg_lineLinear(points);
    var i = 1,
        n = points.length,
        pi = points[0],
        x0 = pi[0],
        y0 = pi[1],
        px = [x0, x0, x0, (pi = points[1])[0]],
        py = [y0, y0, y0, pi[1]],
        path = [x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)];
    points.push(points[n - 1]);
    while (++i <= n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    points.pop();
    path.push("L", pi);
    return path.join("");
  }
  function d3_svg_lineBasisOpen(points) {
    if (points.length < 4) return d3_svg_lineLinear(points);
    var path = [],
        i = -1,
        n = points.length,
        pi,
        px = [0],
        py = [0];
    while (++i < 3) {
      pi = points[i];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
    --i;
    while (++i < n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBasisClosed(points) {
    var path,
        i = -1,
        n = points.length,
        m = n + 4,
        pi,
        px = [],
        py = [];
    while (++i < 4) {
      pi = points[i % n];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path = [d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)];
    --i;
    while (++i < m) {
      pi = points[i % n];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBundle(points, tension) {
    var n = points.length - 1;
    if (n) {
      var x0 = points[0][0],
          y0 = points[0][1],
          dx = points[n][0] - x0,
          dy = points[n][1] - y0,
          i = -1,
          p,
          t;
      while (++i <= n) {
        p = points[i];
        t = i / n;
        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
      }
    }
    return d3_svg_lineBasis(points);
  }
  function d3_svg_lineDot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  }
  var d3_svg_lineBasisBezier1 = [0, 2 / 3, 1 / 3, 0],
      d3_svg_lineBasisBezier2 = [0, 1 / 3, 2 / 3, 0],
      d3_svg_lineBasisBezier3 = [0, 1 / 6, 2 / 3, 1 / 6];
  function d3_svg_lineBasisBezier(path, x, y) {
    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
  }
  function d3_svg_lineSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
  }
  function d3_svg_lineFiniteDifferences(points) {
    var i = 0,
        j = points.length - 1,
        m = [],
        p0 = points[0],
        p1 = points[1],
        d = m[0] = d3_svg_lineSlope(p0, p1);
    while (++i < j) {
      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
    }
    m[i] = d;
    return m;
  }
  function d3_svg_lineMonotoneTangents(points) {
    var tangents = [],
        d,
        a,
        b,
        s,
        m = d3_svg_lineFiniteDifferences(points),
        i = -1,
        j = points.length - 1;
    while (++i < j) {
      d = d3_svg_lineSlope(points[i], points[i + 1]);
      if (abs(d) < ε) {
        m[i] = m[i + 1] = 0;
      } else {
        a = m[i] / d;
        b = m[i + 1] / d;
        s = a * a + b * b;
        if (s > 9) {
          s = d * 3 / Math.sqrt(s);
          m[i] = s * a;
          m[i + 1] = s * b;
        }
      }
    }
    i = -1;
    while (++i <= j) {
      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
      tangents.push([s || 0, m[i] * s || 0]);
    }
    return tangents;
  }
  function d3_svg_lineMonotone(points) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
  }
  d3.svg.line.radial = function () {
    var line = d3_svg_line(d3_svg_lineRadial);
    line.radius = line.x, delete line.x;
    line.angle = line.y, delete line.y;
    return line;
  };
  function d3_svg_lineRadial(points) {
    var point,
        i = -1,
        n = points.length,
        r,
        a;
    while (++i < n) {
      point = points[i];
      r = point[0];
      a = point[1] - halfπ;
      point[0] = r * Math.cos(a);
      point[1] = r * Math.sin(a);
    }
    return points;
  }
  function d3_svg_area(projection) {
    var x0 = d3_geom_pointX,
        x1 = d3_geom_pointX,
        y0 = 0,
        y1 = d3_geom_pointY,
        defined = d3_true,
        interpolate = d3_svg_lineLinear,
        interpolateKey = interpolate.key,
        interpolateReverse = interpolate,
        L = "L",
        tension = .7;
    function area(data) {
      var segments = [],
          points0 = [],
          points1 = [],
          i = -1,
          n = data.length,
          d,
          fx0 = d3_functor(x0),
          fy0 = d3_functor(y0),
          fx1 = x0 === x1 ? function () {
        return x;
      } : d3_functor(x1),
          fy1 = y0 === y1 ? function () {
        return y;
      } : d3_functor(y1),
          x,
          y;
      function segment() {
        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points0.push([x = +fx0.call(this, d, i), y = +fy0.call(this, d, i)]);
          points1.push([+fx1.call(this, d, i), +fy1.call(this, d, i)]);
        } else if (points0.length) {
          segment();
          points0 = [];
          points1 = [];
        }
      }
      if (points0.length) segment();
      return segments.length ? segments.join("") : null;
    }
    area.x = function (_) {
      if (!arguments.length) return x1;
      x0 = x1 = _;
      return area;
    };
    area.x0 = function (_) {
      if (!arguments.length) return x0;
      x0 = _;
      return area;
    };
    area.x1 = function (_) {
      if (!arguments.length) return x1;
      x1 = _;
      return area;
    };
    area.y = function (_) {
      if (!arguments.length) return y1;
      y0 = y1 = _;
      return area;
    };
    area.y0 = function (_) {
      if (!arguments.length) return y0;
      y0 = _;
      return area;
    };
    area.y1 = function (_) {
      if (!arguments.length) return y1;
      y1 = _;
      return area;
    };
    area.defined = function (_) {
      if (!arguments.length) return defined;
      defined = _;
      return area;
    };
    area.interpolate = function (_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _;else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      interpolateReverse = interpolate.reverse || interpolate;
      L = interpolate.closed ? "M" : "L";
      return area;
    };
    area.tension = function (_) {
      if (!arguments.length) return tension;
      tension = _;
      return area;
    };
    return area;
  }
  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
  d3.svg.area = function () {
    return d3_svg_area(d3_identity);
  };
  d3.svg.area.radial = function () {
    var area = d3_svg_area(d3_svg_lineRadial);
    area.radius = area.x, delete area.x;
    area.innerRadius = area.x0, delete area.x0;
    area.outerRadius = area.x1, delete area.x1;
    area.angle = area.y, delete area.y;
    area.startAngle = area.y0, delete area.y0;
    area.endAngle = area.y1, delete area.y1;
    return area;
  };
  d3.svg.chord = function () {
    var source = d3_source,
        target = d3_target,
        radius = d3_svg_chordRadius,
        startAngle = d3_svg_arcStartAngle,
        endAngle = d3_svg_arcEndAngle;
    function chord(d, i) {
      var s = subgroup(this, source, d, i),
          t = subgroup(this, target, d, i);
      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
    }
    function subgroup(self, f, d, i) {
      var subgroup = f.call(self, d, i),
          r = radius.call(self, subgroup, i),
          a0 = startAngle.call(self, subgroup, i) - halfπ,
          a1 = endAngle.call(self, subgroup, i) - halfπ;
      return {
        r: r,
        a0: a0,
        a1: a1,
        p0: [r * Math.cos(a0), r * Math.sin(a0)],
        p1: [r * Math.cos(a1), r * Math.sin(a1)]
      };
    }
    function equals(a, b) {
      return a.a0 == b.a0 && a.a1 == b.a1;
    }
    function arc(r, p, a) {
      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
    }
    function curve(r0, p0, r1, p1) {
      return "Q 0,0 " + p1;
    }
    chord.radius = function (v) {
      if (!arguments.length) return radius;
      radius = d3_functor(v);
      return chord;
    };
    chord.source = function (v) {
      if (!arguments.length) return source;
      source = d3_functor(v);
      return chord;
    };
    chord.target = function (v) {
      if (!arguments.length) return target;
      target = d3_functor(v);
      return chord;
    };
    chord.startAngle = function (v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return chord;
    };
    chord.endAngle = function (v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return chord;
    };
    return chord;
  };
  function d3_svg_chordRadius(d) {
    return d.radius;
  }
  d3.svg.diagonal = function () {
    var source = d3_source,
        target = d3_target,
        projection = d3_svg_diagonalProjection;
    function diagonal(d, i) {
      var p0 = source.call(this, d, i),
          p3 = target.call(this, d, i),
          m = (p0.y + p3.y) / 2,
          p = [p0, {
        x: p0.x,
        y: m
      }, {
        x: p3.x,
        y: m
      }, p3];
      p = p.map(projection);
      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
    }
    diagonal.source = function (x) {
      if (!arguments.length) return source;
      source = d3_functor(x);
      return diagonal;
    };
    diagonal.target = function (x) {
      if (!arguments.length) return target;
      target = d3_functor(x);
      return diagonal;
    };
    diagonal.projection = function (x) {
      if (!arguments.length) return projection;
      projection = x;
      return diagonal;
    };
    return diagonal;
  };
  function d3_svg_diagonalProjection(d) {
    return [d.x, d.y];
  }
  d3.svg.diagonal.radial = function () {
    var diagonal = d3.svg.diagonal(),
        projection = d3_svg_diagonalProjection,
        projection_ = diagonal.projection;
    diagonal.projection = function (x) {
      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
    };
    return diagonal;
  };
  function d3_svg_diagonalRadialProjection(projection) {
    return function () {
      var d = projection.apply(this, arguments),
          r = d[0],
          a = d[1] - halfπ;
      return [r * Math.cos(a), r * Math.sin(a)];
    };
  }
  d3.svg.symbol = function () {
    var type = d3_svg_symbolType,
        size = d3_svg_symbolSize;
    function symbol(d, i) {
      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
    }
    symbol.type = function (x) {
      if (!arguments.length) return type;
      type = d3_functor(x);
      return symbol;
    };
    symbol.size = function (x) {
      if (!arguments.length) return size;
      size = d3_functor(x);
      return symbol;
    };
    return symbol;
  };
  function d3_svg_symbolSize() {
    return 64;
  }
  function d3_svg_symbolType() {
    return "circle";
  }
  function d3_svg_symbolCircle(size) {
    var r = Math.sqrt(size / π);
    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
  }
  var d3_svg_symbols = d3.map({
    circle: d3_svg_symbolCircle,
    cross: function cross(size) {
      var r = Math.sqrt(size / 5) / 2;
      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
    },
    diamond: function diamond(size) {
      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)),
          rx = ry * d3_svg_symbolTan30;
      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
    },
    square: function square(size) {
      var r = Math.sqrt(size) / 2;
      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
    },
    "triangle-down": function triangleDown(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3),
          ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
    },
    "triangle-up": function triangleUp(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3),
          ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
    }
  });
  d3.svg.symbolTypes = d3_svg_symbols.keys();
  var d3_svg_symbolSqrt3 = Math.sqrt(3),
      d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
  d3_selectionPrototype.transition = function (name) {
    var id = d3_transitionInheritId || ++d3_transitionId,
        ns = d3_transitionNamespace(name),
        subgroups = [],
        subgroup,
        node,
        transition = d3_transitionInherit || {
      time: Date.now(),
      ease: d3_ease_cubicInOut,
      delay: 0,
      duration: 250
    };
    for (var j = -1, m = this.length; ++j < m;) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n;) {
        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_selectionPrototype.interrupt = function (name) {
    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
  };
  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
  function d3_selection_interruptNS(ns) {
    return function () {
      var lock, activeId, active;
      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
        active.timer.c = null;
        active.timer.t = NaN;
        if (--lock.count) delete lock[activeId];else delete this[ns];
        lock.active += .5;
        active.event && active.event.interrupt.call(this, this.__data__, active.index);
      }
    };
  }
  function d3_transition(groups, ns, id) {
    d3_subclass(groups, d3_transitionPrototype);
    groups.namespace = ns;
    groups.id = id;
    return groups;
  }
  var d3_transitionPrototype = [],
      d3_transitionId = 0,
      d3_transitionInheritId,
      d3_transitionInherit;
  d3_transitionPrototype.call = d3_selectionPrototype.call;
  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
  d3_transitionPrototype.node = d3_selectionPrototype.node;
  d3_transitionPrototype.size = d3_selectionPrototype.size;
  d3.transition = function (selection, name) {
    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
  };
  d3.transition.prototype = d3_transitionPrototype;
  d3_transitionPrototype.select = function (selector) {
    var id = this.id,
        ns = this.namespace,
        subgroups = [],
        subgroup,
        subnode,
        node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m;) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n;) {
        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
          if ("__data__" in node) subnode.__data__ = node.__data__;
          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
          subgroup.push(subnode);
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.selectAll = function (selector) {
    var id = this.id,
        ns = this.namespace,
        subgroups = [],
        subgroup,
        subnodes,
        node,
        subnode,
        transition;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m;) {
      for (var group = this[j], i = -1, n = group.length; ++i < n;) {
        if (node = group[i]) {
          transition = node[ns][id];
          subnodes = selector.call(node, node.__data__, i, j);
          subgroups.push(subgroup = []);
          for (var k = -1, o = subnodes.length; ++k < o;) {
            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
            subgroup.push(subnode);
          }
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.filter = function (filter) {
    var subgroups = [],
        subgroup,
        group,
        node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_transition(subgroups, this.namespace, this.id);
  };
  d3_transitionPrototype.tween = function (name, tween) {
    var id = this.id,
        ns = this.namespace;
    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
    return d3_selection_each(this, tween == null ? function (node) {
      node[ns][id].tween.remove(name);
    } : function (node) {
      node[ns][id].tween.set(name, tween);
    });
  };
  function d3_transition_tween(groups, name, value, tween) {
    var id = groups.id,
        ns = groups.namespace;
    return d3_selection_each(groups, typeof value === "function" ? function (node, i, j) {
      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
    } : (value = tween(value), function (node) {
      node[ns][id].tween.set(name, value);
    }));
  }
  d3_transitionPrototype.attr = function (nameNS, value) {
    if (arguments.length < 2) {
      for (value in nameNS) {
        this.attr(value, nameNS[value]);
      }return this;
    }
    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate,
        name = d3.ns.qualify(nameNS);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrTween(b) {
      return b == null ? attrNull : (b += "", function () {
        var a = this.getAttribute(name),
            i;
        return a !== b && (i = interpolate(a, b), function (t) {
          this.setAttribute(name, i(t));
        });
      });
    }
    function attrTweenNS(b) {
      return b == null ? attrNullNS : (b += "", function () {
        var a = this.getAttributeNS(name.space, name.local),
            i;
        return a !== b && (i = interpolate(a, b), function (t) {
          this.setAttributeNS(name.space, name.local, i(t));
        });
      });
    }
    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.attrTween = function (nameNS, tween) {
    var name = d3.ns.qualify(nameNS);
    function attrTween(d, i) {
      var f = tween.call(this, d, i, this.getAttribute(name));
      return f && function (t) {
        this.setAttribute(name, f(t));
      };
    }
    function attrTweenNS(d, i) {
      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
      return f && function (t) {
        this.setAttributeNS(name.space, name.local, f(t));
      };
    }
    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.style = function (name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) {
          this.style(priority, name[priority], value);
        }return this;
      }
      priority = "";
    }
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleString(b) {
      return b == null ? styleNull : (b += "", function () {
        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name),
            i;
        return a !== b && (i = d3_interpolate(a, b), function (t) {
          this.style.setProperty(name, i(t), priority);
        });
      });
    }
    return d3_transition_tween(this, "style." + name, value, styleString);
  };
  d3_transitionPrototype.styleTween = function (name, tween, priority) {
    if (arguments.length < 3) priority = "";
    function styleTween(d, i) {
      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
      return f && function (t) {
        this.style.setProperty(name, f(t), priority);
      };
    }
    return this.tween("style." + name, styleTween);
  };
  d3_transitionPrototype.text = function (value) {
    return d3_transition_tween(this, "text", value, d3_transition_text);
  };
  function d3_transition_text(b) {
    if (b == null) b = "";
    return function () {
      this.textContent = b;
    };
  }
  d3_transitionPrototype.remove = function () {
    var ns = this.namespace;
    return this.each("end.transition", function () {
      var p;
      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
    });
  };
  d3_transitionPrototype.ease = function (value) {
    var id = this.id,
        ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].ease;
    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
    return d3_selection_each(this, function (node) {
      node[ns][id].ease = value;
    });
  };
  d3_transitionPrototype.delay = function (value) {
    var id = this.id,
        ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].delay;
    return d3_selection_each(this, typeof value === "function" ? function (node, i, j) {
      node[ns][id].delay = +value.call(node, node.__data__, i, j);
    } : (value = +value, function (node) {
      node[ns][id].delay = value;
    }));
  };
  d3_transitionPrototype.duration = function (value) {
    var id = this.id,
        ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].duration;
    return d3_selection_each(this, typeof value === "function" ? function (node, i, j) {
      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
    } : (value = Math.max(1, value), function (node) {
      node[ns][id].duration = value;
    }));
  };
  d3_transitionPrototype.each = function (type, listener) {
    var id = this.id,
        ns = this.namespace;
    if (arguments.length < 2) {
      var inherit = d3_transitionInherit,
          inheritId = d3_transitionInheritId;
      try {
        d3_transitionInheritId = id;
        d3_selection_each(this, function (node, i, j) {
          d3_transitionInherit = node[ns][id];
          type.call(node, node.__data__, i, j);
        });
      } finally {
        d3_transitionInherit = inherit;
        d3_transitionInheritId = inheritId;
      }
    } else {
      d3_selection_each(this, function (node) {
        var transition = node[ns][id];
        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
      });
    }
    return this;
  };
  d3_transitionPrototype.transition = function () {
    var id0 = this.id,
        id1 = ++d3_transitionId,
        ns = this.namespace,
        subgroups = [],
        subgroup,
        group,
        node,
        transition;
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if (node = group[i]) {
          transition = node[ns][id0];
          d3_transitionNode(node, i, ns, id1, {
            time: transition.time,
            ease: transition.ease,
            delay: transition.delay + transition.duration,
            duration: transition.duration
          });
        }
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id1);
  };
  function d3_transitionNamespace(name) {
    return name == null ? "__transition__" : "__transition_" + name + "__";
  }
  function d3_transitionNode(node, i, ns, id, inherit) {
    var lock = node[ns] || (node[ns] = {
      active: 0,
      count: 0
    }),
        transition = lock[id],
        time,
        timer,
        duration,
        ease,
        tweens;
    function schedule(elapsed) {
      var delay = transition.delay;
      timer.t = delay + time;
      if (delay <= elapsed) return start(elapsed - delay);
      timer.c = start;
    }
    function start(elapsed) {
      var activeId = lock.active,
          active = lock[activeId];
      if (active) {
        active.timer.c = null;
        active.timer.t = NaN;
        --lock.count;
        delete lock[activeId];
        active.event && active.event.interrupt.call(node, node.__data__, active.index);
      }
      for (var cancelId in lock) {
        if (+cancelId < id) {
          var cancel = lock[cancelId];
          cancel.timer.c = null;
          cancel.timer.t = NaN;
          --lock.count;
          delete lock[cancelId];
        }
      }
      timer.c = tick;
      d3_timer(function () {
        if (timer.c && tick(elapsed || 1)) {
          timer.c = null;
          timer.t = NaN;
        }
        return 1;
      }, 0, time);
      lock.active = id;
      transition.event && transition.event.start.call(node, node.__data__, i);
      tweens = [];
      transition.tween.forEach(function (key, value) {
        if (value = value.call(node, node.__data__, i)) {
          tweens.push(value);
        }
      });
      ease = transition.ease;
      duration = transition.duration;
    }
    function tick(elapsed) {
      var t = elapsed / duration,
          e = ease(t),
          n = tweens.length;
      while (n > 0) {
        tweens[--n].call(node, e);
      }
      if (t >= 1) {
        transition.event && transition.event.end.call(node, node.__data__, i);
        if (--lock.count) delete lock[id];else delete node[ns];
        return 1;
      }
    }
    if (!transition) {
      time = inherit.time;
      timer = d3_timer(schedule, 0, time);
      transition = lock[id] = {
        tween: new d3_Map(),
        time: time,
        timer: timer,
        delay: inherit.delay,
        duration: inherit.duration,
        ease: inherit.ease,
        index: i
      };
      inherit = null;
      ++lock.count;
    }
  }
  d3.svg.axis = function () {
    var scale = d3.scale.linear(),
        orient = d3_svg_axisDefaultOrient,
        innerTickSize = 6,
        outerTickSize = 6,
        tickPadding = 3,
        tickArguments_ = [10],
        tickValues = null,
        tickFormat_;
    function axis(g) {
      g.each(function () {
        var g = d3.select(this);
        var scale0 = this.__chart__ || scale,
            scale1 = this.__chart__ = scale.copy();
        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues,
            tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_,
            tick = g.selectAll(".tick").data(ticks, scale1),
            tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε),
            tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(),
            tickUpdate = d3.transition(tick.order()).style("opacity", 1),
            tickSpacing = Math.max(innerTickSize, 0) + tickPadding,
            tickTransform;
        var range = d3_scaleRange(scale1),
            path = g.selectAll(".domain").data([0]),
            pathUpdate = (path.enter().append("path").attr("class", "domain"), d3.transition(path));
        tickEnter.append("line");
        tickEnter.append("text");
        var lineEnter = tickEnter.select("line"),
            lineUpdate = tickUpdate.select("line"),
            text = tick.select("text").text(tickFormat),
            textEnter = tickEnter.select("text"),
            textUpdate = tickUpdate.select("text"),
            sign = orient === "top" || orient === "left" ? -1 : 1,
            x1,
            x2,
            y1,
            y2;
        if (orient === "bottom" || orient === "top") {
          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
        } else {
          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
        }
        lineEnter.attr(y2, sign * innerTickSize);
        textEnter.attr(y1, sign * tickSpacing);
        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
        if (scale1.rangeBand) {
          var x = scale1,
              dx = x.rangeBand() / 2;
          scale0 = scale1 = function scale1(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, scale0);
        }
        tickEnter.call(tickTransform, scale0, scale1);
        tickUpdate.call(tickTransform, scale1, scale1);
      });
    }
    axis.scale = function (x) {
      if (!arguments.length) return scale;
      scale = x;
      return axis;
    };
    axis.orient = function (x) {
      if (!arguments.length) return orient;
      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
      return axis;
    };
    axis.ticks = function () {
      if (!arguments.length) return tickArguments_;
      tickArguments_ = d3_array(arguments);
      return axis;
    };
    axis.tickValues = function (x) {
      if (!arguments.length) return tickValues;
      tickValues = x;
      return axis;
    };
    axis.tickFormat = function (x) {
      if (!arguments.length) return tickFormat_;
      tickFormat_ = x;
      return axis;
    };
    axis.tickSize = function (x) {
      var n = arguments.length;
      if (!n) return innerTickSize;
      innerTickSize = +x;
      outerTickSize = +arguments[n - 1];
      return axis;
    };
    axis.innerTickSize = function (x) {
      if (!arguments.length) return innerTickSize;
      innerTickSize = +x;
      return axis;
    };
    axis.outerTickSize = function (x) {
      if (!arguments.length) return outerTickSize;
      outerTickSize = +x;
      return axis;
    };
    axis.tickPadding = function (x) {
      if (!arguments.length) return tickPadding;
      tickPadding = +x;
      return axis;
    };
    axis.tickSubdivide = function () {
      return arguments.length && axis;
    };
    return axis;
  };
  var d3_svg_axisDefaultOrient = "bottom",
      d3_svg_axisOrients = {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  };
  function d3_svg_axisX(selection, x0, x1) {
    selection.attr("transform", function (d) {
      var v0 = x0(d);
      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
    });
  }
  function d3_svg_axisY(selection, y0, y1) {
    selection.attr("transform", function (d) {
      var v0 = y0(d);
      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
    });
  }
  d3.svg.brush = function () {
    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"),
        x = null,
        y = null,
        xExtent = [0, 0],
        yExtent = [0, 0],
        xExtentDomain,
        yExtentDomain,
        xClamp = true,
        yClamp = true,
        resizes = d3_svg_brushResizes[0];
    function brush(g) {
      g.each(function () {
        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
        var background = g.selectAll(".background").data([0]);
        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
        g.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var resize = g.selectAll(".resize").data(resizes, d3_identity);
        resize.exit().remove();
        resize.enter().append("g").attr("class", function (d) {
          return "resize " + d;
        }).style("cursor", function (d) {
          return d3_svg_brushCursor[d];
        }).append("rect").attr("x", function (d) {
          return (/[ew]$/.test(d) ? -3 : null
          );
        }).attr("y", function (d) {
          return (/^[ns]/.test(d) ? -3 : null
          );
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
        resize.style("display", brush.empty() ? "none" : null);
        var gUpdate = d3.transition(g),
            backgroundUpdate = d3.transition(background),
            range;
        if (x) {
          range = d3_scaleRange(x);
          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
          redrawX(gUpdate);
        }
        if (y) {
          range = d3_scaleRange(y);
          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
          redrawY(gUpdate);
        }
        redraw(gUpdate);
      });
    }
    brush.event = function (g) {
      g.each(function () {
        var event_ = event.of(this, arguments),
            extent1 = {
          x: xExtent,
          y: yExtent,
          i: xExtentDomain,
          j: yExtentDomain
        },
            extent0 = this.__chart__ || extent1;
        this.__chart__ = extent1;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.brush", function () {
            xExtentDomain = extent0.i;
            yExtentDomain = extent0.j;
            xExtent = extent0.x;
            yExtent = extent0.y;
            event_({
              type: "brushstart"
            });
          }).tween("brush:brush", function () {
            var xi = d3_interpolateArray(xExtent, extent1.x),
                yi = d3_interpolateArray(yExtent, extent1.y);
            xExtentDomain = yExtentDomain = null;
            return function (t) {
              xExtent = extent1.x = xi(t);
              yExtent = extent1.y = yi(t);
              event_({
                type: "brush",
                mode: "resize"
              });
            };
          }).each("end.brush", function () {
            xExtentDomain = extent1.i;
            yExtentDomain = extent1.j;
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          });
        } else {
          event_({
            type: "brushstart"
          });
          event_({
            type: "brush",
            mode: "resize"
          });
          event_({
            type: "brushend"
          });
        }
      });
    };
    function redraw(g) {
      g.selectAll(".resize").attr("transform", function (d) {
        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
      });
    }
    function redrawX(g) {
      g.select(".extent").attr("x", xExtent[0]);
      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
    }
    function redrawY(g) {
      g.select(".extent").attr("y", yExtent[0]);
      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
    }
    function brushstart() {
      var target = this,
          eventTarget = d3.select(d3.event.target),
          event_ = event.of(target, arguments),
          g = d3.select(target),
          resizing = eventTarget.datum(),
          resizingX = !/^(n|s)$/.test(resizing) && x,
          resizingY = !/^(e|w)$/.test(resizing) && y,
          dragging = eventTarget.classed("extent"),
          dragRestore = d3_event_dragSuppress(target),
          center,
          origin = d3.mouse(target),
          offset;
      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
      if (d3.event.changedTouches) {
        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
      } else {
        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
      }
      g.interrupt().selectAll("*").interrupt();
      if (dragging) {
        origin[0] = xExtent[0] - origin[0];
        origin[1] = yExtent[0] - origin[1];
      } else if (resizing) {
        var ex = +/w$/.test(resizing),
            ey = +/^n/.test(resizing);
        offset = [xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1]];
        origin[0] = xExtent[ex];
        origin[1] = yExtent[ey];
      } else if (d3.event.altKey) center = origin.slice();
      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
      d3.select("body").style("cursor", eventTarget.style("cursor"));
      event_({
        type: "brushstart"
      });
      brushmove();
      function keydown() {
        if (d3.event.keyCode == 32) {
          if (!dragging) {
            center = null;
            origin[0] -= xExtent[1];
            origin[1] -= yExtent[1];
            dragging = 2;
          }
          d3_eventPreventDefault();
        }
      }
      function keyup() {
        if (d3.event.keyCode == 32 && dragging == 2) {
          origin[0] += xExtent[1];
          origin[1] += yExtent[1];
          dragging = 0;
          d3_eventPreventDefault();
        }
      }
      function brushmove() {
        var point = d3.mouse(target),
            moved = false;
        if (offset) {
          point[0] += offset[0];
          point[1] += offset[1];
        }
        if (!dragging) {
          if (d3.event.altKey) {
            if (!center) center = [(xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2];
            origin[0] = xExtent[+(point[0] < center[0])];
            origin[1] = yExtent[+(point[1] < center[1])];
          } else center = null;
        }
        if (resizingX && move1(point, x, 0)) {
          redrawX(g);
          moved = true;
        }
        if (resizingY && move1(point, y, 1)) {
          redrawY(g);
          moved = true;
        }
        if (moved) {
          redraw(g);
          event_({
            type: "brush",
            mode: dragging ? "move" : "resize"
          });
        }
      }
      function move1(point, scale, i) {
        var range = d3_scaleRange(scale),
            r0 = range[0],
            r1 = range[1],
            position = origin[i],
            extent = i ? yExtent : xExtent,
            size = extent[1] - extent[0],
            min,
            max;
        if (dragging) {
          r0 -= position;
          r1 -= size + position;
        }
        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
        if (dragging) {
          max = (min += position) + size;
        } else {
          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
          if (position < min) {
            max = min;
            min = position;
          } else {
            max = position;
          }
        }
        if (extent[0] != min || extent[1] != max) {
          if (i) yExtentDomain = null;else xExtentDomain = null;
          extent[0] = min;
          extent[1] = max;
          return true;
        }
      }
      function brushend() {
        brushmove();
        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
        d3.select("body").style("cursor", null);
        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
        dragRestore();
        event_({
          type: "brushend"
        });
      }
    }
    brush.x = function (z) {
      if (!arguments.length) return x;
      x = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.y = function (z) {
      if (!arguments.length) return y;
      y = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.clamp = function (z) {
      if (!arguments.length) return x && y ? [xClamp, yClamp] : x ? xClamp : y ? yClamp : null;
      if (x && y) xClamp = !!z[0], yClamp = !!z[1];else if (x) xClamp = !!z;else if (y) yClamp = !!z;
      return brush;
    };
    brush.extent = function (z) {
      var x0, x1, y0, y1, t;
      if (!arguments.length) {
        if (x) {
          if (xExtentDomain) {
            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
          } else {
            x0 = xExtent[0], x1 = xExtent[1];
            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
          }
        }
        if (y) {
          if (yExtentDomain) {
            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
          } else {
            y0 = yExtent[0], y1 = yExtent[1];
            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
          }
        }
        return x && y ? [[x0, y0], [x1, y1]] : x ? [x0, x1] : y && [y0, y1];
      }
      if (x) {
        x0 = z[0], x1 = z[1];
        if (y) x0 = x0[0], x1 = x1[0];
        xExtentDomain = [x0, x1];
        if (x.invert) x0 = x(x0), x1 = x(x1);
        if (x1 < x0) t = x0, x0 = x1, x1 = t;
        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [x0, x1];
      }
      if (y) {
        y0 = z[0], y1 = z[1];
        if (x) y0 = y0[1], y1 = y1[1];
        yExtentDomain = [y0, y1];
        if (y.invert) y0 = y(y0), y1 = y(y1);
        if (y1 < y0) t = y0, y0 = y1, y1 = t;
        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [y0, y1];
      }
      return brush;
    };
    brush.clear = function () {
      if (!brush.empty()) {
        xExtent = [0, 0], yExtent = [0, 0];
        xExtentDomain = yExtentDomain = null;
      }
      return brush;
    };
    brush.empty = function () {
      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
    };
    return d3.rebind(brush, event, "on");
  };
  var d3_svg_brushCursor = {
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  };
  var d3_svg_brushResizes = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []];
  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
  var d3_time_formatUtc = d3_time_format.utc;
  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
  function d3_time_formatIsoNative(date) {
    return date.toISOString();
  }
  d3_time_formatIsoNative.parse = function (string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  };
  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
  d3_time.second = d3_time_interval(function (date) {
    return new d3_date(Math.floor(date / 1e3) * 1e3);
  }, function (date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
  }, function (date) {
    return date.getSeconds();
  });
  d3_time.seconds = d3_time.second.range;
  d3_time.seconds.utc = d3_time.second.utc.range;
  d3_time.minute = d3_time_interval(function (date) {
    return new d3_date(Math.floor(date / 6e4) * 6e4);
  }, function (date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
  }, function (date) {
    return date.getMinutes();
  });
  d3_time.minutes = d3_time.minute.range;
  d3_time.minutes.utc = d3_time.minute.utc.range;
  d3_time.hour = d3_time_interval(function (date) {
    var timezone = date.getTimezoneOffset() / 60;
    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
  }, function (date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
  }, function (date) {
    return date.getHours();
  });
  d3_time.hours = d3_time.hour.range;
  d3_time.hours.utc = d3_time.hour.utc.range;
  d3_time.month = d3_time_interval(function (date) {
    date = d3_time.day(date);
    date.setDate(1);
    return date;
  }, function (date, offset) {
    date.setMonth(date.getMonth() + offset);
  }, function (date) {
    return date.getMonth();
  });
  d3_time.months = d3_time.month.range;
  d3_time.months.utc = d3_time.month.utc.range;
  function d3_time_scale(linear, methods, format) {
    function scale(x) {
      return linear(x);
    }
    scale.invert = function (x) {
      return d3_time_scaleDate(linear.invert(x));
    };
    scale.domain = function (x) {
      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
      linear.domain(x);
      return scale;
    };
    function tickMethod(extent, count) {
      var span = extent[1] - extent[0],
          target = span / count,
          i = d3.bisect(d3_time_scaleSteps, target);
      return i == d3_time_scaleSteps.length ? [methods.year, d3_scale_linearTickRange(extent.map(function (d) {
        return d / 31536e6;
      }), count)[2]] : !i ? [d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2]] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
    }
    scale.nice = function (interval, skip) {
      var domain = scale.domain(),
          extent = d3_scaleExtent(domain),
          method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
      if (method) interval = method[0], skip = method[1];
      function skipped(date) {
        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
      }
      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
        floor: function floor(date) {
          while (skipped(date = interval.floor(date))) {
            date = d3_time_scaleDate(date - 1);
          }return date;
        },
        ceil: function ceil(date) {
          while (skipped(date = interval.ceil(date))) {
            date = d3_time_scaleDate(+date + 1);
          }return date;
        }
      } : interval));
    };
    scale.ticks = function (interval, skip) {
      var extent = d3_scaleExtent(scale.domain()),
          method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [{
        range: interval
      }, skip];
      if (method) interval = method[0], skip = method[1];
      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
    };
    scale.tickFormat = function () {
      return format;
    };
    scale.copy = function () {
      return d3_time_scale(linear.copy(), methods, format);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_time_scaleDate(t) {
    return new Date(t);
  }
  var d3_time_scaleSteps = [1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6];
  var d3_time_scaleLocalMethods = [[d3_time.second, 1], [d3_time.second, 5], [d3_time.second, 15], [d3_time.second, 30], [d3_time.minute, 1], [d3_time.minute, 5], [d3_time.minute, 15], [d3_time.minute, 30], [d3_time.hour, 1], [d3_time.hour, 3], [d3_time.hour, 6], [d3_time.hour, 12], [d3_time.day, 1], [d3_time.day, 2], [d3_time.week, 1], [d3_time.month, 1], [d3_time.month, 3], [d3_time.year, 1]];
  var d3_time_scaleLocalFormat = d3_time_format.multi([[".%L", function (d) {
    return d.getMilliseconds();
  }], [":%S", function (d) {
    return d.getSeconds();
  }], ["%I:%M", function (d) {
    return d.getMinutes();
  }], ["%I %p", function (d) {
    return d.getHours();
  }], ["%a %d", function (d) {
    return d.getDay() && d.getDate() != 1;
  }], ["%b %d", function (d) {
    return d.getDate() != 1;
  }], ["%B", function (d) {
    return d.getMonth();
  }], ["%Y", d3_true]]);
  var d3_time_scaleMilliseconds = {
    range: function range(start, stop, step) {
      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
    },
    floor: d3_identity,
    ceil: d3_identity
  };
  d3_time_scaleLocalMethods.year = d3_time.year;
  d3_time.scale = function () {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
  };
  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function (m) {
    return [m[0].utc, m[1]];
  });
  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([[".%L", function (d) {
    return d.getUTCMilliseconds();
  }], [":%S", function (d) {
    return d.getUTCSeconds();
  }], ["%I:%M", function (d) {
    return d.getUTCMinutes();
  }], ["%I %p", function (d) {
    return d.getUTCHours();
  }], ["%a %d", function (d) {
    return d.getUTCDay() && d.getUTCDate() != 1;
  }], ["%b %d", function (d) {
    return d.getUTCDate() != 1;
  }], ["%B", function (d) {
    return d.getUTCMonth();
  }], ["%Y", d3_true]]);
  d3_time_scaleUtcMethods.year = d3_time.year.utc;
  d3_time.scale.utc = function () {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
  };
  d3.text = d3_xhrType(function (request) {
    return request.responseText;
  });
  d3.json = function (url, callback) {
    return d3_xhr(url, "application/json", d3_json, callback);
  };
  function d3_json(request) {
    return JSON.parse(request.responseText);
  }
  d3.html = function (url, callback) {
    return d3_xhr(url, "text/html", d3_html, callback);
  };
  function d3_html(request) {
    var range = d3_document.createRange();
    range.selectNode(d3_document.body);
    return range.createContextualFragment(request.responseText);
  }
  d3.xml = d3_xhrType(function (request) {
    return request.responseXML;
  });
  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if (typeof module === "object" && module.exports) module.exports = d3;else this.d3 = d3;
}();

/***/ }),

/***/ "tz0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_CONTRIBUTIONS_DATA; });
/* unused harmony export recipientContributionDataFetchStart */
/* unused harmony export recipientContributionDataFetchEnd */
/* unused harmony export recipientContributionDataFetchSuccess */
/* unused harmony export recipientContributionDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRecipientContributionsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var RECIPIENT_CONTRIBUTIONS_DATA = {
  start: "fetch_start/recipient_contributions_data",
  end: "fetch_end/recipient_contributions_data",
  success: "fetch_success/recipient_contributions_data",
  failed: "fetch_failed/recipient_contributions_data"
};

var recipientContributionDataFetchStart = function recipientContributionDataFetchStart() {
  return {
    type: RECIPIENT_CONTRIBUTIONS_DATA.start
  };
};

var recipientContributionDataFetchEnd = function recipientContributionDataFetchEnd() {
  return {
    type: RECIPIENT_CONTRIBUTIONS_DATA.end
  };
};

var recipientContributionDataFetchSuccess = function recipientContributionDataFetchSuccess(data) {
  return {
    type: RECIPIENT_CONTRIBUTIONS_DATA.success,
    data: data
  };
};

var recipientContributionDataFetchFailed = function recipientContributionDataFetchFailed(error) {
  return {
    type: RECIPIENT_CONTRIBUTIONS_DATA.failed,
    error: error
  };
};

var getRecipientContributionsData = function getRecipientContributionsData(year, field_of_operation) {
  return function (dispatch) {
    dispatch(recipientContributionDataFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_CONTRIBUTIONS_DATA(year, field_of_operation)).then(function (response) {
        dispatch(recipientContributionDataFetchEnd());
        dispatch(recipientContributionDataFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(recipientContributionDataFetchEnd());
        dispatch(recipientContributionDataFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "u9EY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);

/***/ }),

/***/ "ve3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_PROFILE_MAP_DATA; });
/* unused harmony export mapDataFetchStart */
/* unused harmony export mapDataFetchEnd */
/* unused harmony export mapDataFetchSuccess */
/* unused harmony export mapDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadRecipientProfileMapData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/************************* Lib Files ************************/


var RECIPIENT_PROFILE_MAP_DATA = {
  start: "fetch_start/recipient_profile_map_data",
  end: "fetch_end/recipient_profile_map_data",
  success: "fetch_success/recipient_profile_map_data",
  failed: "fetch_failed/recipient_profile_map_data"
};

var mapDataFetchStart = function mapDataFetchStart() {
  return {
    type: RECIPIENT_PROFILE_MAP_DATA.start
  };
};

var mapDataFetchEnd = function mapDataFetchEnd() {
  return {
    type: RECIPIENT_PROFILE_MAP_DATA.end
  };
};

var mapDataFetchSuccess = function mapDataFetchSuccess(data) {
  return {
    type: RECIPIENT_PROFILE_MAP_DATA.success,
    data: data
  };
};

var mapDataFetchFailed = function mapDataFetchFailed(error) {
  return {
    type: RECIPIENT_PROFILE_MAP_DATA.failed,
    error: error
  };
};

var mapResponseParser = function mapResponseParser(dispatch, resp) {
  if (resp.success && resp.data) {
    var data = resp.data.filter(function (item, index) {
      return item.latitude !== null && item.longitude !== null;
    });
    data = data.map(function (item, index) {
      var outputs = item.outputs.filter(function (output, key) {
        return output.output_latitude !== null && output.output_longitude !== null;
      });
      item.outputs = outputs;
      return item;
    });
    dispatch(mapDataFetchEnd());
    dispatch(mapDataFetchSuccess(data));
  } else {
    dispatch(mapDataFetchEnd());
  }
};

var loadRecipientProfileMapData = function loadRecipientProfileMapData(year, unit) {
  return function (dispatch) {
    dispatch(mapDataFetchStart());
    unit = unit ? unit : "";
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MAP_RECIPIENT(year, unit)).then(function (resp) {
      return mapResponseParser(dispatch, resp);
    }).catch(function (exception) {
      dispatch(mapDataFetchEnd());
      dispatch(mapDataFetchFailed(exception));
    });
  };
};

/***/ }),

/***/ "voeE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_OUTPUT_RESULTS; });
/* unused harmony export projectOutputResultsFetchStart */
/* unused harmony export projectOutputResultsFetchEnd */
/* unused harmony export projectOutputResultsFetchSuccess */
/* unused harmony export projectOutputResultsFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectOutputResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Output Results //////////////////////////

var PROJECT_OUTPUT_RESULTS = {
  start: "fetch_start/project_output_results",
  end: "fetch_end/project_output_results",
  success: "fetch_success/project_output_results",
  failed: "fetch_failed/project_output_results"
};
var projectOutputResultsFetchStart = function projectOutputResultsFetchStart() {
  return {
    type: PROJECT_OUTPUT_RESULTS.start
  };
};

var projectOutputResultsFetchEnd = function projectOutputResultsFetchEnd() {
  return {
    type: PROJECT_OUTPUT_RESULTS.end
  };
};

var projectOutputResultsFetchSuccess = function projectOutputResultsFetchSuccess(data, index) {
  return {
    type: PROJECT_OUTPUT_RESULTS.success,
    data: data,
    index: index
  };
};

var projectOutputResultsFetchFailed = function projectOutputResultsFetchFailed(error) {
  return {
    type: PROJECT_OUTPUT_RESULTS.failed,
    error: error
  };
};

var fetchProjectOutputResults = function fetchProjectOutputResults(id, index) {
  return function (dispatch, getState) {
    dispatch(projectOutputResultsFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_OUTPUT_RESULTS(id)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(projectOutputResultsFetchEnd());
        dispatch(projectOutputResultsFetchSuccess(resp.data, index));
      } else {
        dispatch(projectOutputResultsFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectOutputResultsFetchEnd());
      dispatch(projectOutputResultsFetchFailed());
    });
  };
};

/***/ }),

/***/ "vp+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_DATA_CLEAR; });
/* unused harmony export projectDataClear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearProjectData; });
/////////////////////// Clear Project Data //////////////////////////

var PROJECT_DATA_CLEAR = {
  clear: "clear/project_data_clear"
};

var projectDataClear = function projectDataClear() {
  return {
    type: PROJECT_DATA_CLEAR.clear
  };
};

var clearProjectData = function clearProjectData() {
  return function (dispatch, getState) {
    dispatch(projectDataClear());
  };
};

/***/ }),

/***/ "w2Oo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_BUDGET_UTILIZATION; });
/* unused harmony export projectBudgetUtilizationFetchStart */
/* unused harmony export projectBudgetUtilizationFetchEnd */
/* unused harmony export projectBudgetUtilizationFetchSuccess */
/* unused harmony export projectBudgetUtilizationFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectBudgetUtilization; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Budget Utilization //////////////////////////

var PROJECT_BUDGET_UTILIZATION = {
  start: "fetch_start/project_budget_utilization",
  end: "fetch_end/project_budget_utilization",
  success: "fetch_success/project_budget_utilization",
  failed: "fetch_failed/project_budget_utilization"
};
var projectBudgetUtilizationFetchStart = function projectBudgetUtilizationFetchStart() {
  return {
    type: PROJECT_BUDGET_UTILIZATION.start
  };
};

var projectBudgetUtilizationFetchEnd = function projectBudgetUtilizationFetchEnd() {
  return {
    type: PROJECT_BUDGET_UTILIZATION.end
  };
};

var projectBudgetUtilizationFetchSuccess = function projectBudgetUtilizationFetchSuccess(data) {
  return {
    type: PROJECT_BUDGET_UTILIZATION.success,
    data: data
  };
};

var projectBudgetUtilizationFetchFailed = function projectBudgetUtilizationFetchFailed(error) {
  return {
    type: PROJECT_BUDGET_UTILIZATION.failed,
    error: error
  };
};

var fetchProjectBudgetUtilization = function fetchProjectBudgetUtilization(id) {
  return function (dispatch, getState) {
    dispatch(projectBudgetUtilizationFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_BUDGET_UTILIZATION(id)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(projectBudgetUtilizationFetchEnd());
        dispatch(projectBudgetUtilizationFetchSuccess(resp.data));
      } else {
        dispatch(projectBudgetUtilizationFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(projectBudgetUtilizationFetchEnd());
      dispatch(projectBudgetUtilizationFetchFailed());
    });
  };
};

/***/ }),

/***/ "wD7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECIPIENT_SDG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECIPIENT_SDG_AGGREGATE; });
/* unused harmony export RecipientSdgFetchStart */
/* unused harmony export RecipientSdgFetchEnd */
/* unused harmony export RecipientSdgFetchSuccess */
/* unused harmony export RecipientSdgFetchFailed */
/* unused harmony export updateRecipientSdgAggregate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchRecipientSdg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__ = __webpack_require__("Cdrj");



var RECIPIENT_SDG = {
  start: "fetch_start/recipient_sdg",
  end: "fetch_end/recipient_sdg",
  success: "fetch_success/recipient_sdg",
  failed: "fetch_failed/recipient_sdg"
};

var RECIPIENT_SDG_AGGREGATE = "RECIPIENT_SDG_AGGREGATE";

var RecipientSdgFetchStart = function RecipientSdgFetchStart() {
  return {
    type: RECIPIENT_SDG.start
  };
};

var RecipientSdgFetchEnd = function RecipientSdgFetchEnd() {
  return {
    type: RECIPIENT_SDG.end
  };
};

var RecipientSdgFetchSuccess = function RecipientSdgFetchSuccess(data) {
  return {
    type: RECIPIENT_SDG.success,
    data: data
  };
};

var RecipientSdgFetchFailed = function RecipientSdgFetchFailed(error) {
  return {
    type: RECIPIENT_SDG.failed,
    error: error
  };
};

var filterZero = function filterZero(data) {
  return data.filter(function (item) {
    if (item.percentage && item.percentage != 0 && item.sdg_budget && item.sdg_budget != 0) {
      return true;
    } else {
      return false;
    }
  });
};

var updateRecipientSdgAggregate = function updateRecipientSdgAggregate(sdgAggregate) {
  return {
    type: RECIPIENT_SDG_AGGREGATE,
    sdgAggregate: sdgAggregate
  };
};

var parseRecepientSdgData = function parseRecepientSdgData(data) {
  data.forEach(function (item) {
    item.sector = item.sdg_code;
    item.sector_color = item.sdg_color;
    item.sector_name = item.sdg_name;
    item.sdg_budget = item.sdg_budget;
  });
};

var fetchRecipientSdg = function fetchRecipientSdg(code, year) {
  return function (dispatch) {
    dispatch(RecipientSdgFetchStart());
    if (year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_COUNTRY_SDG(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          if (resp.data.length) {
            var sdgAggregate = Object(__WEBPACK_IMPORTED_MODULE_1__utils_commonMethods__["c" /* aggregateCalculator */])(resp.data, "sdg_budget");
            dispatch(updateRecipientSdgAggregate(sdgAggregate));
          }
          parseRecepientSdgData(resp.data);
          var filteredArray = filterZero(resp.data);
          dispatch(RecipientSdgFetchSuccess(filteredArray));
          dispatch(RecipientSdgFetchEnd());
        } else {
          dispatch(RecipientSdgFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(RecipientSdgFetchEnd());
        dispatch(RecipientSdgFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Asjh");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "x4+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MARKER_DETAIL; });
/* unused harmony export markerDetailFetchStart */
/* unused harmony export markerDetailFetchEnd */
/* unused harmony export markerDetailFetchSuccess */
/* unused harmony export markerDetailFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchmarkerDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/////////////////////// Fetch Project Output Details //////////////////////////


var MARKER_DETAIL = {
  start: "fetch_start/marker_detail",
  end: "fetch_end/marker_detail",
  success: "fetch_success/marker_detail",
  failed: "fetch_failed/marker_detail"
};
var markerDetailFetchStart = function markerDetailFetchStart() {
  return {
    type: MARKER_DETAIL.start
  };
};

var markerDetailFetchEnd = function markerDetailFetchEnd() {
  return {
    type: MARKER_DETAIL.end
  };
};

var markerDetailFetchSuccess = function markerDetailFetchSuccess(data, index) {
  return {
    type: MARKER_DETAIL.success,
    data: data,
    index: index
  };
};

var markerDetailFetchFailed = function markerDetailFetchFailed(error) {
  return {
    type: MARKER_DETAIL.failed,
    error: error
  };
};

var fetchmarkerDetail = function fetchmarkerDetail(id, index) {
  return function (dispatch, getState) {
    dispatch(markerDetailFetchStart());
    return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_MARKER_DETAIL(id)).then(function (resp) {
      if (resp.data && resp.success) {
        dispatch(markerDetailFetchEnd());
        dispatch(markerDetailFetchSuccess(resp.data, index));
      } else {
        dispatch(markerDetailFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(markerDetailFetchEnd());
      dispatch(markerDetailFetchFailed());
    });
  };
};

/***/ }),

/***/ "xKz7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONORS_MASTER_CONTRIBUTIONS_LIST; });
/* unused harmony export donorsContributionsListFetchStart */
/* unused harmony export donorsContributionsListFetchEnd */
/* unused harmony export donorsContributionsListFetchSuccess */
/* unused harmony export donorsContributionsListFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateMasterContributionsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var DONORS_MASTER_CONTRIBUTIONS_LIST = {
  start: "fetch_start/donors_master_contributions_list",
  end: "fetch_end/donors_master_contributions_list",
  success: "fetch_success/donors_master_contributions_list",
  failed: "fetch_failed/donors_master_contributions_list"
};

var donorsContributionsListFetchStart = function donorsContributionsListFetchStart() {
  return {
    type: DONORS_MASTER_CONTRIBUTIONS_LIST.start
  };
};

var donorsContributionsListFetchEnd = function donorsContributionsListFetchEnd() {
  return {
    type: DONORS_MASTER_CONTRIBUTIONS_LIST.end
  };
};

var donorsContributionsListFetchSuccess = function donorsContributionsListFetchSuccess(data) {
  return {
    type: DONORS_MASTER_CONTRIBUTIONS_LIST.success,
    data: data
  };
};

var donorsContributionsListFetchFailed = function donorsContributionsListFetchFailed(error) {
  return {
    type: DONORS_MASTER_CONTRIBUTIONS_LIST.failed,
    error: error
  };
};

var updateMasterContributionsList = function updateMasterContributionsList(year, portal) {
  return function (dispatch) {
    dispatch(donorsContributionsListFetchStart());
    if (year !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONORS_CONTRIBUTIONS_LIST(year, portal)).then(function (response) {
        dispatch(donorsContributionsListFetchEnd());
        dispatch(donorsContributionsListFetchSuccess(response.data));
      }).catch(function (exception) {
        dispatch(donorsContributionsListFetchEnd());
        dispatch(donorsContributionsListFetchFailed(exception));
      });
    }
  };
};

/***/ }),

/***/ "xgQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COUNTRY_DATA; });
/* unused harmony export globalDataFetchStart */
/* unused harmony export globalDataFetchEnd */
/* unused harmony export globalDataFetchSuccess */
/* unused harmony export globalDataFetchFailed */
/* unused harmony export countryDataUpdate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGlobalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateCountryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECIPIENT_COUNTRY_DATA; });
/* unused harmony export recipientCountryDataFetchStart */
/* unused harmony export recipientCountryDataFetchEnd */
/* unused harmony export recipientCountryDataFetchSuccess */
/* unused harmony export recipientCountryDataFetchFailed */
/* unused harmony export fetchRecipientCountry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var COUNTRY_DATA = {
  start: "fetch_start/global_data",
  end: "fetch_end/global_data",
  success: "fetch_success/global_data",
  failed: "fetch_failed/global_data",
  update: "update/country_data"
};

//////////////////////////////////GLOBAL DATA ///////////////////////////////
var globalDataFetchStart = function globalDataFetchStart() {
  return {
    type: COUNTRY_DATA.start
  };
};

var globalDataFetchEnd = function globalDataFetchEnd() {
  return {
    type: COUNTRY_DATA.end
  };
};

var globalDataFetchSuccess = function globalDataFetchSuccess(data) {
  return {
    type: COUNTRY_DATA.success,
    data: data
  };
};

var globalDataFetchFailed = function globalDataFetchFailed(error) {
  return {
    type: COUNTRY_DATA.failed,
    error: error
  };
};

var countryDataUpdate = function countryDataUpdate(data) {
  return {
    type: COUNTRY_DATA.update,
    data: data
  };
};

var fetchGlobalData = function fetchGlobalData(year) {
  return function (dispatch) {
    dispatch(globalDataFetchStart());
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_PROJECT_AGGREGATE + year).then(function (resp) {
      if (resp.success && resp.data) {
        dispatch(globalDataFetchEnd());
        var data = {
          country_name: "Global",
          total_budget: resp.data.budget,
          total_expense: resp.data.expense,
          project_count: resp.data.projects,
          donor_count: resp.data.donors
        };
        dispatch(globalDataFetchSuccess(data));
      } else {
        dispatch(globalDataFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(globalDataFetchEnd());
      dispatch(globalDataFetchFailed());
    });
  };
};

var updateCountryData = function updateCountryData(data, year) {
  return function (dispatch) {
    dispatch(countryDataUpdate(data));
  };
};

//////////////////////////////////////// COUNTRY DATA /////////////////////////////////////////
var RECIPIENT_COUNTRY_DATA = {
  start: "fetch_start/recipient_country_data",
  end: "fetch_end/recipient_country_data",
  success: "fetch_success/recipient_country_data",
  failed: "fetch_failed/recipient_country_data"
};

var recipientCountryDataFetchStart = function recipientCountryDataFetchStart() {
  return {
    type: RECIPIENT_COUNTRY_DATA.start
  };
};

var recipientCountryDataFetchEnd = function recipientCountryDataFetchEnd() {
  return {
    type: RECIPIENT_COUNTRY_DATA.end
  };
};

var recipientCountryDataFetchSuccess = function recipientCountryDataFetchSuccess(data) {
  return {
    type: RECIPIENT_COUNTRY_DATA.success,
    data: data
  };
};

var recipientCountryDataFetchFailed = function recipientCountryDataFetchFailed(error) {
  return {
    type: RECIPIENT_COUNTRY_DATA.failed,
    error: error
  };
};

var fetchRecipientCountry = function fetchRecipientCountry(countryName, code, year, iso2code, type) {
  return function (dispatch) {
    dispatch(recipientCountryDataFetchStart());
    if (year !== null) return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_RECIPIENT_COUNTRY_BASIC(code, year)).then(function (resp) {
      if (resp.success && resp.data) {
        iso2code = iso2code === "" || iso2code === null ? code : iso2code;
        dispatch(recipientCountryDataFetchEnd());
        var data = {
          country_name: countryName,
          total_budget: resp.data.budget,
          total_expense: resp.data.expense,
          project_count: resp.data.projects_count,
          country_iso3: code,
          country_iso2: iso2code,
          type: type,
          donor_count: resp.data.budget_sources
        };
        dispatch(recipientCountryDataFetchSuccess(data));
      } else {
        dispatch(recipientCountryDataFetchEnd());
      }
    }).catch(function (exception) {
      dispatch(recipientCountryDataFetchEnd());
      dispatch(recipientCountryDataFetchFailed());
    });
  };
};

/***/ }),

/***/ "yg2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SIGNATURE_SOLUTION; });
/* unused harmony export setSignatureSolution */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateSignatureSolution; });
var SET_SIGNATURE_SOLUTION = "SET_SIGNATURE_SOLUTION";

function setSignatureSolution(value) {
  return {
    type: SET_SIGNATURE_SOLUTION,
    value: value
  };
}

var updateSignatureSolution = function updateSignatureSolution(value) {
  return function (dispatch, getState) {
    dispatch(setSignatureSolution(value));
  };
};

/***/ }),

/***/ "ygki":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("i/J7");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);

/***/ }),

/***/ "yuQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THEME_SLIDER_DATA; });
/* unused harmony export donorSliderDataFetchStart */
/* unused harmony export donorSliderDataFetchEnd */
/* unused harmony export donorSliderDataClear */
/* unused harmony export donorSliderDataFetchSuccess */
/* unused harmony export donorSliderDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDonorSliderData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var THEME_SLIDER_DATA = {
  start: "fetch_start/theme_slider_data",
  end: "fetch_end/theme_slider_data",
  success: "fetch_success/theme_slider_data",
  failed: "fetch_failed/theme_slider_data",
  clear: "clear/theme_slider_data"
};

var donorSliderDataFetchStart = function donorSliderDataFetchStart() {
  return {
    type: THEME_SLIDER_DATA.start
  };
};

var donorSliderDataFetchEnd = function donorSliderDataFetchEnd() {
  return {
    type: THEME_SLIDER_DATA.end
  };
};
var donorSliderDataClear = function donorSliderDataClear() {
  return {
    type: THEME_SLIDER_DATA.clear
  };
};

var donorSliderDataFetchSuccess = function donorSliderDataFetchSuccess(data) {
  return {
    type: THEME_SLIDER_DATA.success,
    data: data
  };
};

var donorSliderDataFetchFailed = function donorSliderDataFetchFailed(error) {
  return {
    type: THEME_SLIDER_DATA.failed,
    error: error
  };
};

var fetchDonorSliderData = function fetchDonorSliderData(year, sector) {
  return function (dispatch, getState) {
    budgetSources;
    var operatingUnits = "",
        budgetSources = "";
    // const operatingUnits = getState().tabData.themeFilter.operatingUnits?getState().tabData.themeFilter.operatingUnits:"",
    // budgetSources = getState().tabData.themeFilter.budgetSources?getState().tabData.themeFilter.budgetSources:""
    dispatch(donorSliderDataFetchStart());
    if (year != "" && sector != "") {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONOR_SLIDER_DATA(year, sector, operatingUnits, budgetSources)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(donorSliderDataFetchEnd());
          dispatch(donorSliderDataFetchSuccess(resp.data));
        } else {
          dispatch(donorSliderDataFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(donorSliderDataFetchEnd());
        dispatch(donorSliderDataFetchFailed(exception));
      });
    } else {
      dispatch(donorSliderDataClear());
      dispatch(donorSliderDataFetchEnd());
    }
  };
};

/***/ }),

/***/ "zNX7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_MARKER_SUBTYPE; });
/* unused harmony export setMarkerSubType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateMarkerSubType; });
var SET_MARKER_SUBTYPE = "SET_MARKER_SUBTYPE";

function setMarkerSubType(value) {
  return {
    type: SET_MARKER_SUBTYPE,
    value: value
  };
}

var updateMarkerSubType = function updateMarkerSubType(value) {
  return function (dispatch, getState) {
    dispatch(setMarkerSubType(value));
  };
};

/***/ }),

/***/ "zXJO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DONOR_BUDGET_SOURCES; });
/* unused harmony export donorBudgetSourcesFetchStart */
/* unused harmony export donorBudgetSourcesFetchEnd */
/* unused harmony export donorBudgetSourcesClear */
/* unused harmony export donorBudgetSourcesFetchSuccess */
/* unused harmony export donorBudgetSourcesFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDonorBudgetSources; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");

var DONOR_BUDGET_SOURCES = {
  start: "fetch_start/donor_budget_sources",
  end: "fetch_end/donor_budget_sources",
  success: "fetch_success/donor_budget_sources",
  failed: "fetch_failed/donor_budget_sources",
  clear: "clear/donor_budget_sources"
};

var donorBudgetSourcesFetchStart = function donorBudgetSourcesFetchStart() {
  return {
    type: DONOR_BUDGET_SOURCES.start
  };
};

var donorBudgetSourcesFetchEnd = function donorBudgetSourcesFetchEnd() {
  return {
    type: DONOR_BUDGET_SOURCES.end
  };
};
var donorBudgetSourcesClear = function donorBudgetSourcesClear() {
  return {
    type: DONOR_BUDGET_SOURCES.clear
  };
};

var donorBudgetSourcesFetchSuccess = function donorBudgetSourcesFetchSuccess(data) {
  return {
    type: DONOR_BUDGET_SOURCES.success,
    data: data
  };
};

var donorBudgetSourcesFetchFailed = function donorBudgetSourcesFetchFailed(error) {
  return {
    type: DONOR_BUDGET_SOURCES.failed,
    error: error
  };
};

var fetchDonorBudgetSources = function fetchDonorBudgetSources(code, year) {
  return function (dispatch) {
    dispatch(donorBudgetSourcesFetchStart());
    if (code != "" && year != null) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["a" /* default */].API_DONOR_BUDGET_SOURCES(code, year)).then(function (resp) {
        if (resp.success && resp.data) {
          dispatch(donorBudgetSourcesFetchEnd());
          dispatch(donorBudgetSourcesFetchSuccess(resp.data));
        } else {
          dispatch(donorBudgetSourcesFetchEnd());
        }
      }).catch(function (exception) {
        dispatch(donorBudgetSourcesFetchEnd());
        dispatch(donorBudgetSourcesFetchFailed(exception));
      });
    } else {
      dispatch(donorBudgetSourcesClear());
      dispatch(donorBudgetSourcesFetchEnd());
    }
  };
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.19c89.js